// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/MaterialIcons-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/MaterialIcons-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/MaterialIcons-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/MaterialIcons-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/img/icons/tick-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/img/icons/down-arrow-gray.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/img/icons/down-arrow-gray-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/img/icons/search-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/img/search-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/img/slider-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/img/banner-2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/img/location.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../assets/img/search.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../assets/img/google-map.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../assets/img/special-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../assets/img/doctor.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../assets/img/patient.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../assets/img/specialist-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../assets/img/featured-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../assets/img/banner-3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../assets/img/slider/blue-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../assets/img/slider/feature-img.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../assets/img/slider/banner-01.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../assets/img/slider/banner-02.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../assets/img/shapes/doctor-right-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700,900);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Author       : Dreamguys
Template Name: Doccure - Bootstrap Template
Version      : 1.3
*/

/*============================
 [Table of CSS]

1. General
2. Table
3. Bootstrap Classes
4. Avatar
5. Select2
6. Nav Tabs
7. Modal
8. Components
9. Slick Slider
10. Focus Label
11. Header
12. Mobile Menu
13. Footer
14. Login
15. Home
16. Search
17. Doctor Profile
18. Booking
19. Checkout
20. Booking Success
21. Invoice View
22. Schedule Timings
23. Doctor Dashboard
24. Patient Profile
25. Add Billing
26. Chat
27. Doctor Profile Settings
28. Calendar
29. Patient Dashboard
30. Profile Settings
31. Appoitment List
32. Reviews
33. Voice call
34. Video Call
35. Outgoing Call
36. Incoming Call
37. Terms and Conditions
38. Blog
39. Blog Details
40. Blog Grid
41. Map List & Grid
42. Loader
43. Product
44. Cart
45. Slider
46. Account
47. Responsive

========================================*/

/*-----------------
	1. General
-----------------------*/
@font-face {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* For IE6-8 */
  src: local("Material Icons"), local("MaterialIcons-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}

.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "liga";
}

html {
  height: 100%;
}
body {
  background-color: #f8f9fa;
  color: #272b41;
  font-family: "Poppins", sans-serif;
  /* font-size: 0.9375rem; */
  font-size: 14px;
  height: 100%;
  overflow-x: hidden;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: #272b41;
  font-weight: 500;
}
.h1,
h1 {
  font-size: 2.1rem;
}
.h2,
h2 {
  font-size: 1.77rem;
}
.h3,
h3 {
  font-size: 1.4rem;
}
.h4,
h4 {
  font-size: 1.1rem;
}
.h5,
h5 {
  font-size: 0.9rem;
}
.h6,
h6 {
  font-size: 0.7rem;
}

a {
  color: #2e3842;
}
a:hover {
  color: #1f6dff;
}
a:hover,
a:active,
a:focus {
  outline: none;
  text-decoration: none;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}
input,
button,
a {
  transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
}
button:focus {
  outline: 0;
}
input[type="text"],
input[type="password"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.btn.focus,
.btn:focus {
  box-shadow: inherit;
}
.form-control {
  border-color: #dcdcdc;
  color: #333;
  font-size: 15px;
  min-height: 46px;
  padding: 6px 15px;
}
.table .form-control {
  font-size: 14px;
  min-height: 38px;
}
.container-fluid {
  padding-left: 30px;
  padding-right: 30px;
}
.form-control::-webkit-input-placeholder {
  color: #858585;
  font-size: 14px;
}
.form-control::-moz-placeholder {
  color: #858585;
  font-size: 14px;
}
.form-control:-ms-input-placeholder {
  color: #858585;
  font-size: 14px;
}
.form-control::-ms-input-placeholder {
  color: #858585;
  font-size: 14px;
}
.form-control::placeholder {
  color: #858585;
  font-size: 14px;
}
.list-group-item {
  border: 1px solid #f0f0f0;
}
.content {
  min-height: 560px !important;
  padding: 30px 0 0;
}

/*-----------------
	2. Table
-----------------------*/

.table {
  color: #272b41;
  max-width: 100%;
  margin-bottom: 0;
  width: 100%;
}
.table-striped > tbody > tr:nth-of-type(2n + 1) {
  background-color: #f8f9fa;
}
.table.no-border > tbody > tr > td,
.table > tbody > tr > th,
.table.no-border > tfoot > tr > td,
.table.no-border > tfoot > tr > th,
.table.no-border > thead > tr > td,
.table.no-border > thead > tr > th {
  border-top: 0;
  padding: 10px 8px;
}
.table-nowrap td,
.table-nowrap th {
  white-space: nowrap;
}
.table.dataTable {
  border-collapse: collapse !important;
}
table.table td h2 {
  display: inline-block;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
}
table.table td h2.table-avatar {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  white-space: nowrap;
}
table.table td h2 a {
  color: #272b41;
}
table.table td h2 a:hover {
  color: #09dca4;
}
table.table td h2 span {
  color: #888;
  display: block;
  font-size: 12px;
  margin-top: 3px;
}
.table thead {
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}
.table thead tr th {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.table tbody tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.table tbody tr:last-child {
  border-color: transparent;
}
.table.table-center td,
.table.table-center th {
  vertical-align: middle;
}
.table-hover tbody tr:hover {
  background-color: #f7f7f7;
}
.table-hover tbody tr:hover td {
  color: #474648;
}
.table-striped thead tr {
  border-color: transparent;
}
.table-striped tbody tr {
  border-color: transparent;
}
.table-striped tbody tr:nth-of-type(even) {
  background-color: rgba(255, 255, 255, 0.3);
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(235, 235, 235, 0.4);
}
.table-bordered {
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}
.table-bordered th,
.table-bordered td {
  border-color: rgba(0, 0, 0, 0.05);
}
.card-table .card-body {
  padding: 0;
}
.card-table .card-body .table > thead > tr > th {
  border-top: 0;
}
.card-table .table tr td:first-child,
.card-table .table tr th:first-child {
  padding-left: 1.5rem;
}
.card-table .table tr td:last-child,
.card-table .table tr th:last-child {
  padding-right: 1.5rem;
}
.card-table .table td,
.card-table .table th {
  border-top: 1px solid #e2e5e8;
  padding: 1rem 0.75rem;
  white-space: nowrap;
}

/*-----------------
	3. Bootstrap Classes
-----------------------*/

.btn.focus,
.btn:focus {
  box-shadow: unset;
}
.btn-white {
  background-color: #fff;
  border: 1px solid #ccc;
  color: #272b41;
}
.btn.btn-rounded {
  border-radius: 50px;
}
.bg-primary,
.badge-primary {
  background-color: #09e5ab !important;
}
a.bg-primary:focus,
a.bg-primary:hover,
button.bg-primary:focus,
button.bg-primary:hover {
  background-color: #09dca4 !important;
}
.bg-success,
.badge-success {
  background-color: #00e65b !important;
}
a.bg-success:focus,
a.bg-success:hover,
button.bg-success:focus,
button.bg-success:hover {
  background-color: #00cc52 !important;
}
.bg-info,
.badge-info {
  background-color: #009efb !important;
}
a.bg-info:focus,
a.bg-info:hover,
button.bg-info:focus,
button.bg-info:hover {
  background-color: #028ee1 !important;
}
.bg-warning,
.badge-warning {
  background-color: #ffbc34 !important;
}
a.bg-warning:focus,
a.bg-warning:hover,
button.bg-warning:focus,
button.bg-warning:hover {
  background-color: #e9ab2e !important;
}
.bg-danger,
.badge-danger {
  background-color: #ff0100 !important;
}
a.bg-danger:focus,
a.bg-danger:hover,
button.bg-danger:focus,
button.bg-danger:hover {
  background-color: #e63333 !important;
}
.bg-white {
  background-color: #fff;
}
.bg-purple,
.badge-purple {
  background-color: #9368e9 !important;
}
.text-primary,
.dropdown-menu > li > a.text-primary {
  color: #09e5ab !important;
}
.text-success,
.dropdown-menu > li > a.text-success {
  color: #00cc52 !important;
}
.text-danger,
.dropdown-menu > li > a.text-danger {
  color: #ff0100 !important;
}
.text-info,
.dropdown-menu > li > a.text-info {
  color: #009efb !important;
}
.text-warning,
.dropdown-menu > li > a.text-warning {
  color: #ffbc34 !important;
}
.text-purple,
.dropdown-menu > li > a.text-purple {
  color: #7460ee !important;
}
.text-muted {
  color: #757575 !important;
}
.btn-primary {
  background-color: #09e5ab;
  border: 1px solid #09e5ab;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary.active,
.btn-primary:active,
.open > .dropdown-toggle.btn-primary {
  background-color: #09dca4;
  border: 1px solid #09dca4;
}
.btn-primary.active.focus,
.btn-primary.active:focus,
.btn-primary.active:hover,
.btn-primary.focus:active,
.btn-primary:active:focus,
.btn-primary:active:hover,
.open > .dropdown-toggle.btn-primary.focus,
.open > .dropdown-toggle.btn-primary:focus,
.open > .dropdown-toggle.btn-primary:hover {
  background-color: #09dca4;
  border: 1px solid #09dca4;
}
.btn-primary.active:not(:disabled):not(.disabled),
.btn-primary:active:not(:disabled):not(.disabled),
.show > .btn-primary.dropdown-toggle {
  background-color: #09dca4;
  border-color: #09dca4;
  color: #fff;
}
.btn-primary.active:focus:not(:disabled):not(.disabled),
.btn-primary:active:focus:not(:disabled):not(.disabled),
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: unset;
}
.btn-primary.disabled,
.btn-primary:disabled {
  background-color: #09e5ab;
  border-color: #09e5ab;
  color: #fff;
}
.btn-secondary.active:focus:not(:disabled):not(.disabled),
.btn-secondary:active:focus:not(:disabled):not(.disabled),
.show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: unset;
}
.btn-success {
  background-color: #00e65b;
  border: 1px solid #00e65b;
}
.btn-success:hover,
.btn-success:focus,
.btn-success.active,
.btn-success:active,
.open > .dropdown-toggle.btn-success {
  background-color: #00cc52;
  border: 1px solid #00cc52;
  color: #fff;
}
.btn-success.active.focus,
.btn-success.active:focus,
.btn-success.active:hover,
.btn-success.focus:active,
.btn-success:active:focus,
.btn-success:active:hover,
.open > .dropdown-toggle.btn-success.focus,
.open > .dropdown-toggle.btn-success:focus,
.open > .dropdown-toggle.btn-success:hover {
  background-color: #00cc52;
  border: 1px solid #00cc52;
}
.btn-success.active:not(:disabled):not(.disabled),
.btn-success:active:not(:disabled):not(.disabled),
.show > .btn-success.dropdown-toggle {
  background-color: #00cc52;
  border-color: #00cc52;
  color: #fff;
}
.btn-success.active:focus:not(:disabled):not(.disabled),
.btn-success:active:focus:not(:disabled):not(.disabled),
.show > .btn-success.dropdown-toggle:focus {
  box-shadow: unset;
}
.btn-success.disabled,
.btn-success:disabled {
  background-color: #00e65b;
  border-color: #00e65b;
  color: #fff;
}
.btn-info {
  background-color: #009efb;
  border: 1px solid #009efb;
}
.btn-info:hover,
.btn-info:focus,
.btn-info.active,
.btn-info:active,
.open > .dropdown-toggle.btn-info {
  background-color: #028ee1;
  border: 1px solid #028ee1;
}
.btn-info.active.focus,
.btn-info.active:focus,
.btn-info.active:hover,
.btn-info.focus:active,
.btn-info:active:focus,
.btn-info:active:hover,
.open > .dropdown-toggle.btn-info.focus,
.open > .dropdown-toggle.btn-info:focus,
.open > .dropdown-toggle.btn-info:hover {
  background-color: #028ee1;
  border: 1px solid #028ee1;
}
.btn-info.active:not(:disabled):not(.disabled),
.btn-info:active:not(:disabled):not(.disabled),
.show > .btn-info.dropdown-toggle {
  background-color: #028ee1;
  border-color: #028ee1;
  color: #fff;
}
.btn-info.active:focus:not(:disabled):not(.disabled),
.btn-info:active:focus:not(:disabled):not(.disabled),
.show > .btn-info.dropdown-toggle:focus {
  box-shadow: unset;
}
.btn-info.disabled,
.btn-info:disabled {
  background-color: #009efb;
  border-color: #009efb;
  color: #fff;
}
.btn-warning {
  background-color: #ffbc34;
  border: 1px solid #ffbc34;
}
.btn-warning:hover,
.btn-warning:focus,
.btn-warning.active,
.btn-warning:active,
.open > .dropdown-toggle.btn-warning {
  background-color: #e9ab2e;
  border: 1px solid #e9ab2e;
}
.btn-warning.active.focus,
.btn-warning.active:focus,
.btn-warning.active:hover,
.btn-warning.focus:active,
.btn-warning:active:focus,
.btn-warning:active:hover,
.open > .dropdown-toggle.btn-warning.focus,
.open > .dropdown-toggle.btn-warning:focus,
.open > .dropdown-toggle.btn-warning:hover {
  background-color: #e9ab2e;
  border: 1px solid #e9ab2e;
}
.btn-warning.active:not(:disabled):not(.disabled),
.btn-warning:active:not(:disabled):not(.disabled),
.show > .btn-warning.dropdown-toggle {
  background-color: #e9ab2e;
  border-color: #e9ab2e;
  color: #fff;
}
.btn-warning.active:focus:not(:disabled):not(.disabled),
.btn-warning:active:focus:not(:disabled):not(.disabled),
.show > .btn-warning.dropdown-toggle:focus {
  box-shadow: unset;
}
.btn-warning.disabled,
.btn-warning:disabled {
  background-color: #ffbc34;
  border-color: #ffbc34;
  color: #fff;
}
.btn-danger {
  background-color: #ff0100;
  border: 1px solid #ff0100;
}
.btn-danger:hover,
.btn-danger:focus,
.btn-danger.active,
.btn-danger:active,
.open > .dropdown-toggle.btn-danger {
  background-color: #e63333;
  border: 1px solid #e63333;
}
.btn-danger.active.focus,
.btn-danger.active:focus,
.btn-danger.active:hover,
.btn-danger.focus:active,
.btn-danger:active:focus,
.btn-danger:active:hover,
.open > .dropdown-toggle.btn-danger.focus,
.open > .dropdown-toggle.btn-danger:focus,
.open > .dropdown-toggle.btn-danger:hover {
  background-color: #e63333;
  border: 1px solid #e63333;
}
.btn-danger.active:not(:disabled):not(.disabled),
.btn-danger:active:not(:disabled):not(.disabled),
.show > .btn-danger.dropdown-toggle {
  background-color: #e63333;
  border-color: #e63333;
  color: #fff;
}
.btn-danger.active:focus:not(:disabled):not(.disabled),
.btn-danger:active:focus:not(:disabled):not(.disabled),
.show > .btn-danger.dropdown-toggle:focus {
  box-shadow: unset;
}
.btn-danger.disabled,
.btn-danger:disabled {
  background-color: #f62d51;
  border-color: #f62d51;
  color: #fff;
}
.btn-light.active:focus:not(:disabled):not(.disabled),
.btn-light:active:focus:not(:disabled):not(.disabled),
.show > .btn-light.dropdown-toggle:focus {
  box-shadow: unset;
}
.btn-dark.active:focus:not(:disabled):not(.disabled),
.btn-dark:active:focus:not(:disabled):not(.disabled),
.show > .btn-dark.dropdown-toggle:focus {
  box-shadow: unset;
}
.btn-outline-primary {
  color: #09e5ab;
  border-color: #09e5ab;
}
.btn-outline-primary:hover {
  background-color: #09e5ab;
  border-color: #09e5ab;
}
.btn-outline-primary:focus,
.btn-outline-primary.focus {
  box-shadow: none;
}
.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: #09e5ab;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
  background-color: #09e5ab;
  border-color: #09e5ab;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: none;
}
.btn-outline-success {
  color: #00e65b;
  border-color: #00e65b;
}
.btn-outline-success:hover {
  background-color: #00e65b;
  border-color: #00e65b;
}
.btn-outline-success:focus,
.btn-outline-success.focus {
  box-shadow: none;
}
.btn-outline-success.disabled,
.btn-outline-success:disabled {
  color: #00e65b;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active,
.btn-outline-success:not(:disabled):not(.disabled).active,
.show > .btn-outline-success.dropdown-toggle {
  background-color: #00e65b;
  border-color: #00e65b;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus,
.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: none;
}
.btn-outline-info {
  color: #009efb;
  border-color: #009efb;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #009efb;
  border-color: #009efb;
}
.btn-outline-info:focus,
.btn-outline-info.focus {
  box-shadow: none;
}
.btn-outline-info.disabled,
.btn-outline-info:disabled {
  background-color: transparent;
  color: #009efb;
}
.btn-outline-info:not(:disabled):not(.disabled):active,
.btn-outline-info:not(:disabled):not(.disabled).active,
.show > .btn-outline-info.dropdown-toggle {
  background-color: #009efb;
  border-color: #009efb;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus,
.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: none;
}
.btn-outline-warning {
  color: #ffbc34;
  border-color: #ffbc34;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #ffbc34;
  border-color: #ffbc34;
}
.btn-outline-warning:focus,
.btn-outline-warning.focus {
  box-shadow: none;
}
.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
  background-color: transparent;
  color: #ffbc34;
}
.btn-outline-warning:not(:disabled):not(.disabled):active,
.btn-outline-warning:not(:disabled):not(.disabled).active,
.show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ffbc34;
  border-color: #ffbc34;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus,
.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: none;
}
.btn-outline-danger {
  color: #ff0100;
  border-color: #ff0100;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #ff0100;
  border-color: #ff0100;
}
.btn-outline-danger:focus,
.btn-outline-danger.focus {
  box-shadow: none;
}
.btn-outline-danger.disabled,
.btn-outline-danger:disabled {
  background-color: transparent;
  color: #ff0100;
}
.btn-outline-danger:not(:disabled):not(.disabled):active,
.btn-outline-danger:not(:disabled):not(.disabled).active,
.show > .btn-outline-danger.dropdown-toggle {
  background-color: #ff0100;
  border-color: #ff0100;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus,
.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: none;
}
.btn-outline-light {
  color: #ababab;
  border-color: #e6e6e6;
}
.btn-outline-light.disabled,
.btn-outline-light:disabled {
  color: #ababab;
}
.add-btn {
  max-width: 140px;
}
.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  background-color: #20c0f3;
  border-color: #20c0f3;
}
.pagination > li > a,
.pagination > li > span {
  color: #20c0f3;
}
.page-link:hover {
  color: #20c0f3;
}
.page-link:focus {
  box-shadow: unset;
}
.page-item.active .page-link {
  background-color: #20c0f3;
  border-color: #20c0f3;
}
.dropdown-menu {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  box-shadow: inherit;
  font-size: 14px;
  transform-origin: left top 0;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: #0de0fe;
}
.navbar-nav .open .dropdown-menu {
  border: 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}
.card {
  border: 1px solid #f0f0f0;
  margin-bottom: 1.875rem;
}
.card-body {
  padding: 1.5rem;
}
.card-title {
  margin-bottom: 15px;
}
.card-header {
  border-bottom: 1px solid #f0f0f0;
  padding: 1rem 1.5rem;
}
.card-footer {
  background-color: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 1rem 1.5rem;
}
.card .card-header {
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
}
.card .card-header .card-title {
  margin-bottom: 0;
}
.btn-light {
  border-color: #e6e6e6;
  color: #a6a6a6;
}
.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #20c0f3;
  text-shadow: unset;
}
.bootstrap-datetimepicker-widget table td.today::before {
  border-bottom-color: #20c0f3;
}
.bg-info-light {
  background-color: rgba(2, 182, 179, 0.12) !important;
  color: #1db9aa !important;
}
.bg-primary-light {
  background-color: rgba(17, 148, 247, 0.12) !important;
  color: #2196f3 !important;
}
.bg-danger-light {
  background-color: rgba(242, 17, 54, 0.12) !important;
  color: #e63c3c !important;
}
.bg-warning-light {
  background-color: rgba(255, 152, 0, 0.12) !important;
  color: #f39c12 !important;
}
.bg-success-light {
  background-color: rgba(15, 183, 107, 0.12) !important;
  color: #26af48 !important;
}
.bg-purple-light {
  background-color: rgba(197, 128, 255, 0.12) !important;
  color: #c580ff !important;
}
.bg-default-light {
  background-color: rgba(40, 52, 71, 0.12) !important;
  color: #283447 !important;
}
.text-xs {
  font-size: 0.75rem !important;
}
.text-sm {
  font-size: 0.875rem !important;
}
.text-lg {
  font-size: 1.25rem !important;
}
.text-xl {
  font-size: 1.5rem !important;
}
.form-control:focus {
  border-color: #bbb;
  box-shadow: none;
  outline: 0 none;
}
.form-group {
  margin-bottom: 1.25rem;
}
.slider-btn {
  background: #09e5ab;
  color: #fff;
  border: 1px solid #09e5ab;
  padding: 8px 16px !important;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.slider-btn:hover {
  background: #fff;
  color: #09e5ab;
  border: 1px solid #fff;
  padding: 8px 16px !important;
}
.slider-btn-1 {
  color: #fff;
  border: 1px solid #0d2b77;
  background: #2e3842;
  padding: 8px 16px !important;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.slider-btn-1:hover {
  color: #2e3842;
  border: 1px solid #fff;
  background: #fff;
  padding: 8px 16px !important;
}

/*-----------------
	4. Avatar
-----------------------*/

.avatar {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 3rem;
}
.avatar > img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
.avatar-title {
  width: 100%;
  height: 100%;
  background-color: #20c0f3;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.avatar-away::before,
.avatar-offline::before,
.avatar-online::before {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 25%;
  height: 25%;
  border-radius: 50%;
  content: "";
  border: 2px solid #fff;
}
.avatar-online::before {
  background-color: #00e65b;
}
.avatar-offline::before {
  background-color: #ff0100;
}
.avatar-away::before {
  background-color: #ffbc34;
}
.avatar .border {
  border-width: 3px !important;
}
.avatar .rounded {
  border-radius: 6px !important;
}
.avatar .avatar-title {
  font-size: 18px;
}
.avatar-xs {
  width: 1.65rem;
  height: 1.65rem;
}
.avatar-xs .border {
  border-width: 2px !important;
}
.avatar-xs .rounded {
  border-radius: 4px !important;
}
.avatar-xs .avatar-title {
  font-size: 12px;
}
.avatar-xs.avatar-away::before,
.avatar-xs.avatar-offline::before,
.avatar-xs.avatar-online::before {
  border-width: 1px;
}
.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}
.avatar-sm .border {
  border-width: 3px !important;
}
.avatar-sm .rounded {
  border-radius: 4px !important;
}
.avatar-sm .avatar-title {
  font-size: 15px;
}
.avatar-sm.avatar-away::before,
.avatar-sm.avatar-offline::before,
.avatar-sm.avatar-online::before {
  border-width: 2px;
}
.avatar-lg {
  width: 3.75rem;
  height: 3.75rem;
}
.avatar-lg .border {
  border-width: 3px !important;
}
.avatar-lg .rounded {
  border-radius: 8px !important;
}
.avatar-lg .avatar-title {
  font-size: 24px;
}
.avatar-lg.avatar-away::before,
.avatar-lg.avatar-offline::before,
.avatar-lg.avatar-online::before {
  border-width: 3px;
}
.avatar-xl {
  width: 5rem;
  height: 5rem;
}
.avatar-xl .border {
  border-width: 4px !important;
}
.avatar-xl .rounded {
  border-radius: 8px !important;
}
.avatar-xl .avatar-title {
  font-size: 28px;
}
.avatar-xl.avatar-away::before,
.avatar-xl.avatar-offline::before,
.avatar-xl.avatar-online::before {
  border-width: 4px;
}
.avatar-xxl {
  width: 5.125rem;
  height: 5.125rem;
}
.avatar-xxl .border {
  border-width: 6px !important;
}
.avatar-xxl .rounded {
  border-radius: 8px !important;
}
.avatar-xxl .avatar-title {
  font-size: 30px;
}
.avatar-xxl.avatar-away::before,
.avatar-xxl.avatar-offline::before,
.avatar-xxl.avatar-online::before {
  border-width: 4px;
}
.avatar-group {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.avatar-group .avatar + .avatar {
  margin-left: -0.75rem;
}
.avatar-group .avatar-xs + .avatar-xs {
  margin-left: -0.40625rem;
}
.avatar-group .avatar-sm + .avatar-sm {
  margin-left: -0.625rem;
}
.avatar-group .avatar-lg + .avatar-lg {
  margin-left: -1rem;
}
.avatar-group .avatar-xl + .avatar-xl {
  margin-left: -1.28125rem;
}
.avatar-group .avatar:hover {
  z-index: 1;
}

/*-----------------
	5. Select2
-----------------------*/

.select2-results__option {
  padding: 6px 15px;
}
.select2-container .select2-selection--single {
  border: 1px solid #dcdcdc;
  height: 46px;
}
.select2-container--default
  .select2-selection--single
  .select2-selection__arrow {
  height: 44px;
  right: 7px;
}
.select2-container--default
  .select2-selection--single
  .select2-selection__arrow
  b {
  border-color: #dcdcdc transparent transparent;
  border-style: solid;
  border-width: 6px 6px 0;
  height: 0;
  left: 50%;
  margin-left: -10px;
  margin-top: -2px;
  position: absolute;
  top: 50%;
  width: 0;
}
.select2-container--default.select2-container--open
  .select2-selection--single
  .select2-selection__arrow
  b {
  border-color: transparent transparent #dcdcdc;
  border-width: 0 6px 6px;
}
.select2-container .select2-selection--single .select2-selection__rendered {
  padding-right: 30px;
  padding-left: 15px;
}
.select2-container--default
  .select2-selection--single
  .select2-selection__rendered {
  color: #272b41;
  font-size: 15px;
  font-weight: normal;
  line-height: 44px;
}
.select2-container--default
  .select2-results__option--highlighted[aria-selected] {
  background-color: #20c0f3;
}
.select2-container--default .select2-selection--multiple {
  border: 1px solid #dcdcdc;
  min-height: 46px;
}
.select2-dropdown {
  border-color: #dcdcdc;
}

/*-----------------
	6. Nav Tabs
-----------------------*/

.nav-tabs {
  border-bottom: 1px solid #f0f0f0;
}
.card-header-tabs {
  border-bottom: 0;
}
.nav-tabs > li > a {
  margin-right: 0;
  color: #888;
  border-radius: 0;
}
.nav-tabs > li > a:hover,
.nav-tabs > li > a:focus {
  border-color: transparent;
  color: #272b41;
}
.nav-tabs.nav-tabs-solid > li > a {
  color: #272b41;
}
.nav-tabs.nav-tabs-solid > .active > a,
.nav-tabs.nav-tabs-solid > .active > a:hover,
.nav-tabs.nav-tabs-solid > .active > a:focus {
  background-color: #20c0f3;
  border-color: #20c0f3;
  color: #fff;
}
.tab-content {
  padding-top: 20px;
}
.nav-tabs .nav-link {
  border-radius: 0;
}
.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  background-color: #eee;
  border-color: transparent;
  color: #272b41;
}
.nav-tabs.nav-justified > li > a {
  border-radius: 0;
  margin-bottom: 0;
}
.nav-tabs.nav-justified > li > a:hover,
.nav-tabs.nav-justified > li > a:focus {
  border-bottom-color: #ddd;
}
.nav-tabs.nav-justified.nav-tabs-solid > li > a {
  border-color: transparent;
}
.nav-tabs.nav-tabs-solid > li > a {
  color: #272b41;
}
.nav-tabs.nav-tabs-solid > li > a.active,
.nav-tabs.nav-tabs-solid > li > a.active:hover,
.nav-tabs.nav-tabs-solid > li > a.active:focus {
  background-color: #20c0f3;
  border-color: #20c0f3;
  color: #fff;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded {
  border-radius: 50px;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a {
  border-radius: 50px;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {
  border-radius: 50px;
}
.nav-tabs-justified > li > a {
  border-radius: 0;
  margin-bottom: 0;
}
.nav-tabs-justified > li > a:hover,
.nav-tabs-justified > li > a:focus {
  border-bottom-color: #ddd;
}
.nav-tabs-justified.nav-tabs-solid > li > a {
  border-color: transparent;
}
.nav-tabs.nav-justified.nav-tabs-top {
  border-bottom: 1px solid #ddd;
}
.nav-tabs.nav-justified.nav-tabs-top > li > a,
.nav-tabs.nav-justified.nav-tabs-top > li > a:hover,
.nav-tabs.nav-justified.nav-tabs-top > li > a:focus {
  border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-top > li {
  margin-bottom: 0;
}
.nav-tabs.nav-tabs-top > li > a,
.nav-tabs.nav-tabs-top > li > a:hover,
.nav-tabs.nav-tabs-top > li > a:focus {
  border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-top > li.open > a,
.nav-tabs.nav-tabs-top > li > a:hover,
.nav-tabs.nav-tabs-top > li > a:focus {
  border-top-color: #ddd;
}
.nav-tabs.nav-tabs-top > li + li > a {
  margin-left: 1px;
}
.nav-tabs.nav-tabs-top > li > a.active,
.nav-tabs.nav-tabs-top > li > a.active:hover,
.nav-tabs.nav-tabs-top > li > a.active:focus {
  border-top-color: #20c0f3;
}
.nav-tabs.nav-tabs-bottom > li > a.active,
.nav-tabs.nav-tabs-bottom > li > a.active:hover,
.nav-tabs.nav-tabs-bottom > li > a.active:focus {
  border-bottom-width: 2px;
  border-color: transparent;
  border-bottom-color: #20c0f3;
  background-color: transparent;
  transition: none 0s ease 0s;
  -moz-transition: none 0s ease 0s;
  -o-transition: none 0s ease 0s;
  -ms-transition: none 0s ease 0s;
  -webkit-transition: none 0s ease 0s;
}
.nav-tabs.nav-tabs-solid {
  background-color: #fafafa;
  border: 0;
}
.nav-tabs.nav-tabs-solid > li {
  margin-bottom: 0;
}
.nav-tabs.nav-tabs-solid > li > a {
  border-color: transparent;
}
.nav-tabs.nav-tabs-solid > li > a:hover,
.nav-tabs.nav-tabs-solid > li > a:focus {
  background-color: #f5f5f5;
}
.nav-tabs.nav-tabs-solid > .open:not(.active) > a {
  background-color: #f5f5f5;
  border-color: transparent;
}
.nav-tabs-justified.nav-tabs-top {
  border-bottom: 1px solid #ddd;
}
.nav-tabs-justified.nav-tabs-top > li > a,
.nav-tabs-justified.nav-tabs-top > li > a:hover,
.nav-tabs-justified.nav-tabs-top > li > a:focus {
  border-width: 2px 0 0 0;
}

/*-----------------
	7. Modal
-----------------------*/

.modal {
  -webkit-overflow-scrolling: touch;
  z-index: 9999;
}
.modal-footer.text-center {
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.modal-footer.text-left {
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
}
.modal-dialog.modal-md {
  max-width: 600px;
}
.custom-modal .modal-content {
  border: 0;
  border-radius: 10px;
}
.custom-modal .modal-header {
  padding: 1.25rem;
}
.custom-modal .modal-footer {
  padding: 1.25rem;
}
.custom-modal .modal-body {
  padding: 1.25rem;
}
.custom-modal .close {
  background-color: #a0a0a0;
  border-radius: 50%;
  color: #fff;
  font-size: 17px;
  height: 20px;
  line-height: 20px;
  margin: 0;
  opacity: 1;
  padding: 0;
  position: absolute;
  right: 20px;
  top: 26px;
  width: 20px;
  z-index: 99;
}
.custom-modal .modal-title {
  font-size: 20px;
}
.modal-backdrop.show {
  opacity: 0.4;
  -webkit-transition-duration: 400ms;
  transition-duration: 400ms;
  z-index: 1030;
}
.modal .card {
  box-shadow: unset;
}
.custom-medicalrecord-modal .modal-header {
  margin: 1.5rem 1.5rem 0 1.5rem;
  padding: 0 0 1rem;
  border-color: #e5e5e5;
}
.custom-medicalrecord-modal .form-control,
.custom-medicalrecord-modal .select2-container .select2-selection--single,
.custom-medicalrecord-modal .bootstrap-tagsinput {
  background-color: #f5f5f7;
  border-color: #f5f5f7;
}
.upload-medical-records {
  position: relative;
}
.upload-medical-records input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.upload-medical-records .dropzone {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  min-height: 180px;
}
.upload-medical-records .dropzone h5,
.upload-medical-records .dropzone h6 {
  color: #7c7c7c;
  margin-bottom: 3px;
}
.upload-medical-records .dropzone h6 span {
  text-decoration: underline;
}
.upload-file-value {
  margin-top: 25px;
  color: #4c4c4c;
}
.custom-medicalrecord-modal .bootstrap-tagsinput.focus {
  border-color: #f5f5f7;
}
.custom-medicalrecord-modal .bootstrap-tagsinput .tag {
  margin-bottom: 0;
  border-radius: 50px;
  background-color: #e8f4ff !important;
  border-color: #e8f4ff;
  color: #11549a;
  font-weight: 500;
  padding: 9px 15px;
}
.custom-medicalrecord-modal .bootstrap-tagsinput .tag [data-role="remove"] {
  background-color: #f5faff;
  border-radius: 50px;
  width: 20px;
  height: 20px;
  display: inline-block;
  font-size: 13px;
  line-height: 20px;
}
.custom-medicalrecord-modal .submit-btn {
  min-width: 300px;
}

/*-----------------
	8. Components
-----------------------*/

.comp-header {
  margin-bottom: 1.875rem;
}
.comp-header .comp-title {
  color: #272b41;
}
.line {
  background-color: #20c0f3;
  height: 2px;
  margin: 0;
  width: 60px;
}
.comp-buttons .btn {
  margin-bottom: 5px;
}
.pagination-box .pagination {
  margin-top: 0;
}
.comp-dropdowns .btn-group {
  margin-bottom: 5px;
}
.progress-example .progress {
  margin-bottom: 1.5rem;
}
.progress-xs {
  height: 4px;
}
.progress-sm {
  height: 15px;
}
.progress.progress-sm {
  height: 6px;
}
.progress.progress-md {
  height: 8px;
}
.progress.progress-lg {
  height: 18px;
}

/*-----------------
	9. Slick Slider
-----------------------*/

.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  -ms-touch-action: pan-y;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}
.slick-list {
  position: relative;
  display: block;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
.slick-list:focus {
  outline: none;
}
.slick-list.dragging {
  cursor: pointer;
}
.slick-slider .slick-track,
.slick-slider .slick-list {
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.slick-track {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-track:before,
.slick-track:after {
  display: table;
  content: "";
}
.slick-track:after {
  clear: both;
}
.slick-loading .slick-track {
  visibility: hidden;
}
.slick-slide {
  display: none;
  float: left;
  height: 100%;
  min-height: 1px;
}
[dir="rtl"] .slick-slide {
  float: right;
}
.slick-slide img {
  display: block;
}
.slick-slide.slick-loading img {
  display: none;
}
.slick-slide.dragging img {
  pointer-events: none;
}
.slick-initialized .slick-slide {
  display: block;
}
.slick-loading .slick-slide {
  visibility: hidden;
}
.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}
.slick-arrow.slick-hidden {
  display: none;
}
.slick-prev,
.slick-next,
.pharmacy-home-slider .swiper-button-prev,
.pharmacy-home-slider .swiper-button-next {
  font-size: 0;
  line-height: 0;
  position: absolute;
  top: 50%;
  display: block;
  width: 40px;
  height: 40px;
  padding: 0;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%);
  box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);
  background: #fff;
  border-radius: 100%;
  cursor: pointer;
  border: none;
  outline: none;
  background: #fff;
  z-index: 9999;
}
.slick-prev:hover,
.slick-prev:focus,
.slick-next:hover,
.slick-next:focus,
.pharmacy-home-slider .swiper-button-prev:hover,
.pharmacy-home-slider .swiper-button-next:hover {
  background-color: #0de0fe;
  color: #fff;
  opacity: 1;
}
.slick-prev:hover:before,
.slick-prev:focus:before,
.slick-next:hover:before,
.slick-next:focus:before,
.pharmacy-home-slider .swiper-button-prev:hover:before,
.pharmacy-home-slider .swiper-button-next:hover:before {
  color: #fff;
  opacity: 1;
}
.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
  opacity: 0.25;
}
.slick-prev:before,
.slick-next:before {
  font-family: "slick";
  font-size: 20px;
  line-height: 1;
  opacity: 0.75;
  color: #383838;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.slick-prev {
  left: 0;
  z-index: 1;
}
.pharmacy-home-slider .swiper-button-prev:after,
.pharmacy-home-slider .swiper-button-next:after {
  display: none;
}
.pharmacy-home-slider .swiper-button-prev:before {
  content: "←";
  color: #383838;
  height: 40px;
  font-size: 20px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.pharmacy-home-slider .swiper-button-next:before {
  content: "→";
  color: #383838;
  font-size: 20px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  height: 40px;
}
[dir="rtl"] .slick-prev {
  right: -25px;
  left: auto;
}
.slick-prev:before {
  content: "←";
}
[dir="rtl"] .slick-prev:before {
  content: "→";
}
.slick-next {
  right: 0;
}
[dir="rtl"] .slick-next {
  right: auto;
  left: -25px;
}
.slick-next:before {
  content: "→";
}
[dir="rtl"] .slick-next:before {
  content: "←";
}
.pharmacy-home-slider {
  position: relative;
}
.pharmacy-home-slider .swiper-container {
  position: relative;
  padding: 0 !important;
  height: 450px;
  min-height: inherit;
}
.pharmacy-home-slider .swiper-container:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(13, 13, 13, 0.33);
}
.pharmacy-home-slider .banner-wrapper {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  padding: 0 15px;
  z-index: 999;
}
.pharmacy-home-slider .banner-wrapper .banner-header h1,
.pharmacy-home-slider .banner-wrapper .banner-header p,
.pharmacy-home-slider .search-box .form-text {
  color: #fff;
}
.pharmacy-home-slider img {
  max-width: 100%;
  height: 100%;
}
.pharmacy-home-slider .swiper-pagination {
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  padding: 20px;
}

/*-----------------
	10. Focus Label
-----------------------*/

.form-focus {
  height: 50px;
  position: relative;
}
.form-focus .focus-label {
  font-size: 14px;
  font-weight: 400;
  pointer-events: none;
  position: absolute;
  -webkit-transform: translate3d(0, 22px, 0) scale(1);
  -ms-transform: translate3d(0, 22px, 0) scale(1);
  -o-transform: translate3d(0, 22px, 0) scale(1);
  transform: translate3d(0, 22px, 0) scale(1);
  transform-origin: left top;
  transition: 240ms;
  left: 12px;
  top: -8px;
  z-index: 1;
  color: #b8b8b8;
  margin-bottom: 0;
}
.form-focus.focused .focus-label {
  opacity: 1;
  top: -18px;
  font-size: 12px;
  z-index: 1;
}
.form-focus .form-control:focus ~ .focus-label,
.form-focus .form-control:-webkit-autofill ~ .focus-label {
  opacity: 1;
  font-weight: 400;
  top: -18px;
  font-size: 12px;
  z-index: 1;
}
.form-focus .form-control {
  height: 50px;
  padding: 21px 12px 6px;
}
.form-focus .form-control::-webkit-input-placeholder {
  color: transparent;
  transition: 240ms;
}
.form-focus .form-control:focus::-webkit-input-placeholder {
  transition: none;
}
.form-focus.focused .form-control::-webkit-input-placeholder {
  color: #bbb;
}
.form-focus.select-focus .focus-label {
  opacity: 1;
  font-weight: 300;
  top: -20px;
  font-size: 12px;
  z-index: 1;
}
.form-focus .select2-container .select2-selection--single {
  border: 1px solid #e3e3e3;
  height: 50px;
}
.form-focus
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow {
  height: 48px;
  right: 7px;
}
.form-focus
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow
  b {
  border-color: #ccc transparent transparent;
  border-style: solid;
  border-width: 6px 6px 0;
  height: 0;
  left: 50%;
  margin-left: -10px;
  margin-top: -2px;
  position: absolute;
  top: 50%;
  width: 0;
}
.form-focus
  .select2-container--default.select2-container--open
  .select2-selection--single
  .select2-selection__arrow
  b {
  border-color: transparent transparent #ccc;
  border-width: 0 6px 6px;
}
.form-focus
  .select2-container
  .select2-selection--single
  .select2-selection__rendered {
  padding-right: 30px;
  padding-left: 12px;
  padding-top: 10px;
}
.form-focus
  .select2-container--default
  .select2-selection--single
  .select2-selection__rendered {
  color: #676767;
  font-size: 14px;
  font-weight: normal;
  line-height: 38px;
}
.form-focus
  .select2-container--default
  .select2-results__option--highlighted[aria-selected] {
  background-color: #fc6075;
}

/*-----------------
	11. Header
-----------------------*/
.nav-transparent {
  background-color: transparent !important;
  border-bottom: 0 !important;
}
.header-nav {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #fff;
  border: 0;
  border-bottom: 1px solid #f0f0f0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  position: relative;
  height: 85px;
  padding: 0 30px;
  margin-bottom: 0;
}
.main-nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}
.main-nav > li.active > a {
  color: #0038a0;
}
.main-nav > li .submenu li a {
  display: block;
  padding: 10px 15px;
  clear: both;
  white-space: nowrap;
  font-size: 14px;
  color: #2d3b48;
  -webkit-transition: all 0.35s ease;
  transition: all 0.35s ease;
  width: 100%;
  border-top: 1px solid #f0f0f0;
}
.main-nav > li .submenu > li.has-submenu > a::after {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  position: absolute;
  right: 15px;
  top: 12px;
  font-size: 13px;
}
.main-nav > li .submenu li {
  position: relative;
}
.main-nav li a {
  display: block;
  font-size: 14px;
  font-weight: 500;
}
.main-nav li.login-link {
  display: none;
}
.logo {
  display: inline-block;
  margin-right: 30px;
  width: 200px;
}
.header-contact-img {
  display: inline-block;
}
.header-contact-img i {
  color: rgba(0, 0, 0, 0.5);
  font-size: 30px;
}
.header-contact-detail {
  display: inline-block;
  padding-left: 10px;
}
.header-contact-detail p.contact-header {
  color: #484848;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 2px;
  text-align: left;
}
.header-contact-detail p.contact-info-header {
  color: #000;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 0;
}
.header-navbar-rht {
  margin: 0;
  margin-left: auto;
  padding: 0;
}
.header-navbar-rht li {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  padding-right: 20px;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.header-navbar-rht li:last-child {
  padding-right: 0px;
}
.header-navbar-rht li .dropdown-menu {
  border: 0;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
}
.header-navbar-rht .dropdown-toggle::after {
  display: none;
}
.header-navbar-rht li .dropdown-menu::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  border: 7px solid #fff;
  border-color: transparent transparent #ffffff #ffffff;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
  box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
}
.header-navbar-rht li .dropdown-menu .dropdown-item {
  border-top: 1px solid #f0f0f0;
  padding: 10px 15px;
}
.header-navbar-rht li .dropdown-menu .dropdown-item:first-child {
  border-top: 0;
  border-radius: 5px 5px 0 0;
}
.header-navbar-rht li .dropdown-menu .dropdown-item:last-child {
  border-radius: 0 0 5px 5px;
}
.header-navbar-rht li a.header-login:hover {
  background-color: #09e5ab;
  border-color: #09e5ab;
  color: #fff;
}
.header-navbar-rht li .dropdown-menu a:hover {
  color: #09dca4;
  letter-spacing: 0.5px;
  padding-left: 20px;
  background-color: #fff;
}
.header-navbar-rht li a.header-login {
  border: 2px solid #09e5ab;
  border-radius: 4px;
  padding: 10px 15px !important;
  text-align: center;
  font-size: 15px;
  color: #09e5ab;
  text-transform: uppercase;
  font-weight: 500;
}
.header .has-arrow .dropdown-toggle:after {
  border-top: 0;
  border-left: 0;
  border-bottom: 2px solid #757575;
  border-right: 2px solid #757575;
  content: "";
  height: 8px;
  display: inline-block;
  pointer-events: none;
  -webkit-transform-origin: 66% 66%;
  -ms-transform-origin: 66% 66%;
  transform-origin: 66% 66%;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  width: 8px;
  vertical-align: 2px;
  margin-left: 10px;
}
.header .has-arrow .dropdown-toggle[aria-expanded="true"]:after {
  -webkit-transform: rotate(-135deg);
  -ms-transform: rotate(-135deg);
  transform: rotate(-135deg);
}
.header-trans.header-five .main-menu-wrapper {
  margin-left: 40px;
}
.blue-font > li > a {
  color: #2a85d1;
  text-transform: uppercase;
}
.header-trans.header-five .header-navbar-rht li a.header-login.white-bg {
  background-color: #fff;
  color: #28daf4;
  border: 1px solid #28daf4;
  font-size: 12px;
}
.user-menu {
  float: right;
  margin: 0;
  position: relative;
  z-index: 99;
}
.user-menu.nav > li > a {
  color: #fff;
  font-size: 14px;
  line-height: 58px;
  padding: 0 15px;
  height: 60px;
}
.user-menu.nav > li > a:hover,
.user-menu.nav > li > a:focus {
  background-color: rgba(0, 0, 0, 0.2);
}
.user-menu.nav > li > a:hover i,
.user-menu.nav > li > a:focus i {
  color: #fff;
}
.user-img {
  display: inline-block;
  position: relative;
}
.header-contact-detail p.contact-info-header.white-font {
  color: #fff;
}
.user-img > img {
  height: 31px;
  object-fit: cover;
  width: 31px;
}
.user-menu.nav > li > a.mobile_btn {
  border: 0;
  position: relative;
  padding: 0;
  margin: 0;
  cursor: pointer;
}
.header-navbar-rht .dropdown-menu {
  min-width: 200px;
  padding: 0;
}
.header-navbar-rht .dropdown-menu .dropdown-item {
  padding: 7px 15px;
}
.header-navbar-rht .dropdown-menu .dropdown-item {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-top: 1px solid #e3e3e3;
  padding: 10px 15px;
}
.header-navbar-rht .dropdown-menu .dropdown-item:hover {
  color: #09dca4;
}
.user-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 10px 15px;
}
.user-header .user-text {
  margin-left: 10px;
}
.user-header .user-text h6 {
  font-size: 15px;
  margin-bottom: 2px;
}
.header-navbar-rht .logged-item .nav-link {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 14px;
  line-height: 85px;
  padding: 0 10px;
}
.view-cart-header a {
  position: relative;
  font-size: 20px;
}
.unread-msg1 {
  background-color: #09e5ab;
  border-radius: 2px;
  color: #272b41;
  font-size: 10px;
  font-style: normal;
  padding: 0 5px;
  position: absolute;
  right: 20px;
  text-align: center;
  top: -10px;
  right: -10px;
}

.header-top {
  display: flex;
  background: #09e5ab;
  color: #fff;
  padding: 8px 30px;
}
.header-top ul {
  display: flex;
  margin: 0;
  list-style: none;
  padding: 0;
}
.header-top ul li {
  padding-right: 25px;
  font-size: 13px;
}
.header-top ul li:last-child {
  padding-right: 0;
}
.header-top .right-top {
  margin-left: auto;
}
.top-icon {
  margin-right: 5px;
}
.search-box-1 {
  background: #09e5ab;
  padding: 40px 20px;
  border-radius: 10px;
  margin-top: -50px;
  position: absolute;
}
.search-box .form-group {
  margin-bottom: 0px;
}
.header-trans {
  /* position: fixed; */
  display: block;
  width: 100%;
  z-index: 9999;
  background: transparent;
}
.header-trans .header-nav {
  background: transparent;
  border-bottom: 1px solid #eef2ff;
}
.header-trans .main-menu-wrapper {
  margin-left: auto;
}
.header-trans .header-contact-img i {
  color: #1c5b90;
  font-size: 14px;
}
.header-trans .header-contact-detail p.contact-info-header {
  color: #1c5b90;
}
.header-trans .header-navbar-rht li a.header-login {
  text-align: center;
  font-size: 13px;
  color: #fff;
  text-transform: uppercase;
  background: #10defd;
  box-shadow: 0px 4px 4px rgb(189 189 189 / 25%);
  border-radius: 47px;
  border: 0;
}
.header-trans .header-navbar-rht li a.header-login.white-bg {
  background-color: #fff;
  color: #2264c5;
}
.header-trans .header-navbar-rht li {
  border-right: 2px solid #fff;
  height: 20px;
  padding-right: 15px;
}
.header-navbar-rht.right-menu li {
  border-right: 0;
}
.right-menu .header-contact-detail p.contact-info-header {
  color: #fff;
}
.right-menu .header-contact-img i {
  width: 30px;
  background-color: #fff;
  height: 30px;
  align-items: center;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  font-size: 11px;
  color: #1860ca;
  border: 2px solid #acc9f5;
}
.right-menu li a.header-login {
  width: 120px;
  padding: 10px !important;
}
.header-trans .header-navbar-rht li:last-child {
  border-right: 0;
  padding-left: 15px;
}
.header-navbar-rht.right-menu li:last-child {
  border-right: 0;
  padding: 0;
}
.header-four .header-nav {
  background-color: #2264c5;
  border: none;
}
.header-four .nav-item {
  line-height: 60px;
  align-items: center;
  display: flex;
}
.header-four .nav-item a.header-login {
  border: 2px solid #fff;
  border-radius: 30px;
  padding: 10px 15px !important;
  text-align: center;
  font-size: 14px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 500;
  line-height: 20px;
}
.header-four .nav-item a.header-login i {
  font-size: 14px;
  margin: 0;
  margin-right: 3px;
}
/*-----------------
	12. Mobile Menu
-----------------------*/

.sidebar-overlay {
  background-color: rgba(0, 0, 0, 0.6);
  display: none;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1040;
}
.menu-opened .main-menu-wrapper {
  transform: translateX(0);
}
.menu-header {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #fff;
  height: 60px;
  padding: 0 20px;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border-bottom: 1px solid #f0f0f0;
  display: none;
}
.menu-logo img {
  height: 40px;
}
.menu-close {
  font-size: 18px;
}
.bar-icon {
  display: inline-block;
  width: 31px;
}
.bar-icon span {
  background-color: #0de0fe;
  display: block;
  float: left;
  height: 3px;
  margin-bottom: 7px;
  width: 31px;
  border-radius: 2px;
}
.bar-icon span:nth-child(2) {
  width: 16px;
}
.bar-icon span:nth-child(3) {
  margin-bottom: 0;
}
#mobile_btn {
  display: none;
  margin-right: 30px;
}
html.menu-opened body {
  overflow: hidden;
}

/*-----------------
	13. Footer
-----------------------*/

.footer {
  background-color: #15558d;
}
.footer .footer-top {
  padding: 40px 0;
}
.footer.custom-footer .footer-top {
  padding: 60px 0;
}
.footer.footer-four .footer-top {
  padding: 50px 0;
}
.footer.footer-five {
  background-color: #1376ca;
}
.footer.footer-five .footer-top {
  background-color: #1376ca;
  padding: 60px 0;
}
.footer.footer-five .footer-bottom .copyright {
  border-top: 1px solid #28daf4;
}
.footer.custom-footer .footer-bottom .copyright {
  border-top: 1px solid #0f4d84;
}
.footer.custom-footer .copyright-text span {
  color: #20c0f3;
}
.footer-title {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 30px;
  text-transform: capitalize;
}
.footer .footer-widget.footer-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
  outline: none;
}
.footer .footer-widget .footer-logo {
  margin-bottom: 30px;
}
.footer .footer-widget .footer-about-content p {
  color: #fff;
}
.footer .footer-widget .footer-about-content p:last-child {
  margin-bottom: 0;
}
.footer .footer-menu ul li {
  margin-bottom: 10px;
  position: relative;
}
.footer .footer-menu ul li:last-child {
  margin-bottom: 0;
}
.footer .footer-menu ul li a {
  color: #fff;
  font-size: 15px;
  padding-left: 20px;
  position: relative;
  transition: all 0.4s ease 0s;
}
.footer .footer-widget.footer-menu ul li a:hover {
  color: #fff;
  letter-spacing: 0.5px;
  padding-left: 30px;
}
.footer .footer-menu ul li a::before {
  content: "\\f101";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  left: 0;
  margin-right: 5px;
  position: absolute;
  top: 0;
}
.footer-contact-info {
  color: #fff;
  font-size: 15px;
}
.footer-contact-info .footer-address {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.footer-contact-info .footer-address span {
  margin-right: 20px;
}
.footer-contact-info .footer-address span i.fa-map-marker-alt {
  font-size: 20px;
}
.footer-contact-info p i {
  margin-right: 15px;
}
.footer .footer-bottom .copyright {
  border-top: 1px solid #1663a6;
  padding: 30px 0;
}
.footer .footer-bottom .copyright-text p {
  color: #fff;
  font-size: 15px;
}
.footer .footer-bottom .copyright-text p a {
  color: #09e5ab;
  -webkit-transition: all 0.4s ease 0s;
  -o-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;
}
.footer .footer-bottom .copyright-text p a:hover {
  color: #fff;
}
.footer .footer-bottom .copyright-text p.title {
  font-weight: 400;
  margin: 10px 0 0;
}
.footer .social-icon ul {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer .social-icon ul li {
  margin-right: 15px;
}
.footer .social-icon ul li:last-child {
  margin-right: 0px;
}
.footer .social-icon ul li a {
  color: #fff;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 20px;
  transition: all 0.4s ease 0s;
}
.footer .social-icon ul li a:hover {
  color: #09e5ab;
}
.policy-menu {
  font-size: 14px;
  margin: 0;
  padding: 0;
  text-align: right;
}
.policy-menu li {
  display: inline-block;
  margin-left: 15px;
}
.policy-menu li:last-child {
  margin-right: 0;
}
.policy-menu li a {
  color: #fff;
}
.policy-menu li a:hover,
.policy-menu li a:focus {
  color: #09e5ab;
}
.policy-menu li::after {
  color: #fff;
  content: "|";
  font-weight: 300;
  position: relative;
  left: 10px;
}
.policy-menu li:last-child::after {
  content: "";
}

.footer.footer-2 .footer-menu ul li a::before {
  display: none;
}
.footer.footer-2 .footer-menu ul li a {
  font-size: 13px;
  padding-left: 0;
}
.footer.footer-2 .footer-widget.footer-menu ul li a:hover {
  letter-spacing: 0;
  padding-left: 0;
}
.footer.footer-2 .footer-title {
  color: #20c0f3;
  font-size: 18px;
  margin-bottom: 10px;
}
.footer.footer-2 .footer-widget .footer-logo {
  margin-bottom: 10px;
}
.footer.footer-2 .footer-widget .footer-logo img {
  width: 120px;
}
.footer.footer-2 .footer-widget .footer-about-content p {
  font-size: 13px;
}
.footer.footer-2 .footer-address p {
  font-size: 13px;
}
.footer.footer-2 .footer-contact-info {
  font-size: 13px;
}
.footer.footer-2 .footer-contact-info .footer-address span i.fa-map-marker-alt {
  font-size: 16px;
}

/*-----------------
	14. Login
-----------------------*/

.account-page {
  background-color: #fff;
}
.account-page .content {
  padding: 50px 0;
}
.login-right {
  background-color: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 25px;
}
.login-header {
  margin-bottom: 20px;
}
.login-header p {
  margin-bottom: 0;
}
.login-header h3 {
  font-size: 18px;
  margin-bottom: 3px;
}
.login-header h3 a {
  color: #0de0fe;
  float: right;
  font-size: 15px;
  margin-top: 2px;
}
.login-right .dont-have {
  color: #3d3d3d;
  margin-top: 20px;
  font-size: 13px;
}
.login-right .dont-have a {
  color: #09dca4;
}
.login-btn {
  font-size: 18px;
  font-weight: 500;
}
.login-or {
  color: #d4d4d4;
  margin-bottom: 20px;
  margin-top: 20px;
  padding-bottom: 10px;
  padding-top: 10px;
  position: relative;
}
.or-line {
  background-color: #e5e5e5;
  height: 1px;
  margin-bottom: 0;
  margin-top: 0;
  display: block;
}
.span-or {
  background-color: #fff;
  display: block;
  left: 50%;
  margin-left: -20px;
  position: absolute;
  text-align: center;
  top: -3px;
  width: 42px;
}
.forgot-link {
  color: #3d3d3d;
  display: inline-block;
  font-size: 13px;
  margin-bottom: 10px;
  font-weight: 400;
}
.btn-facebook {
  background-color: #3a559f;
  color: #fff;
  font-size: 13px;
  padding: 8px 12px;
}
.btn-google {
  background-color: #dd4b39;
  color: #fff;
  font-size: 13px;
  padding: 8px 12px;
}
.social-login .btn:hover,
.social-login .btn:focus {
  color: #fff;
}
.login-page .login-right {
  width: 100%;
  position: relative;
  font-family: "Poppins", sans-serif;
  height: 100vh;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  border: 0;
  padding: 0;
  border-radius: 0;
}
.login-bottom-copyright {
  color: #a4a4a4;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-self: flex-end;
  -webkit-align-self: flex-end;
  padding-bottom: 25px;
  width: 100%;
}
.login-right .inner-right-login {
  max-width: 450px;
  margin: 0 auto;
  width: 100%;
}
.login-header .logo-icon {
  margin: 40px auto 20px;
  text-align: center;
}
.step-list {
  padding: 10px 0;
  text-align: center;
}
.step-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-block;
}
.step-list ul li {
  float: left;
  padding-right: 10px;
  margin: 5px 0l;
}
.step-list ul li:last-child {
  padding-right: 0;
}
.step-list ul li a {
  background-color: #e9f5f7;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  font-size: 14px;
  color: #808080;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.step-list ul li a:hover {
  background-color: #0de0fe;
  color: #fff;
}
.step-list ul li a.active {
  background-color: #0de0fe;
  color: #fff;
}
.step-list ul li a.active-done {
  background-color: #0de0fe;
  color: #fff;
}
.step-list ul li a.active-done {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 18px;
  font-size: 0;
}
.profile-pic-col {
  padding-top: 40px;
  text-align: center;
}
.profile-pic-col h3 {
  color: #000;
  font-size: 20px !important;
}
.profile-pic-upload {
  width: 150px;
  background: rgba(175, 213, 254, 0.4);
  border-radius: 20px;
  padding: 24px;
  margin: 40px auto 0;
  position: relative;
}
.profile-pic-upload input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.profile-pic-upload .cam-col {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 70px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  overflow: hidden;
}
.profile-pic-upload span {
  color: #000;
  font-size: 13px;
  list-style: 18px;
  display: inline-block;
  margin-top: 15px;
}
.select-gender-col [type="radio"]:checked,
.select-gender-col [type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
.select-gender-col [type="radio"]:checked + label,
.select-gender-col [type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #666;
}
.select-gender-col [type="radio"]:checked + label:before,
.select-gender-col [type="radio"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 5px 20px 60px 10px rgba(0, 4, 107, 0.07);
}
.select-gender-col [type="radio"]:checked + label:after,
.select-gender-col [type="radio"]:not(:checked) + label:after {
  content: "";
  width: 100%;
  height: 100%;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 10px;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  border: 2px solid #0de0fe;
}
.select-gender-col [type="radio"]:not(:checked) + label:after {
  opacity: 0;
}
.select-gender-col [type="radio"]:checked + label:after {
  opacity: 1;
}
.select-gender-col .gender-icon {
  position: relative;
}
.select-gender-col label {
  padding: 15px 20px !important;
  text-align: center;
}
.select-gender-col span {
  position: relative;
  color: #000;
  display: inline-block;
  margin-top: 10px;
  font-size: 16px;
  width: 100%;
}
.gender-icon img {
  max-height: 90px;
}
.pregnant-col .remember-me-col {
  color: #000;
  font-size: 16px;
}
.pregnant-col .remember-me-col .custom_check .checkmark {
  border-color: #0de0fe;
}
.step-process-col {
  text-align: left;
}
.login-page .login-right .step-process-col label {
  color: #0de0fe;
}
.login-right
  .step-process-col
  .select2-container--default
  .select2-selection--single
  .select2-selection__rendered {
  color: #808080;
}
.login-right
  .step-process-col
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow
  b {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.login-page .login-right .step-process-col .form-control {
  color: #808080;
}
.checklist-col span {
  font-size: 16px;
}
.checklist-col .custom_check .checkmark {
  width: 24px;
  height: 24px;
}
.checklist-col .custom_check .checkmark:after {
  left: 6px;
  top: 3px;
}
.checklist-col .remember-me-col {
  padding: 10px 0;
  position: relative;
}
.checklist-col.pregnant-col .remember-me-col .custom_check .checkmark {
  border-color: #b4abca;
}
.checklist-col.pregnant-col .remember-me-col .custom_check {
  padding-left: 25px;
}
.otp-col {
  color: #fff;
}
.otp-col h3 {
  color: #fff;
  font-size: 20px;
  margin-bottom: 15px;
}
.dnt-recive-call {
  color: #fff;
}
.dnt-recive-call a {
  color: #fff;
}
.otp-box .digit-group input {
  width: 45px;
  height: 45px;
  background-color: rgba(245, 245, 245, 0.2);
  border: none;
  text-align: center;
  font-size: 16px;
  color: white;
  margin: 0 3px;
  box-shadow: 5px 20px 60px 10px rgba(0, 4, 107, 0.07);
  border-radius: 8px;
  color: #000;
}
.otp-box {
  margin: 25px 0;
}
.otp-box .digit-group input:focus {
  background-color: #fff;
  border: 0;
  outline: 0;
}
.otp-box .splitter {
  padding: 0 5px;
  color: white;
  font-size: 24px;
}
.otp-box .prompt {
  margin-bottom: 20px;
  font-size: 20px;
  color: white;
}
.otp-box input[type="text"].active {
  background-color: #fff;
  color: #000;
}
.increment-decrement .input-groups {
  border: 0;
  background-color: transparent;
  height: 35px;
  margin-right: 0px;
  display: block;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.increment-decrement .input-groups .quantity-field {
  width: 40px;
  text-align: center;
  background-color: transparent;
  float: left;
  border: 0;
}
.increment-decrement .input-groups .quantity-field:focus {
  border: 0;
  outline: 0;
}
.increment-decrement .input-groups input[type="button"] {
  background-color: transparent;
  font-size: 20px;
  border: 1px solid #0de0fe;
  border-radius: 4px;
  height: 24px;
  width: 24px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  margin-top: 0px;
  line-height: 0;
  padding: 0;
  color: #0de0fe;
}
.increment-decrement .input-groups input[type="button"]:focus-visible {
  outline: 0;
}
.increment-decrement .input-groups input[type="button"].button-minus {
  float: left;
}
.increment-decrement .input-groups input[type="button"].button-plus {
  float: right;
}
.country-select {
  position: relative;
}
.country-select .select-col {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
.country-select .select-col .flagstrap {
  height: 100%;
}
.country-select .select-col .btn-info.dropdown-toggle {
  border: 0;
  color: #0de0fe;
  border-radius: 10px 0px 0px 10px;
  background-color: #fff;
  height: 100%;
  font-size: 0;
  width: 79px;
  padding: 0 12px;
  text-align: left;
}
.country-select .select-col .btn-info.dropdown-toggle:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 14px;
  height: 7px;
  border: 0;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.country-select .select-col .dropdown-menu {
  font-size: 0;
  width: 79px;
  min-width: inherit;
  margin-top: 0;
  padding: 0;
  border-radius: 10px;
}
.country-select .select-col .dropdown-menu li {
  margin: 14px 13px;
}
.country-select .select-col .dropdown-menu li:first-child {
  display: none;
}
.country-select .select-col .dropdown-menu li a {
  display: inline-block;
  cursor: pointer;
}
.country-select .select-col .flagstrap-icon.flagstrap-in,
.country-select .select-col .flagstrap-icon.flagstrap-ng,
.country-select .select-col .flagstrap-icon.flagstrap-gb,
.country-select .select-col .flagstrap-icon.flagstrap-us {
  background-position: center;
  width: 33px;
  height: 22px;
  background-size: cover;
  border-radius: 4px;
}
.country-select .select-col .btn-info.dropdown-toggle span {
  font-size: 0;
}
.login-right
  .country-select
  .select-col
  .select2-container--default
  .select2-selection--single {
  background-color: #fff;
  border-radius: 10px 0 0 10px;
  width: 79px;
}
.login-right
  .country-select
  .select-col
  .select2-container--default
  .select2-selection--single
  .select2-selection__rendered {
  color: #0de0fe;
}
.login-right
  .country-select
  .select-col
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow
  b {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.country-select .number-col input {
  padding-left: 96px;
}
.location-text h5 {
  color: #000;
  margin-top: 5px;
}
.location-search {
  margin: 12px 0;
}
.login-page .login-right .search-location-input-box input {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: 10px 50%;
  background-size: 16px;
  padding-left: 38px;
  color: #948ca0;
}
.skip-now-col {
  margin-top: 5px;
}
.skip-now-col a {
  color: #000;
  font-size: 12px;
}
.sort-by-col .select2-container .select2-selection--single {
  border-color: #dcd0ff;
  border-radius: 10px;
  width: 160px;
}
.sort-by-col
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow
  b {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.premium-text {
  font-size: 18px;
}
.plan-details {
  list-style: none;
  padding: 4px 0 0;
  margin: 0;
}
.plan-details li {
  position: relative;
  min-width: 35%;
}
.plan-details li span {
  color: #b4abca;
  display: inline-block;
  margin-bottom: 3px;
  font-size: 15px;
}
.plan-chooser-col {
  background-color: rgba(175, 213, 254, 0.4);
  border-radius: 20px;
  padding: 5px 20px;
  margin-bottom: 28px;
}
.plan-chooser-col .memeber-img {
  border-radius: 15px;
  margin-bottom: 10px;
  width: 100%;
}
.plan-chooser-col .memeber-img img {
  border-radius: 15px;
}
.memeber-details h4 {
  margin-bottom: 0;
}
.payment-menthods ul {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: center;
}
.payment-menthods ul li {
  display: inline-block;
  padding: 6px;
}
.select-gender-col.payment-menthods-choose label {
  min-width: 90px;
  padding: 10px !important;
  text-align: center;
  color: #000;
}
.select-gender-col.payment-menthods-choose label span.credit-card-option {
  min-width: 192px;
  font-size: 15px;
}
.select-gender-col.payment-menthods-choose label img {
  position: relative;
  max-width: 68px;
}
.select-gender-col.payment-menthods-choose
  [type="radio"]:checked
  + label::after,
.select-gender-col.payment-menthods-choose
  [type="radio"]:not(:checked)
  + label::after {
  border: 1px solid #0de0fe;
}
.card-choose-col {
  max-width: 325px;
  margin: 0 auto;
}
.day-week-month-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.day-week-month-col ul li {
  float: left;
}
.day-week-month-col ul li a {
  background-color: #f5faff;
  border: 1px solid transparent;
  color: #64627c;
  display: inline-block;
  padding: 10px 20px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}
.day-week-month-col ul li a.active {
  border-color: #536cf1;
  color: #536cf1;
  border-radius: 0 !important;
}
.day-week-month-col ul li:first-child a {
  border-radius: 4px 0 0 4px !important;
}
.day-week-month-col ul li:last-child a {
  border-radius: 0px 4px 4px 0px !important;
}
.day-week-month-col ul li a:first-child.active,
.day-week-month-col ul li a:last-child.active {
  border-color: #536cf1;
}
.plan-chooser-col .subscription-list {
  margin: 15px 0;
}

/*-----------------
	15. Home
-----------------------*/

.section-search {
  background: #f9f9f9 url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat bottom center;
  min-height: 628px;
  background-size: 100% auto;
  position: relative;
  background-blend-mode: Darken;
  padding: 80px 0;
}
.section-search-1 {
  background: #f9f9f9 url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat bottom center;
  min-height: 550px;
  position: relative;
  background-blend-mode: Darken;
}
.doctor-search-section {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-position: 50% 0;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 1;
}
.section-search-2 {
  background: #4d72d0;
  background-repeat: repeat;
}
.section-header {
  margin-bottom: 60px;
}
.section-header h2 {
  font-size: 36px;
  margin-bottom: 0;
  font-weight: 500;
}
.section-header .sub-title {
  color: #757575;
  font-size: 16px;
  max-width: 600px;
  margin: 15px auto 0;
}
.section-header p {
  color: #757575;
  font-size: 16px;
  margin-bottom: 0;
  margin-top: 15px;
}
.banner-wrapper {
  margin: 0 auto;
  max-width: 750px;
  width: 100%;
}
.banner-wrapper .banner-header {
  margin-bottom: 30px;
}
.banner-wrapper .banner-header h1 {
  margin-bottom: 10px;
  font-size: 40px;
  font-weight: 600;
}
.banner-wrapper .banner-header p {
  color: #757575;
  font-size: 20px;
  margin-bottom: 0;
}
.search-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.search-box .form-control {
  border: 1px solid #ccc;
  box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.075);
  border-radius: 5px;
  padding-left: 35px;
}
.search-box .search-location-home {
  -ms-flex: 0 0 350px;
  flex: 0 0 350px;
  margin-right: 12px;
  position: relative;
  width: 100%;
}
.search-box .search-location {
  -ms-flex: 0 0 295px;
  flex: 0 0 295px;
  margin-right: 12px;
  position: relative;
  width: 295px;
}
.search-location .form-control {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat 10px center;
}
.search-box .search-info {
  -ms-flex: 0 0 400px;
  flex: 0 0 400px;
  margin-right: 12px;
  position: relative;
  width: 400px;
}
.search-info .form-control {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat 10px center;
}
.search-box .search-btn {
  width: 46px;
  -ms-flex: 0 0 46px;
  flex: 0 0 46px;
  height: 46px;
}
.search-box .search-btn span {
  display: none;
  font-weight: 500;
}
.search-box .form-text {
  color: #757575;
  font-size: 13px;
}
.section-specialities {
  background-color: #fff;
  padding: 80px 0;
}
.slick-dots {
  position: absolute;
  bottom: -25px;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
}
.slick-dots li,
.pharmacy-home-slider .swiper-pagination-bullet {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 5px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
  border-radius: 0;
}
.pharmacy-home-slider .swiper-pagination-bullet {
  background: #c0c0c0;
  width: 20px;
  height: 5px;
  opacity: 1;
  transform: scale(1) !important;
  left: 0 !important;
}
.pharmacy-home-slider
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #0de0fe;
  width: 20px;
  height: 5px;
  opacity: 1;
}
.search-img {
  margin-top: 80px;
  margin-bottom: 80px;
}
.banner-wrapper .banner-header {
  margin-bottom: 30px;
}
.banner-wrapper .banner-header h1 {
  margin-bottom: 10px;
  font-size: 40px;
  font-weight: 600;
}
.banner-wrapper .banner-header p {
  color: #757575;
  font-size: 20px;
  margin-bottom: 0;
}
.search-area {
  background: #ffffff6b;
  padding: 60px 30px;
  position: relative;
  z-index: 1;
  border-radius: 10px;
  max-width: 410px;
  margin: auto;
}
.search-doctor {
  margin: auto;
}
.search-area h2 {
  font-size: 1.7rem;
  font-weight: 600;
}
.search-btn {
  width: 100%;
  margin-top: 15px;
}
.search-box-1 .search-btn {
  width: 46px;
  -ms-flex: 0 0 46px;
  flex: 0 0 46px;
  height: 46px;
  background: #fff;
  color: #09e5ab;
}
.search-box-3 {
  background: #1e5c92;
  padding: 40px 20px;
  border-radius: 10px;
  margin-top: -50px;
  position: absolute;
}
.btn-search {
  background: #fff;
  border: 1px solid #fff;
  color: #1e5c92;
}
.search-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.search-box .form-control {
  border: 1px solid #ccc;
  box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.075);
  border-radius: 5px;
  padding-left: 35px;
}
.search-box .search-location {
  -ms-flex: 0 0 295px;
  flex: 0 0 295px;
  margin-right: 12px;
  position: relative;
  width: 295px;
}
.search-location .form-control {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat 10px center;
}
.search-box .search-info {
  -ms-flex: 0 0 390px;
  flex: 0 0 390px;
  margin-right: 12px;
  position: relative;
  width: 390px;
}
.search-info .form-control {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat 10px center;
}
.search-box .search-btn {
  width: 46px;
  -ms-flex: 0 0 46px;
  flex: 0 0 46px;
  height: 46px;
}
.search-box .search-btn span {
  display: none;
  font-weight: 500;
}
.search-box .form-text {
  color: #757575;
  font-size: 13px;
}
.section-specialities {
  background-color: #fff;
  padding: 80px 0;
}
.section-category {
  background-color: #fff;
  padding: 80px 0;
}
.dot-slider .slick-slide {
  height: 600px;
}
.dot-slider .profile-widget {
  padding: 0;
  border: none;
}
.dot-slider .slick-slide img {
  width: 100%;
}
.slick-dots li button {
  font-size: 0;
  line-height: 0;
  display: block;
  width: 20px;
  height: 5px;
  padding: 0;
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: none;
  background: #c0c0c0;
}
.dot-slider .slick-dots {
  position: absolute;
  top: 30%;
  right: 50px;
  bottom: unset;
  width: unset;
}
.dot-slider .slick-dots li {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: flex;
  background-color: #fff;
  align-items: center;
  justify-content: center;
  margin: 8px 0;
}
.dot-slider .slick-dots li button {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #fff;
}
.dot-slider .slick-dots li.slick-active button {
  background-color: #1860ca;
}
.slick-dots li button:hover,
.slick-dots li button:focus {
  outline: none;
}
.slick-dots li button:hover:before,
.slick-dots li button:focus:before {
  opacity: 1;
}
.slick-dots li button:before {
  display: none;
  font-family: "slick";
  font-size: 76px;
  line-height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  content: "-";
  text-align: center;
  opacity: 0.25;
  color: black;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.slick-dots li.slick-active button {
  background-color: #0de0fe;
}
.slick-dots li.slick-active button:before {
  opacity: 1;
  color: #0de0fe;
}
.slick-slide {
  outline: none !important;
}
.specialities-slider .slick-slide {
  display: block;
  padding: 0 12px;
  margin-left: 0;
  margin-right: 20px;
  margin-top: 10px;
}
.specialities-slider .slick-dots {
  margin-top: 44px;
  position: unset;
}
.speicality-img {
  position: relative;
  height: 150px;
  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);
  border-radius: 100%;
  width: 150px;
  background: #fff;
}
.speicality-img img {
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
}
.speicality-img span {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  bottom: 10px;
  right: 10px;
  box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  padding: 5px;
  background-color: #fff;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.speicality-img span i {
  font-size: 15px;
  color: #0de0fe;
}
.speicality-item p {
  font-size: 16px;
  font-weight: 500;
  margin: 30px 0 0;
}
.section-doctor {
  background-color: #f8f9fa;
  padding: 80px 0;
}
.section-doctor .section-header {
  margin-bottom: 30px;
}
.section-doctor .section-header p {
  margin-top: 10px;
}
.doctor-slider .slick-slide {
  display: block;
  margin-left: 0;
  padding: 10px;
  width: 280px;
}
.profile-widget {
  background-color: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  margin-bottom: 30px;
  position: relative;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  padding: 15px;
}
.doc-img {
  position: relative;
  overflow: hidden;
  z-index: 1;
  border-radius: 4px;
}
.doc-img img {
  border-radius: 4px;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  transform: translateZ(0);
  -moz-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -o-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  width: 100%;
}
.doc-img:hover img {
  -webkit-transform: scale(1.15);
  -moz-transform: scale(1.15);
  transform: scale(1.15);
}
.profile-widget .fav-btn {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: #fff;
  width: 30px;
  height: 30px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 3px;
  color: #2e3842;
  -webkit-transform: translate3d(100%, 0, 0);
  -ms-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
  opacity: 0;
  visibility: hidden;
  z-index: 99;
}
.profile-widget:hover .fav-btn {
  opacity: 1;
  visibility: visible;
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.profile-widget .fav-btn:hover {
  background-color: #fb1612;
  color: #fff;
}
.pro-content {
  padding: 15px 0 0;
}
.pro-content .title {
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 5px;
}
.profile-widget .pro-content .title a {
  display: inline-block;
}
.profile-widget .verified {
  color: #28a745;
  margin-left: 3px;
}
.profile-widget p.speciality {
  font-size: 13px;
  color: #757575;
  margin-bottom: 5px;
  min-height: 40px;
}
.rating {
  list-style: none;
  margin: 0 0 7px;
  padding: 0;
  width: 100%;
}
.rating i {
  color: #dedfe0;
}
.rating i.filled {
  color: #f4c150;
}
.profile-widget .rating {
  color: #757575;
  font-size: 14px;
  margin-bottom: 15px;
}
.profile-widget .rating i {
  font-size: 14px;
}
.available-info {
  font-size: 13px;
  color: #757575;
  font-weight: 400;
  list-style: none;
  padding: 0;
  margin-bottom: 15px;
}
.available-info li + li {
  margin-top: 5px;
}
.available-info li i {
  width: 22px;
}
.row.row-sm {
  margin-left: -3px;
  margin-right: -3px;
}
.row.row-sm > div {
  padding-left: 3px;
  padding-right: 3px;
}
.view-btn {
  color: #0de0fe;
  font-size: 13px;
  border: 2px solid #0de0fe;
  text-align: center;
  display: block;
  font-weight: 500;
  padding: 6px;
}
.view-btn:hover,
.view-btn:focus {
  background-color: #0de0fe;
  color: #fff;
}
.book-btn {
  background-color: #0de0fe;
  border: 2px solid #0de0fe;
  color: #fff;
  font-size: 13px;
  text-align: center;
  display: block;
  font-weight: 500;
  padding: 6px;
}
.book-btn:hover,
.book-btn:focus {
  background-color: #01cae4;
  border-color: #01cae4;
  color: #fff;
}
.section-doctor .profile-widget {
  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
}
.about-content p {
  font-size: 14px;
  font-weight: 400;
  line-height: 26px;
  margin: 0;
}
.about-content p + p {
  margin-top: 20px;
}
.about-content a {
  background-color: #0de0fe;
  border-radius: 4px;
  color: #fff;
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  margin-top: 30px;
  min-width: 150px;
  padding: 15px 20px;
  text-align: center;
}
.about-content a:hover,
.about-content a:focus {
  background-color: #01cae4;
  border-color: #01cae4;
  color: #fff;
}
.section-features {
  background-color: #fff;
  padding: 80px 0;
}
.feature-item img {
  border-radius: 100%;
  box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);
  height: 115px;
  object-fit: cover;
  width: 115px;
}
.feature-item p {
  font-weight: 500;
  margin: 20px 0 0;
}
.features-slider .slick-slide {
  margin-right: 62px;
}
.features-slider .slick-center {
  opacity: 1;
  transform: scale(1.2);
}
.features-slider .slick-list {
  padding: 16px 50px !important;
}
.features-slider .slick-dots {
  margin-top: 44px;
  position: unset;
}
.section-blogs {
  background-color: #f8f9fa;
  padding: 80px 0;
}
.view-all .btn {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 600;
  padding: 12px 30px;
}

.full-slide-home {
  background: #e3e3e3;
}
.slide-image {
  width: 100%;
  min-height: 358px;
  display: flex !important;
  justify-content: center;
  flex-direction: column;
  padding: 70px 50px 70px 100px;
  vertical-align: middle;
  background-position: right;
  background-size: contain;
}
.slide-image h2 {
  font-size: 36px;
  font-weight: 500;
}
.slide-ul li:before {
  font-family: "Font Awesome 5 Free";
  display: inline-block;
  padding-right: 6px;
  vertical-align: middle;
  content: "\\f192";
  color: #a2a1a1;
  font-size: 10px;
}
.slide-ul li {
  color: #757575;
  font-size: 13px;
}
.home-tile-section {
  background-color: #f8f9fa;
  padding: 80px 0;
}
.book-btn1 {
  background-color: #0de0fe;
  border: 2px solid #0de0fe;
  color: #fff;
  font-size: 16px;
  text-align: center;
  font-weight: 500;
  padding: 6px 10px;
}
.book-btn1:hover {
  background-color: #01cae4;
  border-color: #01cae4;
  color: #ffffff;
}
.doctor-book-card {
  position: relative;
  max-width: 100%;
  margin: 0 auto;
  box-shadow: 0px 3px 20px #0000000b;
  overflow: hidden;
}
.doctor-book-card img {
  vertical-align: middle;
  border-radius: 0.25rem;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
}
.doctor-book-card:hover img {
  -webkit-transform: scale(1.15);
  -moz-transform: scale(1.15);
  transform: scale(1.15);
}
.doctor-book-card-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  color: #f1f1f1;
  width: 100%;
  padding: 20px;
  height: 100%;
  border-radius: 0.25rem;
}
.doctor-book-card-content > div {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
.doctor-book-card-content .book-btn1 {
  font-size: 14px;
}
.search-box1 form {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
}
.section-search-pharmacy .search-box1 .search-btn {
  margin-top: 0;
}
.search-box1 .form-control {
  border: 1px solid #ccc;
  box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.075);
  border-radius: 5px;
  padding-left: 35px;
}
.search-box1 .search-location {
  -ms-flex: 0 0 240px;
  flex: 0 0 240px;
  margin-right: 12px;
  position: relative;
  width: 240px;
}
.search-box1 .search-location .form-control {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat 10px center;
}
.search-box1 .search-info {
  -ms-flex: 0 0 490px;
  flex: 0 0 490px;
  margin-right: 12px;
  position: relative;
  width: 490px;
}
/*.search-box1 .search-info .form-control {
	background: #fff url() no-repeat 10px center;
}*/
.search-box1 .search-btn {
  width: 46px;
  -ms-flex: 0 0 46px;
  flex: 0 0 46px;
  height: 46px;
}
.search-box1 .search-btn span {
  display: none;
  font-weight: 500;
}
.search-box1 .form-text {
  color: #757575;
  font-size: 13px;
}
.section-search1 {
  background: #f9f9f9 url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat bottom center;
  min-height: 580px;
  background-size: 100% auto;
  position: relative;
  background-blend-mode: Darken;
  padding: 80px 0;
}
.banner-wrapper2 {
  margin: 0 auto;
  max-width: 680px;
  width: 100%;
}
.search-box1 .search-location1 {
  margin-right: 12px;
  position: relative;
  width: 400px;
  margin-bottom: 0;
}
.banner-wrapper2 {
  margin: 0 auto;
  max-width: 680px;
  width: 100%;
}
.search-detect {
  padding: 5px 9px 5px 28px;
  position: absolute;
  top: 8px;
  right: 5px;
  font-size: 13px;
  color: #757575;
  border-radius: 5px;
  background: #e3e3e3 url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat 9px center;
  cursor: pointer;
}
.section-search-pharmacy {
  min-height: inherit !important;
  background: #fff;
  padding: 40px 0;
}
.tile-card-content-1 {
  background: rgb(0, 0, 0);
  background: rgba(13, 13, 13, 0.33);
}
.doctor-book-card h3 {
  text-shadow: 2px 4px 3px rgba(0, 0, 0, 0.3);
  color: #fff;
}
.full-slide-home .slick-prev {
  left: 30px;
}
.full-slide-home .slick-next {
  right: 30px;
}
.full-slide-home .slick-slide > div > .col-12 {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
}

.category-box {
  text-align: center;
  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 30px;
}
.category-box:hover {
  text-align: center;
  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  cursor: pointer;
}
.category-image {
  background: #09e5ab;
  height: 60px;
  margin: auto;
  width: 60px;
  align-items: center;
  padding-top: 7px;
  border-radius: 4px;
}
.category-image img {
  width: 45px;
  height: 45px;
}
.category-content {
  margin-top: 20px;
}
.category-content h4 {
  font-size: 20px;
  font-weight: 500;
  color: #272b41;
}
.banner-header h2 {
  color: #186db5;
  font-size: 32px;
  font-weight: 600;
  line-height: 54px;
}
.doctor-search-form input {
  background: #ffffff;
  border-radius: 130px;
  min-height: 60px;
  border: 0;
}
.doctor-search-form.trans .form-control {
  color: #fff;
}
.doctor-search-form.trans select {
  background: transparent;
  border-radius: 130px;
  min-height: 60px;
}
.doctor-search-form.trans input,
select {
  background-color: transparent;
  border: 2px solid #c2d6f3 !important;
}
.doctor-search-form.trans input::placeholder,
.doctor-search-form.trans select::placeholder {
  color: #fff;
}
.trans .form-custom i {
  color: #fff;
}
.trans .banner-btn {
  background-color: #13a5e5;
}
.no-border {
  border: none !important;
}
.doctor-category {
  position: relative;
  margin-top: -130px;
  z-index: 9;
  padding: 60px 0;
}
.pop-box {
  background-color: #ffffff;
  padding: 15px 15px 0;
  border-radius: 5px;
  box-shadow: 0px 4px 44px rgba(219, 219, 219, 0.25);
}
.pop-box .top-section {
  background-color: #e5f6fd;
  padding: 20px;
  align-items: center;
  justify-content: center;
  display: flex;
  min-height: 150px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.pop-box .top-section i {
  background-color: #fff;
  width: 100px;
  height: 100px;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 50%;
  font-size: 30px;
  color: #20c0f3;
  border: 5px solid #f5f8f9;
}
.pop-box .body-section {
  justify-content: center;
  text-align: center;
  padding: 20px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
}
.pop-box .body-section h3 {
  color: #2467ca;
  font-weight: 600;
  font-size: 24px;
}
.pop-box .body-section p {
  color: #e74e84;
  font-weight: 500;
}
.pop-box .body-section .book-btn {
  width: 150px;
  margin: 0 auto;
  border-radius: 30px;
}
.pop-box .top-section.two {
  background-color: #fff1c9;
}
.pop-box .top-section.two i {
  color: #ffbd07;
}
.pop-box .top-section.three {
  background-color: #ffe0e7;
}
.pop-box .top-section.three i {
  color: #ffaabd;
}
.clinic-specialities {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  padding: 60px 0;
  background-size: cover;
  background-repeat: no-repeat;
}
.section-header-three {
  margin-bottom: 60px;
}

.section-header-three h2 {
  color: #2868c8;
  font-weight: 700;
  font-size: 30px;
  position: relative;
  display: inline-block;
}
.section-header-three h2:before {
  position: absolute;
  content: "";
  width: 13px;
  height: 13px;
  background: #ffd152;
  border-radius: 50%;
  left: -40px;
  box-shadow: 15px 0px 0px -2px #ffd152;
  top: 12px;
}
.section-header-three h2:after {
  position: absolute;
  width: 13px;
  height: 13px;
  content: "";
  background: #ffd152;
  border-radius: 50%;
  top: 12px;
  right: -40px;
  box-shadow: -15px 0px 0px -2px #ffd152;
}
.section-header-three p {
  color: #757575;
  font-size: 16px;
  max-width: 600px;
  margin: 15px auto 0;
}
.clinic-specialities .section-header h2 {
  color: #2868c8;
  font-weight: 700;
  font-size: 30px;
}
.clinic-specialities .section-header h2 img {
  margin: 2px 5px 5px;
}
.special-box {
  background-color: #fff;
  border-radius: 10px;
  height: 160px;
  cursor: pointer;
  margin-bottom: 30px;
  -webkit-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
  transition: ease all 0.4s;
}
.special-box:hover {
  background-color: #1c71ef;
  -webkit-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
  transition: ease all 0.4s;
}
.special-box .special-body {
  padding: 20px;
}
.special-box .special-body img {
  width: 50px;
  margin-bottom: 15px;
}
.special-box .special-body h4 {
  font-size: 16px;
  margin: 0;
  font-weight: 500;
}
.special-box .special-footer {
  border-top: 1px solid #eaeaea;
  padding: 15px;
  width: 100%;
  margin: 0;
}
.special-box .special-footer .doc-count {
  font-size: 14px;
  font-weight: 700;
  color: #e74e84;
}
.special-box .special-footer .doc-count span,
.special-box .special-footer .clin-count span {
  color: #000000;
  font-weight: 500;
}
.special-box .special-footer .clin-count {
  font-size: 14px;
  font-weight: 700;
  color: #1c71ef;
}
.special-box .spc-book {
  background-color: #fff;
  padding: 10px 15px;
  min-width: 120px;
  color: #e74e84;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  display: none;
}
.special-box .spc-book i {
  background-color: #e74e84;
  color: #fff;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  font-size: 9px;
}
.special-box:hover img,
.special-box:hover .special-footer {
  display: none;
}
.special-box:hover h4 {
  color: #fff;
}
.special-box:hover .spc-book {
  margin-top: 10px;
  display: block;
}
.special-box:hover .special-body {
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.view-all-more .btn {
  background: #0ce0ff;
  border-radius: 30px;
  border-color: #0ce0ff;
  padding: 9px 30px;
  margin-top: 20px;
}
.browse-section {
  background-color: #e5f6fd;
  padding: 60px 0;
}
.brower-box {
  text-align: center;
  border-radius: 10px;
  border: 6px solid #fff;
  background-color: #ffffff;
  margin-bottom: 20px;
}
.brower-box > div {
  border-radius: 15px;
  background-color: #e5f6fd;
  height: 100%;
  padding: 15px;
}
.brower-img {
  background-color: #1c71ef;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.brower-img img {
  width: auto;
}
.brower-box h4 {
  font-size: 16px;
  font-weight: 600;
  color: #2264c5;
}
.brower-box p {
  font-size: 14px;
  font-weight: 500;
  color: #e74e84;
  margin: 0;
}
.brower-box p span {
  color: #000;
}
.doc-background {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-position: center;
  min-height: 350px;
  background-size: cover;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
}
.doc-background::before {
  content: "";
  position: absolute;
  background: rgba(61, 59, 59, 0.84);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: -1;
}
.doctor-divison h3 {
  font-size: 28px;
  color: #fff;
  font-weight: 700;
  margin-bottom: 20px;
}
.doctor-divison p {
  font-size: 14px;
  color: #fff;
  font-weight: 600;
  margin-bottom: 30px;
}
.doctor-divison .doc-bok-btn {
  font-size: 14px;
  padding: 6px 12px;
  color: #fff;
  background-color: #1c71ef;
  border-radius: 30px;
  width: 100px;
  text-align: center;
}
.pat-background {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-position: center;
  min-height: 350px;
  background-size: cover;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
}
.pat-background::before {
  content: "";
  position: absolute;
  background: rgba(28, 113, 239, 0.9);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: -1;
}
.pat-background .doc-bok-btn {
  background-color: #fed35d;
}
.book-section {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  padding: 60px 0;
  background-size: cover;
  background-repeat: no-repeat;
}
.book-best-doctors {
  margin-bottom: 30px;
}
.book-best-doctors .book-header img {
  border-radius: 10px 10px 0px 0px;
  width: 100%;
  position: relative;
  display: inline-block;
  z-index: 1;
}
.book-best-doctors .book-header img::before {
  content: "";
  position: absolute;
  background: rgba(61, 59, 59, 0.84);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: -1;
}
.book-best-doctors .book-header .img-overlay {
  position: absolute;
  top: 10px;
  right: 20px;
  background: #e74e84;
  border-radius: 50%;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  width: 25px;
  height: 25px;
  justify-content: center;
  align-items: center;
  display: flex;
}
.book-best-doctors .book-header .img-overlay i {
  font-size: 12px;
}
.doctors-body .inner-section > span {
  color: #e74e84;
  font-size: 14px;
}
.book-best-doctors .doctors-body {
  padding: 0;
  box-shadow: 0px -6px 54px rgba(152, 152, 152, 0.25);
  border-radius: 0;
}
.book-best-doctors .doctors-body .inner-section {
  padding: 15px 15px 0;
}
.book-best-doctors .doctors-body .rating i {
  font-size: 10px;
  color: #dfdfdf;
  margin-bottom: 10px;
}
.book-best-doctors .doctors-body .rating i.filled {
  color: #fed35d;
}
.book-best-doctors .doctors-body .average-ratings {
  background-color: #fed35d;
  font-size: 11px;
  font-weight: 700;
}
.book-best-doctors .doctors-body h4 {
  color: #22396b;
  text-transform: uppercase;
  font-size: 20px;
  margin-bottom: 5px;
}
.book-best-doctors .doctors-body p {
  color: #0098ae;
  font-size: 12px;
  font-weight: 600;
}
.book-best-doctors .loc-details {
  margin: 15px 0 0;
  background-color: #f6faff;
  padding: 15px 10px 0;
}
.book-best-doctors .loc-details .d-flex {
  margin-bottom: 15px;
}
.book-best-doctors .loc-details img {
  color: #22396b;
  width: auto;
  margin-right: 8px;
}
.book-best-doctors .available-info {
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  clear: both;
  display: block;
  margin: 0;
}
.book-best-doctors .data-info {
  font-weight: 700;
  font-size: 11px;
  color: #2264c5;
}
.book-best-doctors .amt-txt {
  color: #e74e84;
  font-size: 18px;
  font-weight: 600;
}
.book-best-doctors .doctors-body .book-btn {
  font-size: 14px;
  padding: 6px 12px;
  color: #fff;
  background-color: #1c71ef;
  border-radius: 30px;
  width: 100px;
  text-align: center;
  float: right;
}
.latest-blog {
  background-color: #f4fcff;
  padding: 60px 0 30px;
}
.latest-blog .blog-wrap {
  margin-bottom: 30px;
  background-color: #fff;
  border-radius: 10px 10px 0px 0px;
}
.latest-blog .blog-wrap img {
  border-radius: 10px;
}
.latest-blog .blog-wrap .blog-wrap-body {
  padding: 20px 15px;
  background-color: #fff;
}
.latest-blog .blog-wrap .blog-wrap-body h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
}
.latest-blog .blog-wrap .blog-wrap-body h3 a:hover {
  color: #2b6ccb;
}
.latest-blog .blog-wrap .blog-wrap-body p {
  font-size: 14px;
  color: #737373;
}
.latest-blog .blog-wrap .blog-wrap-body .blog-footer {
  border-top: 1px solid #1b70ee;
  padding: 15px 0 0;
}
.latest-blog .blog-footer .read-txt,
.latest-blog .blog-footer .cal-txt {
  color: #1b70ee;
  font-size: 14px;
  font-weight: 600;
}
.latest-blog .blog-footer .read-txt i {
  margin: 2px 6px;
  position: absolute;
  top: 3px;
}
.latest-blog .blog-footer .cal-txt i {
  margin: 2px 6px;
}
.clinics-section {
  padding: 60px 0 40px;
  background: #fff;
}
.section-heading h2 {
  font-weight: 700;
  font-size: 26px;
  color: #1c5b90;
}
.section-heading p {
  font-size: 14px;
  color: #757578;
  margin-bottom: 0;
}
.section-heading {
  margin-bottom: 30px;
}
.clinics-card {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}
.clinic-item .clinics-card .clinics-img:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(28, 91, 144, 0.9);
}
.clinics-info {
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
}
.clinics-info img {
  width: 60px !important;
  margin: auto;
  margin-bottom: 10px;
}
.clinics-info span {
  font-weight: 600;
  font-size: 18px;
  color: #fff;
}
.clinics-icon i {
  border-radius: 50%;
  height: 35px;
  width: 35px;
  text-align: center;
  line-height: 35px;
  background: #10defd;
  color: #fff;
  margin: auto;
  display: block;
}
.clinics-icon {
  transform: translate(0, -50%);
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.clinics-img {
  position: relative;
}
.clinic-item:hover .clinics-card .clinics-img:after {
  background: rgba(45, 226, 253, 0.9);
}
.clinic-item:hover .clinics-icon i {
  color: #1c5b90;
  background: #fff;
}
.clinic-item:hover .clinics-icon {
  transform: translate(0, -180%);
}
.specialities-section {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-position: 50% 0;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 1;
}
.specialities-section:after {
  content: "";
  position: absolute;
  background: rgba(25, 69, 107, 0.9);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: -1;
}
.section-heading.bg-area h2 {
  color: #fff;
}
.section-heading.bg-area p {
  color: #fff;
}
.specialist-card {
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(183, 183, 183, 0.25);
  border-radius: 163px;
  align-items: center;
  padding: 15px;
  margin-bottom: 25px;
}
.specialist-card:hover {
  background: #e0f2ff;
}
.specialist-img {
  background: #1b5d92;
  padding: 10px;
  height: 55px;
  width: 55px;
  border-radius: 50%;
  margin-right: 10px;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}

.specialist-card:hover .specialist-img {
  background: #10defd;
}
.specialist-info h4 {
  font-weight: 600;
  color: #274782;
  margin-bottom: 0;
}
.specialist-info p {
  font-weight: 500;
  color: #000000;
  margin-bottom: 0;
}
.specialist-nav i {
  border-radius: 50%;
  height: 35px;
  width: 35px;
  text-align: center;
  line-height: 35px;
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(183, 183, 183, 0.25);
  color: #d84153;
  margin: auto;
  display: block;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.specialist-card:hover .specialist-nav i {
  background: #10defd;
  color: #fff;
}
.specialities-section {
  padding: 80px 0 55px;
}
.our-doctors-card {
  background: rgba(232, 246, 255, 0.4);
  border: 1px solid rgba(231, 237, 255, 0.5);
  border-radius: 10px;
  padding: 10px;
}
.doctors-body .rating {
  font-size: 12px;
}
.doctors-body .rating i.filled {
  color: #1c5b90;
}
.average-ratings {
  background: #1c5b90;
  border-radius: 70px;
  color: #fff;
  padding: 1px 15px;
  margin-left: 10px;
}
.doctors-body h4 {
  color: #1c1c1c;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.doctors-body p {
  color: #204892;
  font-weight: 500;
  margin-bottom: 0;
  font-size: 12px;
}
.doctors-body .location p {
  font-size: 14px;
  color: #000000;
}
.doctors-body .location p i {
  color: #1c5b90;
}
.doctors-body .view-btn {
  background: #e8f6ff;
  border: 1px solid #e8eeff;
  box-sizing: border-box;
  border-radius: 30px;
  color: rgba(41, 68, 129, 0.9);
  padding: 10px 0;
}
.doctors-body .book-btn {
  background: #10defd;
  border-radius: 30px;
  padding: 10px 0;
  border: 0;
}
.doctors-body .book-btn:hover {
  border: 0;
}
.doctors-body {
  background: #ffffff;
  border-radius: 0px 0px 10px 10px;
  padding: 10px;
}
.doctors-body .location {
  padding: 20px 0;
}
.doctors-header img {
  border-radius: 10px 10px 0 0;
}
.our-doctors-section {
  padding: 60px 0;
  background: #fff;
}
.doctors-header {
  position: relative;
}
.doctors-header .img-overlay {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #1b5d92;
  border-radius: 110px;
  padding: 5px 10px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
}
.clinic-features-section {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-position: 50% 0;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 60px 0;
}
.clinic-features {
  position: relative;
}
.clinic-features img {
  border-radius: 10px;
}
.clinic-feature-overlay .img-overlay {
  background: #20c0f3;
  border-radius: 60px;
  padding: 10px 15px;
  text-transform: uppercase;
  color: #e6f4fd;
  font-weight: 600;
  min-width: 150px;
  display: inline-block;
}
.clinic-feature-overlay {
  position: absolute;
  bottom: 20px;
  text-align: center;
  width: 100%;
}
.our-blog-section {
  padding: 60px 0;
  background: #fff;
}
.blogs-info span {
  color: #20c0f3;
}
.blogs-info h4 {
  color: #000000;
  line-height: 28px;
}
.blogs-info p {
  color: #000000;
  font-size: 13px;
}
.blogs-time {
  color: #17418e !important;
}
.blogs-overlay {
  align-items: center;
  background: #ffffff;
  border-radius: 30px 0px 0px 30px;
  position: absolute;
  bottom: 10px;
  right: 0;
  padding: 5px;
}
.blogs-img {
  position: relative;
}
.blogs-overlay img {
  height: 35px;
  width: 35px !important;
  border-radius: 50%;
  margin-right: 10px;
}
.blogs-writter {
  display: none;
}
.our-blogs {
  display: block;
  transition: 0.6s;
  border-radius: 10px 10px 0px 0px;
  overflow: hidden;
}
.our-blogs:hover .blogs-writter {
  display: block;
}
.blogs-info {
  background: #ffffff;
  border: 1px solid #e8eeff;
  padding: 15px;
}
.blogs-btn {
  background: #1c5b90;
  border-radius: 30px;
  color: #fff;
  padding: 8px 10px;
  display: block;
  width: 110px;
  text-align: center;
  font-size: 12px;
}
.blogs-nav {
  border: 1px solid #e8eeff;
  padding: 10px;
  border-top: 0;
}
.form-custom {
  position: relative;
}
.form-custom i {
  position: absolute;
  top: 35%;
  right: 15px;
  color: #dd2d4e;
}
.doctor-search-section {
  padding-top: 95px;
}
.banner-btn {
  background: #1c5b90;
  border-radius: 130px;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  padding: 20px 30px;
  width: 100%;
}
.banner-btn:hover {
  background: #10defd;
  color: #fff;
}
.doctor-search {
  padding-bottom: 15px;
}
.slide-nav-1 button.owl-next,
.slide-nav-1 button.owl-prev,
.slide-nav-2 button.owl-next,
.slide-nav-2 button.owl-prev,
.slide-nav-3 button.owl-next,
.slide-nav-3 button.owl-prev,
.slide-nav-4 button.owl-next,
.slide-nav-4 button.owl-prev {
  width: 34px;
  height: 34px;
  background: #10defd;
  text-shadow: none;
  top: 4px;
  cursor: pointer;
  border: 0;
  color: #ffffff;
  margin-bottom: 15px;
  border-radius: 8px;
  transform: rotate(-44deg);
}

.owl-nav button.owl-next span,
.owl-nav button.owl-prev span {
  font-size: 34px;
  line-height: 25px;
  transform: rotate(44deg);
  display: flex;
  padding-left: 6px;
  padding-bottom: 3px;
}

.owl-nav button.owl-next {
  margin-left: 20px;
}

.owl-theme .owl-dots,
.owl-nav button {
  margin-top: 30px;
}

.owl-theme .owl-dots .owl-dot span {
  width: 28px;
  height: 6px;
  margin: 5px 3px 0;
  background: #f3f3f3;
  display: block;
  -webkit-backface-visibility: visible;
  transition: opacity 0.2s ease;
  border-radius: 30px;
  position: relative;
}

.owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
  background: #00825b;
}
.custom-arrow {
  transform: rotate(44deg);
}
.shapes {
  position: absolute;
  width: 100%;
}
.shape-1 {
  position: absolute;
  top: 0;
  left: 0px;
}
.shape-2 {
  position: absolute;
  top: 0;
  right: 0;
}
.shape-3 {
  position: absolute;
  top: -110px;
  left: 0px;
}
.shape-4 {
  position: absolute;
  top: -110px;
  right: 0;
}
.section-search-3 {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-position: 50% 0;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 1;
  min-height: 550px;
  padding-top: 85px;
}
.section-search-3:after {
  content: "";
  position: absolute;
  background: rgba(24, 96, 202, 0.9);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: -1;
}
.header-banner h2 {
  color: #ffffff;
  font-weight: 600;
  line-height: 40px;
}
.header-banner p {
  font-size: 17px;
  color: #ffffff;
}
.header-highlight {
  font-weight: 700;
  color: #0ce0ff;
}
.section-search-3 .banner-info {
  padding: 130px 0 190px;
}
body .multi-optn {
  background-color: #ffffff;
}
.pharmacy-home-slider .banner-wrapper.doc-form {
  left: 35%;
}
.side-dots .swiper-container {
  position: relative;
  padding: 0 !important;
  height: 500px;
  min-height: inherit;
}
.doc-form {
  position: absolute;
  top: 155px;
  padding: 50px 0;
}
.side-dots img {
  width: 100%;
}
.app-form {
  position: relative;
  padding: 30px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.87);
}
.app-form h2 {
  color: #e74e84;
  font-size: 34px;
  margin-bottom: 30px;
}
.app-form h2 .header-highlight {
  color: #1860ca;
  font-weight: 600;
}
.app-form .doctor-search-form input {
  border-radius: 20px;
}
.app-form .form-custom i {
  color: #0ce0ff;
}
.app-form .banner-btn {
  background-color: #0ce0ff;
  padding: 18px 30px;
  border-radius: 20px;
}
.category-sec {
  margin-top: -30px;
  padding: 0 0 50px 0;
}
.set-category {
  background-color: #1860ca;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 15px;
  border-radius: 20px;
  min-height: 200px;
}
.set-category .img-holder {
  margin-right: 20px;
}
.set-category .img-holder a {
  width: 60px;
  height: 60px;
  display: flex;
  background-color: #fff;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
}
.set-category .img-holder a img {
  width: 30px;
}
.set-category .info-holder h3 {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
}
.set-category .info-holder p {
  font-size: 14px;
  color: #fff;
  margin-bottom: 30px;
}
.set-category .info-holder .book-now {
  color: #fff;
}
.set-category .info-holder .book-now i {
  margin: 4px 6px;
  position: absolute;
}
.set-category h2 {
  font-size: 60px;
  position: absolute;
  font-weight: 700;
  bottom: -13px;
  right: 25px;
  color: #fff;
  opacity: 0.1;
  margin: 0;
}
.set-category.light {
  background-color: #0ce0ff;
}
.set-category.lighter {
  background-color: #00bcd1;
}
.clinic-section {
  padding: 50px 0 20px;
}
.sec-header {
  margin-bottom: 40px;
  text-align: center;
}
.sec-header h2 {
  font-size: 30px;
  margin-bottom: 0;
  font-weight: 700;
  color: #22396b;
}
.sec-header .bottom-border {
  border-top: 3px solid #e74e84;
  width: 75px;
  margin: 0 auto;
  margin-top: 20px;
  position: relative;
  display: inline-block;
  border-radius: 150px;
}
.sec-header .bottom-border:after {
  content: "";
  position: absolute;
  width: 6px;
  background: #fff;
  right: 4px;
  height: 3px;
  z-index: 9;
  top: -3px;
}
.clinic-slider .slick-list,
.browse-slider .slick-list,
.book-slider .slick-list {
  padding-top: 50px;
}
.clinic-slider .slick-prev,
.clinic-slider .slick-next,
.browse-slider .slick-prev,
.browse-slider .slick-next,
.book-slider .slick-prev,
.book-slider .slick-next {
  width: 35px;
  height: 35px;
  border-radius: 5px 12px 5px 12px;
  background-color: #e74e84;
  transform: translateX(0%) rotate(-45deg);
  -webkit-transform: translateX(0%) rotate(-45deg);
  -ms-transform: translateX(0%) rotate(-45deg);
  z-index: 999;
}
.clinic-slider .slick-prev:before,
.browse-slider .slick-prev:before,
.book-slider .slick-prev:before {
  content: "";
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}
.clinic-slider .slick-next:before,
.browse-slider .slick-next:before,
.book-slider .slick-next:before {
  content: "";
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
}
.clinic-slider .slick-prev:before,
.clinic-slider .slick-next:before,
.browse-slider .slick-prev:before,
.browse-slider .slick-next:before,
.book-slider .slick-prev:before,
.book-slider .slick-next:before {
  font-family: "slick";
  font-size: 10px;
  line-height: 1;
  opacity: 0.75;
  color: #ffffff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: solid #ffffff;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}
.clinic-slider .slick-prev,
.browse-slider .slick-prev,
.book-slider .slick-prev {
  right: 80px;
  left: unset;
  top: 0;
}
.clinic-slider .slick-next,
.browse-slider .slick-next,
.book-slider .slick-next {
  right: 15px;
  left: unset;
  top: 0;
}
.clinic-slider .slick-slide,
.browse-slider .slick-slide,
.book-slider .slick-slide {
  display: block;
  margin-left: 0;
  padding: 10px;
  width: 280px;
  padding-bottom: 0;
}
.clinic-slider .profile-widget,
.browse-slider .browse-widget,
.book-slider .profile-widget {
  padding: 0;
  border: none;
  background-color: transparent;
  border-radius: 0;
}
.clinic-slider .brower-box {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-sizing: border-box;
  box-shadow: 0px 4px 44px rgba(238, 238, 238, 0.25);
  border-radius: 10px;
  padding: 30px;
  margin: 0;
  transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
}
.clinic-slider .brower-box:hover {
  background-color: #1860ca;
  transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
}
.clinic-slider .brower-box a {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 85px;
  width: 85px;
  background-color: #1860ca;
  border-radius: 50% 50% 50% 50% / 60% 60% 35% 35%;
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
  margin: 0 auto;
  margin-bottom: 15px;
}
.clinic-slider .brower-box img {
  width: 70px;
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.clinic-slider .brower-box h4 {
  color: #000;
  font-size: 20px;
  margin-bottom: 13px;
}
.clinic-slider .brower-box p {
  margin-bottom: 20px;
}
.clinic-slider .brower-box .arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0ce0ff;
  width: 35px;
  height: 35px;
  margin: 0 auto;
  border-radius: 50%;
  transform: unset;
}
.clinic-slider .brower-box .img-fluid.hover {
  display: none;
}
.clinic-slider .brower-box .arrow i {
  color: #fff;
}
.clinic-slider .brower-box:hover a {
  background-color: #fff;
}
.clinic-slider .brower-box:hover .img-fluid.hover {
  display: block;
}
.clinic-slider .brower-box:hover .img-fluid {
  display: none;
}
.clinic-slider .brower-box:hover a.arrow {
  background-color: #2868c8;
}
.clinic-slider .brower-box:hover h4,
.clinic-slider .brower-box:hover p,
.clinic-slider .brower-box:hover p span {
  color: #fff;
}
.browse-speciality {
  padding: 50px 0 35px;
  background-color: #f8fbff;
}
.browse-widget {
  padding: 0;
}
.browse-widget > img {
  border-radius: 10px;
  width: 100%;
}
.browse-widget .overlay {
  position: absolute;
  top: 0;
  background-color: rgba(34, 100, 197, 0.8);
  width: 100%;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.browse-widget:hover .overlay {
  background-color: rgba(36, 36, 36, 0.5);
}
.browse-widget .overlay h3 {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}
.browse-widget .overlay .arrows {
  position: absolute;
  bottom: -15px;
  background-color: #0ce0ff;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.browse-widget .overlay .arrows i {
  color: #fff;
}
.browse-widget:hover .arrows {
  transform: translate(0, -320%);
  background-color: #ffffff;
}
.browse-widget:hover .arrows i {
  color: #1c5b90;
}
.patient-select {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  padding: 50px 0;
  background-size: cover;
}
.select-box {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  padding: 30px;
  border-radius: 60px 10px 10px 60px;
  border: 5px solid rgba(255, 255, 255, 0.8);
  position: relative;
  z-index: 1;
}
.select-box::before {
  content: "";
  position: absolute;
  background: rgba(16, 222, 253, 0.6);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: -1;
  border-radius: 55px 5px 5px 55px;
}
.select-box h2 {
  font-size: 30px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
}
.select-box .image-holder {
  margin-right: 20px;
}
.select-box .image-holder span {
  background-color: #fff;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 6px solid rgb(210 237 246);
}
.select-box .image-holder span img {
  width: 55px;
}
.select-box p {
  font-size: 15px;
  color: #fff;
  margin-bottom: 30px;
}
.select-box .book-now {
  background-color: #1c71ef;
  padding: 6px 20px;
  color: #fff;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  display: block;
  width: 150px;
}
.select-box.theme {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  border-radius: 10px 60px 60px 10px;
}
.select-box.theme::before {
  content: "";
  position: absolute;
  background: rgba(28, 113, 239, 0.6);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: -1;
  border-radius: 5px 55px 55px 5px;
}
.select-box.theme .image-holder span {
  border: 6px solid rgb(217 225 240);
}
.select-box.theme .book-now {
  background-color: #20d7f2;
}
.book-doctor {
  padding: 50px 0;
}
.book-slider .profile-widget {
  padding: 0;
  border: none;
  margin-bottom: 70px;
}
.book-slider .profile-widget a {
  border-radius: 10px 10px 0px 0px;
}
.book-slider .profile-widget a img {
  width: 100%;
  border-radius: 10px 10px 0px 0px;
}
.book-slider .pro-content {
  padding: 0;
  position: absolute;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  padding: 10px;
  border-radius: 10px 10px 0px 0px;
}
.book-slider .pro-content .amt {
  background-color: #e74e84;
  padding: 3px 8px;
  border-radius: 30px;
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  opacity: 0;
  transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
}
.book-slider .pro-content .star {
  background-color: #2264c5;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: absolute;
  right: 0;
  color: #fff;
  font-size: 12px;
}
.book-slider .profile-widget:hover .amt {
  opacity: 1;
}
.book-slider .provider-info h3 a {
  font-size: 22px;
  font-weight: 700;
  color: #22396b;
}
.book-slider .profile-widget .provider-info {
  background-color: #fff;
  padding: 15px;
  border-radius: 10px;
  position: absolute;
  bottom: -40px;
  width: 100%;
  left: 0;
  transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
}
.book-slider .profile-widget:hover .provider-info {
  transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
}
.book-slider .provider-info h5 {
  color: #e74e84;
  font-size: 15px;
  font-weight: 600;
  float: left;
}
.book-slider .provider-info .side-arrow {
  position: absolute;
  width: 40px;
  height: 40px;
  background-color: #2868c8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 15px;
  right: 15px;
  color: #fff;
}
.book-slider .provider-info .rating {
  display: none;
  font-size: 12px;
  width: auto;
  text-align: right;
}
.book-slider .provider-info .rating i {
  font-size: 10px;
  color: #dfdfdf;
}
.book-slider .provider-info .rating i.filled {
  color: #fed35d;
}
.book-slider .provider-info .rating span {
  padding: 0 8px;
  background-color: #fed35d;
  border-radius: 30px;
  font-size: 10px;
  color: #fff;
  font-weight: 700;
  margin-left: 5px;
}
.book-slider .profile-widget .content-info {
  display: none;
  padding: 0;
}
.book-slider .profile-widget:hover .side-arrow {
  display: none;
}
.book-slider .profile-widget:hover .rating,
.book-slider .profile-widget:hover .content-info {
  display: block;
}
.book-slider .available-info li i {
  font-size: 14px;
  color: #1c5b90;
}
.book-slider .available-info li {
  font-size: 14px;
  font-weight: 500;
  color: #000;
}
.book-slider .content-info .view-btn,
.book-slider .content-info .view-btn:hover {
  background-color: #216ee1;
  border: 1px solid #216ee1;
  border-radius: 30px;
  padding: 7px;
  border: none;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
}
.book-slider .content-info .book-btn,
.book-slider .content-info .book-btn:hover {
  background-color: #10defd;
  border: 1px solid #10defd;
  border-radius: 30px;
  padding: 7px;
  border: none;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
}
.book-doctor .view-btn {
  background-color: #20c0f3;
  font-size: 16px;
  color: #ffffff;
  font-weight: 700;
  border-radius: 30px;
  border: 1px solid #20c0f3;
  padding: 6px 20px;
}
.aval-features {
  background-color: #2467ca;
}
.aval-features .feature {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  padding: 40px;
  background-repeat: no-repeat;
  background-size: cover;
}
.aval-features .feature .info-box {
  background: rgba(24, 96, 202, 0.8);
  padding: 40px;
}
.aval-features .feature .info-box h2 {
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
}
.aval-features .feature .info-box p {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 20px;
}
.aval-features .feature .info-box a {
  background: #10defd;
  border-radius: 30px;
  width: 120px;
  color: #fff;
  padding: 6px;
}
.aval-features .aval-widget .features-img {
  width: 150px;
  height: 150px;
  border-radius: 80px 60px 50px 50px;
  margin: 0 auto;
}
.aval-features .aval-widget .features-img img {
  border-radius: 80px 60px 50px 50px;
  width: 100%;
  border: 4px solid #ffffff;
}
.aval-features .aval-widget .features-img p {
  background: #20c0f3;
  border-radius: 30px;
  color: #fff;
  text-align: center;
  padding: 6px;
  margin: 20px 0 0;
}
.aval-slider .slick-slide {
  display: block;
  margin-left: 0;
  padding: 10px;
  width: 280px;
}
.aval-slider .aval-widget {
  margin-bottom: 30px;
  position: relative;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.aval-slider .slick-list {
  padding: 50px 0;
}
.aval-slider .slick-prev,
.aval-slider .slick-next {
  width: 35px;
  height: 35px;
}
.aval-slider .slick-prev {
  left: 5px;
}
.aval-slider .slick-prev:hover,
.aval-slider .slick-prev:focus,
.aval-slider .slick-next:hover,
.aval-slider .slick-next:focus {
  background-color: #fff;
}
.aval-slider .slick-next {
  right: 5px;
}
.aval-slider .slick-prev:before {
  font-family: "slick";
  font-size: 10px;
  line-height: 1;
  opacity: 0.75;
  color: #1860ca;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: solid #1860ca;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  content: "";
  transform: rotate(140deg);
  -webkit-transform: rotate(140deg);
}
.aval-slider .slick-next:before {
  font-family: "slick";
  font-size: 10px;
  line-height: 1;
  opacity: 0.75;
  color: #1860ca;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: solid #1860ca;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  content: "";
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}
.home-search-section {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 1;
}
.home-search-section .wrapper-content {
  padding: 90px 0 0;
}
.doctor-search-form select {
  background: #ffffff;
  border-radius: 130px;
  min-height: 60px;
  border: none !important;
}
.doctor-search-form select,
.doctor-search-form input {
  border: 1px solid rgba(16, 222, 253, 0.1);
  box-shadow: 0px 4px 4px rgba(237, 237, 237, 0.25);
  border-radius: 5px;
}
.home-search-section .banner-header h2 {
  color: #28daf4;
  font-weight: 500;
  margin-bottom: 30px;
  font-size: 38px;
}
.home-search-section .banner-header h2 .highlighter {
  font-weight: 600;
}
.home-search-section .doctor-form .banner-btn {
  background: #e74e84;
  border: 1px solid #e74e84;
  box-shadow: 10px 4px 14px rgba(247, 247, 247, 0.25);
  border-radius: 5px;
}
.facility-section {
  background-color: #f3f8ff;
  padding: 60px 0;
}
.facility-section .visit-doctor {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 30px;
}
.facility-section .visit-doctor .inner-details {
  position: relative;
  display: flex;
  align-items: center;
}
.facility-section .visit-doctor .inner-details img {
  position: absolute;
  bottom: -20px;
  right: 0;
  width: 50px;
}
.visit-doctor .inner-details .count h2 {
  font-weight: 700;
  font-size: 24px;
  color: #1860ca;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  border: 5px solid #f7faff;
  justify-content: center;
  align-items: center;
  display: flex;
  margin-right: 20px;
}
.visit-doctor .inner-details .info h2 {
  font-weight: 700;
  font-size: 24px;
  color: #1860ca;
}
.visit-doctor .inner-details .info p {
  color: #9d9d9d;
  font-size: 14px;
  max-width: 280px;
}
.visit-doctor .inner-details .info a {
  font-size: 14px;
  font-weight: 600;
  color: #1860ca;
}
.visit-doctor .inner-details .info a i {
  margin: 5px 6px;
  position: absolute;
}
.visit-doctor .inner-details.pharmacy .count h2,
.visit-doctor .inner-details.pharmacy .info h2,
.visit-doctor .inner-details.pharmacy .info a,
.visit-doctor .inner-details.pharmacy .info a i {
  color: #0ce0ff;
}
.visit-doctor .inner-details.lab .count h2,
.visit-doctor .inner-details.lab .info h2,
.visit-doctor .inner-details.lab .info a,
.visit-doctor .inner-details.lab .info a i {
  color: #00bcd1;
}
.clinic-speciality {
  background-color: #fff;
  padding: 60px 0;
}
.heading-wrapper {
  margin-bottom: 40px;
  align-items: center;
}
.heading-wrapper h1 {
  max-width: 250px;
  font-weight: 700;
  font-size: 38px;
  color: #6c6c6c;
}
.heading-wrapper .nav-arrow {
  width: 40px;
  height: 40px;
  background-color: #f3f8ff;
  border: 3px solid #1860ca;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #2264c5;
}
.clinic-wrap {
  position: relative;
  overflow: hidden;
  display: block;
  width: 100%;
  margin-bottom: 30px;
  border-radius: 10px;
  height: 250px;
}
.clinic-wrap:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: rgb(222 235 255 / 28%);
  border-radius: 5px;
}
.clinic-wrap .wrapper-overlay {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 20px;
}
.clinic-wrap .wrapper-overlay img {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 5px solid #f7faff;
  border-radius: 50%;
  margin-bottom: 30px;
}
.clinic-wrap .wrapper-overlay h3 {
  font-size: 22px;
  color: #e74e84;
  font-weight: 700;
  margin-bottom: 30px;
}
.clinic-wrap .wrapper-overlay .row.row-sm {
  position: absolute;
  width: 100%;
  bottom: 0;
}
.clinic-wrap .wrapper-overlay p {
  font-weight: 700;
  color: #e74e84;
  font-size: 14px;
}
.clinic-wrap .wrapper-overlay p.blue {
  color: rgba(24, 96, 202, 0.9);
}
.clinic-wrap .wrapper-overlay p span {
  font-weight: 500;
  color: #000;
}
.browse-section.brower-category {
  padding: 60px 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.browse-section.brower-category .heading-wrapper h1 {
  color: #e5f6fd;
}
.browse-section.brower-category .brower-box > div {
  background-color: #f2f7ff;
  border-radius: 20px 20px 0px 0px;
}
.browse-section.brower-category .brower-img {
  background-color: #28daf4;
  margin-bottom: 40px;
}
.browse-section.brower-category .brower-box h4 {
  color: #28daf4;
}
.doctor-divison.provider-select .doc-background {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-size: cover;
  padding: 60px 30px;
}
.doctor-divison.provider-select .doc-background::before {
  background: rgba(242, 247, 255, 0.94);
}
.doctor-divison.provider-select .pat-background {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-size: cover;
  padding: 60px 30px;
}
.doctor-divison.provider-select .pat-background::before {
  background: rgba(40, 218, 244, 0.9);
}
.doctor-divison.provider-select .doc-background h3 {
  color: #2357a6;
}
.doctor-divison.provider-select .doc-background p {
  color: #4b4b4b;
}
.doctor-divison.provider-select .pat-background a {
  background-color: #0ce0ff;
}
.doc-booking {
  padding: 60px 0;
  background-color: #f3f8ff;
}
.doc-booking .book-slider .slick-prev,
.doc-booking .book-slider .slick-next {
  border: 3px solid #1860ca;
  background-color: #f3f8ff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  transform: none;
  top: -110px;
  box-shadow: none;
}
.doc-booking .book-slider .slick-prev:before {
  transform: rotate(140deg);
  -webkit-transform: rotate(140deg);
}
.doc-booking .book-slider .slick-next:before {
  transform: rotate(320deg);
  -webkit-transform: rotate(320deg);
}
.doc-booking .book-slider .slick-prev:before,
.doc-booking .book-slider .slick-next:before {
  font-family: "slick";
  font-size: 10px;
  line-height: 1;
  opacity: 0.75;
  color: #ffffff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: solid #1860ca;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}
.doc-booking .book-slider .slick-list {
  padding-top: 0;
}
.doc-booking .book-slider .pro-content .amt {
  opacity: 1;
  position: absolute;
  left: -7px;
  padding: 6px 12px;
  border-radius: 0px 100px 100px 0px;
  background-color: #28daf4;
}
.doc-booking .book-slider .profile-widget .content-info,
.doc-booking .book-slider .provider-info .rating {
  display: block;
  text-align: left;
}
.doc-booking .book-slider .profile-widget a img,
.doc-booking .book-slider .pro-content {
  border-radius: 10px;
}
.doc-booking .book-slider .profile-widget .provider-info {
  bottom: 0;
  background-color: #1376ca;
  border-radius: 0 0 10px 10px;
}
.doc-booking .book-slider .profile-widget .provider-info h3 a {
  color: #28daf4;
}
.doc-booking .book-slider .profile-widget {
  margin-bottom: 0;
}
.doc-booking .book-slider .provider-info h5 {
  color: #fff;
  float: unset;
}
.doc-booking .book-slider .profile-widget a.book-btn {
  border-radius: 30px;
  background-color: transparent;
  width: 100px;
}
/*-----------------
	16. Search
-----------------------*/

.breadcrumb-bar {
  background-color: #15558d;
  padding: 15px 0;
}
.breadcrumb-bar .breadcrumb-title {
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  margin: 5px 0 0;
}
.page-breadcrumb ol {
  background-color: transparent;
  font-size: 12px;
  margin-bottom: 0;
  padding: 0;
}
.page-breadcrumb ol li a {
  color: #fff;
}
.page-breadcrumb ol li.active {
  color: #fff;
}
.page-breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  color: #fff;
  font-size: 10px;
}
.sort-by {
  float: right;
}
.sort-title {
  color: #fff;
  font-size: 14px;
  margin-right: 10px;
}
.custom-short-by .sort-title {
  color: #2e3842;
}
.custom-short-by > div {
  margin-right: 20px;
}
.custom-short-by > div:first-child {
  margin-right: 0;
}
.sortby-fliter {
  display: inline-block;
  width: 120px;
}
.cal-icon {
  position: relative;
  width: 100%;
}
.cal-icon:after {
  color: #979797;
  content: "\\f073";
  display: block;
  font-family: "Font Awesome 5 Free";
  font-size: 16px;
  font-weight: 400;
  margin: auto;
  position: absolute;
  right: 15px;
  top: 10px;
}
.custom_check {
  color: #666;
  display: inline-block;
  position: relative;
  font-size: 14px;
  font-size: 0.9375rem;
  padding-left: 30px;
  margin-bottom: 10px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.custom_check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.custom_check input:checked ~ .checkmark {
  background-color: #fff;
}
.custom_check .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border: 1px solid #dcdcdc;
  background-color: #fff;
  border-radius: 3px;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.custom_check .checkmark::after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  position: absolute;
  display: none;
  left: 4px;
  top: 0;
  color: #0de0fe;
  font-size: 11px;
}
.custom_check input:checked ~ .checkmark:after {
  display: block;
}
.custom_radio {
  color: #555;
  display: inline-block;
  position: relative;
  font-size: 14px;
  font-size: 0.9375rem;
  padding-left: 30px;
  margin-bottom: 10px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.radio_input .custom_radio + .custom_radio {
  margin-left: 15px;
}
.custom_radio input {
  position: absolute;
  opacity: 0;
}
.custom_radio input:checked ~ .checkmark:after {
  opacity: 1;
}
.custom_radio .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
}
.custom_radio .checkmark:after {
  display: block;
  content: "";
  position: absolute;
  opacity: 0;
  top: 3px;
  left: 3px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ff9b44;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.filter-widget {
  margin-bottom: 20px;
}
.filter-widget h4 {
  font-size: 1rem;
  margin-bottom: 15px;
}
.filter-widget .custom_check {
  line-height: 18px;
}
.btn-search .btn {
  background-color: #0de0fe;
  border: 1px solid #0de0fe;
  color: #fff;
  height: 46px;
  font-weight: 500;
  font-size: 16px;
}
.doctor-widget {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.doc-info-left {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.doc-info-right {
  margin-left: auto;
  -ms-flex: 0 0 205px;
  flex: 0 0 205px;
  max-width: 205px;
}
.doctor-img {
  -ms-flex: 0 0 150px;
  flex: 0 0 150px;
  margin-right: 20px;
  width: 150px;
}
.doctor-img img {
  border-radius: 5px;
}
.doc-department {
  color: #20c0f3;
  font-size: 14px;
  margin-bottom: 8px;
}
.doc-department img {
  width: 19px;
  display: inline-block;
  margin-right: 10px;
}
.doc-location {
  color: #757575;
  font-size: 14px;
  margin-bottom: 25px;
}
.pharmacy-location,
.pharmacy-title {
  color: #2e3842;
}
.doc-location a {
  color: #09e5ab;
  font-weight: 500;
}
.doctor-widget .doc-name {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 3px;
}
.doc-speciality {
  font-size: 14px;
  color: #757575;
  margin-bottom: 15px;
}
.doctor-widget .rating i {
  font-size: 14px;
}
.doctor-widget .average-rating {
  font-size: 14px;
  font-weight: 500;
}
.clinic-details {
  margin-bottom: 15px;
}
.clinic-details h5 {
  font-weight: normal;
  color: #757575;
  margin-bottom: 25px;
}
.clinic-details ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.clinic-details ul li {
  display: inline-block;
  padding-right: 5px;
}
.clinic-details ul li:last-child {
  padding-right: 0;
}
.clinic-details ul li a {
  display: inline-block;
}
.clinic-details ul li a img {
  border-radius: 5px;
  width: 40px;
}
.clinic-services {
  color: #272b41;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 13px;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.clinic-services span {
  border: 1px solid #ccc;
  border-radius: 4px;
  display: inline-block;
  font-size: 12px;
  padding: 3px 10px;
}
.clinic-services span + span {
  margin-left: 5px;
}
.clini-infos {
  margin-bottom: 15px;
}
.clini-infos h2 b.strike {
  text-decoration: line-through;
  font-weight: 500;
}
.clini-infos ul {
  font-size: 14px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.clini-infos ul li {
  display: block;
  line-height: 30px;
  color: #4e4852;
}
.clini-infos ul li i {
  font-size: 15px;
  min-width: 30px;
}
.clinic-booking a + a {
  margin-top: 15px;
}
.clinic-booking a {
  background-color: #fff;
  border: 2px solid #20c0f3;
  border-radius: 4px;
  color: #20c0f3;
  display: block;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  padding: 10px 20px;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
}
.clinic-booking a.view-pro-btn:hover,
.clinic-booking a.view-pro-btn:focus {
  background: #20c0f3;
  color: #fff;
}
.clinic-booking a.apt-btn {
  background-color: #20c0f3;
  color: #fff;
}
.clinic-booking a.apt-btn:hover,
.clinic-booking a.apt-btn:focus {
  background-color: #0db9f2;
  border-color: #0db9f2;
  color: #fff;
}
.load-more {
  margin-bottom: 30px;
}
.doctor-img1 {
  margin-right: 20px;
}
.doctor-img1 img {
  border-radius: 4px;
}

/*-----------------
	17. Doctor Profile
-----------------------*/

.clinic-direction {
  color: #757575;
  font-size: 14px;
  margin-bottom: 25px;
}
.clinic-direction a {
  color: #09e5ab;
  font-weight: 500;
}
.doctor-action {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 15px;
}
.doctor-action a + a {
  margin-left: 8px;
}
.doctor-action .fav-btn:hover {
  background-color: #fb1612;
  border-color: #fb1612;
  color: #fff;
}
.msg-btn:hover,
.msg-btn:focus {
  background-color: #09e5ab;
  border-color: #09e5ab;
  color: #fff;
}
.call-btn:hover,
.call-btn:focus {
  background-color: #09e5ab;
  border-color: #09e5ab;
  color: #fff;
}
.user-tabs .nav-tabs > li > a {
  border: 0;
  border-bottom: 3px solid transparent;
  color: #3e3e3e;
  font-weight: 600;
  padding: 20px;
}
.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active,
.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:hover,
.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:focus {
  border-bottom-width: 3px;
  color: #20c0f3;
}
.user-tabs .med-records {
  display: inline-block;
  min-width: 130px;
}
.user-tabs .nav-tabs > li > a:hover {
  background-color: unset;
  color: #20c0f3;
}
.widget {
  margin-bottom: 30px;
}
.widget-title {
  margin-bottom: 15px;
}
.experience-box {
  position: relative;
}
.experience-list {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
}
.experience-list::before {
  background: #ddd;
  bottom: 0;
  content: "";
  left: 8px;
  position: absolute;
  top: 8px;
  width: 2px;
}
.experience-list > li {
  position: relative;
}
.experience-list > li:last-child .experience-content {
  margin-bottom: 0;
}
.experience-user .avatar {
  height: 32px;
  line-height: 32px;
  margin: 0;
  width: 32px;
}
.experience-list > li .experience-user {
  background: #fff;
  height: 10px;
  left: 4px;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 4px;
  width: 10px;
}
.experience-list > li .experience-content {
  background-color: #fff;
  margin: 0 0 20px 40px;
  padding: 0;
  position: relative;
}
.experience-list > li .experience-content .timeline-content {
  color: #757575;
}
.experience-list > li .experience-content .timeline-content a.name {
  font-weight: 500;
}
.experience-list > li .time {
  color: #757575;
  display: block;
  font-size: 13px;
}
.before-circle {
  background-color: rgba(32, 192, 243, 0.2);
  border-radius: 50%;
  height: 12px;
  width: 12px;
  border: 2px solid #20c0f3;
}
.exp-year {
  color: #20c0f3;
  margin-bottom: 2px;
}
.exp-title {
  font-size: 16px;
}
.awards-widget .experience-list > li:last-child p {
  margin-bottom: 0;
}
.service-list {
  margin-bottom: 30px;
}
.service-list:last-child {
  border-bottom: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}
.service-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.service-list ul li {
  float: left;
  margin: 6px 0;
  padding-left: 25px;
  position: relative;
  width: 33%;
}
.service-list ul li::before {
  color: #ccc;
  content: "\\f30b";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  left: 0;
  position: absolute;
}
.location-list {
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 20px;
}
.location-list + .location-list {
  margin-top: 20px;
}
.clinic-content .clinic-name {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 3px;
}
.clinic-content .clinic-direction a {
  display: inline-block;
  margin-top: 8px;
}
.timings-days {
  font-weight: bold;
  color: #272b41;
  margin-bottom: 5px;
}
.timings-times span {
  display: block;
}
.location-list .consult-price {
  font-size: 20px;
  font-weight: 500;
  color: #272b41;
}
.review-listing {
  border-bottom: 1px solid #f5f7fc;
  margin-top: 20px;
  padding-bottom: 30px;
}
.review-listing > ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.review-listing > ul li + li {
  margin-top: 20px;
  border-top: 1px dashed #f0f0f0;
  padding-top: 20px;
}
.review-listing > ul li .comment {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 30px;
}
.review-listing > ul li .comment:last-child {
  margin-bottom: 0;
}
.review-listing > ul li .comment .comment-body {
  margin-left: 16px;
  width: 100%;
}
.review-listing > ul li .comment .comment-body .meta-data {
  position: relative;
  margin-bottom: 10px;
}
.review-listing > ul li .comment .comment-body .meta-data span {
  display: block;
  font-size: 16px;
  color: #757575;
}
.review-listing > ul li .comment .comment-body .meta-data span.comment-author {
  font-weight: 600;
  color: #272b41;
  text-transform: capitalize;
}
.review-listing > ul li .comment .comment-body .meta-data span.comment-date {
  font-size: 14px;
}
.review-listing > ul li .comment .comment-body .meta-data .review-count {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  top: 3px;
  right: 0;
  width: auto;
}
.review-listing > ul li .comment .comment-body .comment-content {
  color: #757575;
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 14px;
}
.review-listing > ul li .comment .comment-body .comment-reply .comment-btn {
  color: #20c0f3;
  display: inline-block;
  font-weight: 500;
  font-size: 15px;
}
.review-listing .recommend-btn {
  float: right;
  color: #757575;
  font-size: 14px;
  padding: 5px 0;
  margin-bottom: 0;
}
.review-listing .recommend-btn a {
  border: 1px solid rgba(128, 137, 150, 0.4);
  border-radius: 4px;
  display: inline-block;
  padding: 4px 12px;
  color: #757575;
  margin-left: 3px;
  margin-right: 3px;
  transition: all 0.3s;
}
.review-listing .recommend-btn a.like-btn:hover {
  background-color: #28a745;
  border: 1px solid #28a745;
  color: #fff;
}
.review-listing .recommend-btn a.dislike-btn:hover {
  background-color: #dc3545;
  border: 1px solid #dc3545;
  color: #fff;
}
.review-listing .recommend-btn a i {
  font-size: 16px;
}
.review-listing > ul li .comments-reply {
  list-style: none;
  margin-left: 65px;
  padding: 0;
}
.recommended {
  color: #28a745;
  font-size: 15px;
  font-weight: 500;
  margin: 0;
}
.all-feedback {
  margin-top: 20px;
}
.star-rating {
  direction: rtl;
}
.star-rating input[type="radio"] {
  display: none;
}
.star-rating label {
  color: #bbb;
  cursor: pointer;
  font-size: 18px;
  padding: 0;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.star-rating label:hover,
.star-rating label:hover ~ label,
.star-rating input[type="radio"]:checked ~ label {
  color: #f2b600;
}
.terms-accept a {
  color: #20c0f3;
  font-weight: 500;
}
.business-widget {
  background-color: #fcfcfc;
  border: 1px solid #f0f0f0;
  padding: 20px;
  margin-bottom: 0;
}
.listing-day {
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  color: #000;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 10px;
}
.listing-day:last-child {
  margin-bottom: 0;
}
.listing-day.current {
  border-bottom: 1px solid #ddd;
  padding-bottom: 13px;
  margin-bottom: 13px;
}
.listing-day .day {
  font-weight: 500;
}
.listing-day.current .day {
  font-weight: bold;
}
.listing-day.current .day span {
  display: block;
  font-weight: normal;
}
.time-items {
  color: #757575;
}
.time-items > span {
  display: block;
  text-align: right;
}
.time-items > span.open-status {
  margin-bottom: 3px;
}
.dropzone .dz-preview.dz-error:hover .dz-error-message {
  display: none;
}
/*-----------------
	18. Booking
-----------------------*/

.booking-doc-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.booking-doc-info .booking-doc-img {
  width: 80px;
  margin-right: 15px;
}
.booking-doc-info .booking-doc-img img {
  border-radius: 4px;
  height: 80px;
  width: 80px;
  object-fit: cover;
}
.schedule-widget {
  border-radius: 4px;
  min-height: 100px;
}
.schedule-header h4 {
  font-size: 18px;
  font-weight: 600;
  margin: 3px 0 0;
}
.schedule-header {
  border-bottom: 1px solid #f0f0f0;
  border-radius: 4px 4px 0 0;
  padding: 10px 20px;
}
.day-slot ul {
  float: left;
  list-style: none;
  margin-bottom: 0;
  margin-left: -5px;
  margin-right: -5px;
  padding: 0;
  position: relative;
  width: 100%;
}
.day-slot li {
  float: left;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
  width: 14.28%;
}
.day-slot li span {
  display: block;
  font-size: 18px;
  text-transform: uppercase;
}
.day-slot li span.slot-date {
  display: block;
  color: #757575;
  font-size: 14px;
}
.day-slot li small.slot-year {
  color: #757575;
  font-size: 14px;
}
.day-slot li.left-arrow {
  left: 0;
  padding: 0;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 20px !important;
  transform: translateY(-50%);
}
.day-slot li.right-arrow {
  right: -11px;
  padding: 0;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 20px !important;
  transform: translateY(-50%);
}
.schedule-cont {
  padding: 20px;
}
.time-slot ul {
  list-style: none;
  margin-right: -5px;
  margin-left: -5px;
  margin-bottom: 0;
  padding: 0;
}
.time-slot li {
  float: left;
  padding-left: 5px;
  padding-right: 5px;
  width: 14.28%;
  min-height: 1px;
}
.time-slot li .timing {
  background-color: #e9e9e9;
  border: 1px solid #e9e9e9;
  border-radius: 3px;
  color: #757575;
  display: block;
  font-size: 14px;
  margin-bottom: 10px;
  padding: 5px 5px;
  text-align: center;
  position: relative;
}
.time-slot li .timing:hover {
  background-color: #fff;
}
.time-slot li .timing:last-child {
  margin-bottom: 0;
}
.time-slot li .timing.selected {
  background-color: #42c0fb;
  border: 1px solid #42c0fb;
  color: #fff;
}
.time-slot li .timing.selected::before {
  color: #fff;
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-size: 12px;
  font-weight: 900;
  position: absolute;
  right: 6px;
  top: 6px;
}
.schedule-list {
  border-bottom: 1px solid #cfcfcf;
  margin-bottom: 50px;
  padding-bottom: 50px;
}
.schedule-list:last-child {
  border-bottom: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}
.submit-section.proceed-btn {
  margin: 0 0 30px;
}

/*-----------------
	19. Checkout
-----------------------*/

.info-widget {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 30px;
  margin-bottom: 30px;
}
.card-label > label {
  background-color: #fff;
  color: #959595;
  display: inline-block;
  font-size: 13px;
  font-weight: 500;
  margin: 6px auto auto 8px;
  padding: 0 7px;
}
.card-label > input {
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  display: block;
  height: 50px;
  margin-top: -13px;
  padding: 5px 15px 0;
  transition: border-color 0.3s;
  width: 100%;
}
.exist-customer a {
  color: #20c0f3;
  font-weight: 500;
}
.payment-widget .payment-list + .payment-list {
  margin-bottom: 15px;
}
.payment-radio {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-weight: 600;
  color: #272b41;
  text-transform: capitalize;
}
.payment-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.payment-radio .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  width: 19px;
  height: 19px;
  margin: 3px 0 0 0;
  border: 2px solid #ddd;
  border-top-color: rgb(221, 221, 221);
  border-right-color: rgb(221, 221, 221);
  border-bottom-color: rgb(221, 221, 221);
  border-left-color: rgb(221, 221, 221);
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.payment-radio input:checked ~ .checkmark {
  border-color: #20c0f3;
}
.payment-radio .checkmark::after {
  position: absolute;
  left: 3px;
  top: 3px;
  content: "";
  width: 9px;
  height: 9px;
  background-color: #20c0f3;
  opacity: 0;
  visibility: hidden;
  -webkit-transform: scale(0.1);
  -moz-transform: scale(0.1);
  -ms-transform: scale(0.1);
  -o-transform: scale(0.1);
  transform: scale(0.1);
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.payment-radio input:checked ~ .checkmark::after {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
  opacity: 1;
  visibility: visible;
}
.booking-date {
  padding: 0;
  list-style: none;
}
.booking-date li {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #272b41;
  text-transform: capitalize;
  margin-bottom: 15px;
}
.booking-date li span {
  float: right;
  color: #757575;
  font-weight: 400;
  font-size: 15px;
  text-align: right;
}
.booking-date li span a {
  color: #20c0f3;
  font-size: 13px;
  width: 100%;
  display: inline-block;
}
.booking-fee {
  padding: 0;
  list-style: none;
}
.booking-fee li {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #272b41;
  text-transform: capitalize;
  margin-bottom: 15px;
}
.booking-fee li span {
  float: right;
  color: #757575;
  font-weight: 400;
  font-size: 15px;
}
.booking-total {
  border-top: 1px solid #e4e4e4;
  margin-top: 20px;
  padding-top: 20px;
}
.booking-total ul {
  padding: 0;
  list-style: none;
  margin: 0;
}
.booking-total ul li span {
  font-size: 18px;
  font-weight: 600;
  color: #272b41;
}
.booking-total ul li .total-cost {
  color: #20c0f3;
  font-size: 16px;
  float: right;
}

/*-----------------
	20. Booking Success
-----------------------*/

.success-page-cont {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: flex;
}
.success-card .card-body {
  padding: 50px 20px;
}
.success-cont {
  text-align: center;
}
.success-cont i {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #fff;
  width: 60px;
  height: 60px;
  border: 2px solid #09e5ab;
  border-radius: 50%;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 30px;
  margin-bottom: 30px;
  background-color: #09e5ab;
}
.success-cont h3 {
  font-size: 24px;
}
.success-cont p {
  margin-bottom: 30px;
}
.success-cont strong {
  font-weight: 600;
}
.view-inv-btn {
  font-size: 16px;
  font-weight: 600;
  padding: 12px 30px;
}

/*-----------------
	21. Invoice View
-----------------------*/

.invoice-content {
  background-color: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  margin-bottom: 30px;
  padding: 30px;
}
.invoice-item .invoice-logo {
  margin-bottom: 30px;
}
.invoice-item .invoice-logo img {
  width: auto;
  max-height: 52px;
}
.invoice-item .invoice-text h2 {
  color: #272b41;
  font-size: 36px;
  font-weight: 600;
}
.invoice-item .invoice-details {
  text-align: right;
  color: #757575;
  font-weight: 500;
}
.invoice-item .invoice-details strong {
  color: #272b41;
}
.invoice-item .invoice-details-two {
  text-align: left;
}
.invoice-item .invoice-text {
  padding-top: 42px;
  padding-bottom: 36px;
}
.invoice-item .invoice-text h2 {
  font-weight: 400;
}
.invoice-info {
  margin-bottom: 30px;
}
.invoice-info p {
  margin-bottom: 0;
}
.invoice-info.invoice-info2 {
  text-align: right;
}
.invoice-item .customer-text {
  font-size: 18px;
  color: #272b41;
  font-weight: 600;
  margin-bottom: 8px;
  display: block;
}
.invoice-table tr th,
.invoice-table tr td,
.invoice-table-two tr th,
.invoice-table-two tr td {
  color: #272b41;
  font-weight: 600;
  padding: 10px 20px;
  line-height: inherit;
}
.invoice-table tr td,
.invoice-table-two tr td {
  color: #757575;
  font-weight: 500;
}
.invoice-table-two {
  margin-bottom: 0;
}
.invoice-table-two tr th,
.invoice-table-two tr td {
  border-top: 0;
}
.invoice-table-two tr td {
  text-align: right;
}
.invoice-info h5 {
  font-size: 16px;
  font-weight: 500;
}
.other-info {
  margin-top: 10px;
}

/*-----------------
	22. Schedule Timings
-----------------------*/

.tab-content.schedule-cont .card-title {
  margin-bottom: 10px;
}
.doc-times {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.doc-slot-list {
  background-color: #d9534f;
  border: 1px solid #d43f3a;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  margin: 10px 10px 0 0;
  padding: 6px 15px;
}
.doc-slot-list a {
  color: #e48784;
  display: inline-block;
  margin-left: 5px;
}
.doc-slot-list a:hover {
  color: #fff;
}
.schedule-nav .nav-tabs {
  border: 0 !important;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.schedule-nav .nav-tabs li {
  margin: 5px 15px 5px 0;
  display: inline-block;
}
.schedule-nav .nav-tabs li:last-child {
  margin-right: 0;
}
.schedule-nav .nav-tabs > li > a {
  border: 1px solid #dcddea;
  border-radius: 4px;
  padding: 6px 15px;
  text-transform: uppercase;
}
.schedule-nav .nav-tabs li a.active {
  background: #ff4877;
  border: 1px solid #ff4877 !important;
  color: #fff;
}
.hours-info .form-control {
  min-height: auto;
}
.hours-info .btn.btn-danger.trash {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 38px;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.edit-link {
  color: #20c0f3;
  font-size: 16px;
  margin-top: 4px;
}
.visit-btns {
  color: #272b41;
  background-color: #fff;
  width: 80%;
  margin-bottom: 10px;
  display: block;

  /* padding: 8px 14px; */
  outline: unset;
  cursor: pointer;
}
.visits input:checked ~ .visit-rsn {
  background-color: #09e5ab;
  color: #fff;
  border-radius: 4px;
}
.visits input:checked ~ .visit-rsn:before {
  opacity: 1;
}
.visits input:disabled ~ .visit-rsn {
  background-color: #e30303;
  color: #fff;
  border-radius: 5px;
}
.visits .form-check-input {
  opacity: 0;
}
.visits input.form-check-input {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  visibility: hidden;
  margin-left: 0;
}
.visits span.visit-rsn:before {
  color: #09e5ab;
  background-color: #fff;
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-size: 10px;
  font-weight: 900;
  position: absolute;
  right: 10px;
  top: 50%;
  border-radius: 50px;
  width: 18px;
  height: 18px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  opacity: 0;
}
.visits span.visit-rsn {
  background-color: #f3f9ff;
  border: 0;
  border-radius: 4px;
  color: #64627c;
  display: block;
  font-size: 14px;
  margin-bottom: 0px;
  padding: 13px 5px;
  text-align: center;
  position: relative;
  font-weight: 600;
}
.visits span.visit-rsn {
  text-align: center;
  border: 0;
  border-radius: 5px;
  padding: 13px 5px;
  background: #f3f9ff;
  min-width: 133px;
  display: inline-block;
  width: 100%;
}

/*-----------------
	23. Doctor Dashboard
-----------------------*/

.dash-widget {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.circle-bar {
  margin-right: 15px;
}
.dct-border-rht {
  border-right: 1px solid #f0f0f0;
}
.dash-widget h6 {
  font-size: 16px;
  font-weight: 400;
}
.dash-widget h3 {
  font-size: 24px;
  margin-bottom: 5px;
}
.dash-widget p {
  color: #757575;
  font-size: 14px;
  margin-bottom: 0;
}
.circle-bar > div {
  display: inline-block;
  position: relative;
  text-align: center;
}
.circle-bar > div img {
  left: 0;
  position: absolute;
  top: 50%;
  right: 0;
  text-align: center;
  margin: 0 auto;
  transform: translateY(-50%);
}
.circle-bar > div canvas {
  width: 90px !important;
  height: 90px !important;
}
.dash-card .row {
  margin-left: -10px;
  margin-right: -10px;
}
.dash-card .row > div {
  padding-left: 10px;
  padding-right: 10px;
}
.appointment-tab {
  margin-bottom: 30px;
}
.appointment-tab .nav-tabs {
  background-color: #fff;
  padding: 1.5rem;
  border: 1px solid #f0f0f0;
  border-radius: 0.25rem 0.25rem 0 0 !important;
  border-bottom: 0;
}
.appointment-tab .tab-content {
  padding-top: 0;
}
.appointment-tab .card {
  border-radius: 0;
}
.submit-btn-bottom {
  margin-bottom: 30px;
}

/*-----------------
	24. Patient Profile
-----------------------*/

.add-new-btn {
  background-color: #0de0fe;
  border-radius: 30px;
  color: #fff;
  display: inline-block;
  font-weight: 500;
  margin-bottom: 20px;
  padding: 10px 20px;
}
.add-new-btn:focus,
.add-new-btn:hover,
.add-new-btn:active {
  background-color: #0de0fe;
  color: #fff;
}
.patient-info {
  margin-top: 15px;
}
.patient-info ul {
  padding: 0;
  list-style: none;
  font-size: 0.875rem;
  margin: 0;
}
.patient-info ul li {
  position: relative;
  font-size: 0.875rem;
  font-weight: 500;
  color: #272b41;
  text-transform: capitalize;
}
.patient-info ul li + li {
  margin-top: 15px;
}
.patient-info ul li i {
  width: 18px;
}
.patient-info ul li span {
  color: #757575;
  float: right;
  font-weight: 400;
}

/*-----------------
	25. Add Billing
-----------------------*/

.biller-info,
.billing-info {
  margin-bottom: 15px;
}
.add-more-item {
  margin-bottom: 10px;
}
.add-more-item a {
  color: #0de0fe;
  font-weight: 500;
}
.signature-wrap {
  float: right;
  margin-bottom: 20px;
  text-align: center;
  width: 220px;
}
.signature {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 2px dashed #ccc;
  border-radius: 4px;
  color: #272b41;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 85px;
  margin-bottom: 15px;
  width: 100%;
}
.signature:hover {
  background-color: #fcfcfc;
}
.sign-name {
  width: 100%;
  float: right;
}
.pat-widget-profile .pro-widget-content {
  padding: 0 0 20px;
}
.pat-widget-profile .booking-date li {
  font-size: 0.875rem;
}
.pat-widget-profile .booking-date li span {
  font-size: 0.875rem;
}

/*-----------------
	26. Chat
-----------------------*/

.chat-page .content {
  padding: 0;
}
.chat-page .content > .container-fluid {
  padding: 0;
}
.chat-page .footer {
  display: none;
}
.chat-window {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  position: relative;
  height: 100%;
}
.chat-cont-left {
  border-right: 1px solid #f0f0f0;
  -ms-flex: 0 0 35%;
  flex: 0 0 35%;
  left: 0;
  max-width: 35%;
  position: relative;
  z-index: 4;
}
.chat-cont-left .chat-header {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
  color: #272b41;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 72px;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 0 15px;
}
.chat-cont-left .chat-header span {
  font-size: 20px;
  font-weight: 500;
  text-transform: capitalize;
}
.chat-cont-left .chat-header .chat-compose {
  color: #8a8a8a;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.chat-cont-left .chat-search {
  background-color: #f5f5f6;
  border-bottom: 1px solid #e5e5e5;
  padding: 10px 15px;
  width: 100%;
}
.chat-cont-left .chat-search .input-group {
  width: 100%;
}
.chat-cont-left .chat-search .input-group .form-control {
  background-color: #fff;
  border-radius: 50px;
  padding-left: 36px;
}
.chat-cont-left .chat-search .input-group .form-control:focus {
  border-color: #ccc;
  box-shadow: none;
}
.chat-cont-left .chat-search .input-group .input-group-prepend {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  bottom: 0;
  color: #666;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  left: 15px;
  pointer-events: none;
  position: absolute;
  top: 0;
  z-index: 4;
}
.chat-window .chat-scroll {
  min-height: 200px;
  height: 100%;
  /* max-height: calc(100vh - 400px); */
  overflow-y: auto;
}
.chat-cont-left .chat-users-list {
  background-color: #fff;
}
.chat-cont-left .chat-users-list a.media {
  border-bottom: 1px solid #f0f0f0;
  padding: 10px 15px;
  transition: all 0.2s ease 0s;
}
.chat-cont-left .chat-users-list a.media:last-child {
  border-bottom: 0;
}
.chat-cont-left .chat-users-list a.media .media-img-wrap {
  margin-right: 15px;
  position: relative;
}
.chat-cont-left .chat-users-list a.media .media-img-wrap .avatar {
  height: 45px;
  width: 45px;
}
.chat-cont-left .chat-users-list a.media .media-img-wrap .status {
  bottom: 7px;
  height: 10px;
  right: 4px;
  position: absolute;
  width: 10px;
  border: 2px solid #fff;
}
.chat-cont-left .chat-users-list a.media .media-body {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.chat-cont-left
  .chat-users-list
  a.media
  .media-body
  > div:first-child
  .user-name,
.chat-cont-left
  .chat-users-list
  a.media
  .media-body
  > div:first-child
  .user-last-chat {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-cont-left
  .chat-users-list
  a.media
  .media-body
  > div:first-child
  .user-name {
  color: #272b41;
  text-transform: capitalize;
}
.chat-cont-left
  .chat-users-list
  a.media
  .media-body
  > div:first-child
  .user-last-chat {
  color: #8a8a8a;
  font-size: 14px;
  line-height: 24px;
}
.chat-cont-left .chat-users-list a.media .media-body > div:last-child {
  text-align: right;
}
.chat-cont-left
  .chat-users-list
  a.media
  .media-body
  > div:last-child
  .last-chat-time {
  color: #8a8a8a;
  font-size: 13px;
}
.chat-cont-left .chat-users-list a.media:hover {
  background-color: #f5f5f6;
}
.chat-cont-left
  .chat-users-list
  a.media.read-chat
  .media-body
  > div:last-child
  .last-chat-time {
  color: #8a8a8a;
}
.chat-cont-left .chat-users-list a.media.active {
  background-color: #f5f5f6;
}
.chat-cont-right {
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
.chat-cont-right .chat-header {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 72px;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 0 15px;
}
.chat-cont-right .chat-header .back-user-list {
  display: none;
  margin-right: 5px;
  margin-left: -7px;
}
.chat-cont-right .chat-header .media {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.chat-cont-right .chat-header .media .media-img-wrap {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 15px;
}
.chat-cont-right .chat-header .media .media-img-wrap .avatar {
  height: 50px;
  width: 50px;
}
.chat-cont-right .chat-header .media .media-img-wrap .status {
  border: 2px solid #fff;
  bottom: 0;
  height: 10px;
  position: absolute;
  right: 3px;
  width: 10px;
}
.chat-cont-right .chat-header .media .media-body .user-name {
  color: #272b41;
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
}
.chat-cont-right .chat-header .media .media-body .user-status {
  color: #666;
  font-size: 14px;
}
.chat-cont-right .chat-header .chat-options {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.chat-cont-right .chat-header .chat-options > a {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 50%;
  color: #8a8a8a;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-left: 10px;
  width: 30px;
}
.chat-cont-right .chat-body {
  background-color: #f5f5f6;
}
.chat-cont-right .chat-body ul.list-unstyled {
  margin: 0 auto;
  padding: 15px;
  width: 100%;
}
.chat-cont-right .chat-body .media .avatar {
  height: 30px;
  width: 30px;
}
.chat-cont-right .chat-body .media .media-body {
  margin-left: 20px;
}
.chat-cont-right .chat-body .media .media-body .msg-box > div {
  padding: 10px 15px;
  border-radius: 0.25rem;
  display: inline-block;
  position: relative;
}
.chat-cont-right .chat-body .media .media-body .msg-box > div p {
  color: #272b41;
  margin-bottom: 0;
}
.chat-cont-right .chat-body .media .media-body .msg-box + .msg-box {
  margin-top: 5px;
}
.chat-cont-right .chat-body .media.received {
  margin-bottom: 20px;
}
.chat-cont-right .chat-body .media:last-child {
  margin-bottom: 0;
}
.chat-cont-right .chat-body .media.received .media-body .msg-box > div {
  background-color: #fff;
}
.chat-cont-right .chat-body .media.sent {
  margin-bottom: 20px;
}
.chat-cont-right .chat-body .media.sent .media-body {
  -webkit-box-align: flex-end;
  -ms-flex-align: flex-end;
  align-items: flex-end;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
  margin-left: 0;
}
.chat-cont-right .chat-body .media.sent .media-body .msg-box > div {
  background-color: #e3e3e3;
}
.chat-cont-right .chat-body .media.sent .media-body .msg-box > div p {
  color: #272b41;
}
.chat-cont-right .chat-body .chat-date {
  font-size: 14px;
  margin: 1.875rem 0;
  overflow: hidden;
  position: relative;
  text-align: center;
  text-transform: capitalize;
}
.chat-cont-right .chat-body .chat-date:before {
  background-color: #e0e3e4;
  content: "";
  height: 1px;
  margin-right: 28px;
  position: absolute;
  right: 50%;
  top: 50%;
  width: 100%;
}
.chat-cont-right .chat-body .chat-date:after {
  background-color: #e0e3e4;
  content: "";
  height: 1px;
  left: 50%;
  margin-left: 28px;
  position: absolute;
  top: 50%;
  width: 100%;
}
.chat-cont-right .chat-footer {
  background-color: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 16px 15px;
  position: relative;
}
.chat-cont-right .chat-footer .input-group {
  width: 100%;
}
.chat-cont-right .chat-footer .input-group .form-control {
  background-color: #f5f5f6;
  border: none;
  border-radius: 50px;
}
.chat-cont-right .chat-footer .input-group .form-control:focus {
  background-color: #f5f5f6;
  border: none;
  box-shadow: none;
}
.chat-cont-right .chat-footer .input-group .input-group-prepend .btn,
.chat-cont-right .chat-footer .input-group .input-group-append .btn {
  background-color: transparent;
  border: none;
  color: #9f9f9f;
}
.chat-cont-right
  .chat-footer
  .input-group
  .input-group-append
  .btn.msg-send-btn {
  background-color: #0de0fe;
  border-color: #0de0fe;
  border-radius: 50%;
  color: #fff;
  margin-left: 10px;
  min-width: 46px;
  font-size: 20px;
}
.msg-typing {
  width: auto;
  height: 24px;
  padding-top: 8px;
}
.msg-typing span {
  height: 8px;
  width: 8px;
  float: left;
  margin: 0 1px;
  background-color: #a0a0a0;
  display: block;
  border-radius: 50%;
  opacity: 0.4;
}
.msg-typing span:nth-of-type(1) {
  animation: 1s blink infinite 0.33333s;
}
.msg-typing span:nth-of-type(2) {
  animation: 1s blink infinite 0.66666s;
}
.msg-typing span:nth-of-type(3) {
  animation: 1s blink infinite 0.99999s;
}
.chat-cont-right .chat-body .media.received .media-body .msg-box {
  position: relative;
}
.chat-cont-right
  .chat-body
  .media.received
  .media-body
  .msg-box:first-child:before {
  border-bottom: 6px solid transparent;
  border-right: 6px solid #fff;
  border-top: 6px solid transparent;
  content: "";
  height: 0;
  left: -6px;
  position: absolute;
  right: auto;
  top: 8px;
  width: 0;
}
.chat-cont-right .chat-body .media.sent .media-body .msg-box {
  padding-left: 50px;
  position: relative;
}
.chat-cont-right
  .chat-body
  .media.sent
  .media-body
  .msg-box:first-child:before {
  border-bottom: 6px solid transparent;
  border-left: 6px solid #e3e3e3;
  border-top: 6px solid transparent;
  content: "";
  height: 0;
  left: auto;
  position: absolute;
  right: -6px;
  top: 8px;
  width: 0;
}
.chat-msg-info {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  clear: both;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 5px 0 0;
}
.chat-msg-info li {
  font-size: 13px;
  padding-right: 16px;
  position: relative;
}
.chat-msg-info li:not(:last-child):after {
  position: absolute;
  right: 8px;
  top: 50%;
  content: "";
  height: 4px;
  width: 4px;
  background: #d2dde9;
  border-radius: 50%;
  transform: translate(50%, -50%);
}
.chat-cont-right
  .chat-body
  .media.sent
  .media-body
  .msg-box
  .chat-msg-info
  li:not(:last-child)::after {
  right: auto;
  left: 8px;
  transform: translate(-50%, -50%);
  background: #aaa;
}
.chat-cont-right
  .chat-body
  .media.received
  .media-body
  .msg-box
  > div
  .chat-time {
  color: rgba(50, 65, 72, 0.4);
}
.chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-time {
  color: rgba(50, 65, 72, 0.4);
}
.chat-msg-info li a {
  color: #777;
}
.chat-msg-info li a:hover {
  color: #2c80ff;
}
.chat-seen i {
  color: #00d285;
  font-size: 16px;
}
.chat-msg-attachments {
  padding: 4px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  margin: 0 -1px;
}
.chat-msg-attachments > div {
  margin: 0 1px;
}
.chat-cont-right
  .chat-body
  .media.sent
  .media-body
  .msg-box
  > div
  .chat-msg-info {
  flex-direction: row-reverse;
}
.chat-cont-right
  .chat-body
  .media.sent
  .media-body
  .msg-box
  > div
  .chat-msg-attachments {
  flex-direction: row-reverse;
}
.chat-cont-right
  .chat-body
  .media.sent
  .media-body
  .msg-box
  > div
  .chat-msg-info
  li {
  padding-left: 16px;
  padding-right: 0;
  position: relative;
}
.chat-attachment img {
  max-width: 100%;
}
.chat-attachment {
  position: relative;
  max-width: 130px;
  overflow: hidden;
}
.chat-attachment {
  border-radius: 0.25rem;
}
.chat-attachment:before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #000;
  content: "";
  opacity: 0.4;
  transition: all 0.4s;
}
.chat-attachment:hover:before {
  opacity: 0.6;
}
.chat-attach-caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  color: #fff;
  padding: 7px 15px;
  font-size: 13px;
  opacity: 1;
  transition: all 0.4s;
}
.chat-attach-download {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.4s;
  color: #fff;
  width: 32px;
  line-height: 32px;
  background: rgba(255, 255, 255, 0.2);
  text-align: center;
}
.chat-attach-download:hover {
  color: #495463;
  background: #fff;
}
.chat-attachment:hover .chat-attach-caption {
  opacity: 0;
}
.chat-attachment:hover .chat-attach-download {
  opacity: 1;
}
.chat-attachment-list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: -5px;
}
.chat-attachment-list li {
  width: 33.33%;
  padding: 5px;
}
.chat-attachment-item {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 5px solid rgba(230, 239, 251, 0.5);
  height: 100%;
  min-height: 60px;
  text-align: center;
  font-size: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.chat-cont-right
  .chat-body
  .media.sent
  .media-body
  .msg-box
  > div:hover
  .chat-msg-actions {
  opacity: 1;
}
.chat-msg-actions {
  position: absolute;
  left: -30px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  transition: all 0.4s;
  z-index: 2;
}
.chat-msg-actions > a {
  padding: 0 10px;
  color: #495463;
  font-size: 24px;
}
.chat-msg-actions > a:hover {
  color: #2c80ff;
}

@keyframes blink {
  50% {
    opacity: 1;
  }
}
.btn-file {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 20px;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  overflow: hidden;
  padding: 0 0.75rem;
  position: relative;
  vertical-align: middle;
}
.btn-file input {
  cursor: pointer;
  filter: alpha(opacity=0);
  font-size: 23px;
  height: 100%;
  margin: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
}

/*-----------------
	27. Doctor Profile Settings
-----------------------*/

.profile-image img {
  margin-bottom: 1.5rem;
}
.change-photo-btn {
  background-color: #20c0f3;
  border-radius: 50px;
  color: #fff;
  cursor: pointer;
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin: 0 auto;
  padding: 10px 15px;
  position: relative;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  text-align: center;
  width: 220px;
}
.change-photo-btn input.upload {
  bottom: 0;
  cursor: pointer;
  filter: alpha(opacity=0);
  left: 0;
  margin: 0;
  opacity: 0;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 220px;
}
.dropzone {
  background-color: #fbfbfb;
  border: 2px dashed rgba(0, 0, 0, 0.1);
}
.btn-icon {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
  position: absolute;
  padding: 0;
  font-size: 10px;
  width: 20px;
  height: 20px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  right: 3px;
  top: 3px;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.upload-images {
  position: relative;
  width: 80px;
}
.upload-images img {
  border-radius: 4px;
  height: 80px;
  width: auto;
}
.upload-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.upload-wrap .upload-images + .upload-images {
  margin-left: 20px;
}
.contact-card .card-body {
  padding-bottom: 0.625rem;
}
.custom_price_cont {
  margin-top: 20px;
}
.btn.btn-danger.trash {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 46px;
  width: 46px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.add-more a {
  color: #20c0f3;
}
.bootstrap-tagsinput {
  border-color: #dcdcdc;
  box-shadow: inherit;
  min-height: 46px;
  width: 100%;
  border-radius: 0;
}
.bootstrap-tagsinput.focus {
  border-color: #bbb;
}
.bootstrap-tagsinput .tag {
  background-color: #20c0f3;
  color: #fff;
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  margin-right: 2px;
  padding: 11px 15px;
  border-radius: 0;
}
.services-card .bootstrap-tagsinput input {
  width: 160px;
}
.submit-section .submit-btn {
  padding: 12px 30px;
  font-weight: 600;
  font-size: 16px;
  min-width: 120px;
}
.submit-section .submit-btn + .submit-btn {
  margin-left: 15px;
}

/*-----------------
	28. Calendar
-----------------------*/

#calendar-events {
  background-color: #fcfcfc;
}
.calendar-events {
  border: 1px solid transparent;
  cursor: move;
  padding: 10px 15px;
}
.calendar-events:hover {
  border-color: #e9e9e9;
  background-color: #fff;
}
.calendar-events i {
  margin-right: 8px;
}
.calendar {
  float: left;
  margin-bottom: 0;
}
.fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5rem;
}
.none-border .modal-footer {
  border-top: none;
}
.fc-toolbar h2 {
  font-size: 18px;
  font-weight: 600;
  font-family: "Roboto", sans-serif;
  line-height: 30px;
  text-transform: uppercase;
}
.fc-day-grid-event .fc-time {
  font-family: "Roboto", sans-serif;
}
.fc-day {
  background: #fff;
}
.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar button:focus,
.fc-toolbar button:hover,
.fc-toolbar .ui-state-hover {
  z-index: 0;
}
.fc th.fc-widget-header {
  background: #eeeeee;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
}
.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #f3f3f3;
}
.fc-basic-view .fc-day-number,
.fc-basic-view .fc-week-number {
  padding: 2px 5px;
}
.fc-button {
  background: #f1f1f1;
  border: none;
  color: #797979;
  text-transform: capitalize;
  box-shadow: none !important;
  border-radius: 3px !important;
  margin: 0 3px !important;
  padding: 6px 12px !important;
  height: auto !important;
}
.fc-text-arrow {
  font-family: inherit;
  font-size: 16px;
}
.fc-state-hover {
  background: #f3f3f3;
}
.fc-state-highlight {
  background: #f0f0f0;
}
.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #20c0f3 !important;
  color: #fff !important;
  text-shadow: none !important;
}
.fc-cell-overlay {
  background: #f0f0f0;
}
.fc-unthemed .fc-today {
  background: #fff;
}
.fc-event {
  border-radius: 2px;
  border: none;
  color: #fff !important;
  cursor: move;
  font-size: 13px;
  margin: 1px 7px;
  padding: 5px 5px;
  text-align: center;
}
.fc-basic-view td.fc-week-number span {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}
.fc-basic-view td.fc-day-number {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}
.event-form .input-group .form-control {
  height: 40px;
}

/*-----------------
	29. Patient Dashboard
-----------------------*/

.profile-sidebar {
  background-color: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  margin-bottom: 30px;
  overflow: hidden;
}
.pro-widget-content {
  border-bottom: 1px solid #f0f0f0;
  padding: 20px;
  text-align: center;
}

.profile-info-widget {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  text-align: left;
}
.profile-info-widget .booking-doc-img {
  margin-right: 15px;
}
.profile-info-widget .booking-doc-img img {
  border-radius: 4px;
  height: 90px;
  width: 90px;
  object-fit: cover;
}
.profile-det-info {
  overflow: hidden;
}
.profile-det-info h3 {
  font-size: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.patient-details h5 {
  color: #757575;
  font-size: 13px;
  font-weight: normal;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.patient-details h5 i {
  width: 18px;
}
.dashboard-menu ul {
  color: #757575;
  font-size: 14px;
  line-height: 17px;
  list-style: none;
  margin: 0;
  padding: 0;
  text-transform: capitalize;
}
.dashboard-menu ul li {
  line-height: inherit;
}
.dashboard-menu > ul > li {
  border-bottom: 1px solid #f0f0f0;
  position: relative;
}
.dashboard-menu > ul > li:last-child {
  border-bottom: 0;
}
.dashboard-menu ul li a span,
.dashboard-menu ul li a i {
  display: inline-block;
  vertical-align: middle;
}
.dashboard-menu > ul > li > a {
  color: #757575;
  display: block;
  padding: 16px 20px;
}
.dashboard-menu > ul > li:hover > a,
.dashboard-menu > ul > li.active > a {
  color: #0de0fe;
}
.dashboard-menu ul li a i {
  font-size: 16px;
  margin-right: 10px;
  width: 16px;
}
.unread-msg {
  background-color: #09e5ab;
  border-radius: 2px;
  color: #272b41;
  font-size: 10px;
  font-style: normal;
  padding: 0 5px;
  position: absolute;
  right: 20px;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
}
.patient-dashboard-top,
.patient-graph-box {
  display: flex;
  display: -webkit-flex;
}
.patient-dashboard-top > div {
  width: 100%;
}
.patient-dashboard-top h6 {
  font-size: 18px;
  margin-bottom: 0;
}
.patient-dashboard-top h6 sub {
  font-size: 12px;
}
.patient-graph-col .graph-box {
  background: #7289de;
  border-bottom: 8px solid #6a5dee;
  padding: 22px;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  margin: 15px 0;
}
.patient-graph-col .graph-box h4 {
  color: #fff;
  margin-bottom: 15px;
  text-align: center;
}
.patient-graph-col .graph-box > div {
  width: 100%;
}
.graph-img {
  text-align: center;
  margin: 0 auto;
  width: 100%;
}
.graph-status-result {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  align-items: flex-end;
  -webkit-align-items: flex-end;
}
.graph-status-result h3 {
  color: #fff;
  margin-bottom: 0;
  line-height: 0.9;
  width: 100%;
}
.graph-status-result span.graph-update-date {
  color: #fff;
  font-weight: 500;
  opacity: 0.7;
  text-align: center;
  width: 100%;
}
.patient-graph-col .graph-box.pink-graph {
  background-color: #ffa69e;
  border-bottom: 8px solid #fe9286;
}
.patient-graph-col .graph-box.sky-blue-graph {
  background-color: #a9d4ff;
  border-bottom: 8px solid #8ec4ff;
}
.patient-graph-col .graph-box.orange-graph {
  background-color: #ffb88e;
  border-bottom: 8px solid #ffa775;
}

/*-----------------
	30. Profile Settings
-----------------------*/

.change-avatar {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.change-avatar .profile-img {
  margin-right: 15px;
}
.change-avatar .profile-img img {
  border-radius: 4px;
  height: 100px;
  width: 100px;
  object-fit: cover;
}
.change-avatar .change-photo-btn {
  margin: 0 0 10px;
  width: 150px;
}
.widget-profile.pat-widget-profile .profile-info-widget .booking-doc-img {
  padding: 0;
}
.widget-profile.pat-widget-profile .profile-info-widget .booking-doc-img img {
  border-radius: 50%;
  height: 100px;
  width: 100px;
}

/*-----------------
	31. Appoitment List
-----------------------*/

.widget-profile {
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
}
.widget-profile .profile-info-widget {
  display: block;
  text-align: center;
}
.widget-profile .profile-info-widget .booking-doc-img {
  display: inline-block;
  margin: 0 0 15px;
  width: auto;
  padding: 8px;
  background-color: #f7f7f7;
  border-radius: 50%;
}
.widget-profile .profile-info-widget .booking-doc-img img {
  border-radius: 50%;
  height: 120px;
  width: 120px;
}
.appointment-list .profile-info-widget {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-right: auto;
  text-align: left;
}
.appointment-list .profile-info-widget .booking-doc-img img {
  border-radius: 4px;
  height: 120px;
  object-fit: cover;
  width: 120px;
}
.appointments .appointment-list {
  background-color: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 20px;
  padding: 20px;
}
.appointments .appointment-list:last-child {
  margin-bottom: 30px;
}
.appointments .appointment-action {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.appointment-action a + a {
  margin-left: 5px;
}
.appointment-action a {
  font-size: 13px;
}
.info-details {
  list-style: none;
  margin: 0;
  padding: 0;
}
.info-details li .title {
  color: #272b41;
  font-weight: 500;
}
.info-details li .text {
  color: #757575;
  display: block;
  font-size: 16px;
  overflow: hidden;
}
.info-details li {
  margin-bottom: 10px;
}
.info-details li:last-child {
  margin-bottom: 0;
}

/*-----------------
	32. Reviews
-----------------------*/

.doc-review.review-listing {
  margin: 0;
}
.review-listing.doc-review > ul > li {
  background-color: #fff;
  border: 1px solid #f0f0f0;
  padding: 20px;
}

/*-----------------
	33. Voice call
-----------------------*/

.modal-open .main-wrapper {
  /* -webkit-filter: blur(1px);
  -moz-filter: blur(1px);
  -o-filter: blur(1px);
  -ms-filter: blur(1px);
  filter: blur(1px);
  z-index: 1000; */
}
.call-main-row {
  bottom: 0;
  left: 0;
  overflow: auto;
  padding-bottom: inherit;
  padding-top: inherit;
  position: absolute;
  right: 0;
  top: 0;
}
.call-main-wrapper {
  display: table;
  height: 100%;
  table-layout: fixed;
  width: 100%;
}
.call-view {
  display: table-cell;
  height: 100%;
  float: none;
  padding: 0;
  position: static;
  vertical-align: top;
  width: 75%;
}
.call-window {
  display: table;
  height: 100%;
  table-layout: fixed;
  width: 100%;
  background-color: #fff;
  border: 1px solid #f0f0f0;
}
.fixed-header {
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
  padding: 10px 15px;
}
.fixed-header .navbar {
  border: 0 none;
  margin: 0;
  min-height: auto;
  padding: 0;
}
.fixed-header .user-info a {
  color: #272b41;
  font-weight: 500;
}
.typing-text {
  color: #20c0f3;
  font-size: 12px;
  text-transform: lowercase;
}
.last-seen {
  color: #888;
  display: block;
  font-size: 12px;
}
.custom-menu {
  margin-top: 6px;
}
.fixed-header .custom-menu {
  margin: 0 0 1px;
}
.custom-menu.nav > li > a {
  color: #bbb;
  font-size: 26px;
  line-height: 32px;
  margin-left: 15px;
  padding: 0;
}
.custom-menu.navbar-nav > li > a:hover,
.custom-menu.navbar-nav > li > a:focus {
  background-color: transparent;
}
.custom-menu .dropdown-menu {
  left: auto;
  right: 0;
}
.call-contents {
  display: table-row;
  height: 100%;
}
.call-content-wrap {
  height: 100%;
  position: relative;
  width: 100%;
}
.voice-call-avatar {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-direction: column;
  flex-direction: column;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  -ms-flex: 2;
  flex: 2;
}
.voice-call-avatar .call-avatar {
  margin: 15px;
  width: 150px;
  height: 150px;
  border-radius: 100%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 3px;
  background-color: #fff;
}
.call-duration {
  display: inline-block;
  font-size: 30px;
  margin-top: 4px;
  position: absolute;
  left: 0;
}
.voice-call-avatar .call-timing-count {
  padding: 5px;
}
.voice-call-avatar .username {
  font-size: 20px;
  font-weight: 500;
}
.call-footer {
  background-color: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 15px;
}
.call-icons {
  text-align: center;
  position: relative;
}
.call-icons .call-items {
  border-radius: 5px;
  padding: 0;
  margin: 0;
  list-style: none;
  display: inline-block;
}
.call-icons .call-items .call-item {
  display: inline-block;
  text-align: center;
  margin-right: 5px;
}
.call-icons .call-items .call-item:last-child {
  margin-right: 0;
}
.call-icons .call-items .call-item a {
  color: #777;
  border: 1px solid #ddd;
  width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 50px;
  display: inline-block;
  font-size: 20px;
}
.call-icons .call-items .call-item a i {
  width: 18px;
  height: 18px;
}
.user-video {
  bottom: 0;
  left: 0;
  overflow: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
}
.user-video img {
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  display: block;
  margin: 0 auto;
}
.user-video video {
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  display: block;
  margin: 0 auto;
}
.my-video {
  position: absolute;
  z-index: 99;
  bottom: 20px;
  right: 20px;
}
.my-video ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.my-video ul li {
  float: left;
  width: 120px;
  margin-right: 10px;
}
.my-video ul li img {
  border: 3px solid #fff;
  border-radius: 6px;
}
.end-call {
  position: absolute;
  top: 7px;
  right: 0;
}
.end-call a {
  background-color: #f06060;
  border-radius: 50px;
  color: #fff;
  display: inline-block;
  line-height: 10px;
  padding: 8px 25px;
  text-transform: uppercase;
}
.call-users {
  position: absolute;
  z-index: 99;
  bottom: 20px;
  right: 20px;
}
.call-users ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.call-users ul li {
  float: left;
  width: 80px;
  margin-left: 10px;
}
.call-users ul li img {
  border-radius: 6px;
  padding: 2px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.call-mute {
  width: 80px;
  height: 80px;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  text-align: center;
  line-height: 80px;
  border-radius: 6px;
  font-size: 30px;
  color: #fff;
  display: none;
  top: 0;
  border: 3px solid transparent;
}
.call-users ul li a:hover .call-mute {
  display: block;
}
.call-details {
  margin: 10px 0 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.call-info {
  margin-left: 10px;
  width: 100%;
}
.call-user-details,
.call-timing {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.call-description {
  white-space: nowrap;
  vertical-align: bottom;
}
.call-timing {
  color: #727272;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
  margin-top: 1px;
  overflow: hidden;
  white-space: pre;
}

/*-----------------
	34. Video Call
-----------------------*/

.content-full {
  height: 100%;
  position: relative;
  width: 100%;
}
.video-window .fixed-header {
  padding: 0;
  border: 0;
}
.video-window .fixed-header .nav > li > a {
  padding: 18px 15px;
}

/*-----------------
	35. Outgoing Call
-----------------------*/

.call-box .call-wrapper {
  height: auto;
  text-align: center;
}
.call-box .call-wrapper .call-avatar {
  margin-bottom: 30px;
  cursor: pointer;
  animation: ripple 2s infinite;
}
.call-box .call-wrapper .call-user {
  margin-bottom: 30px;
}
.call-box .call-wrapper .call-user span {
  display: block;
  font-weight: 500;
  text-align: center;
}
.call-box .call-wrapper .call-items {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.call-box .call-wrapper .call-items .call-item {
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid transparent;
  border-radius: 100%;
  color: #fff;
  line-height: 0;
  margin: 0 5px;
  padding: 15px;
}
.call-box .call-wrapper .call-items .call-item:hover {
  opacity: 0.9;
}
.call-box .call-wrapper .call-items .call-item:first-child {
  margin-top: -30px;
}
.call-box .call-wrapper .call-items .call-item:last-child {
  margin-top: -30px;
}
.call-box .call-wrapper .call-items .call-item.call-end {
  padding: 20px;
  margin: 30px 20px 0;
  background: #f06060;
  border: 1px solid #f06060;
  color: #fff;
  line-height: 0;
  border-radius: 100%;
}
.call-box .call-wrapper .call-items .call-item.call-start {
  padding: 20px;
  margin: 30px 20px 0;
  background: #55ce63;
  border: 1px solid #55ce63;
  color: #fff;
  line-height: 0;
  border-radius: 100%;
}
.call-box.incoming-box .call-wrapper .call-items .call-item.call-start {
  margin: 0 10px;
}
.call-box.incoming-box .call-wrapper .call-items .call-item.call-end {
  margin: 0 10px;
}
.call-box .call-avatar {
  border-radius: 100%;
  height: 140px;
  max-width: 140px;
  min-width: 140px;
  position: relative;
  width: 100%;
  border: 10px solid #fafafa;
}
.call-box .btn {
  /* background: rgba(0, 0, 0, 0); */
  transition: all 0.3s ease 0s;
}
@-webkit-keyframes ripple {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
  }
  100% {
    -webkit-box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);
  }
}
@keyframes ripple {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
  }
  100% {
    -moz-box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);
    box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);
  }
}

/*-----------------
	36. Incoming Call
-----------------------*/

.incoming-btns {
  margin-top: 20px;
}
.call-wrapper {
  position: relative;
  height: calc(100vh - 50px);
}
.call-page .footer {
  display: none;
}
.dropdown-action .dropdown-toggle::after {
  display: none;
}
.call-modal .modal-body {
  padding: 40px;
}
.call-modal .modal-content {
  border: 0;
  border-radius: 10px;
}
.call-box .call-wrapper .call-user h4 {
  font-size: 24px;
}

/*-----------------
	37. Terms and Conditions
-----------------------*/

.terms-text {
  margin-bottom: 20px;
}
.terms-text h4 {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 20px;
}
.terms-text p {
  color: #666;
  display: inline-block;
  font-size: 16px;
}

/*-----------------
	38. Blog
-----------------------*/

.blog {
  border: 1px solid #f0f0f0;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 30px;
  padding: 1.5rem;
  position: relative;
}
.blog-image {
  overflow: hidden;
}
.blog-image,
.blog-image > a,
.blog-image img {
  display: block;
  position: relative;
  width: 100%;
  height: auto;
}
.blog-image img {
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  transform: translateZ(0);
  -moz-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -o-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
}
.blog-image a:hover img {
  -webkit-transform: scale(1.15);
  -moz-transform: scale(1.15);
  transform: scale(1.15);
}
.blog-image {
  margin-bottom: 30px;
}
.blog-content {
  position: relative;
}
.blog-title {
  font-size: 22px;
  margin: 0 0 10px;
}
.blog-title a {
  color: #272b41;
}
.blog-title a:hover {
  color: #20c0f3;
}
.blog-content p {
  color: #666;
  font-size: 14px;
  margin: 0 0 30px;
}
.read-more {
  display: inline-block;
  font-size: 16px;
  padding: 0;
  color: #20c0f3;
  text-decoration: underline;
  font-weight: bold;
}
.blog-info {
  color: #757575;
  font-size: 14px;
  margin-bottom: 15px;
}
.blog-info a {
  color: #757575;
}
.blog-info a:hover {
  color: #757575;
}
.blog-info i {
  color: #20c0f3;
  font-size: 14px;
  margin-right: 5px;
}
.entry-meta {
  color: #757575;
  font-size: 14px;
  list-style: none;
  margin-bottom: 15px;
  padding: 0;
}
.entry-meta li {
  display: inline-block;
  margin-right: 15px;
}
.entry-meta li:last-child {
  margin-right: 0;
}
.blog-pagination .pagination {
  margin-bottom: 30px;
}
.blog-pagination .pagination li a {
  padding: 12px 20px;
  font-weight: 600;
  color: #2e3842;
  margin-right: 10px;
  border-radius: inherit !important;
  border-color: #f0f0f0;
}
.blog-pagination .pagination li.disabled a {
  border-color: #f0f0f0;
}
.blog-pagination .pagination li.active a {
  background: #20c0f3;
  border-color: transparent;
  color: #ffffff;
}
.post-left ul {
  margin: 0;
  padding-left: 0;
  list-style: none;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.post-left ul li {
  margin-bottom: 5px;
  margin-right: 20px;
}
.post-left ul li:last-child {
  margin-right: 0;
}
.post-author a {
  display: flex;
  align-items: center;
}
.video {
  position: relative;
  padding-bottom: 56%;
  height: 0;
  overflow: hidden;
}
.video iframe,
.video object,
.video embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}
.latest-posts {
  margin: 0;
  padding: 0;
}
.latest-posts li {
  display: table;
  width: 100%;
  margin-bottom: 20px;
}
.latest-posts li:last-child {
  padding-bottom: 0px;
  margin-bottom: 0px;
  border-bottom: none;
}
.post-thumb {
  border-radius: 4px;
  width: 80px;
  float: left;
  overflow: hidden;
}
.post-thumb a img {
  border-radius: 4px;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  transform: translateZ(0);
  -moz-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -o-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
}
.post-thumb a:hover img {
  -webkit-transform: scale(1.15);
  -moz-transform: scale(1.15);
  transform: scale(1.15);
}
.post-info {
  margin-left: 95px;
}
.post-info h4 {
  font-size: 15px;
  margin: 0 0 5px;
}
.post-info h4 a {
  color: #272b41;
}
.post-info h4 a:hover {
  color: #20c0f3;
}
.post-info p {
  color: #757575;
  font-size: 12px;
  margin: 0;
}
.post-info p i {
  color: #20c0f3;
  font-size: 14px;
  margin-right: 4px;
}
.category-widget .categories {
  list-style: none;
  margin: 0;
  padding: 0;
}
.category-widget .categories li {
  margin-bottom: 20px;
}
.category-widget .categories li:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.category-widget .categories li a {
  color: #2e3842;
  font-size: 15px;
  font-weight: 500;
}
.category-widget .categories li a span {
  float: right;
  color: #757575;
}
.category-widget .categories li a:hover {
  color: #20c0f3;
}
.category-widget .categories > li > a > i {
  color: #20c0f3;
  font-size: 18px;
  margin-right: 10px;
}
.tags-widget .card-body {
  padding-bottom: 1rem;
}
.tags {
  list-style: none;
  margin: 0;
  overflow: hidden;
  padding: 0;
}
.tags li {
  float: left;
}
.tag {
  background-color: #fff;
  border-radius: 4px;
  color: #272b41;
  padding: 5px 10px;
  position: relative;
  margin: 0 0.5rem 0.5rem 0;
  font-size: 14px;
  border: 1px solid #ccc;
  display: inline-block;
}
.tag:hover {
  background-color: #20c0f3;
  border-color: #20c0f3;
  color: #fff;
}
.comment-by {
  display: block;
  font-size: 14px;
  line-height: 21px;
  margin: 0 0 10px;
}
.comments-list .comment-block p {
  font-size: 14px;
  margin-bottom: 5px;
}
.blogs-section {
  padding: 50px 0;
  background-color: #ffffff;
}
.blogs-section.blog-container {
  padding: 60px 0;
}
.blog-wrapper {
  background: #ffffff;
  border: 1px solid #e8eeff;
  box-sizing: border-box;
  border-radius: 10px 10px 0px 0px;
  margin-bottom: 30px;
}
.blog-wrapper .wrap-image img {
  width: 100%;
  border-radius: 10px 10px 0px 0px;
}
.blog-wrapper .wrap-content {
  padding: 10px;
}
.blog-wrapper .wrap-content:before {
  width: 0;
  height: 0;
  border-left: 149px solid transparent;
  border-right: 149px solid transparent;
  border-bottom: 20px solid #ffffff;
  margin-left: 0;
  position: absolute;
  margin-top: -30px;
  left: 15px;
}
.blog-wrapper .wrap-content .sp-title {
  font-size: 13px;
  color: #2264c5;
  font-weight: 600;
  margin-right: 5px;
}
.blog-wrapper .wrap-content .post-author img {
  width: 20px;
  flex: 0 0 20px;
  margin: 0 5px;
}
.blog-wrapper .wrap-content .post-author span {
  font-size: 12px;
  font-weight: 600;
  color: #000000;
}
.blog-wrapper .wrap-content .date-cart {
  background-color: #1860ca;
  padding: 10px 8px;
  font-size: 28px;
  color: #fff;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  width: 65px;
  height: 60px;
  margin: 0;
  position: absolute;
  right: 25px;
  margin-top: -40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.blog-wrapper .wrap-content .date-cart span {
  font-size: 11px;
  font-weight: 500;
}
.blog-wrapper .wrap-content-body {
  margin-top: 10px;
}
.blog-wrapper .wrap-content-body h3 a {
  font-size: 18px;
  font-weight: 500;
  color: #000;
  line-height: 1.5;
}
.blog-wrapper .wrap-content-body p {
  font-size: 12px;
  color: #000;
}
.blog-wrapper .wrap-content-body a.read-txt {
  width: 110px;
  padding: 10px;
  background: #0ce0ff;
  border-radius: 30px;
  display: block;
  text-align: center;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}
.blogs-section .view-btn {
  background-color: #20c0f3;
  font-size: 16px;
  color: #ffffff;
  font-weight: 700;
  border-radius: 30px;
  border: 1px solid #20c0f3;
  padding: 6px 20px;
}
.blog-container .blog-wrapper .wrap-content .date-cart {
  top: 50px;
  right: 25px;
}
.blog-container .blog-wrapper .wrap-content-body h3 a {
  color: #1860ca;
}
.blog-container .blog-wrapper .wrap-content .sp-title {
  color: #28daf4;
  font-size: 14px;
}
/*-----------------
	39. Blog Details
-----------------------*/

.blog-view .blog-title {
  font-size: 24px;
}
.blog-content p:last-child {
  margin-bottom: 0;
}
.blog-view .blog-info {
  border: 0;
  margin-bottom: 20px;
  padding: 0;
}
.social-share {
  float: left;
  list-style: none;
  margin: 0;
  padding: 0;
}
.social-share > li {
  display: inline-block;
  float: left;
  margin-left: 10px;
  text-align: center;
}
.social-share > li:first-child {
  margin-left: 0;
}
.social-share > li > a {
  border: 1px solid #dfdfdf;
  color: #666;
  display: inline-block;
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  width: 40px;
}
.social-share > li > a:hover {
  background-color: #20c0f3;
  color: #fff;
  border-color: #20c0f3;
}
.blog-reply > a {
  color: #999;
  font-size: 12px;
  font-weight: 500;
}
.blog-date {
  color: #999;
  font-size: 12px;
}
.blog-comments .comments-list {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
}
.blog-comments .comments-list li {
  clear: both;
  padding-left: 80px;
}
.blog-comments .comments-list li .comment {
  margin-bottom: 20px;
}
.blog-comments .comments-list li .comment-author {
  left: 0;
  position: absolute;
}
.blog-comments .comments-list li img.avatar {
  height: 58px;
  width: 58px;
  border-radius: 58px;
}
.blog-comments .comment-btn {
  color: #20c0f3;
  display: inline-block;
  font-weight: 500;
  font-size: 15px;
}
.blog-author-name {
  color: #272b41;
  font-size: 16px;
  font-weight: 600;
}
.new-comment label {
  font-weight: 500;
}
.comment-submit .btn {
  background-color: #20c0f3;
  border-color: #20c0f3;
  border-radius: 0;
  font-size: 18px;
  padding: 8px 26px;
  color: #fff;
}
.about-author-img {
  background-color: #fff;
  height: 100px;
  overflow: hidden;
  position: absolute;
  width: 100px;
}
.author-details {
  margin-left: 120px;
}
.about-author {
  min-height: 100px;
}
.author-details .blog-author-name {
  display: inline-block;
  margin-bottom: 10px;
}
.post-author img {
  border-radius: 100%;
  width: 28px;
  flex: 0 0 28px;
  margin-right: 5px;
}
.post-author a > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.custom-edit-service textarea.form-control {
  min-height: 200px;
}
.custom-edit-service .service-upload {
  border: 1px solid #dcdcdc;
  border-radius: 0.25rem;
  text-align: center;
  padding: 70px 0;
  margin-bottom: 30px;
  background-color: #fff;
  position: relative;
}
.custom-edit-service .service-upload input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.custom-edit-service .service-upload i {
  font-size: 50px;
  color: #858585;
}
.custom-edit-service .service-upload span {
  font-size: 15px;
  color: #858585;
  margin-top: 14px;
  display: block;
}
.custom-edit-service .upload-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
}
.custom-edit-service .upload-wrap li {
  margin: 10px;
}
.custom-edit-service .upload-wrap li:first-child {
  margin-left: 0;
}
.custom-edit-service .upload-wrap li img {
  max-width: 100%;
}
/*-----------------
	40. Blog Grid
-----------------------*/

.grid-blog .blog-title {
  font-size: 18px;
  margin: 0 0 5px;
  min-height: 43px;
}
.grid-blog .blog-content p {
  margin: 0 0 15px;
}
.grid-blog .blog-info {
  margin-bottom: 15px;
}
.grid-blog .blog-image {
  margin-bottom: 20px;
}
.blog.grid-blog {
  padding: 20px;
}
.grid-blog .entry-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 0;
}
.grid-blog .entry-meta li {
  margin-bottom: 10px;
}
.grid-blog .entry-meta li:last-child {
  flex: 0 0 100px;
  max-width: 100px;
}
.grid-blog .post-author {
  width: 189px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.grid-blog .post-author a:hover {
  color: #20c0f3;
}

/*-----------------
	41. Map List & Grid
-----------------------*/

.map-page .footer {
  display: none;
}
.map-page .header {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1030;
}
.map-page .content {
  padding-top: 115px;
}
.map-right {
  bottom: 0;
  height: 100%;
  min-height: 100%;
  padding-right: 30px;
  position: fixed;
  right: 0;
  top: 115px;
  z-index: 1029;
}
.map-listing {
  height: calc(100vh - 145px);
  width: 100%;
}
.map-listing .profile-widget {
  width: 200px !important;
  padding: 0;
  border: 0;
  margin-bottom: 0;
}
.map-right .available-info {
  margin-bottom: 0;
}
.view-icons {
  display: inline-flex;
  float: right;
}
.view-icons a {
  align-items: center;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #212529;
  display: flex;
  font-size: 20px;
  justify-content: center;
  padding: 4px 10px;
  text-align: center;
  margin-left: 10px;
  width: 44px;
  height: 44px;
}
.view-icons a:hover {
  border-color: #20c0f3;
  color: #20c0f3;
}
.view-icons a.active {
  background-color: #20c0f3;
  border-color: #20c0f3;
  color: #fff;
}

/*-----------------
	42. Loader
-----------------------*/

#loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
.loader {
  display: inline-block;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  width: 50px;
  position: absolute;
  top: 50%;
}
.loader span {
  -webkit-animation: loader 1.3s linear infinite;
  animation: loader 1.3s linear infinite;
  background-color: #20c0f3;
  border-radius: 100%;
  display: inline-block;
  height: 50px;
  position: absolute;
  width: 50px;
}
.loader span:last-child {
  animation-delay: -0.8s;
  -webkit-animation-delay: -0.8s;
}
@keyframes loader {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  100% {
    transform: scale(1, 1);
    opacity: 0;
  }
}
@-webkit-keyframes loader {
  0% {
    -webkit-transform: scale(0, 0);
    opacity: 0.5;
  }
  100% {
    -webkit-transform: scale(1, 1);
    opacity: 0;
  }
}

/*-----------------
	43. Product
-----------------------*/

.product-custom span.price {
  font-size: 20px;
  font-weight: 500;
}
.product-custom span.price-strike {
  font-weight: 400;
  text-decoration: line-through;
  color: #999;
}
.product-custom .cart-icon {
  font-size: 18px;
  width: 40px;
  height: 40px;
  border-radius: 100px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  float: right;
}
.product-custom .profile-widget:hover .cart-icon {
  color: #fff;
  background-color: #0de0fe;
}
.product-description .doctor-img1 {
  width: 40%;
}
.product-description .doc-info-cont {
  width: 60%;
}
.feature-product span {
  padding-bottom: 10px;
  display: inline-block;
}
.feature-product ul li {
  padding: 3px 0;
}
ul.benifits-col li i {
  font-size: 20px;
  margin-right: 20px;
  color: #20c0f3;
}
.custom-increment .input-group1 {
  display: flex;
  display: -webkit-flex;
  width: 100%;
}
.custom-increment .input-group-btn {
}
.custom-increment.cart .input-group1 {
  justify-content: center;
  -webkit-justify-content: center;
}
.custom-increment input[type="text"] {
  border: 1px solid #dbdbdb;
  border-radius: 0;
  padding: 7px 15px;
  text-align: center;
  width: 70%;
}
.custom-increment.cart input[type="text"] {
  width: 60px;
}
.custom-increment input[type="text"]:focus {
  border-color: transparent;
}
.custom-increment button {
  font-size: 14px;
  height: 39px;
  background: #dcdcdc;
  color: #000;
  border: 0;
  display: inline-block;
}
.custom-increment button:hover,
.custom-increment button:focus,
.custom-increment button:active {
  background: #dcdcdc !important;
  color: #000 !important;
  border: 0 !important;
}
.custom-increment.cart button {
  font-size: 10px;
}
.custom-increment button.btn-success {
  border-radius: 0 4px 4px 0;
}
.custom-increment button.btn-danger {
  border-radius: 4px 0px 0px 4px;
}

/*-----------------
	44. Cart
-----------------------*/
.view-cart-header {
  position: relative;
}
.view-cart-header .shopping-cart {
  margin: 20px 0;
  float: right;
  background: white;
  width: 320px;
  position: absolute;
  right: 0;
  top: 99%;
  border-radius: 3px;
  padding: 20px;
  z-index: 999;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
  display: none;
}
.view-cart-header .shopping-cart.show-cart {
  opacity: 1;
  visibility: visible;
}
.view-cart-header .shopping-cart-total {
  float: right;
}
.view-cart-header .shopping-cart-items {
  padding-top: 0px;
}
.view-cart-header .shopping-cart-items li {
  margin-bottom: 10px;
  padding-right: 0;
  display: block;
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 14px;
  position: relative;
}
.view-cart-header .shopping-cart-items .close-icon {
  position: absolute;
  top: 10px;
  right: 0;
  cursor: pointer;
}
.view-cart-header .shopping-cart-items img {
  float: left;
  width: 70px;
  margin-right: 12px;
  max-width: 100%;
  height: auto;
}
.view-cart-header .shopping-cart-items .item-name {
  display: block;
  padding-top: 10px;
  font-size: 14px;
  padding-right: 20px;
}
.view-cart-header .shopping-cart-items .item-price {
  margin-right: 8px;
  color: #20c0f3;
  font-size: 13px;
}
.view-cart-header .shopping-cart-items .item-quantity {
  color: #abb0be;
  font-size: 13px;
}
.view-cart-header .shopping-cart:after {
  border: 7px solid #fff;
  border-color: transparent transparent #fff #fff;
  box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
  content: "";
  right: 0;
  position: absolute;
  top: 2px;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
}
.view-cart-header .cart-icon {
  color: #515783;
  font-size: 24px;
  margin-right: 7px;
  float: left;
}
.view-cart-header .booking-date li {
  padding: 0;
  display: block;
  width: 100%;
  margin-bottom: 10px;
}
.view-cart-header .booking-date li span {
  float: right;
}
.view-cart-header .booking-total {
  padding-top: 0;
  text-align: center;
}
.view-cart-header .apt-btn {
  font-size: 13px;
  padding: 7px 20px;
}
/*-----------------
	45. Slider
-----------------------*/

.carousel-fade .carousel-item {
  opacity: 0;
  transition-duration: 0.6s;
  transition-property: opacity;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  opacity: 1;
}

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  opacity: 0;
}

.carousel-fade .carousel-item-next,
.carousel-fade .carousel-item-prev,
.carousel-fade .carousel-item.active,
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-prev {
  transform: translateX(0);
  transform: translate3d(0, 0, 0);
}
.carousel-item {
  height: 75vh;
  min-height: 350px;
  background: no-repeat center center scroll;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  z-index: -1 !important;
}
.carousel-caption {
  position: absolute;
  right: 0;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-bottom: 20px;
  color: #fff;
  top: 110px;
}
.carousel-caption span {
  font-size: 32px;
  font-weight: 700;
  color: rgb(46, 56, 66);
}
.carousel-caption h2 {
  font-size: 54px;
  font-weight: 700;
  color: rgb(30, 92, 146);
}
.carousel-caption p {
  font-size: 18px;
  font-weight: 700;
  color: rgb(46, 56, 66);
}

/*-----------------
	46. Account
-----------------------*/

.account-card {
  border-radius: 10px;
  margin-bottom: 30px;
  font-size: 16px;
  padding: 10px;
  text-align: center;
}
.account-card span {
  font-size: 24px;
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}
.info-list {
  margin-bottom: 10px;
}
.info-list .title {
  color: #272b41;
  font-weight: 500;
}
.info-list .text {
  color: #757575;
  display: block;
  overflow: hidden;
}

/*-----------------
	47. Responsive
-----------------------*/

@media only screen and (min-width: 768px) {
  .avatar-xxl {
    width: 8rem;
    height: 8rem;
  }
  .avatar-xxl .border {
    border-width: 4px !important;
  }
  .avatar-xxl .rounded {
    border-radius: 12px !important;
  }
  .avatar-xxl .avatar-title {
    font-size: 42px;
  }
  .avatar-xxl.avatar-away:before,
  .avatar-xxl.avatar-offline:before,
  .avatar-xxl.avatar-online:before {
    border-width: 4px;
  }
}
@media (min-width: 992px) {
  .main-nav > li {
    margin-right: 30px;
  }
  .white-font > li > a {
    color: #fff;
  }
  .main-nav > li:last-child {
    margin-right: 0;
  }
  .main-nav li {
    display: block;
    position: relative;
  }
  .main-nav > li > a {
    line-height: 85px;
    padding: 0 !important;
  }
  .header-four .main-nav > li > a {
    line-height: 80px;
    color: #fff;
  }
  .main-nav > li > a > i {
    font-size: 12px;
    margin-left: 3px;
  }
  .main-nav li > ul {
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
    display: block;
    font-size: 14px;
    left: 0;
    margin: 0;
    min-width: 200px;
    opacity: 0;
    padding: 0;
    position: absolute;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    -webkit-transform: translateY(20px);
    -ms-transform: translateY(20px);
    transform: translateY(20px);
    top: 100%;
    visibility: hidden;
    z-index: 1000;
  }
  .main-nav li .submenu::before {
    border: 7px solid #fff;
    border-color: transparent transparent #fff #fff;
    box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
    content: "";
    left: 45px;
    position: absolute;
    top: 2px;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
  }
  .main-nav li.has-submenu:hover > .submenu {
    visibility: visible;
    opacity: 1;
    margin-top: 0;
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
  .main-nav .has-submenu.active > a {
    color: #09dca4;
  }
  .header-four .main-nav .has-submenu.active > a {
    color: #fff;
    border-top: 3px solid #e74e84;
  }
  .main-nav .has-submenu.active .submenu li.active > a {
    color: #09dca4;
  }
  .main-nav > li .submenu li:first-child a {
    border-top: 0;
  }
  .main-nav
    > li.has-submenu:hover
    > .submenu
    > li.has-submenu:hover
    > .submenu {
    visibility: visible;
    opacity: 1;
    margin-top: -1px;
    margin-right: 0;
  }
  .main-nav > li .submenu > li .submenu {
    left: 100%;
    top: 0;
    margin-top: 10px;
  }
  .main-nav li .submenu a:hover {
    color: #09dca4;
    letter-spacing: 0.5px;
    padding-left: 20px;
  }
  .main-nav > .has-submenu > .submenu > .has-submenu > .submenu::before {
    top: 20px;
    margin-left: -35px;
    box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);
    border-color: transparent #fff #fff transparent;
  }
  .header-navbar-rht li.show > .dropdown-menu {
    visibility: visible;
    opacity: 1;
    margin-top: 0;
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
  .header-navbar-rht li .dropdown-menu {
    border-radius: 5px;
    padding: 0;
    margin: 0;
    min-width: 250px;
    visibility: hidden;
    opacity: 0;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    display: block;
    -webkit-transform: translateY(20px);
    -ms-transform: translateY(20px);
    transform: translateY(20px);
  }
  .header-five .main-nav .has-submenu.active > a {
    color: #28daf4;
  }
  .header-five .main-nav .has-submenu.active > a:after {
    content: "";
    position: absolute;
    width: 70px;
    background: #28daf4;
    left: -7px;
    height: 2px;
    z-index: 9;
    bottom: 25px;
  }
}
@media only screen and (max-width: 1399px) {
  .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-name,
  .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-last-chat {
    max-width: 180px;
  }
  .row.row-grid {
    margin-left: -8px;
    margin-right: -8px;
  }
  .row.row-grid > div {
    padding-right: 8px;
    padding-left: 8px;
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
}
@media (min-width: 1200px) {
  .aval-features .custom-contain {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
}
@media (min-width: 1600px) {
  .blog-wrapper .wrap-content:before {
    border-left: 221px solid transparent;
    border-right: 221px solid transparent;
  }
}
@media only screen and (max-width: 1199px) {
  .header-nav {
    padding-left: 20px;
    padding-right: 20px;
  }
  .container-fluid {
    padding-left: 20px;
    padding-right: 20px;
  }
  .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-name,
  .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-last-chat {
    max-width: 150px;
  }
  .chat-cont-left {
    -ms-flex: 0 0 40%;
    flex: 0 0 40%;
    max-width: 40%;
  }
  .chat-cont-right {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row.row-grid > div {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .dash-widget {
    -ms-flex-direction: column;
    flex-direction: column;
    text-align: center;
  }
  .circle-bar {
    margin: 0 0 15px;
  }
  .header-navbar-rht li.contact-item {
    display: none;
  }
  .map-right {
    height: 450px;
    position: static;
    min-height: inherit;
    margin-bottom: 30px;
    padding-right: 15px;
  }
  .map-listing {
    height: 450px;
  }
  .map-page .content {
    padding-top: 100px;
  }
}
@media only screen and (max-width: 991.98px) {
  .main-nav {
    padding: 0;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
  }
  .main-nav ul {
    background-color: #3474ac;
    display: none;
    list-style: none;
    margin: 0;
    padding-left: 0;
  }
  .main-nav > li {
    border-bottom: 1px solid #1663a6;
    margin-left: 0;
  }
  .main-nav li + li {
    margin-left: 0;
  }
  .main-nav > li > a {
    line-height: 1.5;
    padding: 15px 20px !important;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
  }
  .main-nav > li > a > i {
    float: right;
    margin-top: 5px;
  }
  .main-nav > li .submenu li a {
    border-top: 0;
    color: #fff;
    padding: 10px 15px 10px 35px;
  }
  .main-nav > li .submenu ul li a {
    padding: 10px 15px 10px 45px;
  }
  .main-nav > li .submenu > li.has-submenu > a::after {
    content: "\\f078";
  }
  .main-nav .has-submenu.active > a {
    color: #09dca4;
  }
  .main-nav .has-submenu.active .submenu li.active > a {
    color: #09dca4;
  }
  .login-left {
    display: none;
  }
  .main-menu-wrapper {
    order: 3;
    width: 260px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1060;
    transform: translateX(-260px);
    transition: all 0.4s;
    background-color: #15558d;
  }
  .menu-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .navbar-header {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
  }
  #mobile_btn {
    display: inline-block;
  }
  .section-search {
    min-height: 330px;
  }
  .section-specialities {
    padding: 50px 0;
  }
  .footer-widget {
    margin-bottom: 30px;
  }
  .chat-cont-left,
  .chat-cont-right {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
    transition: left 0.3s ease-in-out 0s, right 0.3s ease-in-out 0s;
    width: 100%;
  }
  .chat-cont-left {
    border-right: 0;
  }
  .chat-cont-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 75%;
    /* opacity: 0; */
    /* visibility: hidden; */
  }
  .chat-cont-right .chat-header {
    justify-content: start;
    -webkit-justify-content: start;
    -ms-flex-pack: start;
  }
  .chat-cont-right .chat-header .back-user-list {
    display: block;
  }
  .chat-cont-right .chat-header .chat-options {
    margin-left: auto;
  }
  .chat-window.chat-slide .chat-cont-left {
    left: -100%;
  }
  .chat-window.chat-slide .chat-cont-right {
    right: 0;
    opacity: 1;
    visibility: visible;
  }
  .day-slot li.left-arrow {
    left: -10px;
  }
  .container {
    max-width: 100%;
  }
  .appointments .appointment-action {
    margin-top: 10px;
  }
  .appointments .appointment-list {
    display: block;
  }
  .banner-wrapper {
    max-width: 620px;
  }
  .search-box .search-info {
    -ms-flex: 0 0 180px;
    flex: 0 0 180px;
    width: 180px;
  }
  .banner-wrapper .banner-header h1 {
    font-size: 2.125rem;
  }
  .dct-border-rht {
    border-bottom: 1px solid #f0f0f0;
    border-right: 0;
    margin-bottom: 20px;
    padding-bottom: 15px;
  }
  .dr-img {
    display: none;
  }
  .doctor-search {
    padding: 30px 0;
  }
  .doctor-search-section {
    padding-top: 85px;
  }
  .shapes {
    display: none;
  }
  .search-box-3 {
    position: relative;
  }
  .header-top {
    display: none;
  }
  .search-box {
    max-width: 535px;
    margin: 0 auto;
  }
  .card-label > label {
    font-size: 12px;
  }
  .footer .footer-top {
    padding-bottom: 10px;
  }
  .time-slot li .timing.selected::before {
    display: none;
  }
  .review-listing .recommend-btn {
    float: none;
  }
  .dash-widget {
    flex-direction: unset;
    text-align: left;
  }
  .circle-bar {
    margin: 0 15px 0 0;
  }
  .call-wrapper {
    height: calc(100vh - 50px);
  }
  .sidebar-overlay.opened {
    display: block;
  }
  .about-content {
    margin-bottom: 30px;
  }
  .slide-image {
    padding-left: 0;
    padding-right: 0;
  }
  .custom-short-by > div {
    margin-right: 0;
  }
  .product-description .doctor-img1 {
    width: 100%;
    margin-right: 0;
    margin-bottom: 30px;
  }
  .product-description .doc-info-cont {
    width: 100%;
  }
  .product-description .doc-info-left {
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
  }
  .clinics-section {
    padding: 40px 0 25px;
  }
  .specialities-section {
    padding: 60px 0 35px;
  }
  .our-doctors-section {
    padding: 40px 0;
  }
  .clinic-features-section {
    padding: 40px 0;
  }
  .our-blog-section {
    padding: 40px 0;
  }
  .section-search-3 .banner-info {
    padding: 60px 0 130px;
  }
  .section-search-3 .doctor-search-form .banner-btn {
    padding: 18px 30px;
  }
  .pop-box .body-section h3 {
    font-size: 20px;
  }
  .section-header-three h2 {
    font-size: 28px;
  }
  .doc-background,
  .pat-background {
    min-height: 250px;
  }
  .doctor-divison h3 {
    font-size: 20px;
  }
  .doctor-divison p {
    font-size: 12px;
  }
  .doctors-body .inner-section > span {
    font-size: 12px;
  }
  .book-best-doctors .doctors-body .average-ratings {
    padding: 1px 8px;
    font-size: 10px;
    margin-left: 7px;
  }
  .book-best-doctors .doctors-body h4 {
    font-size: 18px;
  }
  .book-best-doctors .amt-txt {
    font-size: 16px;
  }
  .latest-blog .blog-wrap .blog-wrap-body h3 {
    font-size: 18px;
  }
  .header-four .nav-item a.header-login {
    margin: 15px 20px;
  }
  .header-four .nav-item a.header-login i {
    float: unset;
  }
  .doc-form {
    position: absolute;
    top: 85px;
    left: 20px;
    padding: 37px 0;
    width: 600px;
  }
  .dot-slider .slick-slide {
    height: 375px;
  }
  .dot-slider .profile-widget {
    margin-bottom: 0;
  }
  .app-form h2 {
    font-size: 30px;
  }
  .app-form .doctor-search-form input {
    min-height: 50px;
  }
  .app-form .banner-btn {
    padding: 10px 30px;
    min-height: 50px;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .category-sec {
    padding: 50px 0;
    margin-top: 0;
  }
  .set-category {
    padding: 10px;
  }
  .set-category .info-holder h3 {
    font-size: 20px;
  }
  .set-category .info-holder p {
    font-size: 11px;
  }
  .set-category .img-holder {
    margin-right: 10px;
  }
  .set-category .img-holder a {
    width: 50px;
    height: 50px;
  }
  .set-category .img-holder a img {
    width: 20px;
  }
  .select-box {
    padding: 20px;
  }
  .select-box p {
    font-size: 14px;
    margin-bottom: 20px;
  }
  .select-box .book-now {
    padding: 8px 20px;
  }
  .select-box .image-holder {
    margin-right: 15px;
  }
  .aval-features .custom-contain {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .aval-features .feature {
    align-items: center;
    justify-content: center;
    display: flex;
    padding: 40px;
  }
  .aval-features .feature .info-box {
    padding: 20px;
  }
  .aval-features .feature .info-box h2 {
    font-size: 30px;
  }
  .footer.footer-four .footer-top {
    padding: 30px 0 0;
  }
  .aval-features .custom-contain {
    max-width: 100%;
  }
  .header-trans.header-five .main-menu-wrapper {
    margin-left: auto;
  }
  .home-search-section .banner-header h2 {
    font-size: 34px;
  }
  .facility-section .operat-img {
    width: 100%;
  }
  .facility-section .visit-doctor {
    padding: 15px;
    margin-bottom: 20px;
  }
  .facility-section .visit-doctor .inner-details img {
    bottom: -13px;
  }
  .visit-doctor .inner-details .info h2 {
    font-size: 20px;
  }
  .visit-doctor .inner-details .info p {
    font-size: 12px;
    max-width: 100%;
  }
  .visit-doctor .inner-details .count h2 {
    width: 55px;
    height: 55px;
    font-size: 20px;
  }
  .clinic-wrap {
    height: 200px;
  }
  .heading-wrapper h1 {
    font-size: 30px;
    max-width: 100%;
  }
  .clinic-wrap .wrapper-overlay img {
    margin-bottom: 20px;
  }
  .doc-booking .book-slider .slick-prev,
  .doc-booking .book-slider .slick-next {
    top: -100px;
  }
  .blog-wrapper .wrap-content .date-cart {
    font-size: 26px;
  }
  .home-search-section .doctor-search {
    padding: 40px 0;
  }
  .facility-section {
    padding: 40px 0 20px;
  }
  .clinic-speciality {
    padding: 40px 0 10px;
  }
  .browse-section.brower-category {
    padding: 40px 0 20px;
  }
  .doctor-divison.provider-select .doc-background,
  .doctor-divison.provider-select .pat-background {
    padding: 40px 30px;
  }
  .doc-booking {
    padding: 40px 0;
  }
  .blogs-section.blog-container {
    padding: 40px 0 10px;
  }
  .footer.footer-five .footer-top {
    padding: 40px 0 10px;
  }
  .heading-wrapper .nav-arrow {
    display: none;
  }
  .heading-wrapper {
    margin-bottom: 30px;
    text-align: center;
  }
  .blog-wrapper .wrap-content:before {
    border-left: 178px solid transparent;
    border-right: 170px solid transparent;
  }
  .divider .carousel-inner {
    height: 430px;
  }
}
@media only screen and (max-width: 849.98px) {
  .row.row-grid > div {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media only screen and (max-width: 767.98px) {
  body {
    font-size: 0.875rem;
  }
  h1,
  .h1 {
    font-size: 2rem;
  }
  h2,
  .h2 {
    font-size: 1.75rem;
  }
  h3,
  .h3 {
    font-size: 1.375rem;
  }
  h4,
  .h4 {
    font-size: 1rem;
  }
  h5,
  .h5 {
    font-size: 0.875rem;
  }
  h6,
  .h6 {
    font-size: 0.75rem;
  }
  .content {
    padding: 15px 0 0;
  }
  .account-page .content {
    padding: 15px 0;
  }
  .container-fluid {
    padding-left: 15px;
    padding-right: 15px;
  }
  .carousel-item {
    height: auto;
    min-height: auto;
  }
  .card {
    margin-bottom: 20px;
  }
  .profile-sidebar {
    margin-bottom: 20px;
  }
  .appointment-tab {
    margin-bottom: 20px;
  }
  .features-slider .slick-dots,
  .features-img img {
    text-align: center;
    margin: 0 auto;
  }
  .doctor-slider {
    margin-top: 25px;
  }
  .breadcrumb-bar {
    height: auto;
  }
  .login-right {
    margin: 0 15px;
    padding: 15px;
  }
  .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-name,
  .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-last-chat {
    max-width: 250px;
  }
  .chat-window .chat-cont-right .chat-header .media .media-body {
    display: none;
  }
  .divider .carousel-inner {
    height: 100%;
  }
  .divider .form-group {
    margin-bottom: 10px;
  }
  .banner-wrapper .banner-header h1 {
    font-size: 2rem;
  }
  .banner-wrapper .banner-header p {
    font-size: 1rem;
  }
  .section-header h2 {
    font-size: 1.875rem;
  }
  .section-header .sub-title {
    font-size: 0.875rem;
  }
  .speicality-item p {
    font-size: 0.875rem;
  }
  .section-header p {
    font-size: 0.9375rem;
  }
  .footer-title {
    font-size: 1.125rem;
  }
  .search-box {
    max-width: 535px;
    margin: 0 auto;
  }
  .search-box {
    -ms-flex-direction: column;
    flex-direction: column;
    word-wrap: break-word;
    background-clip: border-box;
  }
  .search-box .search-location {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    width: 100%;
  }
  .search-box .search-info {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    width: 100%;
  }
  .search-box .search-btn {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    min-height: 46px;
    width: 100%;
  }
  .search-box .search-btn span {
    display: inline-block;
    margin-left: 5px;
    text-transform: uppercase;
  }
  .section-search {
    background: #f9f9f9;
  }
  .day-slot li span {
    font-size: 16px;
    text-transform: unset;
  }
  .time-slot li .timing span {
    display: block;
  }
  .submit-section.proceed-btn {
    margin-bottom: 20px;
  }
  .day-slot li small.slot-year {
    display: none;
  }
  .success-cont h3 {
    font-size: 22px;
  }
  .view-inv-btn {
    font-size: 14px;
    padding: 10px 30px;
  }
  .invoice-info.invoice-info2 {
    text-align: left;
  }
  .invoice-item .invoice-details {
    text-align: left;
  }
  .section-search,
  .section-doctor,
  .section-features {
    padding: 50px 0;
  }
  .slick-next {
    right: -10px;
  }
  .slick-prev {
    left: -10px;
  }
  .specialities-slider .slick-slide {
    margin-right: 15px;
  }
  .about-content a {
    padding: 12px 20px;
  }
  .submit-section .submit-btn {
    padding: 10px 20px;
    font-size: 15px;
    min-width: 105px;
  }
  .policy-menu {
    margin-top: 10px;
    text-align: left;
  }
  .booking-doc-info .booking-doc-img {
    width: 75px;
  }
  .booking-doc-info .booking-doc-img img {
    height: 75px;
    width: 75px;
  }
  .btn.btn-danger.trash {
    margin-bottom: 20px;
  }
  .nav-tabs.nav-tabs-bottom > li > a.active,
  .nav-tabs.nav-tabs-bottom > li > a.active:hover,
  .nav-tabs.nav-tabs-bottom > li > a.active:focus {
    background-color: #f5f5f5;
  }
  .nav-tabs.nav-justified {
    border-bottom: 1px solid #ddd;
  }
  .nav-tabs.nav-justified > li > a.active,
  .nav-tabs.nav-justified > li > a.active:hover,
  .nav-tabs.nav-justified > li > a.active:focus {
    border-color: transparent transparent transparent #20c0f3;
    border-left-width: 2px;
  }
  .nav-tabs {
    border-bottom: 0;
    position: relative;
    background-color: #fff;
    padding: 5px 0;
    border: 1px solid #ddd;
    border-radius: 3px;
  }
  .nav-tabs .nav-item {
    margin-bottom: 0;
  }
  .nav-tabs > li > a {
    border-width: 2px;
    border-left-color: transparent;
  }
  .nav-tabs .nav-link {
    border-width: 2px;
  }
  .nav-tabs > li > a:hover,
  .nav-tabs > li > a:focus {
    background-color: #fafafa;
  }
  .nav-tabs .nav-item.show .nav-link,
  .nav-tabs .nav-link.active,
  .nav-tabs > li > a.active,
  .nav-tabs > li > a.active:hover,
  .nav-tabs > li > a.active:focus {
    border-color: transparent transparent transparent #20c0f3 !important;
    border-left-width: 2px;
  }
  .nav-tabs > li.open:not(.active) > a,
  .nav-tabs > li.open:not(.active) > a:hover,
  .nav-tabs > li.open:not(.active) > a:focus {
    background-color: #fafafa;
  }
  .nav-tabs.nav-tabs-solid {
    padding: 5px;
  }
  .nav-tabs.nav-tabs-solid.nav-tabs-rounded {
    border-radius: 5px;
  }
  .nav-tabs.nav-tabs-solid > li > a {
    border-left-width: 0 !important;
  }
  .nav-tabs-justified {
    border-bottom: 1px solid #ddd;
  }
  .nav-tabs-justified > li > a.active,
  .nav-tabs-justified > li > a.active:hover,
  .nav-tabs-justified > li > a.active:focus {
    border-width: 0 0 0 2px;
    border-left-color: #20c0f3;
  }
  .review-listing > ul li .comment .comment-body .meta-data span.comment-date {
    margin-bottom: 5px;
  }
  .review-listing > ul li .comment .comment-body .meta-data .review-count {
    position: unset;
  }
  .my-video ul li {
    width: 50px;
  }
  .call-users ul li {
    width: 50px;
  }
  .call-mute {
    font-size: 20px;
    height: 50px;
    line-height: 50px;
    width: 50px;
  }
  .call-duration {
    font-size: 24px;
  }
  .voice-call-avatar .call-avatar {
    height: 100px;
    width: 100px;
  }
  .user-tabs {
    margin-top: 1.5rem;
  }
  .user-tabs .nav-tabs > li > a {
    border-left: 2px solid transparent;
    border-bottom: 0;
    padding: 0.5rem 1rem;
  }
  .user-tabs .nav-tabs.nav-tabs-bottom > li > a.active,
  .user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:hover,
  .user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:focus {
    border-left-width: 2px;
    color: #20c0f3;
  }
  .doctor-widget {
    -ms-flex-direction: column;
    flex-direction: column;
    text-align: center;
  }
  .doc-info-right {
    margin-left: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .doc-info-left {
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .clinic-services {
    display: none;
  }
  .doctor-img {
    margin: 0 auto 20px;
  }
  .doctor-action {
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
  }
  .row.row-grid > div {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .breadcrumb-bar .breadcrumb-title {
    font-size: 18px;
  }
  .dash-widget h6 {
    font-size: 15px;
  }
  .dash-widget h3 {
    font-size: 20px;
  }
  .dash-widget p {
    font-size: 13px;
  }
  .doctor-widget .doc-name {
    font-size: 18px;
  }
  .exp-title,
  .booking-total ul li span,
  .booking-total ul li .total-cost {
    font-size: 14px;
  }
  .invoice-item .customer-text {
    font-size: 16px;
  }
  .call-wrapper {
    height: calc(100vh - 50px);
  }
  .appointment-tab .nav-tabs {
    padding: 1.5rem;
  }
  .submit-btn-bottom {
    margin-bottom: 20px;
  }
  .service-list ul li {
    width: 50%;
  }
  .grid-blog .blog-title {
    min-height: inherit;
  }
  .blog-title {
    font-size: 20px;
  }
  .blog-view .blog-title {
    font-size: 22px;
  }
  .full-slide-home .slick-prev {
    left: 15px;
  }
  .full-slide-home .slick-next {
    right: 15px;
  }
  .search-box1 form p {
    margin-bottom: 15px !important;
  }
  .search-box1 .search-location1 {
    margin-right: 0;
    margin-bottom: 15px;
  }
  .product-description .doctor-widget {
    text-align: left;
  }
  .pharmacy-home-slider .swiper-button-prev,
  .pharmacy-home-slider .swiper-button-next {
    display: none;
  }
  .banner-header h2 {
    font-size: 26px;
    line-height: 40px;
  }
  .section-heading {
    margin-bottom: 15px;
  }
  .owl-theme .owl-dots,
  .owl-nav button {
    margin-top: 10px;
  }
  .clinics-section {
    padding: 30px 0 10px;
  }
  .specialities-section {
    padding: 40px 0 15px;
  }
  .our-doctors-section {
    padding: 30px 0;
  }
  .clinic-features-section {
    padding: 30px 0;
  }
  .our-blog-section {
    padding: 30px 0;
  }
  .section-heading h2 {
    font-size: 20px;
  }
  .slide-nav-1 button.owl-next,
  .slide-nav-1 button.owl-prev,
  .slide-nav-2 button.owl-next,
  .slide-nav-2 button.owl-prev,
  .slide-nav-3 button.owl-next,
  .slide-nav-3 button.owl-prev,
  .slide-nav-4 button.owl-next,
  .slide-nav-4 button.owl-prev {
    width: 28px;
    height: 28px;
  }
  .section-search-3 .banner-info {
    padding: 20px 0 100px;
  }
  .pop-box .body-section h3 {
    font-size: 18px;
  }
  .section-header-three h2 {
    font-size: 24px;
  }
  .section-header-three p {
    font-size: 14px;
  }
  .section-header-three {
    margin-bottom: 40px;
  }
  .doctor-category {
    padding: 40px 0 10px;
    margin-top: -110px;
  }
  .clinic-specialities {
    padding: 40px 0;
  }
  .browse-section {
    padding: 40px 0;
  }
  .doc-background,
  .pat-background {
    padding: 20px 15px;
    min-height: 200px;
  }
  .doctor-divison > .d-flex {
    display: block !important;
  }
  .doctor-divison h3 {
    font-size: 16px;
  }
  .doctor-divison p {
    font-size: 11px;
  }
  .book-section {
    padding: 40px 0;
  }
  .latest-blog {
    padding: 40px 0 10px;
  }
  .footer.custom-footer .footer-top {
    padding: 40px 0 10px;
  }
  .app-form h2 {
    font-size: 20px;
  }
  .doc-form {
    padding: 10px;
    left: 0;
  }
  .app-form {
    display: none;
  }
  .dot-slider .slick-slide {
    height: 100%;
  }
  .dot-slider .profile-widget {
    margin: 0;
  }
  .category-sec {
    padding: 30px 0 0;
  }
  .set-category {
    margin-bottom: 30px;
  }
  .clinic-section {
    padding: 30px 0 0;
  }
  .sec-header h2 {
    font-size: 24px;
  }
  .browse-speciality {
    padding: 30px 0 15px;
  }
  .select-box {
    margin-bottom: 30px;
    border-radius: 60px;
  }
  .select-box::before {
    border-radius: 55px;
  }
  .select-box.theme {
    border-radius: 60px;
  }
  .select-box.theme::before {
    border-radius: 55px;
  }
  .set-category h2 {
    bottom: 0;
  }
  .patient-select {
    background: #2264c5 url(${___CSS_LOADER_URL_REPLACEMENT_20___});
    padding: 30px 0 0;
  }
  .select-box h2 {
    font-size: 24px;
  }
  .select-box p {
    font-size: 12px;
  }
  .select-box .book-now {
    font-size: 13px;
  }
  .book-doctor {
    padding: 30px 0;
  }
  .book-slider .provider-info h3 {
    font-size: 18px;
  }
  .book-slider .provider-info h5 {
    font-size: 12px;
  }
  .book-slider .provider-info .side-arrow {
    width: 30px;
    height: 30px;
  }
  .book-slider .available-info li {
    font-size: 13px;
  }
  .book-slider .content-info .view-btn,
  .book-slider .content-info .view-btn:hover,
  .book-slider .content-info .book-btn,
  .book-slider .content-info .book-btn:hover {
    font-size: 12px;
  }
  .book-doctor .row.mt-4 {
    margin-top: 0 !important;
  }
  .book-doctor .view-btn,
  .blogs-section .view-btn {
    font-size: 14px;
  }
  .aval-features .feature {
    padding: 30px;
  }
  .aval-features .feature .info-box h2 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  .aval-features .feature .info-box p {
    margin-bottom: 15px;
    font-size: 13px;
  }
  .aval-features .feature .info-box a {
    font-size: 12px;
    width: 100px;
  }
  .aval-features .col-md-6.pl-0 {
    padding-left: 15px !important;
  }
  .aval-slider .slick-list {
    padding: 30px 0;
  }
  .blogs-section {
    padding: 30px 0;
  }
  .blog-wrapper .wrap-content .date-cart {
    font-size: 22px;
    width: 60px;
    height: 55px;
    padding: 5px;
  }
  .blog-wrapper .wrap-content .date-cart span {
    font-size: 10px;
  }
  .blog-wrapper .wrap-content-body h3 {
    font-size: 17px;
  }
  .home-search-section .banner-header h2 {
    font-size: 30px;
  }
  .heading-wrapper h1 {
    font-size: 24px;
  }
  .clinic-wrap .wrapper-overlay h3 {
    font-size: 20px;
    text-align: center;
  }
  .facility-section .operat-img {
    width: 100%;
    margin-bottom: 20px;
  }
  .visit-doctor .inner-details .info h2,
  .visit-doctor .inner-details .count h2 {
    font-size: 18px;
  }
  .clinic-wrap .wrapper-overlay img {
    margin: 0 auto 0;
  }
  .clinic-wrap .wrapper-overlay p {
    text-align: center;
  }
  .doc-booking .book-slider .slick-list {
    padding-top: 50px;
  }
  .doc-booking .book-slider .slick-prev,
  .doc-booking .book-slider .slick-next {
    top: 0;
  }
  .book-slider .provider-info h3 a {
    font-size: 20px;
  }
  .blog-container .blog-wrapper .wrap-content-body h3 a {
    font-size: 17px;
  }
  .blog-wrapper .wrap-content:before {
    border-left: 170px solid transparent;
    border-right: 160px solid transparent;
  }
  .pop-box {
    margin-bottom: 30px;
  }
}

@media only screen and (max-width: 575.98px) {
  body {
    font-size: 0.8125rem;
  }
  h1,
  .h1 {
    font-size: 1.75rem;
  }
  h2,
  .h2 {
    font-size: 1.5rem;
  }
  h3,
  .h3 {
    font-size: 1.25rem;
  }
  h4,
  .h4 {
    font-size: 1rem;
  }
  h5,
  .h5 {
    font-size: 0.875rem;
  }
  h6,
  .h6 {
    font-size: 0.75rem;
  }
  .card {
    margin-bottom: 0.9375rem;
  }
  .card-body {
    padding: 1.25rem;
  }
  .card-header {
    padding: 0.75rem 1.25rem;
  }
  .card-footer {
    padding: 0.75rem 1.25rem;
  }
  .header-nav {
    padding-left: 15px;
    padding-right: 15px;
  }
  .header-navbar-rht {
    display: none;
  }
  .main-nav li.login-link {
    display: block;
  }
  .navbar-header {
    width: 100%;
  }
  #mobile_btn {
    left: 0;
    margin-right: 0;
    padding: 0 15px;
    position: absolute;
    z-index: 99;
  }
  .navbar-brand.logo {
    width: 100%;
    text-align: center;
    margin-right: 0;
  }
  .navbar-brand.logo img {
    height: 40px;
  }
  .search-box {
    display: block;
  }
  .search-box .search-location {
    width: 100%;
    -ms-flex: none;
    flex: none;
  }
  .search-box .search-info {
    width: 100%;
    -ms-flex: none;
    flex: none;
  }
  .banner-wrapper .banner-header h1 {
    font-size: 28px;
  }
  .slick-next {
    right: 0px;
  }
  .section-header h2 {
    font-size: 1.5rem;
  }
  .section-header .sub-title {
    font-size: 0.875rem;
  }
  .speicality-item p {
    font-size: 0.875rem;
  }
  .section-header p {
    font-size: 0.9375rem;
  }
  .footer-title {
    font-size: 1.125rem;
  }
  .booking-schedule.schedule-widget {
    overflow-x: auto;
  }
  .booking-schedule.schedule-widget > div {
    width: 730px;
  }
  .booking-schedule .day-slot ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .booking-schedule .day-slot li {
    -ms-flex: 0 0 100px;
    flex: 0 0 100px;
    width: 100px;
  }
  .booking-schedule .time-slot ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .booking-schedule .time-slot li {
    -ms-flex: 0 0 100px;
    flex: 0 0 100px;
    width: 100px;
  }
  .booking-schedule .time-slot li .timing span {
    display: inline-block;
  }
  .booking-schedule .day-slot li.right-arrow {
    right: -20px;
  }
  .booking-doc-info .booking-doc-img {
    width: 70px;
  }
  .booking-doc-info .booking-doc-img img {
    height: 70px;
    width: 70px;
  }
  .voice-call-avatar .call-avatar {
    height: 80px;
    width: 80px;
  }
  .call-duration {
    display: block;
    margin-top: 0;
    margin-bottom: 10px;
    position: inherit;
  }
  .end-call {
    margin-top: 10px;
    position: inherit;
  }
  .user-tabs .med-records {
    min-width: 110px;
  }
  .pagination-lg .page-link {
    font-size: 1rem;
    padding: 0.5rem 0.625rem;
  }
  .row.row-grid > div {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .edit-link {
    font-size: 14px;
    margin-top: 2px;
  }
  .invoice-content {
    padding: 1.25rem;
  }
  .change-avatar .profile-img img {
    height: 80px;
    width: 80px;
  }
  .submit-btn-bottom {
    margin-bottom: 0.9375rem;
  }
  .service-list ul li {
    width: 100%;
  }
  .blog {
    padding: 1.25rem;
  }
  .blog-title {
    font-size: 18px;
  }
  .blog-view .blog-title {
    font-size: 20px;
  }
  .blog-info i {
    font-size: 14px;
  }
  .post-left ul li {
    margin-right: 10px;
  }
  .post-left ul li:last-child {
    margin-right: 10px;
  }
  .about-author-img {
    height: 60px;
    width: 60px;
  }
  .author-details {
    margin-left: 80px;
  }
  .blog-comments .comments-list li img.avatar {
    border-radius: 40px;
    height: 40px;
    width: 40px;
  }
  .blog-comments .comments-list li {
    padding: 10px 0 0 50px;
  }
  .read-more {
    font-size: 14px;
  }
}

@media only screen and (max-width: 479px) {
  .section-search {
    min-height: 410px;
    padding: 30px 15px;
  }
  .specialities-slider .slick-slide {
    margin-right: 10px;
  }
  .speicality-img {
    width: 120px;
    height: 120px;
  }
  .speicality-img img {
    width: 50px;
  }
  .clinic-booking a.view-pro-btn {
    width: 100%;
    margin-bottom: 15px;
  }
  .clinic-booking a.apt-btn {
    width: 100%;
  }
  .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-name,
  .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-last-chat {
    max-width: 160px;
  }
  .section-features,
  .section-features,
  .section-specialities {
    background-color: #fff;
    padding: 30px 0;
  }
  .login-header h3 a {
    color: #0de0fe;
    float: none;
    font-size: 15px;
    margin-top: 10px;
    text-align: center;
    display: block;
  }
  .login-header h3 {
    text-align: center;
  }
  .appointments .appointment-list {
    text-align: center;
  }
  .appointment-list .profile-info-widget {
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .appointment-list .profile-info-widget {
    text-align: center;
  }
  .appointment-list .profile-info-widget .booking-doc-img {
    margin: 0 0 15px;
  }
  .appointment-list .profile-info-widget .booking-doc-img img {
    border-radius: 50%;
    height: 100px;
    width: 100px;
  }
  .appointment-list .profile-det-info {
    margin-bottom: 15px;
  }
  .appointments .appointment-action {
    margin-top: 0;
  }
  .user-tabs .nav-tabs .nav-item {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
  }
  .review-listing .recommend-btn span {
    display: block;
    margin-bottom: 10px;
  }
  .review-listing > ul li .comments-reply {
    margin-left: 0;
  }
  .schedule-nav .nav-tabs li {
    display: block;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    margin-right: 0;
  }
  .fc-header-toolbar .fc-left {
    margin-bottom: 10px;
  }
  .fc-header-toolbar .fc-right {
    margin-bottom: 10px;
  }
  .section-header-three h2 {
    font-size: 15px;
  }
  .section-header-three p {
    font-size: 11px;
  }
  .section-search-3 .banner-info {
    padding: 20px 0 70px;
  }
  .special-box .special-body h4 {
    font-size: 15px;
  }
  .special-box .special-footer .doc-count,
  .special-box .special-footer .clin-count {
    font-size: 13px;
  }
  .view-all-more .btn {
    font-size: 14px;
    padding: 6px 20px;
  }
  .section-header-three {
    margin-bottom: 30px;
  }
  .doctor-divison h3 {
    font-size: 14px;
    margin-bottom: 15px;
  }
  .doctor-divison p {
    font-size: 10px;
    margin-bottom: 20px;
  }
  .doctor-divison .doc-bok-btn {
    font-size: 12px;
    padding: 5px 10px;
  }
  .book-best-doctors .doctors-body h4 {
    font-size: 16px;
  }
  .book-best-doctors .loc-details img {
    margin-right: 6px;
  }
  .book-best-doctors .available-info {
    font-size: 11px;
  }
  .book-best-doctors .data-info {
    font-size: 10px;
  }
  .book-best-doctors .amt-txt {
    font-size: 14px;
  }
  .book-best-doctors .doctors-body .book-btn {
    font-size: 12px;
    padding: 5px 10px;
    width: 80px;
  }
  .latest-blog .blog-wrap .blog-wrap-body h3 {
    font-size: 16px;
  }
  .latest-blog .blog-wrap .blog-wrap-body p {
    font-size: 12px;
  }
  .latest-blog .blog-footer .read-txt,
  .latest-blog .blog-footer .cal-txt {
    font-size: 12px;
  }
  .aval-features .feature .info-box h2 {
    font-size: 20px;
  }
  .home-search-section .banner-header h2 {
    font-size: 28px;
  }
  .blog-wrapper .wrap-content:before {
    border-left: 125px solid transparent;
    border-right: 125px solid transparent;
  }
}
.mapgridrating i:not(:last-child) {
  margin-right: 3px;
}
.mapgridrating1 i:not(:last-child) {
  margin-right: 3px;
}
.rating1 i:not(:last-child) {
  margin-right: none !important;
}
.favouritesrating .fa-star {
  font-size: 16px;
}
.mapgridrating1 .fa-star {
  font-size: 16px;
}
.favouritesrating .rating {
  margin-right: unset !important;
}
.rating1 i.filled {
  color: #f3c41b;
}
.fancystyle {
  display: unset !important;
}
.stickyside {
  position: sticky;
  top: 0;
  padding-bottom: 1px;
}

/* @media only screen and (max-width: 576px) {
  .footer {
    display: none;
  }
} */
`, "",{"version":3,"sources":["webpack://./assets/style.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;yCAmDyC;;AAEzC;;wBAEwB;AAGxB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,4CAA2C,EAAE,cAAc;EAC3D;;;8DAG2D;AAC7D;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;;;;;;EAME,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;AACA;;;EAGE,yDAAyD;AAC3D;AACA;;;EAGE,yBAAyB;EACzB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,UAAU;AACZ;AACA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;;wBAEwB;;AAExB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;;EAME,aAAa;EACb,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,gDAAgD;AAClD;AACA;;EAEE,iCAAiC;AACnC;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;wBAEwB;;AAExB;;EAEE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,oCAAoC;AACtC;AACA;;;;EAIE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;;;;EAIE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;;;;EAIE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;;;;EAIE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;;;;EAIE,oCAAoC;AACtC;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;EAKE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;;;;;EASE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;;;EAGE,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;EAKE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;AACA;;;;;;;;;EASE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;;;EAGE,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;EAKE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;;;;;EASE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;;;EAGE,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;EAKE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;;;;;EASE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;;;EAGE,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;EAKE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;;;;;;EASE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;;;EAGE,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;;;EAGE,iBAAiB;AACnB;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,uCAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;AACA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;AACA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;AACA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;AACA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;AACA;EACE,sDAAsD;EACtD,yBAAyB;AAC3B;AACA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;wBAEwB;;AAExB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;;;EAGE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ;;AAEA;;wBAEwB;;AAExB;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;;;EAGE,YAAY;EACZ,UAAU;AACZ;AACA;;;;EAIE,6CAA6C;EAC7C,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;AACA;;;;EAIE,6CAA6C;EAC7C,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;;EAGE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;;AAEA;;wBAEwB;;AAExB;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;;;EAGE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,uBAAuB;AACzB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,mCAAmC;AACrC;AACA;EACE,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;;;EAGE,uBAAuB;AACzB;;AAEA;;wBAEwB;;AAExB;EACE,iCAAiC;EACjC,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;AACvB;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;;wBAEwB;;AAExB;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;;wBAEwB;;AAExB;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;;EAEE,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;;;;EAIE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,iCAAiC;EACjC,6BAA6B;EAC7B,2CAA2C;EAC3C,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;AACA;;;;;;EAME,yBAAyB;EACzB,WAAW;EACX,UAAU;AACZ;AACA;;;;;;EAME,WAAW;EACX,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,OAAO;EACP,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,WAAW;EACX,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,YAAY;AACd;AACA;;;EAGE,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;;wBAEwB;;AAExB;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mDAAmD;EACnD,+CAA+C;EAC/C,8CAA8C;EAC9C,2CAA2C;EAC3C,0BAA0B;EAC1B,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,UAAU;EACV,eAAe;EACf,UAAU;AACZ;AACA;;EAEE,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,UAAU;AACZ;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;;;;EAIE,YAAY;EACZ,UAAU;AACZ;AACA;;;;;EAKE,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;AACA;;;;;EAKE,0CAA0C;EAC1C,uBAAuB;AACzB;AACA;;;;EAIE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;;;EAIE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;;wBAEwB;AACxB;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,0BAA0B;EAC1B,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,sCAAsC;AACxC;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,sBAAsB;EACtB,qDAAqD;EACrD,6BAA6B;EAC7B,qBAAqB;EACrB,iCAAiC;EACjC,yBAAyB;EACzB,gDAAgD;AAClD;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,+BAA+B;EAC/B,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,yCAAyC;EACzC,iCAAiC;EACjC,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;AACA;;wBAEwB;;AAExB;EACE,oCAAoC;EACpC,aAAa;EACb,YAAY;EACZ,OAAO;EACP,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;EAC5B,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;;wBAEwB;;AAExB;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;EACd,oCAAoC;EACpC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;;EAEE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;;wBAEwB;;AAExB;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;EACpB,4BAA4B;EAC5B,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yDAAwD;EACxD,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,oDAAoD;AACtD;AACA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;;EAME,yDAA8D;AAChE;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,oDAAoD;EACpD,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,UAAU;EACV,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yDAAmE;EACnE,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;;;;EAIE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;;;;;EAKE,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;AACb;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;;;EAOE,yDAAmE;AACrE;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,yDAA0D;EAC1D,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;AACA;;;;;EAKE,yDAA8D;AAChE;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;;wBAEwB;;AAExB;EACE,mFAA4E;EAC5E,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,mFAA4E;EAC5E,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,oDAA2C;EAC3C,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,gDAAgD;EAChD,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,+EAAsE;AACxE;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,+EAAoE;AACtE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,aAAa;EACb,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,UAAU;EACV,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,gDAAgD;EAChD,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,+EAAsE;AACxE;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,+EAAoE;AACtE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,WAAW;EACX,WAAW;EACX,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,UAAU;AACZ;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,2BAA2B;EAC3B,OAAO;EACP,QAAQ;EACR,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,wBAAwB;EACxB,8DAA8D;EAC9D,6DAA6D;EAC7D,4DAA4D;EAC5D,iEAAiE;EACjE,yDAAyD;EACzD,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,0CAA0C;EAC1C,sCAAsC;EACtC,kCAAkC;EAClC,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,yDAAyD;AAC3D;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;EACpC,cAAc;EACd,WAAW;EACX,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;AACtC;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,gDAAgD;EAChD,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,+EAAsE;AACxE;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE;AACF;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,mFAA4E;EAC5E,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iFAA0E;EAC1E,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,2CAA2C;EAC3C,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,kDAAkD;AACpD;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,oDAAiD;EACjD,eAAe;EACf,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,aAAa;EACb,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;AACA;;EAEE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,oDAAyC;EACzC,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,oDAA0C;EAC1C,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAiD;EACjD,eAAe;EACf,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;EACV,mDAAmD;EACnD,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,2BAA2B;EAC3B,OAAO;EACP,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,oDAAgD;EAChD,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;EAClD,cAAc;EACd,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,oDAA8C;EAC9C,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;;;;;;;;EAQE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,oDAA2C;EAC3C,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;AACX;AACA;;;EAGE,iBAAiB;AACnB;AACA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,wCAAwC;EACxC,gDAAgD;EAChD,4CAA4C;EAC5C,YAAY;AACd;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,iCAAiC;AACnC;AACA;;;EAGE,WAAW;EACX,uBAAuB;EACvB,+BAA+B;AACjC;AACA;;;;;;EAME,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;AACA;;;EAGE,WAAW;EACX,WAAW;EACX,MAAM;AACR;AACA;;;EAGE,WAAW;EACX,WAAW;EACX,MAAM;AACR;AACA;;;EAGE,cAAc;EACd,cAAc;EACd,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;AACA;;;EAGE,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kDAAkD;EAClD,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,gDAAgD;EAChD,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,oDAAiD;EACjD,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,oDAAyC;EACzC,aAAa;EACb,kCAAkC;EAClC,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;AACA;EACE,oDAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAAqD;EACrD,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;;;;EAIE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,oDAAmD;EACnD,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,yCAAyC;EACzC,iDAAiD;EACjD,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mDAAmD;EACnD,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;;;;EAIE,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,oDAAmD;EACnD,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,oDAAyC;EACzC,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,oDAAyD;EACzD,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;AACA;;EAEE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;AACd;AACA;;wBAEwB;;AAExB;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,MAAM;EACN,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,mCAAmC;EACnC,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;;wBAEwB;;AAExB;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,SAAS;EACT,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;;;EAGE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,wCAAwC;EACxC,gCAAgC;AAClC;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;;wBAEwB;;AAExB;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;;wBAEwB;;AAExB;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,oCAAoC;EACpC,sCAAsC;EACtC,uCAAuC;EACvC,qCAAqC;EACrC,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;;wBAEwB;;AAExB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;wBAEwB;;AAExB;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;;;;EAIE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;;wBAEwB;;AAExB;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,cAAc;;EAEd,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;wBAEwB;;AAExB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;;wBAEwB;;AAExB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;;EAGE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;wBAEwB;;AAExB;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;;wBAEwB;;AAExB;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,OAAO;EACP,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;;;;;;;;;;;;EAYE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;;EAME,cAAc;EACd,0BAA0B;AAC5B;AACA;;;;;;EAME,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,aAAa;EACb,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,kBAAkB;AACpB;AACA;;;;;EAKE,oCAAoC;EACpC,4BAA4B;EAC5B,iCAAiC;EACjC,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;;EAKE,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;EACjC,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;;;;;;;EAOE,WAAW;EACX,SAAS;EACT,gCAAgC;EAChC,gBAAgB;AAClB;AACA;;;;;;;EAOE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;;;;;;;EAOE,2BAA2B;AAC7B;AACA;;;;;;;EAOE,2BAA2B;AAC7B;AACA;;;;;;;;EAQE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;;;;;;;EAOE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;;wBAEwB;;AAExB;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,OAAO;EACP,SAAS;EACT,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,UAAU;EACV,QAAQ;EACR,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;;wBAEwB;;AAExB;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;;;;;EAKE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;AACA;;;;;;;EAOE,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,oCAAoC;EACpC,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,YAAY;AACd;;AAEA;;wBAEwB;;AAExB;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;AACA;;EAEE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;wBAEwB;;AAExB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;;wBAEwB;;AAExB;EACE,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;;wBAEwB;;AAExB;EACE,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;wBAEwB;;AAExB;EACE;;;;;kBAKgB;AAClB;AACA;EACE,SAAS;EACT,OAAO;EACP,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;AACA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,WAAW;EACX,OAAO;AACT;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;EACT,OAAO;EACP,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;EACb,MAAM;EACN,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;wBAEwB;;AAExB;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;;AAEA;;wBAEwB;;AAExB;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,aAAa;EACb,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;AACF;AACA;EACE;IACE,2CAA2C;IAC3C,sCAAsC;EACxC;EACA;IACE,4CAA4C;IAC5C,uCAAuC;EACzC;AACF;;AAEA;;wBAEwB;;AAExB;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA;;wBAEwB;;AAExB;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;wBAEwB;;AAExB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,wBAAwB;EACxB,8DAA8D;EAC9D,6DAA6D;EAC7D,4DAA4D;EAC5D,iEAAiE;EACjE,yDAAyD;AAC3D;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,wBAAwB;EACxB,8DAA8D;EAC9D,6DAA6D;EAC7D,4DAA4D;EAC5D,iEAAiE;EACjE,yDAAyD;AAC3D;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;AACA;EACE,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,qCAAqC;EACrC,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;;wBAEwB;;AAExB;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;;wBAEwB;;AAExB;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;;wBAEwB;;AAExB;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,MAAM;EACN,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,aAAa;AACf;AACA;EACE,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;wBAEwB;;AAExB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,UAAU;EACZ;AACF;;AAEA;;wBAEwB;;AAExB;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;AACA;AACA;AACA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,qBAAqB;AACvB;AACA;;;EAGE,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;;AAEA;;wBAEwB;AACxB;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,yCAAyC;EACzC,aAAa;AACf;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,+CAA+C;EAC/C,gDAAgD;EAChD,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,QAAQ;EACR,6BAA6B;EAC7B,qBAAqB;EACrB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;wBAEwB;;AAExB;EACE,UAAU;EACV,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;;EAKE,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,0CAA0C;EAC1C,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;wBAEwB;;AAExB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;;wBAEwB;;AAExB;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;;;IAGE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,sCAAsC;IACtC,cAAc;IACd,eAAe;IACf,OAAO;IACP,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,iCAAiC;IACjC,yBAAyB;IACzB,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;IAC3B,SAAS;IACT,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,+CAA+C;IAC/C,gDAAgD;IAChD,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,6BAA6B;IAC7B,qBAAqB;IACrB,iCAAiC;IACjC,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,gCAAgC;IAChC,4BAA4B;IAC5B,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,6BAA6B;EAC/B;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;;;;;IAKE,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,UAAU;IACV,MAAM;IACN,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,kBAAkB;IAClB,2CAA2C;IAC3C,+CAA+C;EACjD;EACA;IACE,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,gCAAgC;IAChC,4BAA4B;IAC5B,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,iCAAiC;IACjC,yBAAyB;IACzB,cAAc;IACd,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;EAC7B;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;EACd;AACF;AACA;EACE;;;;;;;;;;;;IAYE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;EACvB;AACF;AACA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,oCAAoC;IACpC,qCAAqC;EACvC;AACF;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;;;;;;;;;;;;IAYE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,UAAU;IACV,0BAA0B;IAC1B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,eAAe;EACjB;EACA;IACE,gCAAgC;IAChC,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,aAAa;IACb,WAAW;IACX,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,oBAAoB;IACpB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,+DAA+D;IAC/D,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;IACX,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,QAAQ;IACR,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gCAAgC;IAChC,eAAe;IACf,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,oCAAoC;IACpC,qCAAqC;EACvC;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;;IAEE,eAAe;EACjB;EACA;;IAEE,kBAAkB;EACpB;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,eAAe;EACjB;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;;;;;;;;;;;;IAYE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,qBAAqB;IACrB,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;;;IAGE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;;;IAGE,yDAAyD;IACzD,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,8BAA8B;EAChC;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;;;;IAKE,oEAAoE;IACpE,sBAAsB;EACxB;EACA;;;IAGE,yBAAyB;EAC3B;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;;;IAGE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,oBAAoB;EACtB;EACA;;;IAGE,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;;;;;;;IAQE,WAAW;IACX,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,OAAO;EACT;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,SAAS;EACX;EACA;IACE,4DAAyD;IACzD,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;;;;IAIE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,MAAM;EACR;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,oCAAoC;IACpC,qCAAqC;EACvC;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,kBAAkB;EACpB;EACA;;IAEE,iBAAiB;EACnB;EACA;;IAEE,kBAAkB;EACpB;EACA;;IAEE,eAAe;EACjB;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,OAAO;IACP,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,cAAc;IACd,UAAU;EACZ;EACA;IACE,WAAW;IACX,cAAc;IACd,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;;;;;;;;;;;;IAYE,gBAAgB;EAClB;EACA;;;IAGE,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,oCAAoC;IACpC,qCAAqC;EACvC;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;AACrB;;AAEA;;;;GAIG","sourcesContent":["/*\nAuthor       : Dreamguys\nTemplate Name: Doccure - Bootstrap Template\nVersion      : 1.3\n*/\n\n/*============================\n [Table of CSS]\n\n1. General\n2. Table\n3. Bootstrap Classes\n4. Avatar\n5. Select2\n6. Nav Tabs\n7. Modal\n8. Components\n9. Slick Slider\n10. Focus Label\n11. Header\n12. Mobile Menu\n13. Footer\n14. Login\n15. Home\n16. Search\n17. Doctor Profile\n18. Booking\n19. Checkout\n20. Booking Success\n21. Invoice View\n22. Schedule Timings\n23. Doctor Dashboard\n24. Patient Profile\n25. Add Billing\n26. Chat\n27. Doctor Profile Settings\n28. Calendar\n29. Patient Dashboard\n30. Profile Settings\n31. Appoitment List\n32. Reviews\n33. Voice call\n34. Video Call\n35. Outgoing Call\n36. Incoming Call\n37. Terms and Conditions\n38. Blog\n39. Blog Details\n40. Blog Grid\n41. Map List & Grid\n42. Loader\n43. Product\n44. Cart\n45. Slider\n46. Account\n47. Responsive\n\n========================================*/\n\n/*-----------------\n\t1. General\n-----------------------*/\n\n@import url(\"https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700,900\");\n@font-face {\n  font-family: \"Material Icons\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(./fonts/MaterialIcons-Regular.eot); /* For IE6-8 */\n  src: local(\"Material Icons\"), local(\"MaterialIcons-Regular\"),\n    url(./fonts/MaterialIcons-Regular.woff2) format(\"woff2\"),\n    url(./fonts/MaterialIcons-Regular.woff) format(\"woff\"),\n    url(./fonts/MaterialIcons-Regular.ttf) format(\"truetype\");\n}\n\n.material-icons {\n  font-family: \"Material Icons\";\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  display: inline-block;\n  line-height: 1;\n  text-transform: none;\n  letter-spacing: normal;\n  word-wrap: normal;\n  white-space: nowrap;\n  direction: ltr;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  -moz-osx-font-smoothing: grayscale;\n  font-feature-settings: \"liga\";\n}\n\nhtml {\n  height: 100%;\n}\nbody {\n  background-color: #f8f9fa;\n  color: #272b41;\n  font-family: \"Poppins\", sans-serif;\n  /* font-size: 0.9375rem; */\n  font-size: 14px;\n  height: 100%;\n  overflow-x: hidden;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: #272b41;\n  font-weight: 500;\n}\n.h1,\nh1 {\n  font-size: 2.1rem;\n}\n.h2,\nh2 {\n  font-size: 1.77rem;\n}\n.h3,\nh3 {\n  font-size: 1.4rem;\n}\n.h4,\nh4 {\n  font-size: 1.1rem;\n}\n.h5,\nh5 {\n  font-size: 0.9rem;\n}\n.h6,\nh6 {\n  font-size: 0.7rem;\n}\n\na {\n  color: #2e3842;\n}\na:hover {\n  color: #1f6dff;\n}\na:hover,\na:active,\na:focus {\n  outline: none;\n  text-decoration: none;\n}\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0px 1000px white inset !important;\n}\ninput,\nbutton,\na {\n  transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  -webkit-transition: all 0.4s ease;\n}\nbutton:focus {\n  outline: 0;\n}\ninput[type=\"text\"],\ninput[type=\"password\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n.btn.focus,\n.btn:focus {\n  box-shadow: inherit;\n}\n.form-control {\n  border-color: #dcdcdc;\n  color: #333;\n  font-size: 15px;\n  min-height: 46px;\n  padding: 6px 15px;\n}\n.table .form-control {\n  font-size: 14px;\n  min-height: 38px;\n}\n.container-fluid {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n.form-control::-webkit-input-placeholder {\n  color: #858585;\n  font-size: 14px;\n}\n.form-control::-moz-placeholder {\n  color: #858585;\n  font-size: 14px;\n}\n.form-control:-ms-input-placeholder {\n  color: #858585;\n  font-size: 14px;\n}\n.form-control::-ms-input-placeholder {\n  color: #858585;\n  font-size: 14px;\n}\n.form-control::placeholder {\n  color: #858585;\n  font-size: 14px;\n}\n.list-group-item {\n  border: 1px solid #f0f0f0;\n}\n.content {\n  min-height: 560px !important;\n  padding: 30px 0 0;\n}\n\n/*-----------------\n\t2. Table\n-----------------------*/\n\n.table {\n  color: #272b41;\n  max-width: 100%;\n  margin-bottom: 0;\n  width: 100%;\n}\n.table-striped > tbody > tr:nth-of-type(2n + 1) {\n  background-color: #f8f9fa;\n}\n.table.no-border > tbody > tr > td,\n.table > tbody > tr > th,\n.table.no-border > tfoot > tr > td,\n.table.no-border > tfoot > tr > th,\n.table.no-border > thead > tr > td,\n.table.no-border > thead > tr > th {\n  border-top: 0;\n  padding: 10px 8px;\n}\n.table-nowrap td,\n.table-nowrap th {\n  white-space: nowrap;\n}\n.table.dataTable {\n  border-collapse: collapse !important;\n}\ntable.table td h2 {\n  display: inline-block;\n  font-size: inherit;\n  font-weight: 400;\n  margin: 0;\n  padding: 0;\n  vertical-align: middle;\n}\ntable.table td h2.table-avatar {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  font-size: inherit;\n  font-weight: 400;\n  margin: 0;\n  padding: 0;\n  vertical-align: middle;\n  white-space: nowrap;\n}\ntable.table td h2 a {\n  color: #272b41;\n}\ntable.table td h2 a:hover {\n  color: #09dca4;\n}\ntable.table td h2 span {\n  color: #888;\n  display: block;\n  font-size: 12px;\n  margin-top: 3px;\n}\n.table thead {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.03);\n}\n.table thead tr th {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.table tbody tr {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.table tbody tr:last-child {\n  border-color: transparent;\n}\n.table.table-center td,\n.table.table-center th {\n  vertical-align: middle;\n}\n.table-hover tbody tr:hover {\n  background-color: #f7f7f7;\n}\n.table-hover tbody tr:hover td {\n  color: #474648;\n}\n.table-striped thead tr {\n  border-color: transparent;\n}\n.table-striped tbody tr {\n  border-color: transparent;\n}\n.table-striped tbody tr:nth-of-type(even) {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(235, 235, 235, 0.4);\n}\n.table-bordered {\n  border: 1px solid rgba(0, 0, 0, 0.05) !important;\n}\n.table-bordered th,\n.table-bordered td {\n  border-color: rgba(0, 0, 0, 0.05);\n}\n.card-table .card-body {\n  padding: 0;\n}\n.card-table .card-body .table > thead > tr > th {\n  border-top: 0;\n}\n.card-table .table tr td:first-child,\n.card-table .table tr th:first-child {\n  padding-left: 1.5rem;\n}\n.card-table .table tr td:last-child,\n.card-table .table tr th:last-child {\n  padding-right: 1.5rem;\n}\n.card-table .table td,\n.card-table .table th {\n  border-top: 1px solid #e2e5e8;\n  padding: 1rem 0.75rem;\n  white-space: nowrap;\n}\n\n/*-----------------\n\t3. Bootstrap Classes\n-----------------------*/\n\n.btn.focus,\n.btn:focus {\n  box-shadow: unset;\n}\n.btn-white {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  color: #272b41;\n}\n.btn.btn-rounded {\n  border-radius: 50px;\n}\n.bg-primary,\n.badge-primary {\n  background-color: #09e5ab !important;\n}\na.bg-primary:focus,\na.bg-primary:hover,\nbutton.bg-primary:focus,\nbutton.bg-primary:hover {\n  background-color: #09dca4 !important;\n}\n.bg-success,\n.badge-success {\n  background-color: #00e65b !important;\n}\na.bg-success:focus,\na.bg-success:hover,\nbutton.bg-success:focus,\nbutton.bg-success:hover {\n  background-color: #00cc52 !important;\n}\n.bg-info,\n.badge-info {\n  background-color: #009efb !important;\n}\na.bg-info:focus,\na.bg-info:hover,\nbutton.bg-info:focus,\nbutton.bg-info:hover {\n  background-color: #028ee1 !important;\n}\n.bg-warning,\n.badge-warning {\n  background-color: #ffbc34 !important;\n}\na.bg-warning:focus,\na.bg-warning:hover,\nbutton.bg-warning:focus,\nbutton.bg-warning:hover {\n  background-color: #e9ab2e !important;\n}\n.bg-danger,\n.badge-danger {\n  background-color: #ff0100 !important;\n}\na.bg-danger:focus,\na.bg-danger:hover,\nbutton.bg-danger:focus,\nbutton.bg-danger:hover {\n  background-color: #e63333 !important;\n}\n.bg-white {\n  background-color: #fff;\n}\n.bg-purple,\n.badge-purple {\n  background-color: #9368e9 !important;\n}\n.text-primary,\n.dropdown-menu > li > a.text-primary {\n  color: #09e5ab !important;\n}\n.text-success,\n.dropdown-menu > li > a.text-success {\n  color: #00cc52 !important;\n}\n.text-danger,\n.dropdown-menu > li > a.text-danger {\n  color: #ff0100 !important;\n}\n.text-info,\n.dropdown-menu > li > a.text-info {\n  color: #009efb !important;\n}\n.text-warning,\n.dropdown-menu > li > a.text-warning {\n  color: #ffbc34 !important;\n}\n.text-purple,\n.dropdown-menu > li > a.text-purple {\n  color: #7460ee !important;\n}\n.text-muted {\n  color: #757575 !important;\n}\n.btn-primary {\n  background-color: #09e5ab;\n  border: 1px solid #09e5ab;\n}\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary.active,\n.btn-primary:active,\n.open > .dropdown-toggle.btn-primary {\n  background-color: #09dca4;\n  border: 1px solid #09dca4;\n}\n.btn-primary.active.focus,\n.btn-primary.active:focus,\n.btn-primary.active:hover,\n.btn-primary.focus:active,\n.btn-primary:active:focus,\n.btn-primary:active:hover,\n.open > .dropdown-toggle.btn-primary.focus,\n.open > .dropdown-toggle.btn-primary:focus,\n.open > .dropdown-toggle.btn-primary:hover {\n  background-color: #09dca4;\n  border: 1px solid #09dca4;\n}\n.btn-primary.active:not(:disabled):not(.disabled),\n.btn-primary:active:not(:disabled):not(.disabled),\n.show > .btn-primary.dropdown-toggle {\n  background-color: #09dca4;\n  border-color: #09dca4;\n  color: #fff;\n}\n.btn-primary.active:focus:not(:disabled):not(.disabled),\n.btn-primary:active:focus:not(:disabled):not(.disabled),\n.show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.btn-primary.disabled,\n.btn-primary:disabled {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n  color: #fff;\n}\n.btn-secondary.active:focus:not(:disabled):not(.disabled),\n.btn-secondary:active:focus:not(:disabled):not(.disabled),\n.show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.btn-success {\n  background-color: #00e65b;\n  border: 1px solid #00e65b;\n}\n.btn-success:hover,\n.btn-success:focus,\n.btn-success.active,\n.btn-success:active,\n.open > .dropdown-toggle.btn-success {\n  background-color: #00cc52;\n  border: 1px solid #00cc52;\n  color: #fff;\n}\n.btn-success.active.focus,\n.btn-success.active:focus,\n.btn-success.active:hover,\n.btn-success.focus:active,\n.btn-success:active:focus,\n.btn-success:active:hover,\n.open > .dropdown-toggle.btn-success.focus,\n.open > .dropdown-toggle.btn-success:focus,\n.open > .dropdown-toggle.btn-success:hover {\n  background-color: #00cc52;\n  border: 1px solid #00cc52;\n}\n.btn-success.active:not(:disabled):not(.disabled),\n.btn-success:active:not(:disabled):not(.disabled),\n.show > .btn-success.dropdown-toggle {\n  background-color: #00cc52;\n  border-color: #00cc52;\n  color: #fff;\n}\n.btn-success.active:focus:not(:disabled):not(.disabled),\n.btn-success:active:focus:not(:disabled):not(.disabled),\n.show > .btn-success.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.btn-success.disabled,\n.btn-success:disabled {\n  background-color: #00e65b;\n  border-color: #00e65b;\n  color: #fff;\n}\n.btn-info {\n  background-color: #009efb;\n  border: 1px solid #009efb;\n}\n.btn-info:hover,\n.btn-info:focus,\n.btn-info.active,\n.btn-info:active,\n.open > .dropdown-toggle.btn-info {\n  background-color: #028ee1;\n  border: 1px solid #028ee1;\n}\n.btn-info.active.focus,\n.btn-info.active:focus,\n.btn-info.active:hover,\n.btn-info.focus:active,\n.btn-info:active:focus,\n.btn-info:active:hover,\n.open > .dropdown-toggle.btn-info.focus,\n.open > .dropdown-toggle.btn-info:focus,\n.open > .dropdown-toggle.btn-info:hover {\n  background-color: #028ee1;\n  border: 1px solid #028ee1;\n}\n.btn-info.active:not(:disabled):not(.disabled),\n.btn-info:active:not(:disabled):not(.disabled),\n.show > .btn-info.dropdown-toggle {\n  background-color: #028ee1;\n  border-color: #028ee1;\n  color: #fff;\n}\n.btn-info.active:focus:not(:disabled):not(.disabled),\n.btn-info:active:focus:not(:disabled):not(.disabled),\n.show > .btn-info.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.btn-info.disabled,\n.btn-info:disabled {\n  background-color: #009efb;\n  border-color: #009efb;\n  color: #fff;\n}\n.btn-warning {\n  background-color: #ffbc34;\n  border: 1px solid #ffbc34;\n}\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning.active,\n.btn-warning:active,\n.open > .dropdown-toggle.btn-warning {\n  background-color: #e9ab2e;\n  border: 1px solid #e9ab2e;\n}\n.btn-warning.active.focus,\n.btn-warning.active:focus,\n.btn-warning.active:hover,\n.btn-warning.focus:active,\n.btn-warning:active:focus,\n.btn-warning:active:hover,\n.open > .dropdown-toggle.btn-warning.focus,\n.open > .dropdown-toggle.btn-warning:focus,\n.open > .dropdown-toggle.btn-warning:hover {\n  background-color: #e9ab2e;\n  border: 1px solid #e9ab2e;\n}\n.btn-warning.active:not(:disabled):not(.disabled),\n.btn-warning:active:not(:disabled):not(.disabled),\n.show > .btn-warning.dropdown-toggle {\n  background-color: #e9ab2e;\n  border-color: #e9ab2e;\n  color: #fff;\n}\n.btn-warning.active:focus:not(:disabled):not(.disabled),\n.btn-warning:active:focus:not(:disabled):not(.disabled),\n.show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.btn-warning.disabled,\n.btn-warning:disabled {\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n  color: #fff;\n}\n.btn-danger {\n  background-color: #ff0100;\n  border: 1px solid #ff0100;\n}\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger.active,\n.btn-danger:active,\n.open > .dropdown-toggle.btn-danger {\n  background-color: #e63333;\n  border: 1px solid #e63333;\n}\n.btn-danger.active.focus,\n.btn-danger.active:focus,\n.btn-danger.active:hover,\n.btn-danger.focus:active,\n.btn-danger:active:focus,\n.btn-danger:active:hover,\n.open > .dropdown-toggle.btn-danger.focus,\n.open > .dropdown-toggle.btn-danger:focus,\n.open > .dropdown-toggle.btn-danger:hover {\n  background-color: #e63333;\n  border: 1px solid #e63333;\n}\n.btn-danger.active:not(:disabled):not(.disabled),\n.btn-danger:active:not(:disabled):not(.disabled),\n.show > .btn-danger.dropdown-toggle {\n  background-color: #e63333;\n  border-color: #e63333;\n  color: #fff;\n}\n.btn-danger.active:focus:not(:disabled):not(.disabled),\n.btn-danger:active:focus:not(:disabled):not(.disabled),\n.show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.btn-danger.disabled,\n.btn-danger:disabled {\n  background-color: #f62d51;\n  border-color: #f62d51;\n  color: #fff;\n}\n.btn-light.active:focus:not(:disabled):not(.disabled),\n.btn-light:active:focus:not(:disabled):not(.disabled),\n.show > .btn-light.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.btn-dark.active:focus:not(:disabled):not(.disabled),\n.btn-dark:active:focus:not(:disabled):not(.disabled),\n.show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n.btn-outline-primary {\n  color: #09e5ab;\n  border-color: #09e5ab;\n}\n.btn-outline-primary:hover {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n}\n.btn-outline-primary:focus,\n.btn-outline-primary.focus {\n  box-shadow: none;\n}\n.btn-outline-primary.disabled,\n.btn-outline-primary:disabled {\n  color: #09e5ab;\n  background-color: transparent;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active,\n.btn-outline-primary:not(:disabled):not(.disabled).active,\n.show > .btn-outline-primary.dropdown-toggle {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus,\n.btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: none;\n}\n.btn-outline-success {\n  color: #00e65b;\n  border-color: #00e65b;\n}\n.btn-outline-success:hover {\n  background-color: #00e65b;\n  border-color: #00e65b;\n}\n.btn-outline-success:focus,\n.btn-outline-success.focus {\n  box-shadow: none;\n}\n.btn-outline-success.disabled,\n.btn-outline-success:disabled {\n  color: #00e65b;\n  background-color: transparent;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active,\n.btn-outline-success:not(:disabled):not(.disabled).active,\n.show > .btn-outline-success.dropdown-toggle {\n  background-color: #00e65b;\n  border-color: #00e65b;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active:focus,\n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-success.dropdown-toggle:focus {\n  box-shadow: none;\n}\n.btn-outline-info {\n  color: #009efb;\n  border-color: #009efb;\n}\n.btn-outline-info:hover {\n  color: #fff;\n  background-color: #009efb;\n  border-color: #009efb;\n}\n.btn-outline-info:focus,\n.btn-outline-info.focus {\n  box-shadow: none;\n}\n.btn-outline-info.disabled,\n.btn-outline-info:disabled {\n  background-color: transparent;\n  color: #009efb;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active,\n.btn-outline-info:not(:disabled):not(.disabled).active,\n.show > .btn-outline-info.dropdown-toggle {\n  background-color: #009efb;\n  border-color: #009efb;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active:focus,\n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-info.dropdown-toggle:focus {\n  box-shadow: none;\n}\n.btn-outline-warning {\n  color: #ffbc34;\n  border-color: #ffbc34;\n}\n.btn-outline-warning:hover {\n  color: #212529;\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n}\n.btn-outline-warning:focus,\n.btn-outline-warning.focus {\n  box-shadow: none;\n}\n.btn-outline-warning.disabled,\n.btn-outline-warning:disabled {\n  background-color: transparent;\n  color: #ffbc34;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active,\n.btn-outline-warning:not(:disabled):not(.disabled).active,\n.show > .btn-outline-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus,\n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: none;\n}\n.btn-outline-danger {\n  color: #ff0100;\n  border-color: #ff0100;\n}\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #ff0100;\n  border-color: #ff0100;\n}\n.btn-outline-danger:focus,\n.btn-outline-danger.focus {\n  box-shadow: none;\n}\n.btn-outline-danger.disabled,\n.btn-outline-danger:disabled {\n  background-color: transparent;\n  color: #ff0100;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active,\n.btn-outline-danger:not(:disabled):not(.disabled).active,\n.show > .btn-outline-danger.dropdown-toggle {\n  background-color: #ff0100;\n  border-color: #ff0100;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus,\n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: none;\n}\n.btn-outline-light {\n  color: #ababab;\n  border-color: #e6e6e6;\n}\n.btn-outline-light.disabled,\n.btn-outline-light:disabled {\n  color: #ababab;\n}\n.add-btn {\n  max-width: 140px;\n}\n.pagination > .active > a,\n.pagination > .active > a:focus,\n.pagination > .active > a:hover,\n.pagination > .active > span,\n.pagination > .active > span:focus,\n.pagination > .active > span:hover {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n}\n.pagination > li > a,\n.pagination > li > span {\n  color: #20c0f3;\n}\n.page-link:hover {\n  color: #20c0f3;\n}\n.page-link:focus {\n  box-shadow: unset;\n}\n.page-item.active .page-link {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n}\n.dropdown-menu {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n  box-shadow: inherit;\n  font-size: 14px;\n  transform-origin: left top 0;\n}\n.dropdown-item.active,\n.dropdown-item:active {\n  background-color: #0de0fe;\n}\n.navbar-nav .open .dropdown-menu {\n  border: 0;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n}\n.card {\n  border: 1px solid #f0f0f0;\n  margin-bottom: 1.875rem;\n}\n.card-body {\n  padding: 1.5rem;\n}\n.card-title {\n  margin-bottom: 15px;\n}\n.card-header {\n  border-bottom: 1px solid #f0f0f0;\n  padding: 1rem 1.5rem;\n}\n.card-footer {\n  background-color: #fff;\n  border-top: 1px solid #f0f0f0;\n  padding: 1rem 1.5rem;\n}\n.card .card-header {\n  background-color: #fff;\n  border-bottom: 1px solid #f0f0f0;\n}\n.card .card-header .card-title {\n  margin-bottom: 0;\n}\n.btn-light {\n  border-color: #e6e6e6;\n  color: #a6a6a6;\n}\n.bootstrap-datetimepicker-widget table td.active,\n.bootstrap-datetimepicker-widget table td.active:hover {\n  background-color: #20c0f3;\n  text-shadow: unset;\n}\n.bootstrap-datetimepicker-widget table td.today::before {\n  border-bottom-color: #20c0f3;\n}\n.bg-info-light {\n  background-color: rgba(2, 182, 179, 0.12) !important;\n  color: #1db9aa !important;\n}\n.bg-primary-light {\n  background-color: rgba(17, 148, 247, 0.12) !important;\n  color: #2196f3 !important;\n}\n.bg-danger-light {\n  background-color: rgba(242, 17, 54, 0.12) !important;\n  color: #e63c3c !important;\n}\n.bg-warning-light {\n  background-color: rgba(255, 152, 0, 0.12) !important;\n  color: #f39c12 !important;\n}\n.bg-success-light {\n  background-color: rgba(15, 183, 107, 0.12) !important;\n  color: #26af48 !important;\n}\n.bg-purple-light {\n  background-color: rgba(197, 128, 255, 0.12) !important;\n  color: #c580ff !important;\n}\n.bg-default-light {\n  background-color: rgba(40, 52, 71, 0.12) !important;\n  color: #283447 !important;\n}\n.text-xs {\n  font-size: 0.75rem !important;\n}\n.text-sm {\n  font-size: 0.875rem !important;\n}\n.text-lg {\n  font-size: 1.25rem !important;\n}\n.text-xl {\n  font-size: 1.5rem !important;\n}\n.form-control:focus {\n  border-color: #bbb;\n  box-shadow: none;\n  outline: 0 none;\n}\n.form-group {\n  margin-bottom: 1.25rem;\n}\n.slider-btn {\n  background: #09e5ab;\n  color: #fff;\n  border: 1px solid #09e5ab;\n  padding: 8px 16px !important;\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n.slider-btn:hover {\n  background: #fff;\n  color: #09e5ab;\n  border: 1px solid #fff;\n  padding: 8px 16px !important;\n}\n.slider-btn-1 {\n  color: #fff;\n  border: 1px solid #0d2b77;\n  background: #2e3842;\n  padding: 8px 16px !important;\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n.slider-btn-1:hover {\n  color: #2e3842;\n  border: 1px solid #fff;\n  background: #fff;\n  padding: 8px 16px !important;\n}\n\n/*-----------------\n\t4. Avatar\n-----------------------*/\n\n.avatar {\n  position: relative;\n  display: inline-block;\n  width: 3rem;\n  height: 3rem;\n}\n.avatar > img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.avatar-title {\n  width: 100%;\n  height: 100%;\n  background-color: #20c0f3;\n  color: #fff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.avatar-away::before,\n.avatar-offline::before,\n.avatar-online::before {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 25%;\n  height: 25%;\n  border-radius: 50%;\n  content: \"\";\n  border: 2px solid #fff;\n}\n.avatar-online::before {\n  background-color: #00e65b;\n}\n.avatar-offline::before {\n  background-color: #ff0100;\n}\n.avatar-away::before {\n  background-color: #ffbc34;\n}\n.avatar .border {\n  border-width: 3px !important;\n}\n.avatar .rounded {\n  border-radius: 6px !important;\n}\n.avatar .avatar-title {\n  font-size: 18px;\n}\n.avatar-xs {\n  width: 1.65rem;\n  height: 1.65rem;\n}\n.avatar-xs .border {\n  border-width: 2px !important;\n}\n.avatar-xs .rounded {\n  border-radius: 4px !important;\n}\n.avatar-xs .avatar-title {\n  font-size: 12px;\n}\n.avatar-xs.avatar-away::before,\n.avatar-xs.avatar-offline::before,\n.avatar-xs.avatar-online::before {\n  border-width: 1px;\n}\n.avatar-sm {\n  width: 2.5rem;\n  height: 2.5rem;\n}\n.avatar-sm .border {\n  border-width: 3px !important;\n}\n.avatar-sm .rounded {\n  border-radius: 4px !important;\n}\n.avatar-sm .avatar-title {\n  font-size: 15px;\n}\n.avatar-sm.avatar-away::before,\n.avatar-sm.avatar-offline::before,\n.avatar-sm.avatar-online::before {\n  border-width: 2px;\n}\n.avatar-lg {\n  width: 3.75rem;\n  height: 3.75rem;\n}\n.avatar-lg .border {\n  border-width: 3px !important;\n}\n.avatar-lg .rounded {\n  border-radius: 8px !important;\n}\n.avatar-lg .avatar-title {\n  font-size: 24px;\n}\n.avatar-lg.avatar-away::before,\n.avatar-lg.avatar-offline::before,\n.avatar-lg.avatar-online::before {\n  border-width: 3px;\n}\n.avatar-xl {\n  width: 5rem;\n  height: 5rem;\n}\n.avatar-xl .border {\n  border-width: 4px !important;\n}\n.avatar-xl .rounded {\n  border-radius: 8px !important;\n}\n.avatar-xl .avatar-title {\n  font-size: 28px;\n}\n.avatar-xl.avatar-away::before,\n.avatar-xl.avatar-offline::before,\n.avatar-xl.avatar-online::before {\n  border-width: 4px;\n}\n.avatar-xxl {\n  width: 5.125rem;\n  height: 5.125rem;\n}\n.avatar-xxl .border {\n  border-width: 6px !important;\n}\n.avatar-xxl .rounded {\n  border-radius: 8px !important;\n}\n.avatar-xxl .avatar-title {\n  font-size: 30px;\n}\n.avatar-xxl.avatar-away::before,\n.avatar-xxl.avatar-offline::before,\n.avatar-xxl.avatar-online::before {\n  border-width: 4px;\n}\n.avatar-group {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.avatar-group .avatar + .avatar {\n  margin-left: -0.75rem;\n}\n.avatar-group .avatar-xs + .avatar-xs {\n  margin-left: -0.40625rem;\n}\n.avatar-group .avatar-sm + .avatar-sm {\n  margin-left: -0.625rem;\n}\n.avatar-group .avatar-lg + .avatar-lg {\n  margin-left: -1rem;\n}\n.avatar-group .avatar-xl + .avatar-xl {\n  margin-left: -1.28125rem;\n}\n.avatar-group .avatar:hover {\n  z-index: 1;\n}\n\n/*-----------------\n\t5. Select2\n-----------------------*/\n\n.select2-results__option {\n  padding: 6px 15px;\n}\n.select2-container .select2-selection--single {\n  border: 1px solid #dcdcdc;\n  height: 46px;\n}\n.select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow {\n  height: 44px;\n  right: 7px;\n}\n.select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  border-color: #dcdcdc transparent transparent;\n  border-style: solid;\n  border-width: 6px 6px 0;\n  height: 0;\n  left: 50%;\n  margin-left: -10px;\n  margin-top: -2px;\n  position: absolute;\n  top: 50%;\n  width: 0;\n}\n.select2-container--default.select2-container--open\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  border-color: transparent transparent #dcdcdc;\n  border-width: 0 6px 6px;\n}\n.select2-container .select2-selection--single .select2-selection__rendered {\n  padding-right: 30px;\n  padding-left: 15px;\n}\n.select2-container--default\n  .select2-selection--single\n  .select2-selection__rendered {\n  color: #272b41;\n  font-size: 15px;\n  font-weight: normal;\n  line-height: 44px;\n}\n.select2-container--default\n  .select2-results__option--highlighted[aria-selected] {\n  background-color: #20c0f3;\n}\n.select2-container--default .select2-selection--multiple {\n  border: 1px solid #dcdcdc;\n  min-height: 46px;\n}\n.select2-dropdown {\n  border-color: #dcdcdc;\n}\n\n/*-----------------\n\t6. Nav Tabs\n-----------------------*/\n\n.nav-tabs {\n  border-bottom: 1px solid #f0f0f0;\n}\n.card-header-tabs {\n  border-bottom: 0;\n}\n.nav-tabs > li > a {\n  margin-right: 0;\n  color: #888;\n  border-radius: 0;\n}\n.nav-tabs > li > a:hover,\n.nav-tabs > li > a:focus {\n  border-color: transparent;\n  color: #272b41;\n}\n.nav-tabs.nav-tabs-solid > li > a {\n  color: #272b41;\n}\n.nav-tabs.nav-tabs-solid > .active > a,\n.nav-tabs.nav-tabs-solid > .active > a:hover,\n.nav-tabs.nav-tabs-solid > .active > a:focus {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n  color: #fff;\n}\n.tab-content {\n  padding-top: 20px;\n}\n.nav-tabs .nav-link {\n  border-radius: 0;\n}\n.nav-tabs .nav-link:focus,\n.nav-tabs .nav-link:hover {\n  background-color: #eee;\n  border-color: transparent;\n  color: #272b41;\n}\n.nav-tabs.nav-justified > li > a {\n  border-radius: 0;\n  margin-bottom: 0;\n}\n.nav-tabs.nav-justified > li > a:hover,\n.nav-tabs.nav-justified > li > a:focus {\n  border-bottom-color: #ddd;\n}\n.nav-tabs.nav-justified.nav-tabs-solid > li > a {\n  border-color: transparent;\n}\n.nav-tabs.nav-tabs-solid > li > a {\n  color: #272b41;\n}\n.nav-tabs.nav-tabs-solid > li > a.active,\n.nav-tabs.nav-tabs-solid > li > a.active:hover,\n.nav-tabs.nav-tabs-solid > li > a.active:focus {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n  color: #fff;\n}\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded {\n  border-radius: 50px;\n}\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a {\n  border-radius: 50px;\n}\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {\n  border-radius: 50px;\n}\n.nav-tabs-justified > li > a {\n  border-radius: 0;\n  margin-bottom: 0;\n}\n.nav-tabs-justified > li > a:hover,\n.nav-tabs-justified > li > a:focus {\n  border-bottom-color: #ddd;\n}\n.nav-tabs-justified.nav-tabs-solid > li > a {\n  border-color: transparent;\n}\n.nav-tabs.nav-justified.nav-tabs-top {\n  border-bottom: 1px solid #ddd;\n}\n.nav-tabs.nav-justified.nav-tabs-top > li > a,\n.nav-tabs.nav-justified.nav-tabs-top > li > a:hover,\n.nav-tabs.nav-justified.nav-tabs-top > li > a:focus {\n  border-width: 2px 0 0 0;\n}\n.nav-tabs.nav-tabs-top > li {\n  margin-bottom: 0;\n}\n.nav-tabs.nav-tabs-top > li > a,\n.nav-tabs.nav-tabs-top > li > a:hover,\n.nav-tabs.nav-tabs-top > li > a:focus {\n  border-width: 2px 0 0 0;\n}\n.nav-tabs.nav-tabs-top > li.open > a,\n.nav-tabs.nav-tabs-top > li > a:hover,\n.nav-tabs.nav-tabs-top > li > a:focus {\n  border-top-color: #ddd;\n}\n.nav-tabs.nav-tabs-top > li + li > a {\n  margin-left: 1px;\n}\n.nav-tabs.nav-tabs-top > li > a.active,\n.nav-tabs.nav-tabs-top > li > a.active:hover,\n.nav-tabs.nav-tabs-top > li > a.active:focus {\n  border-top-color: #20c0f3;\n}\n.nav-tabs.nav-tabs-bottom > li > a.active,\n.nav-tabs.nav-tabs-bottom > li > a.active:hover,\n.nav-tabs.nav-tabs-bottom > li > a.active:focus {\n  border-bottom-width: 2px;\n  border-color: transparent;\n  border-bottom-color: #20c0f3;\n  background-color: transparent;\n  transition: none 0s ease 0s;\n  -moz-transition: none 0s ease 0s;\n  -o-transition: none 0s ease 0s;\n  -ms-transition: none 0s ease 0s;\n  -webkit-transition: none 0s ease 0s;\n}\n.nav-tabs.nav-tabs-solid {\n  background-color: #fafafa;\n  border: 0;\n}\n.nav-tabs.nav-tabs-solid > li {\n  margin-bottom: 0;\n}\n.nav-tabs.nav-tabs-solid > li > a {\n  border-color: transparent;\n}\n.nav-tabs.nav-tabs-solid > li > a:hover,\n.nav-tabs.nav-tabs-solid > li > a:focus {\n  background-color: #f5f5f5;\n}\n.nav-tabs.nav-tabs-solid > .open:not(.active) > a {\n  background-color: #f5f5f5;\n  border-color: transparent;\n}\n.nav-tabs-justified.nav-tabs-top {\n  border-bottom: 1px solid #ddd;\n}\n.nav-tabs-justified.nav-tabs-top > li > a,\n.nav-tabs-justified.nav-tabs-top > li > a:hover,\n.nav-tabs-justified.nav-tabs-top > li > a:focus {\n  border-width: 2px 0 0 0;\n}\n\n/*-----------------\n\t7. Modal\n-----------------------*/\n\n.modal {\n  -webkit-overflow-scrolling: touch;\n  z-index: 9999;\n}\n.modal-footer.text-center {\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.modal-footer.text-left {\n  justify-content: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n}\n.modal-dialog.modal-md {\n  max-width: 600px;\n}\n.custom-modal .modal-content {\n  border: 0;\n  border-radius: 10px;\n}\n.custom-modal .modal-header {\n  padding: 1.25rem;\n}\n.custom-modal .modal-footer {\n  padding: 1.25rem;\n}\n.custom-modal .modal-body {\n  padding: 1.25rem;\n}\n.custom-modal .close {\n  background-color: #a0a0a0;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 17px;\n  height: 20px;\n  line-height: 20px;\n  margin: 0;\n  opacity: 1;\n  padding: 0;\n  position: absolute;\n  right: 20px;\n  top: 26px;\n  width: 20px;\n  z-index: 99;\n}\n.custom-modal .modal-title {\n  font-size: 20px;\n}\n.modal-backdrop.show {\n  opacity: 0.4;\n  -webkit-transition-duration: 400ms;\n  transition-duration: 400ms;\n  z-index: 1030;\n}\n.modal .card {\n  box-shadow: unset;\n}\n.custom-medicalrecord-modal .modal-header {\n  margin: 1.5rem 1.5rem 0 1.5rem;\n  padding: 0 0 1rem;\n  border-color: #e5e5e5;\n}\n.custom-medicalrecord-modal .form-control,\n.custom-medicalrecord-modal .select2-container .select2-selection--single,\n.custom-medicalrecord-modal .bootstrap-tagsinput {\n  background-color: #f5f5f7;\n  border-color: #f5f5f7;\n}\n.upload-medical-records {\n  position: relative;\n}\n.upload-medical-records input[type=\"file\"] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n.upload-medical-records .dropzone {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  min-height: 180px;\n}\n.upload-medical-records .dropzone h5,\n.upload-medical-records .dropzone h6 {\n  color: #7c7c7c;\n  margin-bottom: 3px;\n}\n.upload-medical-records .dropzone h6 span {\n  text-decoration: underline;\n}\n.upload-file-value {\n  margin-top: 25px;\n  color: #4c4c4c;\n}\n.custom-medicalrecord-modal .bootstrap-tagsinput.focus {\n  border-color: #f5f5f7;\n}\n.custom-medicalrecord-modal .bootstrap-tagsinput .tag {\n  margin-bottom: 0;\n  border-radius: 50px;\n  background-color: #e8f4ff !important;\n  border-color: #e8f4ff;\n  color: #11549a;\n  font-weight: 500;\n  padding: 9px 15px;\n}\n.custom-medicalrecord-modal .bootstrap-tagsinput .tag [data-role=\"remove\"] {\n  background-color: #f5faff;\n  border-radius: 50px;\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  font-size: 13px;\n  line-height: 20px;\n}\n.custom-medicalrecord-modal .submit-btn {\n  min-width: 300px;\n}\n\n/*-----------------\n\t8. Components\n-----------------------*/\n\n.comp-header {\n  margin-bottom: 1.875rem;\n}\n.comp-header .comp-title {\n  color: #272b41;\n}\n.line {\n  background-color: #20c0f3;\n  height: 2px;\n  margin: 0;\n  width: 60px;\n}\n.comp-buttons .btn {\n  margin-bottom: 5px;\n}\n.pagination-box .pagination {\n  margin-top: 0;\n}\n.comp-dropdowns .btn-group {\n  margin-bottom: 5px;\n}\n.progress-example .progress {\n  margin-bottom: 1.5rem;\n}\n.progress-xs {\n  height: 4px;\n}\n.progress-sm {\n  height: 15px;\n}\n.progress.progress-sm {\n  height: 6px;\n}\n.progress.progress-md {\n  height: 8px;\n}\n.progress.progress-lg {\n  height: 18px;\n}\n\n/*-----------------\n\t9. Slick Slider\n-----------------------*/\n\n.slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -khtml-user-select: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n}\n.slick-list {\n  position: relative;\n  display: block;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n}\n.slick-list:focus {\n  outline: none;\n}\n.slick-list.dragging {\n  cursor: pointer;\n}\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n.slick-track {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.slick-track:before,\n.slick-track:after {\n  display: table;\n  content: \"\";\n}\n.slick-track:after {\n  clear: both;\n}\n.slick-loading .slick-track {\n  visibility: hidden;\n}\n.slick-slide {\n  display: none;\n  float: left;\n  height: 100%;\n  min-height: 1px;\n}\n[dir=\"rtl\"] .slick-slide {\n  float: right;\n}\n.slick-slide img {\n  display: block;\n}\n.slick-slide.slick-loading img {\n  display: none;\n}\n.slick-slide.dragging img {\n  pointer-events: none;\n}\n.slick-initialized .slick-slide {\n  display: block;\n}\n.slick-loading .slick-slide {\n  visibility: hidden;\n}\n.slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n  border: 1px solid transparent;\n}\n.slick-arrow.slick-hidden {\n  display: none;\n}\n.slick-prev,\n.slick-next,\n.pharmacy-home-slider .swiper-button-prev,\n.pharmacy-home-slider .swiper-button-next {\n  font-size: 0;\n  line-height: 0;\n  position: absolute;\n  top: 50%;\n  display: block;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  -webkit-transform: translate(0, -50%);\n  -ms-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);\n  background: #fff;\n  border-radius: 100%;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: #fff;\n  z-index: 9999;\n}\n.slick-prev:hover,\n.slick-prev:focus,\n.slick-next:hover,\n.slick-next:focus,\n.pharmacy-home-slider .swiper-button-prev:hover,\n.pharmacy-home-slider .swiper-button-next:hover {\n  background-color: #0de0fe;\n  color: #fff;\n  opacity: 1;\n}\n.slick-prev:hover:before,\n.slick-prev:focus:before,\n.slick-next:hover:before,\n.slick-next:focus:before,\n.pharmacy-home-slider .swiper-button-prev:hover:before,\n.pharmacy-home-slider .swiper-button-next:hover:before {\n  color: #fff;\n  opacity: 1;\n}\n.slick-prev.slick-disabled:before,\n.slick-next.slick-disabled:before {\n  opacity: 0.25;\n}\n.slick-prev:before,\n.slick-next:before {\n  font-family: \"slick\";\n  font-size: 20px;\n  line-height: 1;\n  opacity: 0.75;\n  color: #383838;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.slick-prev {\n  left: 0;\n  z-index: 1;\n}\n.pharmacy-home-slider .swiper-button-prev:after,\n.pharmacy-home-slider .swiper-button-next:after {\n  display: none;\n}\n.pharmacy-home-slider .swiper-button-prev:before {\n  content: \"←\";\n  color: #383838;\n  height: 40px;\n  font-size: 20px;\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n.pharmacy-home-slider .swiper-button-next:before {\n  content: \"→\";\n  color: #383838;\n  font-size: 20px;\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  height: 40px;\n}\n[dir=\"rtl\"] .slick-prev {\n  right: -25px;\n  left: auto;\n}\n.slick-prev:before {\n  content: \"←\";\n}\n[dir=\"rtl\"] .slick-prev:before {\n  content: \"→\";\n}\n.slick-next {\n  right: 0;\n}\n[dir=\"rtl\"] .slick-next {\n  right: auto;\n  left: -25px;\n}\n.slick-next:before {\n  content: \"→\";\n}\n[dir=\"rtl\"] .slick-next:before {\n  content: \"←\";\n}\n.pharmacy-home-slider {\n  position: relative;\n}\n.pharmacy-home-slider .swiper-container {\n  position: relative;\n  padding: 0 !important;\n  height: 450px;\n  min-height: inherit;\n}\n.pharmacy-home-slider .swiper-container:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 99;\n  background-color: rgba(13, 13, 13, 0.33);\n}\n.pharmacy-home-slider .banner-wrapper {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  padding: 0 15px;\n  z-index: 999;\n}\n.pharmacy-home-slider .banner-wrapper .banner-header h1,\n.pharmacy-home-slider .banner-wrapper .banner-header p,\n.pharmacy-home-slider .search-box .form-text {\n  color: #fff;\n}\n.pharmacy-home-slider img {\n  max-width: 100%;\n  height: 100%;\n}\n.pharmacy-home-slider .swiper-pagination {\n  left: 50%;\n  transform: translateX(-50%);\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  padding: 20px;\n}\n\n/*-----------------\n\t10. Focus Label\n-----------------------*/\n\n.form-focus {\n  height: 50px;\n  position: relative;\n}\n.form-focus .focus-label {\n  font-size: 14px;\n  font-weight: 400;\n  pointer-events: none;\n  position: absolute;\n  -webkit-transform: translate3d(0, 22px, 0) scale(1);\n  -ms-transform: translate3d(0, 22px, 0) scale(1);\n  -o-transform: translate3d(0, 22px, 0) scale(1);\n  transform: translate3d(0, 22px, 0) scale(1);\n  transform-origin: left top;\n  transition: 240ms;\n  left: 12px;\n  top: -8px;\n  z-index: 1;\n  color: #b8b8b8;\n  margin-bottom: 0;\n}\n.form-focus.focused .focus-label {\n  opacity: 1;\n  top: -18px;\n  font-size: 12px;\n  z-index: 1;\n}\n.form-focus .form-control:focus ~ .focus-label,\n.form-focus .form-control:-webkit-autofill ~ .focus-label {\n  opacity: 1;\n  font-weight: 400;\n  top: -18px;\n  font-size: 12px;\n  z-index: 1;\n}\n.form-focus .form-control {\n  height: 50px;\n  padding: 21px 12px 6px;\n}\n.form-focus .form-control::-webkit-input-placeholder {\n  color: transparent;\n  transition: 240ms;\n}\n.form-focus .form-control:focus::-webkit-input-placeholder {\n  transition: none;\n}\n.form-focus.focused .form-control::-webkit-input-placeholder {\n  color: #bbb;\n}\n.form-focus.select-focus .focus-label {\n  opacity: 1;\n  font-weight: 300;\n  top: -20px;\n  font-size: 12px;\n  z-index: 1;\n}\n.form-focus .select2-container .select2-selection--single {\n  border: 1px solid #e3e3e3;\n  height: 50px;\n}\n.form-focus\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow {\n  height: 48px;\n  right: 7px;\n}\n.form-focus\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  border-color: #ccc transparent transparent;\n  border-style: solid;\n  border-width: 6px 6px 0;\n  height: 0;\n  left: 50%;\n  margin-left: -10px;\n  margin-top: -2px;\n  position: absolute;\n  top: 50%;\n  width: 0;\n}\n.form-focus\n  .select2-container--default.select2-container--open\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  border-color: transparent transparent #ccc;\n  border-width: 0 6px 6px;\n}\n.form-focus\n  .select2-container\n  .select2-selection--single\n  .select2-selection__rendered {\n  padding-right: 30px;\n  padding-left: 12px;\n  padding-top: 10px;\n}\n.form-focus\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__rendered {\n  color: #676767;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 38px;\n}\n.form-focus\n  .select2-container--default\n  .select2-results__option--highlighted[aria-selected] {\n  background-color: #fc6075;\n}\n\n/*-----------------\n\t11. Header\n-----------------------*/\n.nav-transparent {\n  background-color: transparent !important;\n  border-bottom: 0 !important;\n}\n.header-nav {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #fff;\n  border: 0;\n  border-bottom: 1px solid #f0f0f0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  position: relative;\n  height: 85px;\n  padding: 0 30px;\n  margin-bottom: 0;\n}\n.main-nav {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.main-nav > li.active > a {\n  color: #0038a0;\n}\n.main-nav > li .submenu li a {\n  display: block;\n  padding: 10px 15px;\n  clear: both;\n  white-space: nowrap;\n  font-size: 14px;\n  color: #2d3b48;\n  -webkit-transition: all 0.35s ease;\n  transition: all 0.35s ease;\n  width: 100%;\n  border-top: 1px solid #f0f0f0;\n}\n.main-nav > li .submenu > li.has-submenu > a::after {\n  content: \"\\f054\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n  position: absolute;\n  right: 15px;\n  top: 12px;\n  font-size: 13px;\n}\n.main-nav > li .submenu li {\n  position: relative;\n}\n.main-nav li a {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n}\n.main-nav li.login-link {\n  display: none;\n}\n.logo {\n  display: inline-block;\n  margin-right: 30px;\n  width: 200px;\n}\n.header-contact-img {\n  display: inline-block;\n}\n.header-contact-img i {\n  color: rgba(0, 0, 0, 0.5);\n  font-size: 30px;\n}\n.header-contact-detail {\n  display: inline-block;\n  padding-left: 10px;\n}\n.header-contact-detail p.contact-header {\n  color: #484848;\n  font-size: 13px;\n  font-weight: 400;\n  margin-bottom: 2px;\n  text-align: left;\n}\n.header-contact-detail p.contact-info-header {\n  color: #000;\n  font-weight: 500;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n.header-navbar-rht {\n  margin: 0;\n  margin-left: auto;\n  padding: 0;\n}\n.header-navbar-rht li {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  padding-right: 20px;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.header-navbar-rht li:last-child {\n  padding-right: 0px;\n}\n.header-navbar-rht li .dropdown-menu {\n  border: 0;\n  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n}\n.header-navbar-rht .dropdown-toggle::after {\n  display: none;\n}\n.header-navbar-rht li .dropdown-menu::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  border: 7px solid #fff;\n  border-color: transparent transparent #ffffff #ffffff;\n  -webkit-transform-origin: 0 0;\n  transform-origin: 0 0;\n  -webkit-transform: rotate(135deg);\n  transform: rotate(135deg);\n  box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\n}\n.header-navbar-rht li .dropdown-menu .dropdown-item {\n  border-top: 1px solid #f0f0f0;\n  padding: 10px 15px;\n}\n.header-navbar-rht li .dropdown-menu .dropdown-item:first-child {\n  border-top: 0;\n  border-radius: 5px 5px 0 0;\n}\n.header-navbar-rht li .dropdown-menu .dropdown-item:last-child {\n  border-radius: 0 0 5px 5px;\n}\n.header-navbar-rht li a.header-login:hover {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n  color: #fff;\n}\n.header-navbar-rht li .dropdown-menu a:hover {\n  color: #09dca4;\n  letter-spacing: 0.5px;\n  padding-left: 20px;\n  background-color: #fff;\n}\n.header-navbar-rht li a.header-login {\n  border: 2px solid #09e5ab;\n  border-radius: 4px;\n  padding: 10px 15px !important;\n  text-align: center;\n  font-size: 15px;\n  color: #09e5ab;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n.header .has-arrow .dropdown-toggle:after {\n  border-top: 0;\n  border-left: 0;\n  border-bottom: 2px solid #757575;\n  border-right: 2px solid #757575;\n  content: \"\";\n  height: 8px;\n  display: inline-block;\n  pointer-events: none;\n  -webkit-transform-origin: 66% 66%;\n  -ms-transform-origin: 66% 66%;\n  transform-origin: 66% 66%;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n  -webkit-transition: all 0.15s ease-in-out;\n  transition: all 0.15s ease-in-out;\n  width: 8px;\n  vertical-align: 2px;\n  margin-left: 10px;\n}\n.header .has-arrow .dropdown-toggle[aria-expanded=\"true\"]:after {\n  -webkit-transform: rotate(-135deg);\n  -ms-transform: rotate(-135deg);\n  transform: rotate(-135deg);\n}\n.header-trans.header-five .main-menu-wrapper {\n  margin-left: 40px;\n}\n.blue-font > li > a {\n  color: #2a85d1;\n  text-transform: uppercase;\n}\n.header-trans.header-five .header-navbar-rht li a.header-login.white-bg {\n  background-color: #fff;\n  color: #28daf4;\n  border: 1px solid #28daf4;\n  font-size: 12px;\n}\n.user-menu {\n  float: right;\n  margin: 0;\n  position: relative;\n  z-index: 99;\n}\n.user-menu.nav > li > a {\n  color: #fff;\n  font-size: 14px;\n  line-height: 58px;\n  padding: 0 15px;\n  height: 60px;\n}\n.user-menu.nav > li > a:hover,\n.user-menu.nav > li > a:focus {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n.user-menu.nav > li > a:hover i,\n.user-menu.nav > li > a:focus i {\n  color: #fff;\n}\n.user-img {\n  display: inline-block;\n  position: relative;\n}\n.header-contact-detail p.contact-info-header.white-font {\n  color: #fff;\n}\n.user-img > img {\n  height: 31px;\n  object-fit: cover;\n  width: 31px;\n}\n.user-menu.nav > li > a.mobile_btn {\n  border: 0;\n  position: relative;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n}\n.header-navbar-rht .dropdown-menu {\n  min-width: 200px;\n  padding: 0;\n}\n.header-navbar-rht .dropdown-menu .dropdown-item {\n  padding: 7px 15px;\n}\n.header-navbar-rht .dropdown-menu .dropdown-item {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border-top: 1px solid #e3e3e3;\n  padding: 10px 15px;\n}\n.header-navbar-rht .dropdown-menu .dropdown-item:hover {\n  color: #09dca4;\n}\n.user-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 10px 15px;\n}\n.user-header .user-text {\n  margin-left: 10px;\n}\n.user-header .user-text h6 {\n  font-size: 15px;\n  margin-bottom: 2px;\n}\n.header-navbar-rht .logged-item .nav-link {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  font-size: 14px;\n  line-height: 85px;\n  padding: 0 10px;\n}\n.view-cart-header a {\n  position: relative;\n  font-size: 20px;\n}\n.unread-msg1 {\n  background-color: #09e5ab;\n  border-radius: 2px;\n  color: #272b41;\n  font-size: 10px;\n  font-style: normal;\n  padding: 0 5px;\n  position: absolute;\n  right: 20px;\n  text-align: center;\n  top: -10px;\n  right: -10px;\n}\n\n.header-top {\n  display: flex;\n  background: #09e5ab;\n  color: #fff;\n  padding: 8px 30px;\n}\n.header-top ul {\n  display: flex;\n  margin: 0;\n  list-style: none;\n  padding: 0;\n}\n.header-top ul li {\n  padding-right: 25px;\n  font-size: 13px;\n}\n.header-top ul li:last-child {\n  padding-right: 0;\n}\n.header-top .right-top {\n  margin-left: auto;\n}\n.top-icon {\n  margin-right: 5px;\n}\n.search-box-1 {\n  background: #09e5ab;\n  padding: 40px 20px;\n  border-radius: 10px;\n  margin-top: -50px;\n  position: absolute;\n}\n.search-box .form-group {\n  margin-bottom: 0px;\n}\n.header-trans {\n  /* position: fixed; */\n  display: block;\n  width: 100%;\n  z-index: 9999;\n  background: transparent;\n}\n.header-trans .header-nav {\n  background: transparent;\n  border-bottom: 1px solid #eef2ff;\n}\n.header-trans .main-menu-wrapper {\n  margin-left: auto;\n}\n.header-trans .header-contact-img i {\n  color: #1c5b90;\n  font-size: 14px;\n}\n.header-trans .header-contact-detail p.contact-info-header {\n  color: #1c5b90;\n}\n.header-trans .header-navbar-rht li a.header-login {\n  text-align: center;\n  font-size: 13px;\n  color: #fff;\n  text-transform: uppercase;\n  background: #10defd;\n  box-shadow: 0px 4px 4px rgb(189 189 189 / 25%);\n  border-radius: 47px;\n  border: 0;\n}\n.header-trans .header-navbar-rht li a.header-login.white-bg {\n  background-color: #fff;\n  color: #2264c5;\n}\n.header-trans .header-navbar-rht li {\n  border-right: 2px solid #fff;\n  height: 20px;\n  padding-right: 15px;\n}\n.header-navbar-rht.right-menu li {\n  border-right: 0;\n}\n.right-menu .header-contact-detail p.contact-info-header {\n  color: #fff;\n}\n.right-menu .header-contact-img i {\n  width: 30px;\n  background-color: #fff;\n  height: 30px;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 11px;\n  color: #1860ca;\n  border: 2px solid #acc9f5;\n}\n.right-menu li a.header-login {\n  width: 120px;\n  padding: 10px !important;\n}\n.header-trans .header-navbar-rht li:last-child {\n  border-right: 0;\n  padding-left: 15px;\n}\n.header-navbar-rht.right-menu li:last-child {\n  border-right: 0;\n  padding: 0;\n}\n.header-four .header-nav {\n  background-color: #2264c5;\n  border: none;\n}\n.header-four .nav-item {\n  line-height: 60px;\n  align-items: center;\n  display: flex;\n}\n.header-four .nav-item a.header-login {\n  border: 2px solid #fff;\n  border-radius: 30px;\n  padding: 10px 15px !important;\n  text-align: center;\n  font-size: 14px;\n  color: #fff;\n  text-transform: uppercase;\n  font-weight: 500;\n  line-height: 20px;\n}\n.header-four .nav-item a.header-login i {\n  font-size: 14px;\n  margin: 0;\n  margin-right: 3px;\n}\n/*-----------------\n\t12. Mobile Menu\n-----------------------*/\n\n.sidebar-overlay {\n  background-color: rgba(0, 0, 0, 0.6);\n  display: none;\n  height: 100%;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1040;\n}\n.menu-opened .main-menu-wrapper {\n  transform: translateX(0);\n}\n.menu-header {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #fff;\n  height: 60px;\n  padding: 0 20px;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  border-bottom: 1px solid #f0f0f0;\n  display: none;\n}\n.menu-logo img {\n  height: 40px;\n}\n.menu-close {\n  font-size: 18px;\n}\n.bar-icon {\n  display: inline-block;\n  width: 31px;\n}\n.bar-icon span {\n  background-color: #0de0fe;\n  display: block;\n  float: left;\n  height: 3px;\n  margin-bottom: 7px;\n  width: 31px;\n  border-radius: 2px;\n}\n.bar-icon span:nth-child(2) {\n  width: 16px;\n}\n.bar-icon span:nth-child(3) {\n  margin-bottom: 0;\n}\n#mobile_btn {\n  display: none;\n  margin-right: 30px;\n}\nhtml.menu-opened body {\n  overflow: hidden;\n}\n\n/*-----------------\n\t13. Footer\n-----------------------*/\n\n.footer {\n  background-color: #15558d;\n}\n.footer .footer-top {\n  padding: 40px 0;\n}\n.footer.custom-footer .footer-top {\n  padding: 60px 0;\n}\n.footer.footer-four .footer-top {\n  padding: 50px 0;\n}\n.footer.footer-five {\n  background-color: #1376ca;\n}\n.footer.footer-five .footer-top {\n  background-color: #1376ca;\n  padding: 60px 0;\n}\n.footer.footer-five .footer-bottom .copyright {\n  border-top: 1px solid #28daf4;\n}\n.footer.custom-footer .footer-bottom .copyright {\n  border-top: 1px solid #0f4d84;\n}\n.footer.custom-footer .copyright-text span {\n  color: #20c0f3;\n}\n.footer-title {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 30px;\n  text-transform: capitalize;\n}\n.footer .footer-widget.footer-menu ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  outline: none;\n}\n.footer .footer-widget .footer-logo {\n  margin-bottom: 30px;\n}\n.footer .footer-widget .footer-about-content p {\n  color: #fff;\n}\n.footer .footer-widget .footer-about-content p:last-child {\n  margin-bottom: 0;\n}\n.footer .footer-menu ul li {\n  margin-bottom: 10px;\n  position: relative;\n}\n.footer .footer-menu ul li:last-child {\n  margin-bottom: 0;\n}\n.footer .footer-menu ul li a {\n  color: #fff;\n  font-size: 15px;\n  padding-left: 20px;\n  position: relative;\n  transition: all 0.4s ease 0s;\n}\n.footer .footer-widget.footer-menu ul li a:hover {\n  color: #fff;\n  letter-spacing: 0.5px;\n  padding-left: 30px;\n}\n.footer .footer-menu ul li a::before {\n  content: \"\\f101\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n  left: 0;\n  margin-right: 5px;\n  position: absolute;\n  top: 0;\n}\n.footer-contact-info {\n  color: #fff;\n  font-size: 15px;\n}\n.footer-contact-info .footer-address {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.footer-contact-info .footer-address span {\n  margin-right: 20px;\n}\n.footer-contact-info .footer-address span i.fa-map-marker-alt {\n  font-size: 20px;\n}\n.footer-contact-info p i {\n  margin-right: 15px;\n}\n.footer .footer-bottom .copyright {\n  border-top: 1px solid #1663a6;\n  padding: 30px 0;\n}\n.footer .footer-bottom .copyright-text p {\n  color: #fff;\n  font-size: 15px;\n}\n.footer .footer-bottom .copyright-text p a {\n  color: #09e5ab;\n  -webkit-transition: all 0.4s ease 0s;\n  -o-transition: all 0.4s ease 0s;\n  transition: all 0.4s ease 0s;\n}\n.footer .footer-bottom .copyright-text p a:hover {\n  color: #fff;\n}\n.footer .footer-bottom .copyright-text p.title {\n  font-weight: 400;\n  margin: 10px 0 0;\n}\n.footer .social-icon ul {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.footer .social-icon ul li {\n  margin-right: 15px;\n}\n.footer .social-icon ul li:last-child {\n  margin-right: 0px;\n}\n.footer .social-icon ul li a {\n  color: #fff;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  font-size: 20px;\n  transition: all 0.4s ease 0s;\n}\n.footer .social-icon ul li a:hover {\n  color: #09e5ab;\n}\n.policy-menu {\n  font-size: 14px;\n  margin: 0;\n  padding: 0;\n  text-align: right;\n}\n.policy-menu li {\n  display: inline-block;\n  margin-left: 15px;\n}\n.policy-menu li:last-child {\n  margin-right: 0;\n}\n.policy-menu li a {\n  color: #fff;\n}\n.policy-menu li a:hover,\n.policy-menu li a:focus {\n  color: #09e5ab;\n}\n.policy-menu li::after {\n  color: #fff;\n  content: \"|\";\n  font-weight: 300;\n  position: relative;\n  left: 10px;\n}\n.policy-menu li:last-child::after {\n  content: \"\";\n}\n\n.footer.footer-2 .footer-menu ul li a::before {\n  display: none;\n}\n.footer.footer-2 .footer-menu ul li a {\n  font-size: 13px;\n  padding-left: 0;\n}\n.footer.footer-2 .footer-widget.footer-menu ul li a:hover {\n  letter-spacing: 0;\n  padding-left: 0;\n}\n.footer.footer-2 .footer-title {\n  color: #20c0f3;\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n.footer.footer-2 .footer-widget .footer-logo {\n  margin-bottom: 10px;\n}\n.footer.footer-2 .footer-widget .footer-logo img {\n  width: 120px;\n}\n.footer.footer-2 .footer-widget .footer-about-content p {\n  font-size: 13px;\n}\n.footer.footer-2 .footer-address p {\n  font-size: 13px;\n}\n.footer.footer-2 .footer-contact-info {\n  font-size: 13px;\n}\n.footer.footer-2 .footer-contact-info .footer-address span i.fa-map-marker-alt {\n  font-size: 16px;\n}\n\n/*-----------------\n\t14. Login\n-----------------------*/\n\n.account-page {\n  background-color: #fff;\n}\n.account-page .content {\n  padding: 50px 0;\n}\n.login-right {\n  background-color: #fff;\n  border: 1px solid #f0f0f0;\n  border-radius: 4px;\n  padding: 25px;\n}\n.login-header {\n  margin-bottom: 20px;\n}\n.login-header p {\n  margin-bottom: 0;\n}\n.login-header h3 {\n  font-size: 18px;\n  margin-bottom: 3px;\n}\n.login-header h3 a {\n  color: #0de0fe;\n  float: right;\n  font-size: 15px;\n  margin-top: 2px;\n}\n.login-right .dont-have {\n  color: #3d3d3d;\n  margin-top: 20px;\n  font-size: 13px;\n}\n.login-right .dont-have a {\n  color: #09dca4;\n}\n.login-btn {\n  font-size: 18px;\n  font-weight: 500;\n}\n.login-or {\n  color: #d4d4d4;\n  margin-bottom: 20px;\n  margin-top: 20px;\n  padding-bottom: 10px;\n  padding-top: 10px;\n  position: relative;\n}\n.or-line {\n  background-color: #e5e5e5;\n  height: 1px;\n  margin-bottom: 0;\n  margin-top: 0;\n  display: block;\n}\n.span-or {\n  background-color: #fff;\n  display: block;\n  left: 50%;\n  margin-left: -20px;\n  position: absolute;\n  text-align: center;\n  top: -3px;\n  width: 42px;\n}\n.forgot-link {\n  color: #3d3d3d;\n  display: inline-block;\n  font-size: 13px;\n  margin-bottom: 10px;\n  font-weight: 400;\n}\n.btn-facebook {\n  background-color: #3a559f;\n  color: #fff;\n  font-size: 13px;\n  padding: 8px 12px;\n}\n.btn-google {\n  background-color: #dd4b39;\n  color: #fff;\n  font-size: 13px;\n  padding: 8px 12px;\n}\n.social-login .btn:hover,\n.social-login .btn:focus {\n  color: #fff;\n}\n.login-page .login-right {\n  width: 100%;\n  position: relative;\n  font-family: \"Poppins\", sans-serif;\n  height: 100vh;\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  border: 0;\n  padding: 0;\n  border-radius: 0;\n}\n.login-bottom-copyright {\n  color: #a4a4a4;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  display: flex;\n  display: -webkit-flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  align-self: flex-end;\n  -webkit-align-self: flex-end;\n  padding-bottom: 25px;\n  width: 100%;\n}\n.login-right .inner-right-login {\n  max-width: 450px;\n  margin: 0 auto;\n  width: 100%;\n}\n.login-header .logo-icon {\n  margin: 40px auto 20px;\n  text-align: center;\n}\n.step-list {\n  padding: 10px 0;\n  text-align: center;\n}\n.step-list ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-block;\n}\n.step-list ul li {\n  float: left;\n  padding-right: 10px;\n  margin: 5px 0l;\n}\n.step-list ul li:last-child {\n  padding-right: 0;\n}\n.step-list ul li a {\n  background-color: #e9f5f7;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #808080;\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n.step-list ul li a:hover {\n  background-color: #0de0fe;\n  color: #fff;\n}\n.step-list ul li a.active {\n  background-color: #0de0fe;\n  color: #fff;\n}\n.step-list ul li a.active-done {\n  background-color: #0de0fe;\n  color: #fff;\n}\n.step-list ul li a.active-done {\n  background-image: url(../assets/img/icons/tick-icon.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 18px;\n  font-size: 0;\n}\n.profile-pic-col {\n  padding-top: 40px;\n  text-align: center;\n}\n.profile-pic-col h3 {\n  color: #000;\n  font-size: 20px !important;\n}\n.profile-pic-upload {\n  width: 150px;\n  background: rgba(175, 213, 254, 0.4);\n  border-radius: 20px;\n  padding: 24px;\n  margin: 40px auto 0;\n  position: relative;\n}\n.profile-pic-upload input[type=\"file\"] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n.profile-pic-upload .cam-col {\n  width: 70px;\n  height: 70px;\n  margin: 0 auto;\n  background-color: #fff;\n  border-radius: 70px;\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  overflow: hidden;\n}\n.profile-pic-upload span {\n  color: #000;\n  font-size: 13px;\n  list-style: 18px;\n  display: inline-block;\n  margin-top: 15px;\n}\n.select-gender-col [type=\"radio\"]:checked,\n.select-gender-col [type=\"radio\"]:not(:checked) {\n  position: absolute;\n  left: -9999px;\n}\n.select-gender-col [type=\"radio\"]:checked + label,\n.select-gender-col [type=\"radio\"]:not(:checked) + label {\n  position: relative;\n  padding-left: 28px;\n  cursor: pointer;\n  line-height: 20px;\n  display: inline-block;\n  color: #666;\n}\n.select-gender-col [type=\"radio\"]:checked + label:before,\n.select-gender-col [type=\"radio\"]:not(:checked) + label:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 5px 20px 60px 10px rgba(0, 4, 107, 0.07);\n}\n.select-gender-col [type=\"radio\"]:checked + label:after,\n.select-gender-col [type=\"radio\"]:not(:checked) + label:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 10px;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n  border: 2px solid #0de0fe;\n}\n.select-gender-col [type=\"radio\"]:not(:checked) + label:after {\n  opacity: 0;\n}\n.select-gender-col [type=\"radio\"]:checked + label:after {\n  opacity: 1;\n}\n.select-gender-col .gender-icon {\n  position: relative;\n}\n.select-gender-col label {\n  padding: 15px 20px !important;\n  text-align: center;\n}\n.select-gender-col span {\n  position: relative;\n  color: #000;\n  display: inline-block;\n  margin-top: 10px;\n  font-size: 16px;\n  width: 100%;\n}\n.gender-icon img {\n  max-height: 90px;\n}\n.pregnant-col .remember-me-col {\n  color: #000;\n  font-size: 16px;\n}\n.pregnant-col .remember-me-col .custom_check .checkmark {\n  border-color: #0de0fe;\n}\n.step-process-col {\n  text-align: left;\n}\n.login-page .login-right .step-process-col label {\n  color: #0de0fe;\n}\n.login-right\n  .step-process-col\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__rendered {\n  color: #808080;\n}\n.login-right\n  .step-process-col\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  background-image: url(../assets/img/icons/down-arrow-gray.svg);\n}\n.login-page .login-right .step-process-col .form-control {\n  color: #808080;\n}\n.checklist-col span {\n  font-size: 16px;\n}\n.checklist-col .custom_check .checkmark {\n  width: 24px;\n  height: 24px;\n}\n.checklist-col .custom_check .checkmark:after {\n  left: 6px;\n  top: 3px;\n}\n.checklist-col .remember-me-col {\n  padding: 10px 0;\n  position: relative;\n}\n.checklist-col.pregnant-col .remember-me-col .custom_check .checkmark {\n  border-color: #b4abca;\n}\n.checklist-col.pregnant-col .remember-me-col .custom_check {\n  padding-left: 25px;\n}\n.otp-col {\n  color: #fff;\n}\n.otp-col h3 {\n  color: #fff;\n  font-size: 20px;\n  margin-bottom: 15px;\n}\n.dnt-recive-call {\n  color: #fff;\n}\n.dnt-recive-call a {\n  color: #fff;\n}\n.otp-box .digit-group input {\n  width: 45px;\n  height: 45px;\n  background-color: rgba(245, 245, 245, 0.2);\n  border: none;\n  text-align: center;\n  font-size: 16px;\n  color: white;\n  margin: 0 3px;\n  box-shadow: 5px 20px 60px 10px rgba(0, 4, 107, 0.07);\n  border-radius: 8px;\n  color: #000;\n}\n.otp-box {\n  margin: 25px 0;\n}\n.otp-box .digit-group input:focus {\n  background-color: #fff;\n  border: 0;\n  outline: 0;\n}\n.otp-box .splitter {\n  padding: 0 5px;\n  color: white;\n  font-size: 24px;\n}\n.otp-box .prompt {\n  margin-bottom: 20px;\n  font-size: 20px;\n  color: white;\n}\n.otp-box input[type=\"text\"].active {\n  background-color: #fff;\n  color: #000;\n}\n.increment-decrement .input-groups {\n  border: 0;\n  background-color: transparent;\n  height: 35px;\n  margin-right: 0px;\n  display: block;\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n}\n.increment-decrement .input-groups .quantity-field {\n  width: 40px;\n  text-align: center;\n  background-color: transparent;\n  float: left;\n  border: 0;\n}\n.increment-decrement .input-groups .quantity-field:focus {\n  border: 0;\n  outline: 0;\n}\n.increment-decrement .input-groups input[type=\"button\"] {\n  background-color: transparent;\n  font-size: 20px;\n  border: 1px solid #0de0fe;\n  border-radius: 4px;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  margin-top: 0px;\n  line-height: 0;\n  padding: 0;\n  color: #0de0fe;\n}\n.increment-decrement .input-groups input[type=\"button\"]:focus-visible {\n  outline: 0;\n}\n.increment-decrement .input-groups input[type=\"button\"].button-minus {\n  float: left;\n}\n.increment-decrement .input-groups input[type=\"button\"].button-plus {\n  float: right;\n}\n.country-select {\n  position: relative;\n}\n.country-select .select-col {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n.country-select .select-col .flagstrap {\n  height: 100%;\n}\n.country-select .select-col .btn-info.dropdown-toggle {\n  border: 0;\n  color: #0de0fe;\n  border-radius: 10px 0px 0px 10px;\n  background-color: #fff;\n  height: 100%;\n  font-size: 0;\n  width: 79px;\n  padding: 0 12px;\n  text-align: left;\n}\n.country-select .select-col .btn-info.dropdown-toggle:after {\n  background-image: url(../assets/img/icons/down-arrow-gray-dark.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  width: 14px;\n  height: 7px;\n  border: 0;\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n}\n.country-select .select-col .dropdown-menu {\n  font-size: 0;\n  width: 79px;\n  min-width: inherit;\n  margin-top: 0;\n  padding: 0;\n  border-radius: 10px;\n}\n.country-select .select-col .dropdown-menu li {\n  margin: 14px 13px;\n}\n.country-select .select-col .dropdown-menu li:first-child {\n  display: none;\n}\n.country-select .select-col .dropdown-menu li a {\n  display: inline-block;\n  cursor: pointer;\n}\n.country-select .select-col .flagstrap-icon.flagstrap-in,\n.country-select .select-col .flagstrap-icon.flagstrap-ng,\n.country-select .select-col .flagstrap-icon.flagstrap-gb,\n.country-select .select-col .flagstrap-icon.flagstrap-us {\n  background-position: center;\n  width: 33px;\n  height: 22px;\n  background-size: cover;\n  border-radius: 4px;\n}\n.country-select .select-col .btn-info.dropdown-toggle span {\n  font-size: 0;\n}\n.login-right\n  .country-select\n  .select-col\n  .select2-container--default\n  .select2-selection--single {\n  background-color: #fff;\n  border-radius: 10px 0 0 10px;\n  width: 79px;\n}\n.login-right\n  .country-select\n  .select-col\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__rendered {\n  color: #0de0fe;\n}\n.login-right\n  .country-select\n  .select-col\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  background-image: url(../assets/img/icons/down-arrow-gray-dark.svg);\n}\n.country-select .number-col input {\n  padding-left: 96px;\n}\n.location-text h5 {\n  color: #000;\n  margin-top: 5px;\n}\n.location-search {\n  margin: 12px 0;\n}\n.login-page .login-right .search-location-input-box input {\n  background-image: url(../assets/img/icons/search-icon.svg);\n  background-repeat: no-repeat;\n  background-position: 10px 50%;\n  background-size: 16px;\n  padding-left: 38px;\n  color: #948ca0;\n}\n.skip-now-col {\n  margin-top: 5px;\n}\n.skip-now-col a {\n  color: #000;\n  font-size: 12px;\n}\n.sort-by-col .select2-container .select2-selection--single {\n  border-color: #dcd0ff;\n  border-radius: 10px;\n  width: 160px;\n}\n.sort-by-col\n  .select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  background-image: url(../assets/img/icons/down-arrow-gray.svg);\n}\n.premium-text {\n  font-size: 18px;\n}\n.plan-details {\n  list-style: none;\n  padding: 4px 0 0;\n  margin: 0;\n}\n.plan-details li {\n  position: relative;\n  min-width: 35%;\n}\n.plan-details li span {\n  color: #b4abca;\n  display: inline-block;\n  margin-bottom: 3px;\n  font-size: 15px;\n}\n.plan-chooser-col {\n  background-color: rgba(175, 213, 254, 0.4);\n  border-radius: 20px;\n  padding: 5px 20px;\n  margin-bottom: 28px;\n}\n.plan-chooser-col .memeber-img {\n  border-radius: 15px;\n  margin-bottom: 10px;\n  width: 100%;\n}\n.plan-chooser-col .memeber-img img {\n  border-radius: 15px;\n}\n.memeber-details h4 {\n  margin-bottom: 0;\n}\n.payment-menthods ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: center;\n}\n.payment-menthods ul li {\n  display: inline-block;\n  padding: 6px;\n}\n.select-gender-col.payment-menthods-choose label {\n  min-width: 90px;\n  padding: 10px !important;\n  text-align: center;\n  color: #000;\n}\n.select-gender-col.payment-menthods-choose label span.credit-card-option {\n  min-width: 192px;\n  font-size: 15px;\n}\n.select-gender-col.payment-menthods-choose label img {\n  position: relative;\n  max-width: 68px;\n}\n.select-gender-col.payment-menthods-choose\n  [type=\"radio\"]:checked\n  + label::after,\n.select-gender-col.payment-menthods-choose\n  [type=\"radio\"]:not(:checked)\n  + label::after {\n  border: 1px solid #0de0fe;\n}\n.card-choose-col {\n  max-width: 325px;\n  margin: 0 auto;\n}\n.day-week-month-col ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.day-week-month-col ul li {\n  float: left;\n}\n.day-week-month-col ul li a {\n  background-color: #f5faff;\n  border: 1px solid transparent;\n  color: #64627c;\n  display: inline-block;\n  padding: 10px 20px;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n}\n.day-week-month-col ul li a.active {\n  border-color: #536cf1;\n  color: #536cf1;\n  border-radius: 0 !important;\n}\n.day-week-month-col ul li:first-child a {\n  border-radius: 4px 0 0 4px !important;\n}\n.day-week-month-col ul li:last-child a {\n  border-radius: 0px 4px 4px 0px !important;\n}\n.day-week-month-col ul li a:first-child.active,\n.day-week-month-col ul li a:last-child.active {\n  border-color: #536cf1;\n}\n.plan-chooser-col .subscription-list {\n  margin: 15px 0;\n}\n\n/*-----------------\n\t15. Home\n-----------------------*/\n\n.section-search {\n  background: #f9f9f9 url(../assets/img/search-bg.png) no-repeat bottom center;\n  min-height: 628px;\n  background-size: 100% auto;\n  position: relative;\n  background-blend-mode: Darken;\n  padding: 80px 0;\n}\n.section-search-1 {\n  background: #f9f9f9 url(../assets/img/slider-bg.jpg) no-repeat bottom center;\n  min-height: 550px;\n  position: relative;\n  background-blend-mode: Darken;\n}\n.doctor-search-section {\n  position: relative;\n  background: url(../assets/img/banner-2.jpg);\n  background-position: 50% 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  z-index: 1;\n}\n.section-search-2 {\n  background: #4d72d0;\n  background-repeat: repeat;\n}\n.section-header {\n  margin-bottom: 60px;\n}\n.section-header h2 {\n  font-size: 36px;\n  margin-bottom: 0;\n  font-weight: 500;\n}\n.section-header .sub-title {\n  color: #757575;\n  font-size: 16px;\n  max-width: 600px;\n  margin: 15px auto 0;\n}\n.section-header p {\n  color: #757575;\n  font-size: 16px;\n  margin-bottom: 0;\n  margin-top: 15px;\n}\n.banner-wrapper {\n  margin: 0 auto;\n  max-width: 750px;\n  width: 100%;\n}\n.banner-wrapper .banner-header {\n  margin-bottom: 30px;\n}\n.banner-wrapper .banner-header h1 {\n  margin-bottom: 10px;\n  font-size: 40px;\n  font-weight: 600;\n}\n.banner-wrapper .banner-header p {\n  color: #757575;\n  font-size: 20px;\n  margin-bottom: 0;\n}\n.search-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.search-box .form-control {\n  border: 1px solid #ccc;\n  box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.075);\n  border-radius: 5px;\n  padding-left: 35px;\n}\n.search-box .search-location-home {\n  -ms-flex: 0 0 350px;\n  flex: 0 0 350px;\n  margin-right: 12px;\n  position: relative;\n  width: 100%;\n}\n.search-box .search-location {\n  -ms-flex: 0 0 295px;\n  flex: 0 0 295px;\n  margin-right: 12px;\n  position: relative;\n  width: 295px;\n}\n.search-location .form-control {\n  background: #fff url(../assets/img/location.png) no-repeat 10px center;\n}\n.search-box .search-info {\n  -ms-flex: 0 0 400px;\n  flex: 0 0 400px;\n  margin-right: 12px;\n  position: relative;\n  width: 400px;\n}\n.search-info .form-control {\n  background: #fff url(../assets/img/search.png) no-repeat 10px center;\n}\n.search-box .search-btn {\n  width: 46px;\n  -ms-flex: 0 0 46px;\n  flex: 0 0 46px;\n  height: 46px;\n}\n.search-box .search-btn span {\n  display: none;\n  font-weight: 500;\n}\n.search-box .form-text {\n  color: #757575;\n  font-size: 13px;\n}\n.section-specialities {\n  background-color: #fff;\n  padding: 80px 0;\n}\n.slick-dots {\n  position: absolute;\n  bottom: -25px;\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  text-align: center;\n}\n.slick-dots li,\n.pharmacy-home-slider .swiper-pagination-bullet {\n  position: relative;\n  display: inline-block;\n  width: 20px;\n  height: 5px;\n  margin: 0 5px;\n  padding: 0;\n  cursor: pointer;\n  border-radius: 0;\n}\n.pharmacy-home-slider .swiper-pagination-bullet {\n  background: #c0c0c0;\n  width: 20px;\n  height: 5px;\n  opacity: 1;\n  transform: scale(1) !important;\n  left: 0 !important;\n}\n.pharmacy-home-slider\n  .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  background-color: #0de0fe;\n  width: 20px;\n  height: 5px;\n  opacity: 1;\n}\n.search-img {\n  margin-top: 80px;\n  margin-bottom: 80px;\n}\n.banner-wrapper .banner-header {\n  margin-bottom: 30px;\n}\n.banner-wrapper .banner-header h1 {\n  margin-bottom: 10px;\n  font-size: 40px;\n  font-weight: 600;\n}\n.banner-wrapper .banner-header p {\n  color: #757575;\n  font-size: 20px;\n  margin-bottom: 0;\n}\n.search-area {\n  background: #ffffff6b;\n  padding: 60px 30px;\n  position: relative;\n  z-index: 1;\n  border-radius: 10px;\n  max-width: 410px;\n  margin: auto;\n}\n.search-doctor {\n  margin: auto;\n}\n.search-area h2 {\n  font-size: 1.7rem;\n  font-weight: 600;\n}\n.search-btn {\n  width: 100%;\n  margin-top: 15px;\n}\n.search-box-1 .search-btn {\n  width: 46px;\n  -ms-flex: 0 0 46px;\n  flex: 0 0 46px;\n  height: 46px;\n  background: #fff;\n  color: #09e5ab;\n}\n.search-box-3 {\n  background: #1e5c92;\n  padding: 40px 20px;\n  border-radius: 10px;\n  margin-top: -50px;\n  position: absolute;\n}\n.btn-search {\n  background: #fff;\n  border: 1px solid #fff;\n  color: #1e5c92;\n}\n.search-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.search-box .form-control {\n  border: 1px solid #ccc;\n  box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.075);\n  border-radius: 5px;\n  padding-left: 35px;\n}\n.search-box .search-location {\n  -ms-flex: 0 0 295px;\n  flex: 0 0 295px;\n  margin-right: 12px;\n  position: relative;\n  width: 295px;\n}\n.search-location .form-control {\n  background: #fff url(../assets/img/location.png) no-repeat 10px center;\n}\n.search-box .search-info {\n  -ms-flex: 0 0 390px;\n  flex: 0 0 390px;\n  margin-right: 12px;\n  position: relative;\n  width: 390px;\n}\n.search-info .form-control {\n  background: #fff url(../assets/img/search.png) no-repeat 10px center;\n}\n.search-box .search-btn {\n  width: 46px;\n  -ms-flex: 0 0 46px;\n  flex: 0 0 46px;\n  height: 46px;\n}\n.search-box .search-btn span {\n  display: none;\n  font-weight: 500;\n}\n.search-box .form-text {\n  color: #757575;\n  font-size: 13px;\n}\n.section-specialities {\n  background-color: #fff;\n  padding: 80px 0;\n}\n.section-category {\n  background-color: #fff;\n  padding: 80px 0;\n}\n.dot-slider .slick-slide {\n  height: 600px;\n}\n.dot-slider .profile-widget {\n  padding: 0;\n  border: none;\n}\n.dot-slider .slick-slide img {\n  width: 100%;\n}\n.slick-dots li button {\n  font-size: 0;\n  line-height: 0;\n  display: block;\n  width: 20px;\n  height: 5px;\n  padding: 0;\n  cursor: pointer;\n  color: transparent;\n  border: 0;\n  outline: none;\n  background: #c0c0c0;\n}\n.dot-slider .slick-dots {\n  position: absolute;\n  top: 30%;\n  right: 50px;\n  bottom: unset;\n  width: unset;\n}\n.dot-slider .slick-dots li {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  display: flex;\n  background-color: #fff;\n  align-items: center;\n  justify-content: center;\n  margin: 8px 0;\n}\n.dot-slider .slick-dots li button {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background-color: #fff;\n}\n.dot-slider .slick-dots li.slick-active button {\n  background-color: #1860ca;\n}\n.slick-dots li button:hover,\n.slick-dots li button:focus {\n  outline: none;\n}\n.slick-dots li button:hover:before,\n.slick-dots li button:focus:before {\n  opacity: 1;\n}\n.slick-dots li button:before {\n  display: none;\n  font-family: \"slick\";\n  font-size: 76px;\n  line-height: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  content: \"-\";\n  text-align: center;\n  opacity: 0.25;\n  color: black;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.slick-dots li.slick-active button {\n  background-color: #0de0fe;\n}\n.slick-dots li.slick-active button:before {\n  opacity: 1;\n  color: #0de0fe;\n}\n.slick-slide {\n  outline: none !important;\n}\n.specialities-slider .slick-slide {\n  display: block;\n  padding: 0 12px;\n  margin-left: 0;\n  margin-right: 20px;\n  margin-top: 10px;\n}\n.specialities-slider .slick-dots {\n  margin-top: 44px;\n  position: unset;\n}\n.speicality-img {\n  position: relative;\n  height: 150px;\n  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);\n  border-radius: 100%;\n  width: 150px;\n  background: #fff;\n}\n.speicality-img img {\n  position: absolute;\n  top: 50%;\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n.speicality-img span {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);\n  border-radius: 50%;\n  padding: 5px;\n  background-color: #fff;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.speicality-img span i {\n  font-size: 15px;\n  color: #0de0fe;\n}\n.speicality-item p {\n  font-size: 16px;\n  font-weight: 500;\n  margin: 30px 0 0;\n}\n.section-doctor {\n  background-color: #f8f9fa;\n  padding: 80px 0;\n}\n.section-doctor .section-header {\n  margin-bottom: 30px;\n}\n.section-doctor .section-header p {\n  margin-top: 10px;\n}\n.doctor-slider .slick-slide {\n  display: block;\n  margin-left: 0;\n  padding: 10px;\n  width: 280px;\n}\n.profile-widget {\n  background-color: #fff;\n  border: 1px solid #f0f0f0;\n  border-radius: 4px;\n  margin-bottom: 30px;\n  position: relative;\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n  padding: 15px;\n}\n.doc-img {\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  border-radius: 4px;\n}\n.doc-img img {\n  border-radius: 4px;\n  -webkit-transform: translateZ(0);\n  -moz-transform: translateZ(0);\n  transform: translateZ(0);\n  -moz-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -o-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  width: 100%;\n}\n.doc-img:hover img {\n  -webkit-transform: scale(1.15);\n  -moz-transform: scale(1.15);\n  transform: scale(1.15);\n}\n.profile-widget .fav-btn {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background-color: #fff;\n  width: 30px;\n  height: 30px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  border-radius: 3px;\n  color: #2e3842;\n  -webkit-transform: translate3d(100%, 0, 0);\n  -ms-transform: translate3d(100%, 0, 0);\n  transform: translate3d(100%, 0, 0);\n  opacity: 0;\n  visibility: hidden;\n  z-index: 99;\n}\n.profile-widget:hover .fav-btn {\n  opacity: 1;\n  visibility: visible;\n  -webkit-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n.profile-widget .fav-btn:hover {\n  background-color: #fb1612;\n  color: #fff;\n}\n.pro-content {\n  padding: 15px 0 0;\n}\n.pro-content .title {\n  font-size: 17px;\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n.profile-widget .pro-content .title a {\n  display: inline-block;\n}\n.profile-widget .verified {\n  color: #28a745;\n  margin-left: 3px;\n}\n.profile-widget p.speciality {\n  font-size: 13px;\n  color: #757575;\n  margin-bottom: 5px;\n  min-height: 40px;\n}\n.rating {\n  list-style: none;\n  margin: 0 0 7px;\n  padding: 0;\n  width: 100%;\n}\n.rating i {\n  color: #dedfe0;\n}\n.rating i.filled {\n  color: #f4c150;\n}\n.profile-widget .rating {\n  color: #757575;\n  font-size: 14px;\n  margin-bottom: 15px;\n}\n.profile-widget .rating i {\n  font-size: 14px;\n}\n.available-info {\n  font-size: 13px;\n  color: #757575;\n  font-weight: 400;\n  list-style: none;\n  padding: 0;\n  margin-bottom: 15px;\n}\n.available-info li + li {\n  margin-top: 5px;\n}\n.available-info li i {\n  width: 22px;\n}\n.row.row-sm {\n  margin-left: -3px;\n  margin-right: -3px;\n}\n.row.row-sm > div {\n  padding-left: 3px;\n  padding-right: 3px;\n}\n.view-btn {\n  color: #0de0fe;\n  font-size: 13px;\n  border: 2px solid #0de0fe;\n  text-align: center;\n  display: block;\n  font-weight: 500;\n  padding: 6px;\n}\n.view-btn:hover,\n.view-btn:focus {\n  background-color: #0de0fe;\n  color: #fff;\n}\n.book-btn {\n  background-color: #0de0fe;\n  border: 2px solid #0de0fe;\n  color: #fff;\n  font-size: 13px;\n  text-align: center;\n  display: block;\n  font-weight: 500;\n  padding: 6px;\n}\n.book-btn:hover,\n.book-btn:focus {\n  background-color: #01cae4;\n  border-color: #01cae4;\n  color: #fff;\n}\n.section-doctor .profile-widget {\n  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.about-content p {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 26px;\n  margin: 0;\n}\n.about-content p + p {\n  margin-top: 20px;\n}\n.about-content a {\n  background-color: #0de0fe;\n  border-radius: 4px;\n  color: #fff;\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 500;\n  margin-top: 30px;\n  min-width: 150px;\n  padding: 15px 20px;\n  text-align: center;\n}\n.about-content a:hover,\n.about-content a:focus {\n  background-color: #01cae4;\n  border-color: #01cae4;\n  color: #fff;\n}\n.section-features {\n  background-color: #fff;\n  padding: 80px 0;\n}\n.feature-item img {\n  border-radius: 100%;\n  box-shadow: 1px 6px 14px rgba(0, 0, 0, 0.2);\n  height: 115px;\n  object-fit: cover;\n  width: 115px;\n}\n.feature-item p {\n  font-weight: 500;\n  margin: 20px 0 0;\n}\n.features-slider .slick-slide {\n  margin-right: 62px;\n}\n.features-slider .slick-center {\n  opacity: 1;\n  transform: scale(1.2);\n}\n.features-slider .slick-list {\n  padding: 16px 50px !important;\n}\n.features-slider .slick-dots {\n  margin-top: 44px;\n  position: unset;\n}\n.section-blogs {\n  background-color: #f8f9fa;\n  padding: 80px 0;\n}\n.view-all .btn {\n  margin-top: 20px;\n  font-size: 16px;\n  font-weight: 600;\n  padding: 12px 30px;\n}\n\n.full-slide-home {\n  background: #e3e3e3;\n}\n.slide-image {\n  width: 100%;\n  min-height: 358px;\n  display: flex !important;\n  justify-content: center;\n  flex-direction: column;\n  padding: 70px 50px 70px 100px;\n  vertical-align: middle;\n  background-position: right;\n  background-size: contain;\n}\n.slide-image h2 {\n  font-size: 36px;\n  font-weight: 500;\n}\n.slide-ul li:before {\n  font-family: \"Font Awesome 5 Free\";\n  display: inline-block;\n  padding-right: 6px;\n  vertical-align: middle;\n  content: \"\\f192\";\n  color: #a2a1a1;\n  font-size: 10px;\n}\n.slide-ul li {\n  color: #757575;\n  font-size: 13px;\n}\n.home-tile-section {\n  background-color: #f8f9fa;\n  padding: 80px 0;\n}\n.book-btn1 {\n  background-color: #0de0fe;\n  border: 2px solid #0de0fe;\n  color: #fff;\n  font-size: 16px;\n  text-align: center;\n  font-weight: 500;\n  padding: 6px 10px;\n}\n.book-btn1:hover {\n  background-color: #01cae4;\n  border-color: #01cae4;\n  color: #ffffff;\n}\n.doctor-book-card {\n  position: relative;\n  max-width: 100%;\n  margin: 0 auto;\n  box-shadow: 0px 3px 20px #0000000b;\n  overflow: hidden;\n}\n.doctor-book-card img {\n  vertical-align: middle;\n  border-radius: 0.25rem;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n}\n.doctor-book-card:hover img {\n  -webkit-transform: scale(1.15);\n  -moz-transform: scale(1.15);\n  transform: scale(1.15);\n}\n.doctor-book-card-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  color: #f1f1f1;\n  width: 100%;\n  padding: 20px;\n  height: 100%;\n  border-radius: 0.25rem;\n}\n.doctor-book-card-content > div {\n  width: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}\n.doctor-book-card-content .book-btn1 {\n  font-size: 14px;\n}\n.search-box1 form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n}\n.section-search-pharmacy .search-box1 .search-btn {\n  margin-top: 0;\n}\n.search-box1 .form-control {\n  border: 1px solid #ccc;\n  box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0.075);\n  border-radius: 5px;\n  padding-left: 35px;\n}\n.search-box1 .search-location {\n  -ms-flex: 0 0 240px;\n  flex: 0 0 240px;\n  margin-right: 12px;\n  position: relative;\n  width: 240px;\n}\n.search-box1 .search-location .form-control {\n  background: #fff url(../assets/img/location.png) no-repeat 10px center;\n}\n.search-box1 .search-info {\n  -ms-flex: 0 0 490px;\n  flex: 0 0 490px;\n  margin-right: 12px;\n  position: relative;\n  width: 490px;\n}\n/*.search-box1 .search-info .form-control {\n\tbackground: #fff url() no-repeat 10px center;\n}*/\n.search-box1 .search-btn {\n  width: 46px;\n  -ms-flex: 0 0 46px;\n  flex: 0 0 46px;\n  height: 46px;\n}\n.search-box1 .search-btn span {\n  display: none;\n  font-weight: 500;\n}\n.search-box1 .form-text {\n  color: #757575;\n  font-size: 13px;\n}\n.section-search1 {\n  background: #f9f9f9 url(../assets/img/search-bg.png) no-repeat bottom center;\n  min-height: 580px;\n  background-size: 100% auto;\n  position: relative;\n  background-blend-mode: Darken;\n  padding: 80px 0;\n}\n.banner-wrapper2 {\n  margin: 0 auto;\n  max-width: 680px;\n  width: 100%;\n}\n.search-box1 .search-location1 {\n  margin-right: 12px;\n  position: relative;\n  width: 400px;\n  margin-bottom: 0;\n}\n.banner-wrapper2 {\n  margin: 0 auto;\n  max-width: 680px;\n  width: 100%;\n}\n.search-detect {\n  padding: 5px 9px 5px 28px;\n  position: absolute;\n  top: 8px;\n  right: 5px;\n  font-size: 13px;\n  color: #757575;\n  border-radius: 5px;\n  background: #e3e3e3 url(../assets/img/google-map.png) no-repeat 9px center;\n  cursor: pointer;\n}\n.section-search-pharmacy {\n  min-height: inherit !important;\n  background: #fff;\n  padding: 40px 0;\n}\n.tile-card-content-1 {\n  background: rgb(0, 0, 0);\n  background: rgba(13, 13, 13, 0.33);\n}\n.doctor-book-card h3 {\n  text-shadow: 2px 4px 3px rgba(0, 0, 0, 0.3);\n  color: #fff;\n}\n.full-slide-home .slick-prev {\n  left: 30px;\n}\n.full-slide-home .slick-next {\n  right: 30px;\n}\n.full-slide-home .slick-slide > div > .col-12 {\n  display: flex;\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n}\n\n.category-box {\n  text-align: center;\n  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 10px;\n  padding: 20px;\n  margin-bottom: 30px;\n}\n.category-box:hover {\n  text-align: center;\n  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  padding: 20px;\n  cursor: pointer;\n}\n.category-image {\n  background: #09e5ab;\n  height: 60px;\n  margin: auto;\n  width: 60px;\n  align-items: center;\n  padding-top: 7px;\n  border-radius: 4px;\n}\n.category-image img {\n  width: 45px;\n  height: 45px;\n}\n.category-content {\n  margin-top: 20px;\n}\n.category-content h4 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #272b41;\n}\n.banner-header h2 {\n  color: #186db5;\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 54px;\n}\n.doctor-search-form input {\n  background: #ffffff;\n  border-radius: 130px;\n  min-height: 60px;\n  border: 0;\n}\n.doctor-search-form.trans .form-control {\n  color: #fff;\n}\n.doctor-search-form.trans select {\n  background: transparent;\n  border-radius: 130px;\n  min-height: 60px;\n}\n.doctor-search-form.trans input,\nselect {\n  background-color: transparent;\n  border: 2px solid #c2d6f3 !important;\n}\n.doctor-search-form.trans input::placeholder,\n.doctor-search-form.trans select::placeholder {\n  color: #fff;\n}\n.trans .form-custom i {\n  color: #fff;\n}\n.trans .banner-btn {\n  background-color: #13a5e5;\n}\n.no-border {\n  border: none !important;\n}\n.doctor-category {\n  position: relative;\n  margin-top: -130px;\n  z-index: 9;\n  padding: 60px 0;\n}\n.pop-box {\n  background-color: #ffffff;\n  padding: 15px 15px 0;\n  border-radius: 5px;\n  box-shadow: 0px 4px 44px rgba(219, 219, 219, 0.25);\n}\n.pop-box .top-section {\n  background-color: #e5f6fd;\n  padding: 20px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  min-height: 150px;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n}\n.pop-box .top-section i {\n  background-color: #fff;\n  width: 100px;\n  height: 100px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  border-radius: 50%;\n  font-size: 30px;\n  color: #20c0f3;\n  border: 5px solid #f5f8f9;\n}\n.pop-box .body-section {\n  justify-content: center;\n  text-align: center;\n  padding: 20px;\n  min-height: 200px;\n  display: flex;\n  flex-direction: column;\n}\n.pop-box .body-section h3 {\n  color: #2467ca;\n  font-weight: 600;\n  font-size: 24px;\n}\n.pop-box .body-section p {\n  color: #e74e84;\n  font-weight: 500;\n}\n.pop-box .body-section .book-btn {\n  width: 150px;\n  margin: 0 auto;\n  border-radius: 30px;\n}\n.pop-box .top-section.two {\n  background-color: #fff1c9;\n}\n.pop-box .top-section.two i {\n  color: #ffbd07;\n}\n.pop-box .top-section.three {\n  background-color: #ffe0e7;\n}\n.pop-box .top-section.three i {\n  color: #ffaabd;\n}\n.clinic-specialities {\n  background: url(../assets/img/special-banner.jpg);\n  padding: 60px 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.section-header-three {\n  margin-bottom: 60px;\n}\n\n.section-header-three h2 {\n  color: #2868c8;\n  font-weight: 700;\n  font-size: 30px;\n  position: relative;\n  display: inline-block;\n}\n.section-header-three h2:before {\n  position: absolute;\n  content: \"\";\n  width: 13px;\n  height: 13px;\n  background: #ffd152;\n  border-radius: 50%;\n  left: -40px;\n  box-shadow: 15px 0px 0px -2px #ffd152;\n  top: 12px;\n}\n.section-header-three h2:after {\n  position: absolute;\n  width: 13px;\n  height: 13px;\n  content: \"\";\n  background: #ffd152;\n  border-radius: 50%;\n  top: 12px;\n  right: -40px;\n  box-shadow: -15px 0px 0px -2px #ffd152;\n}\n.section-header-three p {\n  color: #757575;\n  font-size: 16px;\n  max-width: 600px;\n  margin: 15px auto 0;\n}\n.clinic-specialities .section-header h2 {\n  color: #2868c8;\n  font-weight: 700;\n  font-size: 30px;\n}\n.clinic-specialities .section-header h2 img {\n  margin: 2px 5px 5px;\n}\n.special-box {\n  background-color: #fff;\n  border-radius: 10px;\n  height: 160px;\n  cursor: pointer;\n  margin-bottom: 30px;\n  -webkit-transition: ease all 0.4s;\n  -ms-transition: ease all 0.4s;\n  transition: ease all 0.4s;\n}\n.special-box:hover {\n  background-color: #1c71ef;\n  -webkit-transition: ease all 0.4s;\n  -ms-transition: ease all 0.4s;\n  transition: ease all 0.4s;\n}\n.special-box .special-body {\n  padding: 20px;\n}\n.special-box .special-body img {\n  width: 50px;\n  margin-bottom: 15px;\n}\n.special-box .special-body h4 {\n  font-size: 16px;\n  margin: 0;\n  font-weight: 500;\n}\n.special-box .special-footer {\n  border-top: 1px solid #eaeaea;\n  padding: 15px;\n  width: 100%;\n  margin: 0;\n}\n.special-box .special-footer .doc-count {\n  font-size: 14px;\n  font-weight: 700;\n  color: #e74e84;\n}\n.special-box .special-footer .doc-count span,\n.special-box .special-footer .clin-count span {\n  color: #000000;\n  font-weight: 500;\n}\n.special-box .special-footer .clin-count {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1c71ef;\n}\n.special-box .spc-book {\n  background-color: #fff;\n  padding: 10px 15px;\n  min-width: 120px;\n  color: #e74e84;\n  border-radius: 30px;\n  font-size: 14px;\n  font-weight: 600;\n  display: none;\n}\n.special-box .spc-book i {\n  background-color: #e74e84;\n  color: #fff;\n  border-radius: 50%;\n  width: 12px;\n  height: 12px;\n  justify-content: center;\n  align-items: center;\n  display: inline-flex;\n  font-size: 9px;\n}\n.special-box:hover img,\n.special-box:hover .special-footer {\n  display: none;\n}\n.special-box:hover h4 {\n  color: #fff;\n}\n.special-box:hover .spc-book {\n  margin-top: 10px;\n  display: block;\n}\n.special-box:hover .special-body {\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n}\n.view-all-more .btn {\n  background: #0ce0ff;\n  border-radius: 30px;\n  border-color: #0ce0ff;\n  padding: 9px 30px;\n  margin-top: 20px;\n}\n.browse-section {\n  background-color: #e5f6fd;\n  padding: 60px 0;\n}\n.brower-box {\n  text-align: center;\n  border-radius: 10px;\n  border: 6px solid #fff;\n  background-color: #ffffff;\n  margin-bottom: 20px;\n}\n.brower-box > div {\n  border-radius: 15px;\n  background-color: #e5f6fd;\n  height: 100%;\n  padding: 15px;\n}\n.brower-img {\n  background-color: #1c71ef;\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  margin: 0 auto 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.brower-img img {\n  width: auto;\n}\n.brower-box h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #2264c5;\n}\n.brower-box p {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e74e84;\n  margin: 0;\n}\n.brower-box p span {\n  color: #000;\n}\n.doc-background {\n  background: url(../assets/img/doctor.jpg);\n  background-position: center;\n  min-height: 350px;\n  background-size: cover;\n  padding: 40px 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n}\n.doc-background::before {\n  content: \"\";\n  position: absolute;\n  background: rgba(61, 59, 59, 0.84);\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: -1;\n}\n.doctor-divison h3 {\n  font-size: 28px;\n  color: #fff;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n.doctor-divison p {\n  font-size: 14px;\n  color: #fff;\n  font-weight: 600;\n  margin-bottom: 30px;\n}\n.doctor-divison .doc-bok-btn {\n  font-size: 14px;\n  padding: 6px 12px;\n  color: #fff;\n  background-color: #1c71ef;\n  border-radius: 30px;\n  width: 100px;\n  text-align: center;\n}\n.pat-background {\n  background: url(../assets/img/patient.jpg);\n  background-position: center;\n  min-height: 350px;\n  background-size: cover;\n  padding: 40px 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n}\n.pat-background::before {\n  content: \"\";\n  position: absolute;\n  background: rgba(28, 113, 239, 0.9);\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: -1;\n}\n.pat-background .doc-bok-btn {\n  background-color: #fed35d;\n}\n.book-section {\n  background: url(../assets/img/special-banner.jpg);\n  padding: 60px 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.book-best-doctors {\n  margin-bottom: 30px;\n}\n.book-best-doctors .book-header img {\n  border-radius: 10px 10px 0px 0px;\n  width: 100%;\n  position: relative;\n  display: inline-block;\n  z-index: 1;\n}\n.book-best-doctors .book-header img::before {\n  content: \"\";\n  position: absolute;\n  background: rgba(61, 59, 59, 0.84);\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: -1;\n}\n.book-best-doctors .book-header .img-overlay {\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  background: #e74e84;\n  border-radius: 50%;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  width: 25px;\n  height: 25px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n.book-best-doctors .book-header .img-overlay i {\n  font-size: 12px;\n}\n.doctors-body .inner-section > span {\n  color: #e74e84;\n  font-size: 14px;\n}\n.book-best-doctors .doctors-body {\n  padding: 0;\n  box-shadow: 0px -6px 54px rgba(152, 152, 152, 0.25);\n  border-radius: 0;\n}\n.book-best-doctors .doctors-body .inner-section {\n  padding: 15px 15px 0;\n}\n.book-best-doctors .doctors-body .rating i {\n  font-size: 10px;\n  color: #dfdfdf;\n  margin-bottom: 10px;\n}\n.book-best-doctors .doctors-body .rating i.filled {\n  color: #fed35d;\n}\n.book-best-doctors .doctors-body .average-ratings {\n  background-color: #fed35d;\n  font-size: 11px;\n  font-weight: 700;\n}\n.book-best-doctors .doctors-body h4 {\n  color: #22396b;\n  text-transform: uppercase;\n  font-size: 20px;\n  margin-bottom: 5px;\n}\n.book-best-doctors .doctors-body p {\n  color: #0098ae;\n  font-size: 12px;\n  font-weight: 600;\n}\n.book-best-doctors .loc-details {\n  margin: 15px 0 0;\n  background-color: #f6faff;\n  padding: 15px 10px 0;\n}\n.book-best-doctors .loc-details .d-flex {\n  margin-bottom: 15px;\n}\n.book-best-doctors .loc-details img {\n  color: #22396b;\n  width: auto;\n  margin-right: 8px;\n}\n.book-best-doctors .available-info {\n  font-weight: 500;\n  font-size: 12px;\n  text-transform: uppercase;\n  clear: both;\n  display: block;\n  margin: 0;\n}\n.book-best-doctors .data-info {\n  font-weight: 700;\n  font-size: 11px;\n  color: #2264c5;\n}\n.book-best-doctors .amt-txt {\n  color: #e74e84;\n  font-size: 18px;\n  font-weight: 600;\n}\n.book-best-doctors .doctors-body .book-btn {\n  font-size: 14px;\n  padding: 6px 12px;\n  color: #fff;\n  background-color: #1c71ef;\n  border-radius: 30px;\n  width: 100px;\n  text-align: center;\n  float: right;\n}\n.latest-blog {\n  background-color: #f4fcff;\n  padding: 60px 0 30px;\n}\n.latest-blog .blog-wrap {\n  margin-bottom: 30px;\n  background-color: #fff;\n  border-radius: 10px 10px 0px 0px;\n}\n.latest-blog .blog-wrap img {\n  border-radius: 10px;\n}\n.latest-blog .blog-wrap .blog-wrap-body {\n  padding: 20px 15px;\n  background-color: #fff;\n}\n.latest-blog .blog-wrap .blog-wrap-body h3 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n.latest-blog .blog-wrap .blog-wrap-body h3 a:hover {\n  color: #2b6ccb;\n}\n.latest-blog .blog-wrap .blog-wrap-body p {\n  font-size: 14px;\n  color: #737373;\n}\n.latest-blog .blog-wrap .blog-wrap-body .blog-footer {\n  border-top: 1px solid #1b70ee;\n  padding: 15px 0 0;\n}\n.latest-blog .blog-footer .read-txt,\n.latest-blog .blog-footer .cal-txt {\n  color: #1b70ee;\n  font-size: 14px;\n  font-weight: 600;\n}\n.latest-blog .blog-footer .read-txt i {\n  margin: 2px 6px;\n  position: absolute;\n  top: 3px;\n}\n.latest-blog .blog-footer .cal-txt i {\n  margin: 2px 6px;\n}\n.clinics-section {\n  padding: 60px 0 40px;\n  background: #fff;\n}\n.section-heading h2 {\n  font-weight: 700;\n  font-size: 26px;\n  color: #1c5b90;\n}\n.section-heading p {\n  font-size: 14px;\n  color: #757578;\n  margin-bottom: 0;\n}\n.section-heading {\n  margin-bottom: 30px;\n}\n.clinics-card {\n  position: relative;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.clinic-item .clinics-card .clinics-img:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(28, 91, 144, 0.9);\n}\n.clinics-info {\n  position: absolute;\n  top: 50%;\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  text-align: center;\n}\n.clinics-info img {\n  width: 60px !important;\n  margin: auto;\n  margin-bottom: 10px;\n}\n.clinics-info span {\n  font-weight: 600;\n  font-size: 18px;\n  color: #fff;\n}\n.clinics-icon i {\n  border-radius: 50%;\n  height: 35px;\n  width: 35px;\n  text-align: center;\n  line-height: 35px;\n  background: #10defd;\n  color: #fff;\n  margin: auto;\n  display: block;\n}\n.clinics-icon {\n  transform: translate(0, -50%);\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n.clinics-img {\n  position: relative;\n}\n.clinic-item:hover .clinics-card .clinics-img:after {\n  background: rgba(45, 226, 253, 0.9);\n}\n.clinic-item:hover .clinics-icon i {\n  color: #1c5b90;\n  background: #fff;\n}\n.clinic-item:hover .clinics-icon {\n  transform: translate(0, -180%);\n}\n.specialities-section {\n  position: relative;\n  background: url(../assets/img/specialist-bg.jpg);\n  background-position: 50% 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  z-index: 1;\n}\n.specialities-section:after {\n  content: \"\";\n  position: absolute;\n  background: rgba(25, 69, 107, 0.9);\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: -1;\n}\n.section-heading.bg-area h2 {\n  color: #fff;\n}\n.section-heading.bg-area p {\n  color: #fff;\n}\n.specialist-card {\n  background: #ffffff;\n  box-shadow: 0px 4px 24px rgba(183, 183, 183, 0.25);\n  border-radius: 163px;\n  align-items: center;\n  padding: 15px;\n  margin-bottom: 25px;\n}\n.specialist-card:hover {\n  background: #e0f2ff;\n}\n.specialist-img {\n  background: #1b5d92;\n  padding: 10px;\n  height: 55px;\n  width: 55px;\n  border-radius: 50%;\n  margin-right: 10px;\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n\n.specialist-card:hover .specialist-img {\n  background: #10defd;\n}\n.specialist-info h4 {\n  font-weight: 600;\n  color: #274782;\n  margin-bottom: 0;\n}\n.specialist-info p {\n  font-weight: 500;\n  color: #000000;\n  margin-bottom: 0;\n}\n.specialist-nav i {\n  border-radius: 50%;\n  height: 35px;\n  width: 35px;\n  text-align: center;\n  line-height: 35px;\n  background: #ffffff;\n  box-shadow: 0px 4px 24px rgba(183, 183, 183, 0.25);\n  color: #d84153;\n  margin: auto;\n  display: block;\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n.specialist-card:hover .specialist-nav i {\n  background: #10defd;\n  color: #fff;\n}\n.specialities-section {\n  padding: 80px 0 55px;\n}\n.our-doctors-card {\n  background: rgba(232, 246, 255, 0.4);\n  border: 1px solid rgba(231, 237, 255, 0.5);\n  border-radius: 10px;\n  padding: 10px;\n}\n.doctors-body .rating {\n  font-size: 12px;\n}\n.doctors-body .rating i.filled {\n  color: #1c5b90;\n}\n.average-ratings {\n  background: #1c5b90;\n  border-radius: 70px;\n  color: #fff;\n  padding: 1px 15px;\n  margin-left: 10px;\n}\n.doctors-body h4 {\n  color: #1c1c1c;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n.doctors-body p {\n  color: #204892;\n  font-weight: 500;\n  margin-bottom: 0;\n  font-size: 12px;\n}\n.doctors-body .location p {\n  font-size: 14px;\n  color: #000000;\n}\n.doctors-body .location p i {\n  color: #1c5b90;\n}\n.doctors-body .view-btn {\n  background: #e8f6ff;\n  border: 1px solid #e8eeff;\n  box-sizing: border-box;\n  border-radius: 30px;\n  color: rgba(41, 68, 129, 0.9);\n  padding: 10px 0;\n}\n.doctors-body .book-btn {\n  background: #10defd;\n  border-radius: 30px;\n  padding: 10px 0;\n  border: 0;\n}\n.doctors-body .book-btn:hover {\n  border: 0;\n}\n.doctors-body {\n  background: #ffffff;\n  border-radius: 0px 0px 10px 10px;\n  padding: 10px;\n}\n.doctors-body .location {\n  padding: 20px 0;\n}\n.doctors-header img {\n  border-radius: 10px 10px 0 0;\n}\n.our-doctors-section {\n  padding: 60px 0;\n  background: #fff;\n}\n.doctors-header {\n  position: relative;\n}\n.doctors-header .img-overlay {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: #1b5d92;\n  border-radius: 110px;\n  padding: 5px 10px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n}\n.clinic-features-section {\n  position: relative;\n  background: url(../assets/img/featured-bg.jpg);\n  background-position: 50% 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  padding: 60px 0;\n}\n.clinic-features {\n  position: relative;\n}\n.clinic-features img {\n  border-radius: 10px;\n}\n.clinic-feature-overlay .img-overlay {\n  background: #20c0f3;\n  border-radius: 60px;\n  padding: 10px 15px;\n  text-transform: uppercase;\n  color: #e6f4fd;\n  font-weight: 600;\n  min-width: 150px;\n  display: inline-block;\n}\n.clinic-feature-overlay {\n  position: absolute;\n  bottom: 20px;\n  text-align: center;\n  width: 100%;\n}\n.our-blog-section {\n  padding: 60px 0;\n  background: #fff;\n}\n.blogs-info span {\n  color: #20c0f3;\n}\n.blogs-info h4 {\n  color: #000000;\n  line-height: 28px;\n}\n.blogs-info p {\n  color: #000000;\n  font-size: 13px;\n}\n.blogs-time {\n  color: #17418e !important;\n}\n.blogs-overlay {\n  align-items: center;\n  background: #ffffff;\n  border-radius: 30px 0px 0px 30px;\n  position: absolute;\n  bottom: 10px;\n  right: 0;\n  padding: 5px;\n}\n.blogs-img {\n  position: relative;\n}\n.blogs-overlay img {\n  height: 35px;\n  width: 35px !important;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n.blogs-writter {\n  display: none;\n}\n.our-blogs {\n  display: block;\n  transition: 0.6s;\n  border-radius: 10px 10px 0px 0px;\n  overflow: hidden;\n}\n.our-blogs:hover .blogs-writter {\n  display: block;\n}\n.blogs-info {\n  background: #ffffff;\n  border: 1px solid #e8eeff;\n  padding: 15px;\n}\n.blogs-btn {\n  background: #1c5b90;\n  border-radius: 30px;\n  color: #fff;\n  padding: 8px 10px;\n  display: block;\n  width: 110px;\n  text-align: center;\n  font-size: 12px;\n}\n.blogs-nav {\n  border: 1px solid #e8eeff;\n  padding: 10px;\n  border-top: 0;\n}\n.form-custom {\n  position: relative;\n}\n.form-custom i {\n  position: absolute;\n  top: 35%;\n  right: 15px;\n  color: #dd2d4e;\n}\n.doctor-search-section {\n  padding-top: 95px;\n}\n.banner-btn {\n  background: #1c5b90;\n  border-radius: 130px;\n  color: #fff;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 20px 30px;\n  width: 100%;\n}\n.banner-btn:hover {\n  background: #10defd;\n  color: #fff;\n}\n.doctor-search {\n  padding-bottom: 15px;\n}\n.slide-nav-1 button.owl-next,\n.slide-nav-1 button.owl-prev,\n.slide-nav-2 button.owl-next,\n.slide-nav-2 button.owl-prev,\n.slide-nav-3 button.owl-next,\n.slide-nav-3 button.owl-prev,\n.slide-nav-4 button.owl-next,\n.slide-nav-4 button.owl-prev {\n  width: 34px;\n  height: 34px;\n  background: #10defd;\n  text-shadow: none;\n  top: 4px;\n  cursor: pointer;\n  border: 0;\n  color: #ffffff;\n  margin-bottom: 15px;\n  border-radius: 8px;\n  transform: rotate(-44deg);\n}\n\n.owl-nav button.owl-next span,\n.owl-nav button.owl-prev span {\n  font-size: 34px;\n  line-height: 25px;\n  transform: rotate(44deg);\n  display: flex;\n  padding-left: 6px;\n  padding-bottom: 3px;\n}\n\n.owl-nav button.owl-next {\n  margin-left: 20px;\n}\n\n.owl-theme .owl-dots,\n.owl-nav button {\n  margin-top: 30px;\n}\n\n.owl-theme .owl-dots .owl-dot span {\n  width: 28px;\n  height: 6px;\n  margin: 5px 3px 0;\n  background: #f3f3f3;\n  display: block;\n  -webkit-backface-visibility: visible;\n  transition: opacity 0.2s ease;\n  border-radius: 30px;\n  position: relative;\n}\n\n.owl-theme .owl-dots .owl-dot.active span,\n.owl-theme .owl-dots .owl-dot:hover span {\n  background: #00825b;\n}\n.custom-arrow {\n  transform: rotate(44deg);\n}\n.shapes {\n  position: absolute;\n  width: 100%;\n}\n.shape-1 {\n  position: absolute;\n  top: 0;\n  left: 0px;\n}\n.shape-2 {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.shape-3 {\n  position: absolute;\n  top: -110px;\n  left: 0px;\n}\n.shape-4 {\n  position: absolute;\n  top: -110px;\n  right: 0;\n}\n.section-search-3 {\n  position: relative;\n  background: url(../assets/img/banner-3.jpg);\n  background-position: 50% 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  z-index: 1;\n  min-height: 550px;\n  padding-top: 85px;\n}\n.section-search-3:after {\n  content: \"\";\n  position: absolute;\n  background: rgba(24, 96, 202, 0.9);\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: -1;\n}\n.header-banner h2 {\n  color: #ffffff;\n  font-weight: 600;\n  line-height: 40px;\n}\n.header-banner p {\n  font-size: 17px;\n  color: #ffffff;\n}\n.header-highlight {\n  font-weight: 700;\n  color: #0ce0ff;\n}\n.section-search-3 .banner-info {\n  padding: 130px 0 190px;\n}\nbody .multi-optn {\n  background-color: #ffffff;\n}\n.pharmacy-home-slider .banner-wrapper.doc-form {\n  left: 35%;\n}\n.side-dots .swiper-container {\n  position: relative;\n  padding: 0 !important;\n  height: 500px;\n  min-height: inherit;\n}\n.doc-form {\n  position: absolute;\n  top: 155px;\n  padding: 50px 0;\n}\n.side-dots img {\n  width: 100%;\n}\n.app-form {\n  position: relative;\n  padding: 30px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.87);\n}\n.app-form h2 {\n  color: #e74e84;\n  font-size: 34px;\n  margin-bottom: 30px;\n}\n.app-form h2 .header-highlight {\n  color: #1860ca;\n  font-weight: 600;\n}\n.app-form .doctor-search-form input {\n  border-radius: 20px;\n}\n.app-form .form-custom i {\n  color: #0ce0ff;\n}\n.app-form .banner-btn {\n  background-color: #0ce0ff;\n  padding: 18px 30px;\n  border-radius: 20px;\n}\n.category-sec {\n  margin-top: -30px;\n  padding: 0 0 50px 0;\n}\n.set-category {\n  background-color: #1860ca;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 15px;\n  border-radius: 20px;\n  min-height: 200px;\n}\n.set-category .img-holder {\n  margin-right: 20px;\n}\n.set-category .img-holder a {\n  width: 60px;\n  height: 60px;\n  display: flex;\n  background-color: #fff;\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n}\n.set-category .img-holder a img {\n  width: 30px;\n}\n.set-category .info-holder h3 {\n  font-size: 26px;\n  font-weight: 700;\n  color: #fff;\n}\n.set-category .info-holder p {\n  font-size: 14px;\n  color: #fff;\n  margin-bottom: 30px;\n}\n.set-category .info-holder .book-now {\n  color: #fff;\n}\n.set-category .info-holder .book-now i {\n  margin: 4px 6px;\n  position: absolute;\n}\n.set-category h2 {\n  font-size: 60px;\n  position: absolute;\n  font-weight: 700;\n  bottom: -13px;\n  right: 25px;\n  color: #fff;\n  opacity: 0.1;\n  margin: 0;\n}\n.set-category.light {\n  background-color: #0ce0ff;\n}\n.set-category.lighter {\n  background-color: #00bcd1;\n}\n.clinic-section {\n  padding: 50px 0 20px;\n}\n.sec-header {\n  margin-bottom: 40px;\n  text-align: center;\n}\n.sec-header h2 {\n  font-size: 30px;\n  margin-bottom: 0;\n  font-weight: 700;\n  color: #22396b;\n}\n.sec-header .bottom-border {\n  border-top: 3px solid #e74e84;\n  width: 75px;\n  margin: 0 auto;\n  margin-top: 20px;\n  position: relative;\n  display: inline-block;\n  border-radius: 150px;\n}\n.sec-header .bottom-border:after {\n  content: \"\";\n  position: absolute;\n  width: 6px;\n  background: #fff;\n  right: 4px;\n  height: 3px;\n  z-index: 9;\n  top: -3px;\n}\n.clinic-slider .slick-list,\n.browse-slider .slick-list,\n.book-slider .slick-list {\n  padding-top: 50px;\n}\n.clinic-slider .slick-prev,\n.clinic-slider .slick-next,\n.browse-slider .slick-prev,\n.browse-slider .slick-next,\n.book-slider .slick-prev,\n.book-slider .slick-next {\n  width: 35px;\n  height: 35px;\n  border-radius: 5px 12px 5px 12px;\n  background-color: #e74e84;\n  transform: translateX(0%) rotate(-45deg);\n  -webkit-transform: translateX(0%) rotate(-45deg);\n  -ms-transform: translateX(0%) rotate(-45deg);\n  z-index: 999;\n}\n.clinic-slider .slick-prev:before,\n.browse-slider .slick-prev:before,\n.book-slider .slick-prev:before {\n  content: \"\";\n  transform: rotate(180deg);\n  -webkit-transform: rotate(180deg);\n}\n.clinic-slider .slick-next:before,\n.browse-slider .slick-next:before,\n.book-slider .slick-next:before {\n  content: \"\";\n  transform: rotate(0deg);\n  -webkit-transform: rotate(0deg);\n}\n.clinic-slider .slick-prev:before,\n.clinic-slider .slick-next:before,\n.browse-slider .slick-prev:before,\n.browse-slider .slick-next:before,\n.book-slider .slick-prev:before,\n.book-slider .slick-next:before {\n  font-family: \"slick\";\n  font-size: 10px;\n  line-height: 1;\n  opacity: 0.75;\n  color: #ffffff;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border: solid #ffffff;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  padding: 3px;\n}\n.clinic-slider .slick-prev,\n.browse-slider .slick-prev,\n.book-slider .slick-prev {\n  right: 80px;\n  left: unset;\n  top: 0;\n}\n.clinic-slider .slick-next,\n.browse-slider .slick-next,\n.book-slider .slick-next {\n  right: 15px;\n  left: unset;\n  top: 0;\n}\n.clinic-slider .slick-slide,\n.browse-slider .slick-slide,\n.book-slider .slick-slide {\n  display: block;\n  margin-left: 0;\n  padding: 10px;\n  width: 280px;\n  padding-bottom: 0;\n}\n.clinic-slider .profile-widget,\n.browse-slider .browse-widget,\n.book-slider .profile-widget {\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  border-radius: 0;\n}\n.clinic-slider .brower-box {\n  background: #ffffff;\n  border: 1px solid #f2f2f2;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 44px rgba(238, 238, 238, 0.25);\n  border-radius: 10px;\n  padding: 30px;\n  margin: 0;\n  transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  -webkit-transition: all 0.4s ease;\n}\n.clinic-slider .brower-box:hover {\n  background-color: #1860ca;\n  transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  -webkit-transition: all 0.4s ease;\n}\n.clinic-slider .brower-box a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 85px;\n  width: 85px;\n  background-color: #1860ca;\n  border-radius: 50% 50% 50% 50% / 60% 60% 35% 35%;\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n  margin: 0 auto;\n  margin-bottom: 15px;\n}\n.clinic-slider .brower-box img {\n  width: 70px;\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.clinic-slider .brower-box h4 {\n  color: #000;\n  font-size: 20px;\n  margin-bottom: 13px;\n}\n.clinic-slider .brower-box p {\n  margin-bottom: 20px;\n}\n.clinic-slider .brower-box .arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #0ce0ff;\n  width: 35px;\n  height: 35px;\n  margin: 0 auto;\n  border-radius: 50%;\n  transform: unset;\n}\n.clinic-slider .brower-box .img-fluid.hover {\n  display: none;\n}\n.clinic-slider .brower-box .arrow i {\n  color: #fff;\n}\n.clinic-slider .brower-box:hover a {\n  background-color: #fff;\n}\n.clinic-slider .brower-box:hover .img-fluid.hover {\n  display: block;\n}\n.clinic-slider .brower-box:hover .img-fluid {\n  display: none;\n}\n.clinic-slider .brower-box:hover a.arrow {\n  background-color: #2868c8;\n}\n.clinic-slider .brower-box:hover h4,\n.clinic-slider .brower-box:hover p,\n.clinic-slider .brower-box:hover p span {\n  color: #fff;\n}\n.browse-speciality {\n  padding: 50px 0 35px;\n  background-color: #f8fbff;\n}\n.browse-widget {\n  padding: 0;\n}\n.browse-widget > img {\n  border-radius: 10px;\n  width: 100%;\n}\n.browse-widget .overlay {\n  position: absolute;\n  top: 0;\n  background-color: rgba(34, 100, 197, 0.8);\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n.browse-widget:hover .overlay {\n  background-color: rgba(36, 36, 36, 0.5);\n}\n.browse-widget .overlay h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #fff;\n}\n.browse-widget .overlay .arrows {\n  position: absolute;\n  bottom: -15px;\n  background-color: #0ce0ff;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.browse-widget .overlay .arrows i {\n  color: #fff;\n}\n.browse-widget:hover .arrows {\n  transform: translate(0, -320%);\n  background-color: #ffffff;\n}\n.browse-widget:hover .arrows i {\n  color: #1c5b90;\n}\n.patient-select {\n  background: url(../assets/img/slider/blue-bg.png);\n  padding: 50px 0;\n  background-size: cover;\n}\n.select-box {\n  background: url(../assets/img/doctor.jpg);\n  padding: 30px;\n  border-radius: 60px 10px 10px 60px;\n  border: 5px solid rgba(255, 255, 255, 0.8);\n  position: relative;\n  z-index: 1;\n}\n.select-box::before {\n  content: \"\";\n  position: absolute;\n  background: rgba(16, 222, 253, 0.6);\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: -1;\n  border-radius: 55px 5px 5px 55px;\n}\n.select-box h2 {\n  font-size: 30px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 15px;\n}\n.select-box .image-holder {\n  margin-right: 20px;\n}\n.select-box .image-holder span {\n  background-color: #fff;\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: 6px solid rgb(210 237 246);\n}\n.select-box .image-holder span img {\n  width: 55px;\n}\n.select-box p {\n  font-size: 15px;\n  color: #fff;\n  margin-bottom: 30px;\n}\n.select-box .book-now {\n  background-color: #1c71ef;\n  padding: 6px 20px;\n  color: #fff;\n  border-radius: 30px;\n  font-size: 14px;\n  font-weight: 600;\n  display: block;\n  width: 150px;\n}\n.select-box.theme {\n  background: url(../assets/img/patient.jpg);\n  border-radius: 10px 60px 60px 10px;\n}\n.select-box.theme::before {\n  content: \"\";\n  position: absolute;\n  background: rgba(28, 113, 239, 0.6);\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: -1;\n  border-radius: 5px 55px 55px 5px;\n}\n.select-box.theme .image-holder span {\n  border: 6px solid rgb(217 225 240);\n}\n.select-box.theme .book-now {\n  background-color: #20d7f2;\n}\n.book-doctor {\n  padding: 50px 0;\n}\n.book-slider .profile-widget {\n  padding: 0;\n  border: none;\n  margin-bottom: 70px;\n}\n.book-slider .profile-widget a {\n  border-radius: 10px 10px 0px 0px;\n}\n.book-slider .profile-widget a img {\n  width: 100%;\n  border-radius: 10px 10px 0px 0px;\n}\n.book-slider .pro-content {\n  padding: 0;\n  position: absolute;\n  top: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n  border-radius: 10px 10px 0px 0px;\n}\n.book-slider .pro-content .amt {\n  background-color: #e74e84;\n  padding: 3px 8px;\n  border-radius: 30px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 12px;\n  opacity: 0;\n  transition: all 0.3s ease;\n  -moz-transition: all 0.3s ease;\n  -o-transition: all 0.3s ease;\n  -ms-transition: all 0.3s ease;\n  -webkit-transition: all 0.3s ease;\n}\n.book-slider .pro-content .star {\n  background-color: #2264c5;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  position: absolute;\n  right: 0;\n  color: #fff;\n  font-size: 12px;\n}\n.book-slider .profile-widget:hover .amt {\n  opacity: 1;\n}\n.book-slider .provider-info h3 a {\n  font-size: 22px;\n  font-weight: 700;\n  color: #22396b;\n}\n.book-slider .profile-widget .provider-info {\n  background-color: #fff;\n  padding: 15px;\n  border-radius: 10px;\n  position: absolute;\n  bottom: -40px;\n  width: 100%;\n  left: 0;\n  transition: all 0.3s ease;\n  -moz-transition: all 0.3s ease;\n  -o-transition: all 0.3s ease;\n  -ms-transition: all 0.3s ease;\n  -webkit-transition: all 0.3s ease;\n}\n.book-slider .profile-widget:hover .provider-info {\n  transition: all 0.3s ease;\n  -moz-transition: all 0.3s ease;\n  -o-transition: all 0.3s ease;\n  -ms-transition: all 0.3s ease;\n  -webkit-transition: all 0.3s ease;\n}\n.book-slider .provider-info h5 {\n  color: #e74e84;\n  font-size: 15px;\n  font-weight: 600;\n  float: left;\n}\n.book-slider .provider-info .side-arrow {\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  background-color: #2868c8;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 15px;\n  right: 15px;\n  color: #fff;\n}\n.book-slider .provider-info .rating {\n  display: none;\n  font-size: 12px;\n  width: auto;\n  text-align: right;\n}\n.book-slider .provider-info .rating i {\n  font-size: 10px;\n  color: #dfdfdf;\n}\n.book-slider .provider-info .rating i.filled {\n  color: #fed35d;\n}\n.book-slider .provider-info .rating span {\n  padding: 0 8px;\n  background-color: #fed35d;\n  border-radius: 30px;\n  font-size: 10px;\n  color: #fff;\n  font-weight: 700;\n  margin-left: 5px;\n}\n.book-slider .profile-widget .content-info {\n  display: none;\n  padding: 0;\n}\n.book-slider .profile-widget:hover .side-arrow {\n  display: none;\n}\n.book-slider .profile-widget:hover .rating,\n.book-slider .profile-widget:hover .content-info {\n  display: block;\n}\n.book-slider .available-info li i {\n  font-size: 14px;\n  color: #1c5b90;\n}\n.book-slider .available-info li {\n  font-size: 14px;\n  font-weight: 500;\n  color: #000;\n}\n.book-slider .content-info .view-btn,\n.book-slider .content-info .view-btn:hover {\n  background-color: #216ee1;\n  border: 1px solid #216ee1;\n  border-radius: 30px;\n  padding: 7px;\n  border: none;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 500;\n}\n.book-slider .content-info .book-btn,\n.book-slider .content-info .book-btn:hover {\n  background-color: #10defd;\n  border: 1px solid #10defd;\n  border-radius: 30px;\n  padding: 7px;\n  border: none;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 500;\n}\n.book-doctor .view-btn {\n  background-color: #20c0f3;\n  font-size: 16px;\n  color: #ffffff;\n  font-weight: 700;\n  border-radius: 30px;\n  border: 1px solid #20c0f3;\n  padding: 6px 20px;\n}\n.aval-features {\n  background-color: #2467ca;\n}\n.aval-features .feature {\n  background: url(../assets/img/slider/feature-img.jpg);\n  padding: 40px;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.aval-features .feature .info-box {\n  background: rgba(24, 96, 202, 0.8);\n  padding: 40px;\n}\n.aval-features .feature .info-box h2 {\n  font-size: 40px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 15px;\n}\n.aval-features .feature .info-box p {\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n.aval-features .feature .info-box a {\n  background: #10defd;\n  border-radius: 30px;\n  width: 120px;\n  color: #fff;\n  padding: 6px;\n}\n.aval-features .aval-widget .features-img {\n  width: 150px;\n  height: 150px;\n  border-radius: 80px 60px 50px 50px;\n  margin: 0 auto;\n}\n.aval-features .aval-widget .features-img img {\n  border-radius: 80px 60px 50px 50px;\n  width: 100%;\n  border: 4px solid #ffffff;\n}\n.aval-features .aval-widget .features-img p {\n  background: #20c0f3;\n  border-radius: 30px;\n  color: #fff;\n  text-align: center;\n  padding: 6px;\n  margin: 20px 0 0;\n}\n.aval-slider .slick-slide {\n  display: block;\n  margin-left: 0;\n  padding: 10px;\n  width: 280px;\n}\n.aval-slider .aval-widget {\n  margin-bottom: 30px;\n  position: relative;\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n.aval-slider .slick-list {\n  padding: 50px 0;\n}\n.aval-slider .slick-prev,\n.aval-slider .slick-next {\n  width: 35px;\n  height: 35px;\n}\n.aval-slider .slick-prev {\n  left: 5px;\n}\n.aval-slider .slick-prev:hover,\n.aval-slider .slick-prev:focus,\n.aval-slider .slick-next:hover,\n.aval-slider .slick-next:focus {\n  background-color: #fff;\n}\n.aval-slider .slick-next {\n  right: 5px;\n}\n.aval-slider .slick-prev:before {\n  font-family: \"slick\";\n  font-size: 10px;\n  line-height: 1;\n  opacity: 0.75;\n  color: #1860ca;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border: solid #1860ca;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  padding: 3px;\n  content: \"\";\n  transform: rotate(140deg);\n  -webkit-transform: rotate(140deg);\n}\n.aval-slider .slick-next:before {\n  font-family: \"slick\";\n  font-size: 10px;\n  line-height: 1;\n  opacity: 0.75;\n  color: #1860ca;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border: solid #1860ca;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  padding: 3px;\n  content: \"\";\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n}\n.home-search-section {\n  background: url(../assets/img/slider/banner-01.jpg);\n  background-size: cover;\n  background-repeat: no-repeat;\n  z-index: 1;\n}\n.home-search-section .wrapper-content {\n  padding: 90px 0 0;\n}\n.doctor-search-form select {\n  background: #ffffff;\n  border-radius: 130px;\n  min-height: 60px;\n  border: none !important;\n}\n.doctor-search-form select,\n.doctor-search-form input {\n  border: 1px solid rgba(16, 222, 253, 0.1);\n  box-shadow: 0px 4px 4px rgba(237, 237, 237, 0.25);\n  border-radius: 5px;\n}\n.home-search-section .banner-header h2 {\n  color: #28daf4;\n  font-weight: 500;\n  margin-bottom: 30px;\n  font-size: 38px;\n}\n.home-search-section .banner-header h2 .highlighter {\n  font-weight: 600;\n}\n.home-search-section .doctor-form .banner-btn {\n  background: #e74e84;\n  border: 1px solid #e74e84;\n  box-shadow: 10px 4px 14px rgba(247, 247, 247, 0.25);\n  border-radius: 5px;\n}\n.facility-section {\n  background-color: #f3f8ff;\n  padding: 60px 0;\n}\n.facility-section .visit-doctor {\n  background-color: #fff;\n  padding: 20px;\n  margin-bottom: 30px;\n}\n.facility-section .visit-doctor .inner-details {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.facility-section .visit-doctor .inner-details img {\n  position: absolute;\n  bottom: -20px;\n  right: 0;\n  width: 50px;\n}\n.visit-doctor .inner-details .count h2 {\n  font-weight: 700;\n  font-size: 24px;\n  color: #1860ca;\n  width: 65px;\n  height: 65px;\n  border-radius: 50%;\n  border: 5px solid #f7faff;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  margin-right: 20px;\n}\n.visit-doctor .inner-details .info h2 {\n  font-weight: 700;\n  font-size: 24px;\n  color: #1860ca;\n}\n.visit-doctor .inner-details .info p {\n  color: #9d9d9d;\n  font-size: 14px;\n  max-width: 280px;\n}\n.visit-doctor .inner-details .info a {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1860ca;\n}\n.visit-doctor .inner-details .info a i {\n  margin: 5px 6px;\n  position: absolute;\n}\n.visit-doctor .inner-details.pharmacy .count h2,\n.visit-doctor .inner-details.pharmacy .info h2,\n.visit-doctor .inner-details.pharmacy .info a,\n.visit-doctor .inner-details.pharmacy .info a i {\n  color: #0ce0ff;\n}\n.visit-doctor .inner-details.lab .count h2,\n.visit-doctor .inner-details.lab .info h2,\n.visit-doctor .inner-details.lab .info a,\n.visit-doctor .inner-details.lab .info a i {\n  color: #00bcd1;\n}\n.clinic-speciality {\n  background-color: #fff;\n  padding: 60px 0;\n}\n.heading-wrapper {\n  margin-bottom: 40px;\n  align-items: center;\n}\n.heading-wrapper h1 {\n  max-width: 250px;\n  font-weight: 700;\n  font-size: 38px;\n  color: #6c6c6c;\n}\n.heading-wrapper .nav-arrow {\n  width: 40px;\n  height: 40px;\n  background-color: #f3f8ff;\n  border: 3px solid #1860ca;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  color: #2264c5;\n}\n.clinic-wrap {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  width: 100%;\n  margin-bottom: 30px;\n  border-radius: 10px;\n  height: 250px;\n}\n.clinic-wrap:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  background: rgb(222 235 255 / 28%);\n  border-radius: 5px;\n}\n.clinic-wrap .wrapper-overlay {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n}\n.clinic-wrap .wrapper-overlay img {\n  width: 70px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  border: 5px solid #f7faff;\n  border-radius: 50%;\n  margin-bottom: 30px;\n}\n.clinic-wrap .wrapper-overlay h3 {\n  font-size: 22px;\n  color: #e74e84;\n  font-weight: 700;\n  margin-bottom: 30px;\n}\n.clinic-wrap .wrapper-overlay .row.row-sm {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n.clinic-wrap .wrapper-overlay p {\n  font-weight: 700;\n  color: #e74e84;\n  font-size: 14px;\n}\n.clinic-wrap .wrapper-overlay p.blue {\n  color: rgba(24, 96, 202, 0.9);\n}\n.clinic-wrap .wrapper-overlay p span {\n  font-weight: 500;\n  color: #000;\n}\n.browse-section.brower-category {\n  padding: 60px 0;\n  background: url(../assets/img/slider/banner-02.jpg);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.browse-section.brower-category .heading-wrapper h1 {\n  color: #e5f6fd;\n}\n.browse-section.brower-category .brower-box > div {\n  background-color: #f2f7ff;\n  border-radius: 20px 20px 0px 0px;\n}\n.browse-section.brower-category .brower-img {\n  background-color: #28daf4;\n  margin-bottom: 40px;\n}\n.browse-section.brower-category .brower-box h4 {\n  color: #28daf4;\n}\n.doctor-divison.provider-select .doc-background {\n  background: url(../assets/img/doctor.jpg);\n  background-size: cover;\n  padding: 60px 30px;\n}\n.doctor-divison.provider-select .doc-background::before {\n  background: rgba(242, 247, 255, 0.94);\n}\n.doctor-divison.provider-select .pat-background {\n  background: url(../assets/img/shapes/doctor-right-bg.jpg);\n  background-size: cover;\n  padding: 60px 30px;\n}\n.doctor-divison.provider-select .pat-background::before {\n  background: rgba(40, 218, 244, 0.9);\n}\n.doctor-divison.provider-select .doc-background h3 {\n  color: #2357a6;\n}\n.doctor-divison.provider-select .doc-background p {\n  color: #4b4b4b;\n}\n.doctor-divison.provider-select .pat-background a {\n  background-color: #0ce0ff;\n}\n.doc-booking {\n  padding: 60px 0;\n  background-color: #f3f8ff;\n}\n.doc-booking .book-slider .slick-prev,\n.doc-booking .book-slider .slick-next {\n  border: 3px solid #1860ca;\n  background-color: #f3f8ff;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  transform: none;\n  top: -110px;\n  box-shadow: none;\n}\n.doc-booking .book-slider .slick-prev:before {\n  transform: rotate(140deg);\n  -webkit-transform: rotate(140deg);\n}\n.doc-booking .book-slider .slick-next:before {\n  transform: rotate(320deg);\n  -webkit-transform: rotate(320deg);\n}\n.doc-booking .book-slider .slick-prev:before,\n.doc-booking .book-slider .slick-next:before {\n  font-family: \"slick\";\n  font-size: 10px;\n  line-height: 1;\n  opacity: 0.75;\n  color: #ffffff;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border: solid #1860ca;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  padding: 3px;\n}\n.doc-booking .book-slider .slick-list {\n  padding-top: 0;\n}\n.doc-booking .book-slider .pro-content .amt {\n  opacity: 1;\n  position: absolute;\n  left: -7px;\n  padding: 6px 12px;\n  border-radius: 0px 100px 100px 0px;\n  background-color: #28daf4;\n}\n.doc-booking .book-slider .profile-widget .content-info,\n.doc-booking .book-slider .provider-info .rating {\n  display: block;\n  text-align: left;\n}\n.doc-booking .book-slider .profile-widget a img,\n.doc-booking .book-slider .pro-content {\n  border-radius: 10px;\n}\n.doc-booking .book-slider .profile-widget .provider-info {\n  bottom: 0;\n  background-color: #1376ca;\n  border-radius: 0 0 10px 10px;\n}\n.doc-booking .book-slider .profile-widget .provider-info h3 a {\n  color: #28daf4;\n}\n.doc-booking .book-slider .profile-widget {\n  margin-bottom: 0;\n}\n.doc-booking .book-slider .provider-info h5 {\n  color: #fff;\n  float: unset;\n}\n.doc-booking .book-slider .profile-widget a.book-btn {\n  border-radius: 30px;\n  background-color: transparent;\n  width: 100px;\n}\n/*-----------------\n\t16. Search\n-----------------------*/\n\n.breadcrumb-bar {\n  background-color: #15558d;\n  padding: 15px 0;\n}\n.breadcrumb-bar .breadcrumb-title {\n  color: #fff;\n  font-size: 22px;\n  font-weight: 700;\n  margin: 5px 0 0;\n}\n.page-breadcrumb ol {\n  background-color: transparent;\n  font-size: 12px;\n  margin-bottom: 0;\n  padding: 0;\n}\n.page-breadcrumb ol li a {\n  color: #fff;\n}\n.page-breadcrumb ol li.active {\n  color: #fff;\n}\n.page-breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  color: #fff;\n  font-size: 10px;\n}\n.sort-by {\n  float: right;\n}\n.sort-title {\n  color: #fff;\n  font-size: 14px;\n  margin-right: 10px;\n}\n.custom-short-by .sort-title {\n  color: #2e3842;\n}\n.custom-short-by > div {\n  margin-right: 20px;\n}\n.custom-short-by > div:first-child {\n  margin-right: 0;\n}\n.sortby-fliter {\n  display: inline-block;\n  width: 120px;\n}\n.cal-icon {\n  position: relative;\n  width: 100%;\n}\n.cal-icon:after {\n  color: #979797;\n  content: \"\\f073\";\n  display: block;\n  font-family: \"Font Awesome 5 Free\";\n  font-size: 16px;\n  font-weight: 400;\n  margin: auto;\n  position: absolute;\n  right: 15px;\n  top: 10px;\n}\n.custom_check {\n  color: #666;\n  display: inline-block;\n  position: relative;\n  font-size: 14px;\n  font-size: 0.9375rem;\n  padding-left: 30px;\n  margin-bottom: 10px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.custom_check input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n.custom_check input:checked ~ .checkmark {\n  background-color: #fff;\n}\n.custom_check .checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  width: 20px;\n  border: 1px solid #dcdcdc;\n  background-color: #fff;\n  border-radius: 3px;\n  -moz-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  -webkit-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n.custom_check .checkmark::after {\n  content: \"\\f00c\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n  position: absolute;\n  display: none;\n  left: 4px;\n  top: 0;\n  color: #0de0fe;\n  font-size: 11px;\n}\n.custom_check input:checked ~ .checkmark:after {\n  display: block;\n}\n.custom_radio {\n  color: #555;\n  display: inline-block;\n  position: relative;\n  font-size: 14px;\n  font-size: 0.9375rem;\n  padding-left: 30px;\n  margin-bottom: 10px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.radio_input .custom_radio + .custom_radio {\n  margin-left: 15px;\n}\n.custom_radio input {\n  position: absolute;\n  opacity: 0;\n}\n.custom_radio input:checked ~ .checkmark:after {\n  opacity: 1;\n}\n.custom_radio .checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  width: 20px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 50%;\n}\n.custom_radio .checkmark:after {\n  display: block;\n  content: \"\";\n  position: absolute;\n  opacity: 0;\n  top: 3px;\n  left: 3px;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #ff9b44;\n  -moz-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  -webkit-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\n.filter-widget {\n  margin-bottom: 20px;\n}\n.filter-widget h4 {\n  font-size: 1rem;\n  margin-bottom: 15px;\n}\n.filter-widget .custom_check {\n  line-height: 18px;\n}\n.btn-search .btn {\n  background-color: #0de0fe;\n  border: 1px solid #0de0fe;\n  color: #fff;\n  height: 46px;\n  font-weight: 500;\n  font-size: 16px;\n}\n.doctor-widget {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.doc-info-left {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.doc-info-right {\n  margin-left: auto;\n  -ms-flex: 0 0 205px;\n  flex: 0 0 205px;\n  max-width: 205px;\n}\n.doctor-img {\n  -ms-flex: 0 0 150px;\n  flex: 0 0 150px;\n  margin-right: 20px;\n  width: 150px;\n}\n.doctor-img img {\n  border-radius: 5px;\n}\n.doc-department {\n  color: #20c0f3;\n  font-size: 14px;\n  margin-bottom: 8px;\n}\n.doc-department img {\n  width: 19px;\n  display: inline-block;\n  margin-right: 10px;\n}\n.doc-location {\n  color: #757575;\n  font-size: 14px;\n  margin-bottom: 25px;\n}\n.pharmacy-location,\n.pharmacy-title {\n  color: #2e3842;\n}\n.doc-location a {\n  color: #09e5ab;\n  font-weight: 500;\n}\n.doctor-widget .doc-name {\n  font-size: 20px;\n  font-weight: 500;\n  margin-bottom: 3px;\n}\n.doc-speciality {\n  font-size: 14px;\n  color: #757575;\n  margin-bottom: 15px;\n}\n.doctor-widget .rating i {\n  font-size: 14px;\n}\n.doctor-widget .average-rating {\n  font-size: 14px;\n  font-weight: 500;\n}\n.clinic-details {\n  margin-bottom: 15px;\n}\n.clinic-details h5 {\n  font-weight: normal;\n  color: #757575;\n  margin-bottom: 25px;\n}\n.clinic-details ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.clinic-details ul li {\n  display: inline-block;\n  padding-right: 5px;\n}\n.clinic-details ul li:last-child {\n  padding-right: 0;\n}\n.clinic-details ul li a {\n  display: inline-block;\n}\n.clinic-details ul li a img {\n  border-radius: 5px;\n  width: 40px;\n}\n.clinic-services {\n  color: #272b41;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 13px;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.clinic-services span {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  display: inline-block;\n  font-size: 12px;\n  padding: 3px 10px;\n}\n.clinic-services span + span {\n  margin-left: 5px;\n}\n.clini-infos {\n  margin-bottom: 15px;\n}\n.clini-infos h2 b.strike {\n  text-decoration: line-through;\n  font-weight: 500;\n}\n.clini-infos ul {\n  font-size: 14px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.clini-infos ul li {\n  display: block;\n  line-height: 30px;\n  color: #4e4852;\n}\n.clini-infos ul li i {\n  font-size: 15px;\n  min-width: 30px;\n}\n.clinic-booking a + a {\n  margin-top: 15px;\n}\n.clinic-booking a {\n  background-color: #fff;\n  border: 2px solid #20c0f3;\n  border-radius: 4px;\n  color: #20c0f3;\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 1px;\n  padding: 10px 20px;\n  text-align: center;\n  text-transform: uppercase;\n  width: 100%;\n}\n.clinic-booking a.view-pro-btn:hover,\n.clinic-booking a.view-pro-btn:focus {\n  background: #20c0f3;\n  color: #fff;\n}\n.clinic-booking a.apt-btn {\n  background-color: #20c0f3;\n  color: #fff;\n}\n.clinic-booking a.apt-btn:hover,\n.clinic-booking a.apt-btn:focus {\n  background-color: #0db9f2;\n  border-color: #0db9f2;\n  color: #fff;\n}\n.load-more {\n  margin-bottom: 30px;\n}\n.doctor-img1 {\n  margin-right: 20px;\n}\n.doctor-img1 img {\n  border-radius: 4px;\n}\n\n/*-----------------\n\t17. Doctor Profile\n-----------------------*/\n\n.clinic-direction {\n  color: #757575;\n  font-size: 14px;\n  margin-bottom: 25px;\n}\n.clinic-direction a {\n  color: #09e5ab;\n  font-weight: 500;\n}\n.doctor-action {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-bottom: 15px;\n}\n.doctor-action a + a {\n  margin-left: 8px;\n}\n.doctor-action .fav-btn:hover {\n  background-color: #fb1612;\n  border-color: #fb1612;\n  color: #fff;\n}\n.msg-btn:hover,\n.msg-btn:focus {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n  color: #fff;\n}\n.call-btn:hover,\n.call-btn:focus {\n  background-color: #09e5ab;\n  border-color: #09e5ab;\n  color: #fff;\n}\n.user-tabs .nav-tabs > li > a {\n  border: 0;\n  border-bottom: 3px solid transparent;\n  color: #3e3e3e;\n  font-weight: 600;\n  padding: 20px;\n}\n.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active,\n.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:hover,\n.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:focus {\n  border-bottom-width: 3px;\n  color: #20c0f3;\n}\n.user-tabs .med-records {\n  display: inline-block;\n  min-width: 130px;\n}\n.user-tabs .nav-tabs > li > a:hover {\n  background-color: unset;\n  color: #20c0f3;\n}\n.widget {\n  margin-bottom: 30px;\n}\n.widget-title {\n  margin-bottom: 15px;\n}\n.experience-box {\n  position: relative;\n}\n.experience-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n.experience-list::before {\n  background: #ddd;\n  bottom: 0;\n  content: \"\";\n  left: 8px;\n  position: absolute;\n  top: 8px;\n  width: 2px;\n}\n.experience-list > li {\n  position: relative;\n}\n.experience-list > li:last-child .experience-content {\n  margin-bottom: 0;\n}\n.experience-user .avatar {\n  height: 32px;\n  line-height: 32px;\n  margin: 0;\n  width: 32px;\n}\n.experience-list > li .experience-user {\n  background: #fff;\n  height: 10px;\n  left: 4px;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: 4px;\n  width: 10px;\n}\n.experience-list > li .experience-content {\n  background-color: #fff;\n  margin: 0 0 20px 40px;\n  padding: 0;\n  position: relative;\n}\n.experience-list > li .experience-content .timeline-content {\n  color: #757575;\n}\n.experience-list > li .experience-content .timeline-content a.name {\n  font-weight: 500;\n}\n.experience-list > li .time {\n  color: #757575;\n  display: block;\n  font-size: 13px;\n}\n.before-circle {\n  background-color: rgba(32, 192, 243, 0.2);\n  border-radius: 50%;\n  height: 12px;\n  width: 12px;\n  border: 2px solid #20c0f3;\n}\n.exp-year {\n  color: #20c0f3;\n  margin-bottom: 2px;\n}\n.exp-title {\n  font-size: 16px;\n}\n.awards-widget .experience-list > li:last-child p {\n  margin-bottom: 0;\n}\n.service-list {\n  margin-bottom: 30px;\n}\n.service-list:last-child {\n  border-bottom: 0;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n.service-list ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.service-list ul li {\n  float: left;\n  margin: 6px 0;\n  padding-left: 25px;\n  position: relative;\n  width: 33%;\n}\n.service-list ul li::before {\n  color: #ccc;\n  content: \"\\f30b\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n  left: 0;\n  position: absolute;\n}\n.location-list {\n  border: 1px solid #f0f0f0;\n  border-radius: 4px;\n  padding: 20px;\n}\n.location-list + .location-list {\n  margin-top: 20px;\n}\n.clinic-content .clinic-name {\n  font-size: 18px;\n  font-weight: 500;\n  margin-bottom: 3px;\n}\n.clinic-content .clinic-direction a {\n  display: inline-block;\n  margin-top: 8px;\n}\n.timings-days {\n  font-weight: bold;\n  color: #272b41;\n  margin-bottom: 5px;\n}\n.timings-times span {\n  display: block;\n}\n.location-list .consult-price {\n  font-size: 20px;\n  font-weight: 500;\n  color: #272b41;\n}\n.review-listing {\n  border-bottom: 1px solid #f5f7fc;\n  margin-top: 20px;\n  padding-bottom: 30px;\n}\n.review-listing > ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.review-listing > ul li + li {\n  margin-top: 20px;\n  border-top: 1px dashed #f0f0f0;\n  padding-top: 20px;\n}\n.review-listing > ul li .comment {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 30px;\n}\n.review-listing > ul li .comment:last-child {\n  margin-bottom: 0;\n}\n.review-listing > ul li .comment .comment-body {\n  margin-left: 16px;\n  width: 100%;\n}\n.review-listing > ul li .comment .comment-body .meta-data {\n  position: relative;\n  margin-bottom: 10px;\n}\n.review-listing > ul li .comment .comment-body .meta-data span {\n  display: block;\n  font-size: 16px;\n  color: #757575;\n}\n.review-listing > ul li .comment .comment-body .meta-data span.comment-author {\n  font-weight: 600;\n  color: #272b41;\n  text-transform: capitalize;\n}\n.review-listing > ul li .comment .comment-body .meta-data span.comment-date {\n  font-size: 14px;\n}\n.review-listing > ul li .comment .comment-body .meta-data .review-count {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  top: 3px;\n  right: 0;\n  width: auto;\n}\n.review-listing > ul li .comment .comment-body .comment-content {\n  color: #757575;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  font-size: 14px;\n}\n.review-listing > ul li .comment .comment-body .comment-reply .comment-btn {\n  color: #20c0f3;\n  display: inline-block;\n  font-weight: 500;\n  font-size: 15px;\n}\n.review-listing .recommend-btn {\n  float: right;\n  color: #757575;\n  font-size: 14px;\n  padding: 5px 0;\n  margin-bottom: 0;\n}\n.review-listing .recommend-btn a {\n  border: 1px solid rgba(128, 137, 150, 0.4);\n  border-radius: 4px;\n  display: inline-block;\n  padding: 4px 12px;\n  color: #757575;\n  margin-left: 3px;\n  margin-right: 3px;\n  transition: all 0.3s;\n}\n.review-listing .recommend-btn a.like-btn:hover {\n  background-color: #28a745;\n  border: 1px solid #28a745;\n  color: #fff;\n}\n.review-listing .recommend-btn a.dislike-btn:hover {\n  background-color: #dc3545;\n  border: 1px solid #dc3545;\n  color: #fff;\n}\n.review-listing .recommend-btn a i {\n  font-size: 16px;\n}\n.review-listing > ul li .comments-reply {\n  list-style: none;\n  margin-left: 65px;\n  padding: 0;\n}\n.recommended {\n  color: #28a745;\n  font-size: 15px;\n  font-weight: 500;\n  margin: 0;\n}\n.all-feedback {\n  margin-top: 20px;\n}\n.star-rating {\n  direction: rtl;\n}\n.star-rating input[type=\"radio\"] {\n  display: none;\n}\n.star-rating label {\n  color: #bbb;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0;\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n.star-rating label:hover,\n.star-rating label:hover ~ label,\n.star-rating input[type=\"radio\"]:checked ~ label {\n  color: #f2b600;\n}\n.terms-accept a {\n  color: #20c0f3;\n  font-weight: 500;\n}\n.business-widget {\n  background-color: #fcfcfc;\n  border: 1px solid #f0f0f0;\n  padding: 20px;\n  margin-bottom: 0;\n}\n.listing-day {\n  -webkit-box-align: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  color: #000;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  margin-bottom: 10px;\n}\n.listing-day:last-child {\n  margin-bottom: 0;\n}\n.listing-day.current {\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 13px;\n  margin-bottom: 13px;\n}\n.listing-day .day {\n  font-weight: 500;\n}\n.listing-day.current .day {\n  font-weight: bold;\n}\n.listing-day.current .day span {\n  display: block;\n  font-weight: normal;\n}\n.time-items {\n  color: #757575;\n}\n.time-items > span {\n  display: block;\n  text-align: right;\n}\n.time-items > span.open-status {\n  margin-bottom: 3px;\n}\n.dropzone .dz-preview.dz-error:hover .dz-error-message {\n  display: none;\n}\n/*-----------------\n\t18. Booking\n-----------------------*/\n\n.booking-doc-info {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.booking-doc-info .booking-doc-img {\n  width: 80px;\n  margin-right: 15px;\n}\n.booking-doc-info .booking-doc-img img {\n  border-radius: 4px;\n  height: 80px;\n  width: 80px;\n  object-fit: cover;\n}\n.schedule-widget {\n  border-radius: 4px;\n  min-height: 100px;\n}\n.schedule-header h4 {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 3px 0 0;\n}\n.schedule-header {\n  border-bottom: 1px solid #f0f0f0;\n  border-radius: 4px 4px 0 0;\n  padding: 10px 20px;\n}\n.day-slot ul {\n  float: left;\n  list-style: none;\n  margin-bottom: 0;\n  margin-left: -5px;\n  margin-right: -5px;\n  padding: 0;\n  position: relative;\n  width: 100%;\n}\n.day-slot li {\n  float: left;\n  padding-left: 5px;\n  padding-right: 5px;\n  text-align: center;\n  width: 14.28%;\n}\n.day-slot li span {\n  display: block;\n  font-size: 18px;\n  text-transform: uppercase;\n}\n.day-slot li span.slot-date {\n  display: block;\n  color: #757575;\n  font-size: 14px;\n}\n.day-slot li small.slot-year {\n  color: #757575;\n  font-size: 14px;\n}\n.day-slot li.left-arrow {\n  left: 0;\n  padding: 0;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  width: 20px !important;\n  transform: translateY(-50%);\n}\n.day-slot li.right-arrow {\n  right: -11px;\n  padding: 0;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  width: 20px !important;\n  transform: translateY(-50%);\n}\n.schedule-cont {\n  padding: 20px;\n}\n.time-slot ul {\n  list-style: none;\n  margin-right: -5px;\n  margin-left: -5px;\n  margin-bottom: 0;\n  padding: 0;\n}\n.time-slot li {\n  float: left;\n  padding-left: 5px;\n  padding-right: 5px;\n  width: 14.28%;\n  min-height: 1px;\n}\n.time-slot li .timing {\n  background-color: #e9e9e9;\n  border: 1px solid #e9e9e9;\n  border-radius: 3px;\n  color: #757575;\n  display: block;\n  font-size: 14px;\n  margin-bottom: 10px;\n  padding: 5px 5px;\n  text-align: center;\n  position: relative;\n}\n.time-slot li .timing:hover {\n  background-color: #fff;\n}\n.time-slot li .timing:last-child {\n  margin-bottom: 0;\n}\n.time-slot li .timing.selected {\n  background-color: #42c0fb;\n  border: 1px solid #42c0fb;\n  color: #fff;\n}\n.time-slot li .timing.selected::before {\n  color: #fff;\n  content: \"\\f00c\";\n  font-family: \"Font Awesome 5 Free\";\n  font-size: 12px;\n  font-weight: 900;\n  position: absolute;\n  right: 6px;\n  top: 6px;\n}\n.schedule-list {\n  border-bottom: 1px solid #cfcfcf;\n  margin-bottom: 50px;\n  padding-bottom: 50px;\n}\n.schedule-list:last-child {\n  border-bottom: 0;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n.submit-section.proceed-btn {\n  margin: 0 0 30px;\n}\n\n/*-----------------\n\t19. Checkout\n-----------------------*/\n\n.info-widget {\n  border-bottom: 1px solid #f0f0f0;\n  padding-bottom: 30px;\n  margin-bottom: 30px;\n}\n.card-label > label {\n  background-color: #fff;\n  color: #959595;\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 500;\n  margin: 6px auto auto 8px;\n  padding: 0 7px;\n}\n.card-label > input {\n  background-color: #fff;\n  border: 1px solid #dbdbdb;\n  border-radius: 4px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);\n  display: block;\n  height: 50px;\n  margin-top: -13px;\n  padding: 5px 15px 0;\n  transition: border-color 0.3s;\n  width: 100%;\n}\n.exist-customer a {\n  color: #20c0f3;\n  font-weight: 500;\n}\n.payment-widget .payment-list + .payment-list {\n  margin-bottom: 15px;\n}\n.payment-radio {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 16px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-weight: 600;\n  color: #272b41;\n  text-transform: capitalize;\n}\n.payment-radio input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n.payment-radio .checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 19px;\n  height: 19px;\n  margin: 3px 0 0 0;\n  border: 2px solid #ddd;\n  border-top-color: rgb(221, 221, 221);\n  border-right-color: rgb(221, 221, 221);\n  border-bottom-color: rgb(221, 221, 221);\n  border-left-color: rgb(221, 221, 221);\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  -webkit-transition: all 0.3s;\n  -moz-transition: all 0.3s;\n  -ms-transition: all 0.3s;\n  -o-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.payment-radio input:checked ~ .checkmark {\n  border-color: #20c0f3;\n}\n.payment-radio .checkmark::after {\n  position: absolute;\n  left: 3px;\n  top: 3px;\n  content: \"\";\n  width: 9px;\n  height: 9px;\n  background-color: #20c0f3;\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transform: scale(0.1);\n  -moz-transform: scale(0.1);\n  -ms-transform: scale(0.1);\n  -o-transform: scale(0.1);\n  transform: scale(0.1);\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  -webkit-transition: all 0.3s;\n  -moz-transition: all 0.3s;\n  -ms-transition: all 0.3s;\n  -o-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.payment-radio input:checked ~ .checkmark::after {\n  -webkit-transform: scale(1);\n  -moz-transform: scale(1);\n  -ms-transform: scale(1);\n  -o-transform: scale(1);\n  transform: scale(1);\n  opacity: 1;\n  visibility: visible;\n}\n.booking-date {\n  padding: 0;\n  list-style: none;\n}\n.booking-date li {\n  position: relative;\n  font-size: 14px;\n  font-weight: 500;\n  color: #272b41;\n  text-transform: capitalize;\n  margin-bottom: 15px;\n}\n.booking-date li span {\n  float: right;\n  color: #757575;\n  font-weight: 400;\n  font-size: 15px;\n  text-align: right;\n}\n.booking-date li span a {\n  color: #20c0f3;\n  font-size: 13px;\n  width: 100%;\n  display: inline-block;\n}\n.booking-fee {\n  padding: 0;\n  list-style: none;\n}\n.booking-fee li {\n  position: relative;\n  font-size: 14px;\n  font-weight: 500;\n  color: #272b41;\n  text-transform: capitalize;\n  margin-bottom: 15px;\n}\n.booking-fee li span {\n  float: right;\n  color: #757575;\n  font-weight: 400;\n  font-size: 15px;\n}\n.booking-total {\n  border-top: 1px solid #e4e4e4;\n  margin-top: 20px;\n  padding-top: 20px;\n}\n.booking-total ul {\n  padding: 0;\n  list-style: none;\n  margin: 0;\n}\n.booking-total ul li span {\n  font-size: 18px;\n  font-weight: 600;\n  color: #272b41;\n}\n.booking-total ul li .total-cost {\n  color: #20c0f3;\n  font-size: 16px;\n  float: right;\n}\n\n/*-----------------\n\t20. Booking Success\n-----------------------*/\n\n.success-page-cont {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: flex;\n}\n.success-card .card-body {\n  padding: 50px 20px;\n}\n.success-cont {\n  text-align: center;\n}\n.success-cont i {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #fff;\n  width: 60px;\n  height: 60px;\n  border: 2px solid #09e5ab;\n  border-radius: 50%;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  font-size: 30px;\n  margin-bottom: 30px;\n  background-color: #09e5ab;\n}\n.success-cont h3 {\n  font-size: 24px;\n}\n.success-cont p {\n  margin-bottom: 30px;\n}\n.success-cont strong {\n  font-weight: 600;\n}\n.view-inv-btn {\n  font-size: 16px;\n  font-weight: 600;\n  padding: 12px 30px;\n}\n\n/*-----------------\n\t21. Invoice View\n-----------------------*/\n\n.invoice-content {\n  background-color: #fff;\n  border: 1px solid #f0f0f0;\n  border-radius: 4px;\n  margin-bottom: 30px;\n  padding: 30px;\n}\n.invoice-item .invoice-logo {\n  margin-bottom: 30px;\n}\n.invoice-item .invoice-logo img {\n  width: auto;\n  max-height: 52px;\n}\n.invoice-item .invoice-text h2 {\n  color: #272b41;\n  font-size: 36px;\n  font-weight: 600;\n}\n.invoice-item .invoice-details {\n  text-align: right;\n  color: #757575;\n  font-weight: 500;\n}\n.invoice-item .invoice-details strong {\n  color: #272b41;\n}\n.invoice-item .invoice-details-two {\n  text-align: left;\n}\n.invoice-item .invoice-text {\n  padding-top: 42px;\n  padding-bottom: 36px;\n}\n.invoice-item .invoice-text h2 {\n  font-weight: 400;\n}\n.invoice-info {\n  margin-bottom: 30px;\n}\n.invoice-info p {\n  margin-bottom: 0;\n}\n.invoice-info.invoice-info2 {\n  text-align: right;\n}\n.invoice-item .customer-text {\n  font-size: 18px;\n  color: #272b41;\n  font-weight: 600;\n  margin-bottom: 8px;\n  display: block;\n}\n.invoice-table tr th,\n.invoice-table tr td,\n.invoice-table-two tr th,\n.invoice-table-two tr td {\n  color: #272b41;\n  font-weight: 600;\n  padding: 10px 20px;\n  line-height: inherit;\n}\n.invoice-table tr td,\n.invoice-table-two tr td {\n  color: #757575;\n  font-weight: 500;\n}\n.invoice-table-two {\n  margin-bottom: 0;\n}\n.invoice-table-two tr th,\n.invoice-table-two tr td {\n  border-top: 0;\n}\n.invoice-table-two tr td {\n  text-align: right;\n}\n.invoice-info h5 {\n  font-size: 16px;\n  font-weight: 500;\n}\n.other-info {\n  margin-top: 10px;\n}\n\n/*-----------------\n\t22. Schedule Timings\n-----------------------*/\n\n.tab-content.schedule-cont .card-title {\n  margin-bottom: 10px;\n}\n.doc-times {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.doc-slot-list {\n  background-color: #d9534f;\n  border: 1px solid #d43f3a;\n  border-radius: 4px;\n  color: #fff;\n  font-size: 14px;\n  margin: 10px 10px 0 0;\n  padding: 6px 15px;\n}\n.doc-slot-list a {\n  color: #e48784;\n  display: inline-block;\n  margin-left: 5px;\n}\n.doc-slot-list a:hover {\n  color: #fff;\n}\n.schedule-nav .nav-tabs {\n  border: 0 !important;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.schedule-nav .nav-tabs li {\n  margin: 5px 15px 5px 0;\n  display: inline-block;\n}\n.schedule-nav .nav-tabs li:last-child {\n  margin-right: 0;\n}\n.schedule-nav .nav-tabs > li > a {\n  border: 1px solid #dcddea;\n  border-radius: 4px;\n  padding: 6px 15px;\n  text-transform: uppercase;\n}\n.schedule-nav .nav-tabs li a.active {\n  background: #ff4877;\n  border: 1px solid #ff4877 !important;\n  color: #fff;\n}\n.hours-info .form-control {\n  min-height: auto;\n}\n.hours-info .btn.btn-danger.trash {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 38px;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.edit-link {\n  color: #20c0f3;\n  font-size: 16px;\n  margin-top: 4px;\n}\n.visit-btns {\n  color: #272b41;\n  background-color: #fff;\n  width: 80%;\n  margin-bottom: 10px;\n  display: block;\n\n  /* padding: 8px 14px; */\n  outline: unset;\n  cursor: pointer;\n}\n.visits input:checked ~ .visit-rsn {\n  background-color: #09e5ab;\n  color: #fff;\n  border-radius: 4px;\n}\n.visits input:checked ~ .visit-rsn:before {\n  opacity: 1;\n}\n.visits input:disabled ~ .visit-rsn {\n  background-color: #e30303;\n  color: #fff;\n  border-radius: 5px;\n}\n.visits .form-check-input {\n  opacity: 0;\n}\n.visits input.form-check-input {\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  visibility: hidden;\n  margin-left: 0;\n}\n.visits span.visit-rsn:before {\n  color: #09e5ab;\n  background-color: #fff;\n  content: \"\\f00c\";\n  font-family: \"Font Awesome 5 Free\";\n  font-size: 10px;\n  font-weight: 900;\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  border-radius: 50px;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  opacity: 0;\n}\n.visits span.visit-rsn {\n  background-color: #f3f9ff;\n  border: 0;\n  border-radius: 4px;\n  color: #64627c;\n  display: block;\n  font-size: 14px;\n  margin-bottom: 0px;\n  padding: 13px 5px;\n  text-align: center;\n  position: relative;\n  font-weight: 600;\n}\n.visits span.visit-rsn {\n  text-align: center;\n  border: 0;\n  border-radius: 5px;\n  padding: 13px 5px;\n  background: #f3f9ff;\n  min-width: 133px;\n  display: inline-block;\n  width: 100%;\n}\n\n/*-----------------\n\t23. Doctor Dashboard\n-----------------------*/\n\n.dash-widget {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.circle-bar {\n  margin-right: 15px;\n}\n.dct-border-rht {\n  border-right: 1px solid #f0f0f0;\n}\n.dash-widget h6 {\n  font-size: 16px;\n  font-weight: 400;\n}\n.dash-widget h3 {\n  font-size: 24px;\n  margin-bottom: 5px;\n}\n.dash-widget p {\n  color: #757575;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n.circle-bar > div {\n  display: inline-block;\n  position: relative;\n  text-align: center;\n}\n.circle-bar > div img {\n  left: 0;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  text-align: center;\n  margin: 0 auto;\n  transform: translateY(-50%);\n}\n.circle-bar > div canvas {\n  width: 90px !important;\n  height: 90px !important;\n}\n.dash-card .row {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n.dash-card .row > div {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.appointment-tab {\n  margin-bottom: 30px;\n}\n.appointment-tab .nav-tabs {\n  background-color: #fff;\n  padding: 1.5rem;\n  border: 1px solid #f0f0f0;\n  border-radius: 0.25rem 0.25rem 0 0 !important;\n  border-bottom: 0;\n}\n.appointment-tab .tab-content {\n  padding-top: 0;\n}\n.appointment-tab .card {\n  border-radius: 0;\n}\n.submit-btn-bottom {\n  margin-bottom: 30px;\n}\n\n/*-----------------\n\t24. Patient Profile\n-----------------------*/\n\n.add-new-btn {\n  background-color: #0de0fe;\n  border-radius: 30px;\n  color: #fff;\n  display: inline-block;\n  font-weight: 500;\n  margin-bottom: 20px;\n  padding: 10px 20px;\n}\n.add-new-btn:focus,\n.add-new-btn:hover,\n.add-new-btn:active {\n  background-color: #0de0fe;\n  color: #fff;\n}\n.patient-info {\n  margin-top: 15px;\n}\n.patient-info ul {\n  padding: 0;\n  list-style: none;\n  font-size: 0.875rem;\n  margin: 0;\n}\n.patient-info ul li {\n  position: relative;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #272b41;\n  text-transform: capitalize;\n}\n.patient-info ul li + li {\n  margin-top: 15px;\n}\n.patient-info ul li i {\n  width: 18px;\n}\n.patient-info ul li span {\n  color: #757575;\n  float: right;\n  font-weight: 400;\n}\n\n/*-----------------\n\t25. Add Billing\n-----------------------*/\n\n.biller-info,\n.billing-info {\n  margin-bottom: 15px;\n}\n.add-more-item {\n  margin-bottom: 10px;\n}\n.add-more-item a {\n  color: #0de0fe;\n  font-weight: 500;\n}\n.signature-wrap {\n  float: right;\n  margin-bottom: 20px;\n  text-align: center;\n  width: 220px;\n}\n.signature {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border: 2px dashed #ccc;\n  border-radius: 4px;\n  color: #272b41;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  height: 85px;\n  margin-bottom: 15px;\n  width: 100%;\n}\n.signature:hover {\n  background-color: #fcfcfc;\n}\n.sign-name {\n  width: 100%;\n  float: right;\n}\n.pat-widget-profile .pro-widget-content {\n  padding: 0 0 20px;\n}\n.pat-widget-profile .booking-date li {\n  font-size: 0.875rem;\n}\n.pat-widget-profile .booking-date li span {\n  font-size: 0.875rem;\n}\n\n/*-----------------\n\t26. Chat\n-----------------------*/\n\n.chat-page .content {\n  padding: 0;\n}\n.chat-page .content > .container-fluid {\n  padding: 0;\n}\n.chat-page .footer {\n  display: none;\n}\n.chat-window {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  position: relative;\n  height: 100%;\n}\n.chat-cont-left {\n  border-right: 1px solid #f0f0f0;\n  -ms-flex: 0 0 35%;\n  flex: 0 0 35%;\n  left: 0;\n  max-width: 35%;\n  position: relative;\n  z-index: 4;\n}\n.chat-cont-left .chat-header {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #fff;\n  border-bottom: 1px solid #f0f0f0;\n  color: #272b41;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 72px;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  padding: 0 15px;\n}\n.chat-cont-left .chat-header span {\n  font-size: 20px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n.chat-cont-left .chat-header .chat-compose {\n  color: #8a8a8a;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.chat-cont-left .chat-search {\n  background-color: #f5f5f6;\n  border-bottom: 1px solid #e5e5e5;\n  padding: 10px 15px;\n  width: 100%;\n}\n.chat-cont-left .chat-search .input-group {\n  width: 100%;\n}\n.chat-cont-left .chat-search .input-group .form-control {\n  background-color: #fff;\n  border-radius: 50px;\n  padding-left: 36px;\n}\n.chat-cont-left .chat-search .input-group .form-control:focus {\n  border-color: #ccc;\n  box-shadow: none;\n}\n.chat-cont-left .chat-search .input-group .input-group-prepend {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  bottom: 0;\n  color: #666;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  left: 15px;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  z-index: 4;\n}\n.chat-window .chat-scroll {\n  min-height: 200px;\n  height: 100%;\n  /* max-height: calc(100vh - 400px); */\n  overflow-y: auto;\n}\n.chat-cont-left .chat-users-list {\n  background-color: #fff;\n}\n.chat-cont-left .chat-users-list a.media {\n  border-bottom: 1px solid #f0f0f0;\n  padding: 10px 15px;\n  transition: all 0.2s ease 0s;\n}\n.chat-cont-left .chat-users-list a.media:last-child {\n  border-bottom: 0;\n}\n.chat-cont-left .chat-users-list a.media .media-img-wrap {\n  margin-right: 15px;\n  position: relative;\n}\n.chat-cont-left .chat-users-list a.media .media-img-wrap .avatar {\n  height: 45px;\n  width: 45px;\n}\n.chat-cont-left .chat-users-list a.media .media-img-wrap .status {\n  bottom: 7px;\n  height: 10px;\n  right: 4px;\n  position: absolute;\n  width: 10px;\n  border: 2px solid #fff;\n}\n.chat-cont-left .chat-users-list a.media .media-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n.chat-cont-left\n  .chat-users-list\n  a.media\n  .media-body\n  > div:first-child\n  .user-name,\n.chat-cont-left\n  .chat-users-list\n  a.media\n  .media-body\n  > div:first-child\n  .user-last-chat {\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.chat-cont-left\n  .chat-users-list\n  a.media\n  .media-body\n  > div:first-child\n  .user-name {\n  color: #272b41;\n  text-transform: capitalize;\n}\n.chat-cont-left\n  .chat-users-list\n  a.media\n  .media-body\n  > div:first-child\n  .user-last-chat {\n  color: #8a8a8a;\n  font-size: 14px;\n  line-height: 24px;\n}\n.chat-cont-left .chat-users-list a.media .media-body > div:last-child {\n  text-align: right;\n}\n.chat-cont-left\n  .chat-users-list\n  a.media\n  .media-body\n  > div:last-child\n  .last-chat-time {\n  color: #8a8a8a;\n  font-size: 13px;\n}\n.chat-cont-left .chat-users-list a.media:hover {\n  background-color: #f5f5f6;\n}\n.chat-cont-left\n  .chat-users-list\n  a.media.read-chat\n  .media-body\n  > div:last-child\n  .last-chat-time {\n  color: #8a8a8a;\n}\n.chat-cont-left .chat-users-list a.media.active {\n  background-color: #f5f5f6;\n}\n.chat-cont-right {\n  -ms-flex: 0 0 100%;\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n.chat-cont-right .chat-header {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #fff;\n  border-bottom: 1px solid #f0f0f0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 72px;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  padding: 0 15px;\n}\n.chat-cont-right .chat-header .back-user-list {\n  display: none;\n  margin-right: 5px;\n  margin-left: -7px;\n}\n.chat-cont-right .chat-header .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.chat-cont-right .chat-header .media .media-img-wrap {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-right: 15px;\n}\n.chat-cont-right .chat-header .media .media-img-wrap .avatar {\n  height: 50px;\n  width: 50px;\n}\n.chat-cont-right .chat-header .media .media-img-wrap .status {\n  border: 2px solid #fff;\n  bottom: 0;\n  height: 10px;\n  position: absolute;\n  right: 3px;\n  width: 10px;\n}\n.chat-cont-right .chat-header .media .media-body .user-name {\n  color: #272b41;\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n.chat-cont-right .chat-header .media .media-body .user-status {\n  color: #666;\n  font-size: 14px;\n}\n.chat-cont-right .chat-header .chat-options {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.chat-cont-right .chat-header .chat-options > a {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 50%;\n  color: #8a8a8a;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  height: 30px;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  margin-left: 10px;\n  width: 30px;\n}\n.chat-cont-right .chat-body {\n  background-color: #f5f5f6;\n}\n.chat-cont-right .chat-body ul.list-unstyled {\n  margin: 0 auto;\n  padding: 15px;\n  width: 100%;\n}\n.chat-cont-right .chat-body .media .avatar {\n  height: 30px;\n  width: 30px;\n}\n.chat-cont-right .chat-body .media .media-body {\n  margin-left: 20px;\n}\n.chat-cont-right .chat-body .media .media-body .msg-box > div {\n  padding: 10px 15px;\n  border-radius: 0.25rem;\n  display: inline-block;\n  position: relative;\n}\n.chat-cont-right .chat-body .media .media-body .msg-box > div p {\n  color: #272b41;\n  margin-bottom: 0;\n}\n.chat-cont-right .chat-body .media .media-body .msg-box + .msg-box {\n  margin-top: 5px;\n}\n.chat-cont-right .chat-body .media.received {\n  margin-bottom: 20px;\n}\n.chat-cont-right .chat-body .media:last-child {\n  margin-bottom: 0;\n}\n.chat-cont-right .chat-body .media.received .media-body .msg-box > div {\n  background-color: #fff;\n}\n.chat-cont-right .chat-body .media.sent {\n  margin-bottom: 20px;\n}\n.chat-cont-right .chat-body .media.sent .media-body {\n  -webkit-box-align: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n  margin-left: 0;\n}\n.chat-cont-right .chat-body .media.sent .media-body .msg-box > div {\n  background-color: #e3e3e3;\n}\n.chat-cont-right .chat-body .media.sent .media-body .msg-box > div p {\n  color: #272b41;\n}\n.chat-cont-right .chat-body .chat-date {\n  font-size: 14px;\n  margin: 1.875rem 0;\n  overflow: hidden;\n  position: relative;\n  text-align: center;\n  text-transform: capitalize;\n}\n.chat-cont-right .chat-body .chat-date:before {\n  background-color: #e0e3e4;\n  content: \"\";\n  height: 1px;\n  margin-right: 28px;\n  position: absolute;\n  right: 50%;\n  top: 50%;\n  width: 100%;\n}\n.chat-cont-right .chat-body .chat-date:after {\n  background-color: #e0e3e4;\n  content: \"\";\n  height: 1px;\n  left: 50%;\n  margin-left: 28px;\n  position: absolute;\n  top: 50%;\n  width: 100%;\n}\n.chat-cont-right .chat-footer {\n  background-color: #fff;\n  border-top: 1px solid #f0f0f0;\n  padding: 16px 15px;\n  position: relative;\n}\n.chat-cont-right .chat-footer .input-group {\n  width: 100%;\n}\n.chat-cont-right .chat-footer .input-group .form-control {\n  background-color: #f5f5f6;\n  border: none;\n  border-radius: 50px;\n}\n.chat-cont-right .chat-footer .input-group .form-control:focus {\n  background-color: #f5f5f6;\n  border: none;\n  box-shadow: none;\n}\n.chat-cont-right .chat-footer .input-group .input-group-prepend .btn,\n.chat-cont-right .chat-footer .input-group .input-group-append .btn {\n  background-color: transparent;\n  border: none;\n  color: #9f9f9f;\n}\n.chat-cont-right\n  .chat-footer\n  .input-group\n  .input-group-append\n  .btn.msg-send-btn {\n  background-color: #0de0fe;\n  border-color: #0de0fe;\n  border-radius: 50%;\n  color: #fff;\n  margin-left: 10px;\n  min-width: 46px;\n  font-size: 20px;\n}\n.msg-typing {\n  width: auto;\n  height: 24px;\n  padding-top: 8px;\n}\n.msg-typing span {\n  height: 8px;\n  width: 8px;\n  float: left;\n  margin: 0 1px;\n  background-color: #a0a0a0;\n  display: block;\n  border-radius: 50%;\n  opacity: 0.4;\n}\n.msg-typing span:nth-of-type(1) {\n  animation: 1s blink infinite 0.33333s;\n}\n.msg-typing span:nth-of-type(2) {\n  animation: 1s blink infinite 0.66666s;\n}\n.msg-typing span:nth-of-type(3) {\n  animation: 1s blink infinite 0.99999s;\n}\n.chat-cont-right .chat-body .media.received .media-body .msg-box {\n  position: relative;\n}\n.chat-cont-right\n  .chat-body\n  .media.received\n  .media-body\n  .msg-box:first-child:before {\n  border-bottom: 6px solid transparent;\n  border-right: 6px solid #fff;\n  border-top: 6px solid transparent;\n  content: \"\";\n  height: 0;\n  left: -6px;\n  position: absolute;\n  right: auto;\n  top: 8px;\n  width: 0;\n}\n.chat-cont-right .chat-body .media.sent .media-body .msg-box {\n  padding-left: 50px;\n  position: relative;\n}\n.chat-cont-right\n  .chat-body\n  .media.sent\n  .media-body\n  .msg-box:first-child:before {\n  border-bottom: 6px solid transparent;\n  border-left: 6px solid #e3e3e3;\n  border-top: 6px solid transparent;\n  content: \"\";\n  height: 0;\n  left: auto;\n  position: absolute;\n  right: -6px;\n  top: 8px;\n  width: 0;\n}\n.chat-msg-info {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  clear: both;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: 0;\n  margin: 5px 0 0;\n}\n.chat-msg-info li {\n  font-size: 13px;\n  padding-right: 16px;\n  position: relative;\n}\n.chat-msg-info li:not(:last-child):after {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  content: \"\";\n  height: 4px;\n  width: 4px;\n  background: #d2dde9;\n  border-radius: 50%;\n  transform: translate(50%, -50%);\n}\n.chat-cont-right\n  .chat-body\n  .media.sent\n  .media-body\n  .msg-box\n  .chat-msg-info\n  li:not(:last-child)::after {\n  right: auto;\n  left: 8px;\n  transform: translate(-50%, -50%);\n  background: #aaa;\n}\n.chat-cont-right\n  .chat-body\n  .media.received\n  .media-body\n  .msg-box\n  > div\n  .chat-time {\n  color: rgba(50, 65, 72, 0.4);\n}\n.chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-time {\n  color: rgba(50, 65, 72, 0.4);\n}\n.chat-msg-info li a {\n  color: #777;\n}\n.chat-msg-info li a:hover {\n  color: #2c80ff;\n}\n.chat-seen i {\n  color: #00d285;\n  font-size: 16px;\n}\n.chat-msg-attachments {\n  padding: 4px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  margin: 0 -1px;\n}\n.chat-msg-attachments > div {\n  margin: 0 1px;\n}\n.chat-cont-right\n  .chat-body\n  .media.sent\n  .media-body\n  .msg-box\n  > div\n  .chat-msg-info {\n  flex-direction: row-reverse;\n}\n.chat-cont-right\n  .chat-body\n  .media.sent\n  .media-body\n  .msg-box\n  > div\n  .chat-msg-attachments {\n  flex-direction: row-reverse;\n}\n.chat-cont-right\n  .chat-body\n  .media.sent\n  .media-body\n  .msg-box\n  > div\n  .chat-msg-info\n  li {\n  padding-left: 16px;\n  padding-right: 0;\n  position: relative;\n}\n.chat-attachment img {\n  max-width: 100%;\n}\n.chat-attachment {\n  position: relative;\n  max-width: 130px;\n  overflow: hidden;\n}\n.chat-attachment {\n  border-radius: 0.25rem;\n}\n.chat-attachment:before {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #000;\n  content: \"\";\n  opacity: 0.4;\n  transition: all 0.4s;\n}\n.chat-attachment:hover:before {\n  opacity: 0.6;\n}\n.chat-attach-caption {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  color: #fff;\n  padding: 7px 15px;\n  font-size: 13px;\n  opacity: 1;\n  transition: all 0.4s;\n}\n.chat-attach-download {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.4s;\n  color: #fff;\n  width: 32px;\n  line-height: 32px;\n  background: rgba(255, 255, 255, 0.2);\n  text-align: center;\n}\n.chat-attach-download:hover {\n  color: #495463;\n  background: #fff;\n}\n.chat-attachment:hover .chat-attach-caption {\n  opacity: 0;\n}\n.chat-attachment:hover .chat-attach-download {\n  opacity: 1;\n}\n.chat-attachment-list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: -5px;\n}\n.chat-attachment-list li {\n  width: 33.33%;\n  padding: 5px;\n}\n.chat-attachment-item {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border: 5px solid rgba(230, 239, 251, 0.5);\n  height: 100%;\n  min-height: 60px;\n  text-align: center;\n  font-size: 30px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.chat-cont-right\n  .chat-body\n  .media.sent\n  .media-body\n  .msg-box\n  > div:hover\n  .chat-msg-actions {\n  opacity: 1;\n}\n.chat-msg-actions {\n  position: absolute;\n  left: -30px;\n  top: 50%;\n  transform: translateY(-50%);\n  opacity: 0;\n  transition: all 0.4s;\n  z-index: 2;\n}\n.chat-msg-actions > a {\n  padding: 0 10px;\n  color: #495463;\n  font-size: 24px;\n}\n.chat-msg-actions > a:hover {\n  color: #2c80ff;\n}\n\n@keyframes blink {\n  50% {\n    opacity: 1;\n  }\n}\n.btn-file {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  font-size: 20px;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  overflow: hidden;\n  padding: 0 0.75rem;\n  position: relative;\n  vertical-align: middle;\n}\n.btn-file input {\n  cursor: pointer;\n  filter: alpha(opacity=0);\n  font-size: 23px;\n  height: 100%;\n  margin: 0;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n}\n\n/*-----------------\n\t27. Doctor Profile Settings\n-----------------------*/\n\n.profile-image img {\n  margin-bottom: 1.5rem;\n}\n.change-photo-btn {\n  background-color: #20c0f3;\n  border-radius: 50px;\n  color: #fff;\n  cursor: pointer;\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  margin: 0 auto;\n  padding: 10px 15px;\n  position: relative;\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n  text-align: center;\n  width: 220px;\n}\n.change-photo-btn input.upload {\n  bottom: 0;\n  cursor: pointer;\n  filter: alpha(opacity=0);\n  left: 0;\n  margin: 0;\n  opacity: 0;\n  padding: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 220px;\n}\n.dropzone {\n  background-color: #fbfbfb;\n  border: 2px dashed rgba(0, 0, 0, 0.1);\n}\n.btn-icon {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  text-align: center;\n  position: absolute;\n  padding: 0;\n  font-size: 10px;\n  width: 20px;\n  height: 20px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  right: 3px;\n  top: 3px;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.upload-images {\n  position: relative;\n  width: 80px;\n}\n.upload-images img {\n  border-radius: 4px;\n  height: 80px;\n  width: auto;\n}\n.upload-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.upload-wrap .upload-images + .upload-images {\n  margin-left: 20px;\n}\n.contact-card .card-body {\n  padding-bottom: 0.625rem;\n}\n.custom_price_cont {\n  margin-top: 20px;\n}\n.btn.btn-danger.trash {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 46px;\n  width: 46px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.add-more a {\n  color: #20c0f3;\n}\n.bootstrap-tagsinput {\n  border-color: #dcdcdc;\n  box-shadow: inherit;\n  min-height: 46px;\n  width: 100%;\n  border-radius: 0;\n}\n.bootstrap-tagsinput.focus {\n  border-color: #bbb;\n}\n.bootstrap-tagsinput .tag {\n  background-color: #20c0f3;\n  color: #fff;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: normal;\n  margin-right: 2px;\n  padding: 11px 15px;\n  border-radius: 0;\n}\n.services-card .bootstrap-tagsinput input {\n  width: 160px;\n}\n.submit-section .submit-btn {\n  padding: 12px 30px;\n  font-weight: 600;\n  font-size: 16px;\n  min-width: 120px;\n}\n.submit-section .submit-btn + .submit-btn {\n  margin-left: 15px;\n}\n\n/*-----------------\n\t28. Calendar\n-----------------------*/\n\n#calendar-events {\n  background-color: #fcfcfc;\n}\n.calendar-events {\n  border: 1px solid transparent;\n  cursor: move;\n  padding: 10px 15px;\n}\n.calendar-events:hover {\n  border-color: #e9e9e9;\n  background-color: #fff;\n}\n.calendar-events i {\n  margin-right: 8px;\n}\n.calendar {\n  float: left;\n  margin-bottom: 0;\n}\n.fc-toolbar.fc-header-toolbar {\n  margin-bottom: 1.5rem;\n}\n.none-border .modal-footer {\n  border-top: none;\n}\n.fc-toolbar h2 {\n  font-size: 18px;\n  font-weight: 600;\n  font-family: \"Roboto\", sans-serif;\n  line-height: 30px;\n  text-transform: uppercase;\n}\n.fc-day-grid-event .fc-time {\n  font-family: \"Roboto\", sans-serif;\n}\n.fc-day {\n  background: #fff;\n}\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active,\n.fc-toolbar button:focus,\n.fc-toolbar button:hover,\n.fc-toolbar .ui-state-hover {\n  z-index: 0;\n}\n.fc th.fc-widget-header {\n  background: #eeeeee;\n  font-size: 14px;\n  line-height: 20px;\n  padding: 10px 0;\n  text-transform: uppercase;\n}\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n  border-color: #f3f3f3;\n}\n.fc-basic-view .fc-day-number,\n.fc-basic-view .fc-week-number {\n  padding: 2px 5px;\n}\n.fc-button {\n  background: #f1f1f1;\n  border: none;\n  color: #797979;\n  text-transform: capitalize;\n  box-shadow: none !important;\n  border-radius: 3px !important;\n  margin: 0 3px !important;\n  padding: 6px 12px !important;\n  height: auto !important;\n}\n.fc-text-arrow {\n  font-family: inherit;\n  font-size: 16px;\n}\n.fc-state-hover {\n  background: #f3f3f3;\n}\n.fc-state-highlight {\n  background: #f0f0f0;\n}\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n  background-color: #20c0f3 !important;\n  color: #fff !important;\n  text-shadow: none !important;\n}\n.fc-cell-overlay {\n  background: #f0f0f0;\n}\n.fc-unthemed .fc-today {\n  background: #fff;\n}\n.fc-event {\n  border-radius: 2px;\n  border: none;\n  color: #fff !important;\n  cursor: move;\n  font-size: 13px;\n  margin: 1px 7px;\n  padding: 5px 5px;\n  text-align: center;\n}\n.fc-basic-view td.fc-week-number span {\n  padding-right: 8px;\n  font-weight: 700;\n  font-family: \"Roboto\", sans-serif;\n}\n.fc-basic-view td.fc-day-number {\n  padding-right: 8px;\n  font-weight: 700;\n  font-family: \"Roboto\", sans-serif;\n}\n.event-form .input-group .form-control {\n  height: 40px;\n}\n\n/*-----------------\n\t29. Patient Dashboard\n-----------------------*/\n\n.profile-sidebar {\n  background-color: #fff;\n  border: 1px solid #f0f0f0;\n  border-radius: 4px;\n  margin-bottom: 30px;\n  overflow: hidden;\n}\n.pro-widget-content {\n  border-bottom: 1px solid #f0f0f0;\n  padding: 20px;\n  text-align: center;\n}\n\n.profile-info-widget {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  text-align: left;\n}\n.profile-info-widget .booking-doc-img {\n  margin-right: 15px;\n}\n.profile-info-widget .booking-doc-img img {\n  border-radius: 4px;\n  height: 90px;\n  width: 90px;\n  object-fit: cover;\n}\n.profile-det-info {\n  overflow: hidden;\n}\n.profile-det-info h3 {\n  font-size: 17px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.patient-details h5 {\n  color: #757575;\n  font-size: 13px;\n  font-weight: normal;\n  margin-bottom: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.patient-details h5 i {\n  width: 18px;\n}\n.dashboard-menu ul {\n  color: #757575;\n  font-size: 14px;\n  line-height: 17px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  text-transform: capitalize;\n}\n.dashboard-menu ul li {\n  line-height: inherit;\n}\n.dashboard-menu > ul > li {\n  border-bottom: 1px solid #f0f0f0;\n  position: relative;\n}\n.dashboard-menu > ul > li:last-child {\n  border-bottom: 0;\n}\n.dashboard-menu ul li a span,\n.dashboard-menu ul li a i {\n  display: inline-block;\n  vertical-align: middle;\n}\n.dashboard-menu > ul > li > a {\n  color: #757575;\n  display: block;\n  padding: 16px 20px;\n}\n.dashboard-menu > ul > li:hover > a,\n.dashboard-menu > ul > li.active > a {\n  color: #0de0fe;\n}\n.dashboard-menu ul li a i {\n  font-size: 16px;\n  margin-right: 10px;\n  width: 16px;\n}\n.unread-msg {\n  background-color: #09e5ab;\n  border-radius: 2px;\n  color: #272b41;\n  font-size: 10px;\n  font-style: normal;\n  padding: 0 5px;\n  position: absolute;\n  right: 20px;\n  text-align: center;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.patient-dashboard-top,\n.patient-graph-box {\n  display: flex;\n  display: -webkit-flex;\n}\n.patient-dashboard-top > div {\n  width: 100%;\n}\n.patient-dashboard-top h6 {\n  font-size: 18px;\n  margin-bottom: 0;\n}\n.patient-dashboard-top h6 sub {\n  font-size: 12px;\n}\n.patient-graph-col .graph-box {\n  background: #7289de;\n  border-bottom: 8px solid #6a5dee;\n  padding: 22px;\n  width: 100%;\n  display: flex;\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  margin: 15px 0;\n}\n.patient-graph-col .graph-box h4 {\n  color: #fff;\n  margin-bottom: 15px;\n  text-align: center;\n}\n.patient-graph-col .graph-box > div {\n  width: 100%;\n}\n.graph-img {\n  text-align: center;\n  margin: 0 auto;\n  width: 100%;\n}\n.graph-status-result {\n  display: flex;\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  align-items: flex-end;\n  -webkit-align-items: flex-end;\n}\n.graph-status-result h3 {\n  color: #fff;\n  margin-bottom: 0;\n  line-height: 0.9;\n  width: 100%;\n}\n.graph-status-result span.graph-update-date {\n  color: #fff;\n  font-weight: 500;\n  opacity: 0.7;\n  text-align: center;\n  width: 100%;\n}\n.patient-graph-col .graph-box.pink-graph {\n  background-color: #ffa69e;\n  border-bottom: 8px solid #fe9286;\n}\n.patient-graph-col .graph-box.sky-blue-graph {\n  background-color: #a9d4ff;\n  border-bottom: 8px solid #8ec4ff;\n}\n.patient-graph-col .graph-box.orange-graph {\n  background-color: #ffb88e;\n  border-bottom: 8px solid #ffa775;\n}\n\n/*-----------------\n\t30. Profile Settings\n-----------------------*/\n\n.change-avatar {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.change-avatar .profile-img {\n  margin-right: 15px;\n}\n.change-avatar .profile-img img {\n  border-radius: 4px;\n  height: 100px;\n  width: 100px;\n  object-fit: cover;\n}\n.change-avatar .change-photo-btn {\n  margin: 0 0 10px;\n  width: 150px;\n}\n.widget-profile.pat-widget-profile .profile-info-widget .booking-doc-img {\n  padding: 0;\n}\n.widget-profile.pat-widget-profile .profile-info-widget .booking-doc-img img {\n  border-radius: 50%;\n  height: 100px;\n  width: 100px;\n}\n\n/*-----------------\n\t31. Appoitment List\n-----------------------*/\n\n.widget-profile {\n  background-color: #fff;\n  border-bottom: 1px solid #f0f0f0;\n}\n.widget-profile .profile-info-widget {\n  display: block;\n  text-align: center;\n}\n.widget-profile .profile-info-widget .booking-doc-img {\n  display: inline-block;\n  margin: 0 0 15px;\n  width: auto;\n  padding: 8px;\n  background-color: #f7f7f7;\n  border-radius: 50%;\n}\n.widget-profile .profile-info-widget .booking-doc-img img {\n  border-radius: 50%;\n  height: 120px;\n  width: 120px;\n}\n.appointment-list .profile-info-widget {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: auto;\n  text-align: left;\n}\n.appointment-list .profile-info-widget .booking-doc-img img {\n  border-radius: 4px;\n  height: 120px;\n  object-fit: cover;\n  width: 120px;\n}\n.appointments .appointment-list {\n  background-color: #fff;\n  border: 1px solid #f0f0f0;\n  border-radius: 4px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n  padding: 20px;\n}\n.appointments .appointment-list:last-child {\n  margin-bottom: 30px;\n}\n.appointments .appointment-action {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.appointment-action a + a {\n  margin-left: 5px;\n}\n.appointment-action a {\n  font-size: 13px;\n}\n.info-details {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.info-details li .title {\n  color: #272b41;\n  font-weight: 500;\n}\n.info-details li .text {\n  color: #757575;\n  display: block;\n  font-size: 16px;\n  overflow: hidden;\n}\n.info-details li {\n  margin-bottom: 10px;\n}\n.info-details li:last-child {\n  margin-bottom: 0;\n}\n\n/*-----------------\n\t32. Reviews\n-----------------------*/\n\n.doc-review.review-listing {\n  margin: 0;\n}\n.review-listing.doc-review > ul > li {\n  background-color: #fff;\n  border: 1px solid #f0f0f0;\n  padding: 20px;\n}\n\n/*-----------------\n\t33. Voice call\n-----------------------*/\n\n.modal-open .main-wrapper {\n  /* -webkit-filter: blur(1px);\n  -moz-filter: blur(1px);\n  -o-filter: blur(1px);\n  -ms-filter: blur(1px);\n  filter: blur(1px);\n  z-index: 1000; */\n}\n.call-main-row {\n  bottom: 0;\n  left: 0;\n  overflow: auto;\n  padding-bottom: inherit;\n  padding-top: inherit;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.call-main-wrapper {\n  display: table;\n  height: 100%;\n  table-layout: fixed;\n  width: 100%;\n}\n.call-view {\n  display: table-cell;\n  height: 100%;\n  float: none;\n  padding: 0;\n  position: static;\n  vertical-align: top;\n  width: 75%;\n}\n.call-window {\n  display: table;\n  height: 100%;\n  table-layout: fixed;\n  width: 100%;\n  background-color: #fff;\n  border: 1px solid #f0f0f0;\n}\n.fixed-header {\n  background-color: #fff;\n  border-bottom: 1px solid #f0f0f0;\n  padding: 10px 15px;\n}\n.fixed-header .navbar {\n  border: 0 none;\n  margin: 0;\n  min-height: auto;\n  padding: 0;\n}\n.fixed-header .user-info a {\n  color: #272b41;\n  font-weight: 500;\n}\n.typing-text {\n  color: #20c0f3;\n  font-size: 12px;\n  text-transform: lowercase;\n}\n.last-seen {\n  color: #888;\n  display: block;\n  font-size: 12px;\n}\n.custom-menu {\n  margin-top: 6px;\n}\n.fixed-header .custom-menu {\n  margin: 0 0 1px;\n}\n.custom-menu.nav > li > a {\n  color: #bbb;\n  font-size: 26px;\n  line-height: 32px;\n  margin-left: 15px;\n  padding: 0;\n}\n.custom-menu.navbar-nav > li > a:hover,\n.custom-menu.navbar-nav > li > a:focus {\n  background-color: transparent;\n}\n.custom-menu .dropdown-menu {\n  left: auto;\n  right: 0;\n}\n.call-contents {\n  display: table-row;\n  height: 100%;\n}\n.call-content-wrap {\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n.voice-call-avatar {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  -ms-flex: 2;\n  flex: 2;\n}\n.voice-call-avatar .call-avatar {\n  margin: 15px;\n  width: 150px;\n  height: 150px;\n  border-radius: 100%;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 3px;\n  background-color: #fff;\n}\n.call-duration {\n  display: inline-block;\n  font-size: 30px;\n  margin-top: 4px;\n  position: absolute;\n  left: 0;\n}\n.voice-call-avatar .call-timing-count {\n  padding: 5px;\n}\n.voice-call-avatar .username {\n  font-size: 20px;\n  font-weight: 500;\n}\n.call-footer {\n  background-color: #fff;\n  border-top: 1px solid #f0f0f0;\n  padding: 15px;\n}\n.call-icons {\n  text-align: center;\n  position: relative;\n}\n.call-icons .call-items {\n  border-radius: 5px;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: inline-block;\n}\n.call-icons .call-items .call-item {\n  display: inline-block;\n  text-align: center;\n  margin-right: 5px;\n}\n.call-icons .call-items .call-item:last-child {\n  margin-right: 0;\n}\n.call-icons .call-items .call-item a {\n  color: #777;\n  border: 1px solid #ddd;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  border-radius: 50px;\n  display: inline-block;\n  font-size: 20px;\n}\n.call-icons .call-items .call-item a i {\n  width: 18px;\n  height: 18px;\n}\n.user-video {\n  bottom: 0;\n  left: 0;\n  overflow: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 10;\n}\n.user-video img {\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  max-height: 100%;\n  display: block;\n  margin: 0 auto;\n}\n.user-video video {\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  max-height: 100%;\n  display: block;\n  margin: 0 auto;\n}\n.my-video {\n  position: absolute;\n  z-index: 99;\n  bottom: 20px;\n  right: 20px;\n}\n.my-video ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.my-video ul li {\n  float: left;\n  width: 120px;\n  margin-right: 10px;\n}\n.my-video ul li img {\n  border: 3px solid #fff;\n  border-radius: 6px;\n}\n.end-call {\n  position: absolute;\n  top: 7px;\n  right: 0;\n}\n.end-call a {\n  background-color: #f06060;\n  border-radius: 50px;\n  color: #fff;\n  display: inline-block;\n  line-height: 10px;\n  padding: 8px 25px;\n  text-transform: uppercase;\n}\n.call-users {\n  position: absolute;\n  z-index: 99;\n  bottom: 20px;\n  right: 20px;\n}\n.call-users ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.call-users ul li {\n  float: left;\n  width: 80px;\n  margin-left: 10px;\n}\n.call-users ul li img {\n  border-radius: 6px;\n  padding: 2px;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.call-mute {\n  width: 80px;\n  height: 80px;\n  background-color: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  text-align: center;\n  line-height: 80px;\n  border-radius: 6px;\n  font-size: 30px;\n  color: #fff;\n  display: none;\n  top: 0;\n  border: 3px solid transparent;\n}\n.call-users ul li a:hover .call-mute {\n  display: block;\n}\n.call-details {\n  margin: 10px 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.call-info {\n  margin-left: 10px;\n  width: 100%;\n}\n.call-user-details,\n.call-timing {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.call-description {\n  white-space: nowrap;\n  vertical-align: bottom;\n}\n.call-timing {\n  color: #727272;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 14px;\n  margin-top: 1px;\n  overflow: hidden;\n  white-space: pre;\n}\n\n/*-----------------\n\t34. Video Call\n-----------------------*/\n\n.content-full {\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n.video-window .fixed-header {\n  padding: 0;\n  border: 0;\n}\n.video-window .fixed-header .nav > li > a {\n  padding: 18px 15px;\n}\n\n/*-----------------\n\t35. Outgoing Call\n-----------------------*/\n\n.call-box .call-wrapper {\n  height: auto;\n  text-align: center;\n}\n.call-box .call-wrapper .call-avatar {\n  margin-bottom: 30px;\n  cursor: pointer;\n  animation: ripple 2s infinite;\n}\n.call-box .call-wrapper .call-user {\n  margin-bottom: 30px;\n}\n.call-box .call-wrapper .call-user span {\n  display: block;\n  font-weight: 500;\n  text-align: center;\n}\n.call-box .call-wrapper .call-items {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.call-box .call-wrapper .call-items .call-item {\n  background-color: rgba(255, 255, 255, 0.2);\n  border: 1px solid transparent;\n  border-radius: 100%;\n  color: #fff;\n  line-height: 0;\n  margin: 0 5px;\n  padding: 15px;\n}\n.call-box .call-wrapper .call-items .call-item:hover {\n  opacity: 0.9;\n}\n.call-box .call-wrapper .call-items .call-item:first-child {\n  margin-top: -30px;\n}\n.call-box .call-wrapper .call-items .call-item:last-child {\n  margin-top: -30px;\n}\n.call-box .call-wrapper .call-items .call-item.call-end {\n  padding: 20px;\n  margin: 30px 20px 0;\n  background: #f06060;\n  border: 1px solid #f06060;\n  color: #fff;\n  line-height: 0;\n  border-radius: 100%;\n}\n.call-box .call-wrapper .call-items .call-item.call-start {\n  padding: 20px;\n  margin: 30px 20px 0;\n  background: #55ce63;\n  border: 1px solid #55ce63;\n  color: #fff;\n  line-height: 0;\n  border-radius: 100%;\n}\n.call-box.incoming-box .call-wrapper .call-items .call-item.call-start {\n  margin: 0 10px;\n}\n.call-box.incoming-box .call-wrapper .call-items .call-item.call-end {\n  margin: 0 10px;\n}\n.call-box .call-avatar {\n  border-radius: 100%;\n  height: 140px;\n  max-width: 140px;\n  min-width: 140px;\n  position: relative;\n  width: 100%;\n  border: 10px solid #fafafa;\n}\n.call-box .btn {\n  /* background: rgba(0, 0, 0, 0); */\n  transition: all 0.3s ease 0s;\n}\n@-webkit-keyframes ripple {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);\n  }\n}\n@keyframes ripple {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);\n    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);\n    box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);\n  }\n}\n\n/*-----------------\n\t36. Incoming Call\n-----------------------*/\n\n.incoming-btns {\n  margin-top: 20px;\n}\n.call-wrapper {\n  position: relative;\n  height: calc(100vh - 50px);\n}\n.call-page .footer {\n  display: none;\n}\n.dropdown-action .dropdown-toggle::after {\n  display: none;\n}\n.call-modal .modal-body {\n  padding: 40px;\n}\n.call-modal .modal-content {\n  border: 0;\n  border-radius: 10px;\n}\n.call-box .call-wrapper .call-user h4 {\n  font-size: 24px;\n}\n\n/*-----------------\n\t37. Terms and Conditions\n-----------------------*/\n\n.terms-text {\n  margin-bottom: 20px;\n}\n.terms-text h4 {\n  font-size: 24px;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n.terms-text p {\n  color: #666;\n  display: inline-block;\n  font-size: 16px;\n}\n\n/*-----------------\n\t38. Blog\n-----------------------*/\n\n.blog {\n  border: 1px solid #f0f0f0;\n  background-color: #fff;\n  border-radius: 4px;\n  margin-bottom: 30px;\n  padding: 1.5rem;\n  position: relative;\n}\n.blog-image {\n  overflow: hidden;\n}\n.blog-image,\n.blog-image > a,\n.blog-image img {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: auto;\n}\n.blog-image img {\n  -webkit-transform: translateZ(0);\n  -moz-transform: translateZ(0);\n  transform: translateZ(0);\n  -moz-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -o-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n}\n.blog-image a:hover img {\n  -webkit-transform: scale(1.15);\n  -moz-transform: scale(1.15);\n  transform: scale(1.15);\n}\n.blog-image {\n  margin-bottom: 30px;\n}\n.blog-content {\n  position: relative;\n}\n.blog-title {\n  font-size: 22px;\n  margin: 0 0 10px;\n}\n.blog-title a {\n  color: #272b41;\n}\n.blog-title a:hover {\n  color: #20c0f3;\n}\n.blog-content p {\n  color: #666;\n  font-size: 14px;\n  margin: 0 0 30px;\n}\n.read-more {\n  display: inline-block;\n  font-size: 16px;\n  padding: 0;\n  color: #20c0f3;\n  text-decoration: underline;\n  font-weight: bold;\n}\n.blog-info {\n  color: #757575;\n  font-size: 14px;\n  margin-bottom: 15px;\n}\n.blog-info a {\n  color: #757575;\n}\n.blog-info a:hover {\n  color: #757575;\n}\n.blog-info i {\n  color: #20c0f3;\n  font-size: 14px;\n  margin-right: 5px;\n}\n.entry-meta {\n  color: #757575;\n  font-size: 14px;\n  list-style: none;\n  margin-bottom: 15px;\n  padding: 0;\n}\n.entry-meta li {\n  display: inline-block;\n  margin-right: 15px;\n}\n.entry-meta li:last-child {\n  margin-right: 0;\n}\n.blog-pagination .pagination {\n  margin-bottom: 30px;\n}\n.blog-pagination .pagination li a {\n  padding: 12px 20px;\n  font-weight: 600;\n  color: #2e3842;\n  margin-right: 10px;\n  border-radius: inherit !important;\n  border-color: #f0f0f0;\n}\n.blog-pagination .pagination li.disabled a {\n  border-color: #f0f0f0;\n}\n.blog-pagination .pagination li.active a {\n  background: #20c0f3;\n  border-color: transparent;\n  color: #ffffff;\n}\n.post-left ul {\n  margin: 0;\n  padding-left: 0;\n  list-style: none;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.post-left ul li {\n  margin-bottom: 5px;\n  margin-right: 20px;\n}\n.post-left ul li:last-child {\n  margin-right: 0;\n}\n.post-author a {\n  display: flex;\n  align-items: center;\n}\n.video {\n  position: relative;\n  padding-bottom: 56%;\n  height: 0;\n  overflow: hidden;\n}\n.video iframe,\n.video object,\n.video embed {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n.latest-posts {\n  margin: 0;\n  padding: 0;\n}\n.latest-posts li {\n  display: table;\n  width: 100%;\n  margin-bottom: 20px;\n}\n.latest-posts li:last-child {\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n  border-bottom: none;\n}\n.post-thumb {\n  border-radius: 4px;\n  width: 80px;\n  float: left;\n  overflow: hidden;\n}\n.post-thumb a img {\n  border-radius: 4px;\n  -webkit-transform: translateZ(0);\n  -moz-transform: translateZ(0);\n  transform: translateZ(0);\n  -moz-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -ms-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -o-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  -webkit-transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n}\n.post-thumb a:hover img {\n  -webkit-transform: scale(1.15);\n  -moz-transform: scale(1.15);\n  transform: scale(1.15);\n}\n.post-info {\n  margin-left: 95px;\n}\n.post-info h4 {\n  font-size: 15px;\n  margin: 0 0 5px;\n}\n.post-info h4 a {\n  color: #272b41;\n}\n.post-info h4 a:hover {\n  color: #20c0f3;\n}\n.post-info p {\n  color: #757575;\n  font-size: 12px;\n  margin: 0;\n}\n.post-info p i {\n  color: #20c0f3;\n  font-size: 14px;\n  margin-right: 4px;\n}\n.category-widget .categories {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.category-widget .categories li {\n  margin-bottom: 20px;\n}\n.category-widget .categories li:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n.category-widget .categories li a {\n  color: #2e3842;\n  font-size: 15px;\n  font-weight: 500;\n}\n.category-widget .categories li a span {\n  float: right;\n  color: #757575;\n}\n.category-widget .categories li a:hover {\n  color: #20c0f3;\n}\n.category-widget .categories > li > a > i {\n  color: #20c0f3;\n  font-size: 18px;\n  margin-right: 10px;\n}\n.tags-widget .card-body {\n  padding-bottom: 1rem;\n}\n.tags {\n  list-style: none;\n  margin: 0;\n  overflow: hidden;\n  padding: 0;\n}\n.tags li {\n  float: left;\n}\n.tag {\n  background-color: #fff;\n  border-radius: 4px;\n  color: #272b41;\n  padding: 5px 10px;\n  position: relative;\n  margin: 0 0.5rem 0.5rem 0;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  display: inline-block;\n}\n.tag:hover {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n  color: #fff;\n}\n.comment-by {\n  display: block;\n  font-size: 14px;\n  line-height: 21px;\n  margin: 0 0 10px;\n}\n.comments-list .comment-block p {\n  font-size: 14px;\n  margin-bottom: 5px;\n}\n.blogs-section {\n  padding: 50px 0;\n  background-color: #ffffff;\n}\n.blogs-section.blog-container {\n  padding: 60px 0;\n}\n.blog-wrapper {\n  background: #ffffff;\n  border: 1px solid #e8eeff;\n  box-sizing: border-box;\n  border-radius: 10px 10px 0px 0px;\n  margin-bottom: 30px;\n}\n.blog-wrapper .wrap-image img {\n  width: 100%;\n  border-radius: 10px 10px 0px 0px;\n}\n.blog-wrapper .wrap-content {\n  padding: 10px;\n}\n.blog-wrapper .wrap-content:before {\n  width: 0;\n  height: 0;\n  border-left: 149px solid transparent;\n  border-right: 149px solid transparent;\n  border-bottom: 20px solid #ffffff;\n  margin-left: 0;\n  position: absolute;\n  margin-top: -30px;\n  left: 15px;\n}\n.blog-wrapper .wrap-content .sp-title {\n  font-size: 13px;\n  color: #2264c5;\n  font-weight: 600;\n  margin-right: 5px;\n}\n.blog-wrapper .wrap-content .post-author img {\n  width: 20px;\n  flex: 0 0 20px;\n  margin: 0 5px;\n}\n.blog-wrapper .wrap-content .post-author span {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000000;\n}\n.blog-wrapper .wrap-content .date-cart {\n  background-color: #1860ca;\n  padding: 10px 8px;\n  font-size: 28px;\n  color: #fff;\n  font-weight: 600;\n  line-height: 1.2;\n  text-align: center;\n  width: 65px;\n  height: 60px;\n  margin: 0;\n  position: absolute;\n  right: 25px;\n  margin-top: -40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.blog-wrapper .wrap-content .date-cart span {\n  font-size: 11px;\n  font-weight: 500;\n}\n.blog-wrapper .wrap-content-body {\n  margin-top: 10px;\n}\n.blog-wrapper .wrap-content-body h3 a {\n  font-size: 18px;\n  font-weight: 500;\n  color: #000;\n  line-height: 1.5;\n}\n.blog-wrapper .wrap-content-body p {\n  font-size: 12px;\n  color: #000;\n}\n.blog-wrapper .wrap-content-body a.read-txt {\n  width: 110px;\n  padding: 10px;\n  background: #0ce0ff;\n  border-radius: 30px;\n  display: block;\n  text-align: center;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n}\n.blogs-section .view-btn {\n  background-color: #20c0f3;\n  font-size: 16px;\n  color: #ffffff;\n  font-weight: 700;\n  border-radius: 30px;\n  border: 1px solid #20c0f3;\n  padding: 6px 20px;\n}\n.blog-container .blog-wrapper .wrap-content .date-cart {\n  top: 50px;\n  right: 25px;\n}\n.blog-container .blog-wrapper .wrap-content-body h3 a {\n  color: #1860ca;\n}\n.blog-container .blog-wrapper .wrap-content .sp-title {\n  color: #28daf4;\n  font-size: 14px;\n}\n/*-----------------\n\t39. Blog Details\n-----------------------*/\n\n.blog-view .blog-title {\n  font-size: 24px;\n}\n.blog-content p:last-child {\n  margin-bottom: 0;\n}\n.blog-view .blog-info {\n  border: 0;\n  margin-bottom: 20px;\n  padding: 0;\n}\n.social-share {\n  float: left;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.social-share > li {\n  display: inline-block;\n  float: left;\n  margin-left: 10px;\n  text-align: center;\n}\n.social-share > li:first-child {\n  margin-left: 0;\n}\n.social-share > li > a {\n  border: 1px solid #dfdfdf;\n  color: #666;\n  display: inline-block;\n  font-size: 22px;\n  height: 40px;\n  line-height: 40px;\n  width: 40px;\n}\n.social-share > li > a:hover {\n  background-color: #20c0f3;\n  color: #fff;\n  border-color: #20c0f3;\n}\n.blog-reply > a {\n  color: #999;\n  font-size: 12px;\n  font-weight: 500;\n}\n.blog-date {\n  color: #999;\n  font-size: 12px;\n}\n.blog-comments .comments-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n.blog-comments .comments-list li {\n  clear: both;\n  padding-left: 80px;\n}\n.blog-comments .comments-list li .comment {\n  margin-bottom: 20px;\n}\n.blog-comments .comments-list li .comment-author {\n  left: 0;\n  position: absolute;\n}\n.blog-comments .comments-list li img.avatar {\n  height: 58px;\n  width: 58px;\n  border-radius: 58px;\n}\n.blog-comments .comment-btn {\n  color: #20c0f3;\n  display: inline-block;\n  font-weight: 500;\n  font-size: 15px;\n}\n.blog-author-name {\n  color: #272b41;\n  font-size: 16px;\n  font-weight: 600;\n}\n.new-comment label {\n  font-weight: 500;\n}\n.comment-submit .btn {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n  border-radius: 0;\n  font-size: 18px;\n  padding: 8px 26px;\n  color: #fff;\n}\n.about-author-img {\n  background-color: #fff;\n  height: 100px;\n  overflow: hidden;\n  position: absolute;\n  width: 100px;\n}\n.author-details {\n  margin-left: 120px;\n}\n.about-author {\n  min-height: 100px;\n}\n.author-details .blog-author-name {\n  display: inline-block;\n  margin-bottom: 10px;\n}\n.post-author img {\n  border-radius: 100%;\n  width: 28px;\n  flex: 0 0 28px;\n  margin-right: 5px;\n}\n.post-author a > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.custom-edit-service textarea.form-control {\n  min-height: 200px;\n}\n.custom-edit-service .service-upload {\n  border: 1px solid #dcdcdc;\n  border-radius: 0.25rem;\n  text-align: center;\n  padding: 70px 0;\n  margin-bottom: 30px;\n  background-color: #fff;\n  position: relative;\n}\n.custom-edit-service .service-upload input[type=\"file\"] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n.custom-edit-service .service-upload i {\n  font-size: 50px;\n  color: #858585;\n}\n.custom-edit-service .service-upload span {\n  font-size: 15px;\n  color: #858585;\n  margin-top: 14px;\n  display: block;\n}\n.custom-edit-service .upload-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.custom-edit-service .upload-wrap li {\n  margin: 10px;\n}\n.custom-edit-service .upload-wrap li:first-child {\n  margin-left: 0;\n}\n.custom-edit-service .upload-wrap li img {\n  max-width: 100%;\n}\n/*-----------------\n\t40. Blog Grid\n-----------------------*/\n\n.grid-blog .blog-title {\n  font-size: 18px;\n  margin: 0 0 5px;\n  min-height: 43px;\n}\n.grid-blog .blog-content p {\n  margin: 0 0 15px;\n}\n.grid-blog .blog-info {\n  margin-bottom: 15px;\n}\n.grid-blog .blog-image {\n  margin-bottom: 20px;\n}\n.blog.grid-blog {\n  padding: 20px;\n}\n.grid-blog .entry-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin-bottom: 0;\n}\n.grid-blog .entry-meta li {\n  margin-bottom: 10px;\n}\n.grid-blog .entry-meta li:last-child {\n  flex: 0 0 100px;\n  max-width: 100px;\n}\n.grid-blog .post-author {\n  width: 189px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.grid-blog .post-author a:hover {\n  color: #20c0f3;\n}\n\n/*-----------------\n\t41. Map List & Grid\n-----------------------*/\n\n.map-page .footer {\n  display: none;\n}\n.map-page .header {\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 1030;\n}\n.map-page .content {\n  padding-top: 115px;\n}\n.map-right {\n  bottom: 0;\n  height: 100%;\n  min-height: 100%;\n  padding-right: 30px;\n  position: fixed;\n  right: 0;\n  top: 115px;\n  z-index: 1029;\n}\n.map-listing {\n  height: calc(100vh - 145px);\n  width: 100%;\n}\n.map-listing .profile-widget {\n  width: 200px !important;\n  padding: 0;\n  border: 0;\n  margin-bottom: 0;\n}\n.map-right .available-info {\n  margin-bottom: 0;\n}\n.view-icons {\n  display: inline-flex;\n  float: right;\n}\n.view-icons a {\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  color: #212529;\n  display: flex;\n  font-size: 20px;\n  justify-content: center;\n  padding: 4px 10px;\n  text-align: center;\n  margin-left: 10px;\n  width: 44px;\n  height: 44px;\n}\n.view-icons a:hover {\n  border-color: #20c0f3;\n  color: #20c0f3;\n}\n.view-icons a.active {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n  color: #fff;\n}\n\n/*-----------------\n\t42. Loader\n-----------------------*/\n\n#loader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #fff;\n  z-index: 999999;\n}\n.loader {\n  display: inline-block;\n  height: 50px;\n  left: 50%;\n  margin-left: -25px;\n  margin-top: -25px;\n  width: 50px;\n  position: absolute;\n  top: 50%;\n}\n.loader span {\n  -webkit-animation: loader 1.3s linear infinite;\n  animation: loader 1.3s linear infinite;\n  background-color: #20c0f3;\n  border-radius: 100%;\n  display: inline-block;\n  height: 50px;\n  position: absolute;\n  width: 50px;\n}\n.loader span:last-child {\n  animation-delay: -0.8s;\n  -webkit-animation-delay: -0.8s;\n}\n@keyframes loader {\n  0% {\n    transform: scale(0, 0);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1, 1);\n    opacity: 0;\n  }\n}\n@-webkit-keyframes loader {\n  0% {\n    -webkit-transform: scale(0, 0);\n    opacity: 0.5;\n  }\n  100% {\n    -webkit-transform: scale(1, 1);\n    opacity: 0;\n  }\n}\n\n/*-----------------\n\t43. Product\n-----------------------*/\n\n.product-custom span.price {\n  font-size: 20px;\n  font-weight: 500;\n}\n.product-custom span.price-strike {\n  font-weight: 400;\n  text-decoration: line-through;\n  color: #999;\n}\n.product-custom .cart-icon {\n  font-size: 18px;\n  width: 40px;\n  height: 40px;\n  border-radius: 100px;\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  float: right;\n}\n.product-custom .profile-widget:hover .cart-icon {\n  color: #fff;\n  background-color: #0de0fe;\n}\n.product-description .doctor-img1 {\n  width: 40%;\n}\n.product-description .doc-info-cont {\n  width: 60%;\n}\n.feature-product span {\n  padding-bottom: 10px;\n  display: inline-block;\n}\n.feature-product ul li {\n  padding: 3px 0;\n}\nul.benifits-col li i {\n  font-size: 20px;\n  margin-right: 20px;\n  color: #20c0f3;\n}\n.custom-increment .input-group1 {\n  display: flex;\n  display: -webkit-flex;\n  width: 100%;\n}\n.custom-increment .input-group-btn {\n}\n.custom-increment.cart .input-group1 {\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n.custom-increment input[type=\"text\"] {\n  border: 1px solid #dbdbdb;\n  border-radius: 0;\n  padding: 7px 15px;\n  text-align: center;\n  width: 70%;\n}\n.custom-increment.cart input[type=\"text\"] {\n  width: 60px;\n}\n.custom-increment input[type=\"text\"]:focus {\n  border-color: transparent;\n}\n.custom-increment button {\n  font-size: 14px;\n  height: 39px;\n  background: #dcdcdc;\n  color: #000;\n  border: 0;\n  display: inline-block;\n}\n.custom-increment button:hover,\n.custom-increment button:focus,\n.custom-increment button:active {\n  background: #dcdcdc !important;\n  color: #000 !important;\n  border: 0 !important;\n}\n.custom-increment.cart button {\n  font-size: 10px;\n}\n.custom-increment button.btn-success {\n  border-radius: 0 4px 4px 0;\n}\n.custom-increment button.btn-danger {\n  border-radius: 4px 0px 0px 4px;\n}\n\n/*-----------------\n\t44. Cart\n-----------------------*/\n.view-cart-header {\n  position: relative;\n}\n.view-cart-header .shopping-cart {\n  margin: 20px 0;\n  float: right;\n  background: white;\n  width: 320px;\n  position: absolute;\n  right: 0;\n  top: 99%;\n  border-radius: 3px;\n  padding: 20px;\n  z-index: 999;\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);\n  display: none;\n}\n.view-cart-header .shopping-cart.show-cart {\n  opacity: 1;\n  visibility: visible;\n}\n.view-cart-header .shopping-cart-total {\n  float: right;\n}\n.view-cart-header .shopping-cart-items {\n  padding-top: 0px;\n}\n.view-cart-header .shopping-cart-items li {\n  margin-bottom: 10px;\n  padding-right: 0;\n  display: block;\n  border-bottom: 1px solid #e4e4e4;\n  padding-bottom: 14px;\n  position: relative;\n}\n.view-cart-header .shopping-cart-items .close-icon {\n  position: absolute;\n  top: 10px;\n  right: 0;\n  cursor: pointer;\n}\n.view-cart-header .shopping-cart-items img {\n  float: left;\n  width: 70px;\n  margin-right: 12px;\n  max-width: 100%;\n  height: auto;\n}\n.view-cart-header .shopping-cart-items .item-name {\n  display: block;\n  padding-top: 10px;\n  font-size: 14px;\n  padding-right: 20px;\n}\n.view-cart-header .shopping-cart-items .item-price {\n  margin-right: 8px;\n  color: #20c0f3;\n  font-size: 13px;\n}\n.view-cart-header .shopping-cart-items .item-quantity {\n  color: #abb0be;\n  font-size: 13px;\n}\n.view-cart-header .shopping-cart:after {\n  border: 7px solid #fff;\n  border-color: transparent transparent #fff #fff;\n  box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\n  content: \"\";\n  right: 0;\n  position: absolute;\n  top: 2px;\n  -webkit-transform-origin: 0 0;\n  transform-origin: 0 0;\n  -webkit-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n.view-cart-header .cart-icon {\n  color: #515783;\n  font-size: 24px;\n  margin-right: 7px;\n  float: left;\n}\n.view-cart-header .booking-date li {\n  padding: 0;\n  display: block;\n  width: 100%;\n  margin-bottom: 10px;\n}\n.view-cart-header .booking-date li span {\n  float: right;\n}\n.view-cart-header .booking-total {\n  padding-top: 0;\n  text-align: center;\n}\n.view-cart-header .apt-btn {\n  font-size: 13px;\n  padding: 7px 20px;\n}\n/*-----------------\n\t45. Slider\n-----------------------*/\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-duration: 0.6s;\n  transition-property: opacity;\n}\n\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right {\n  opacity: 1;\n}\n\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n  opacity: 0;\n}\n\n.carousel-fade .carousel-item-next,\n.carousel-fade .carousel-item-prev,\n.carousel-fade .carousel-item.active,\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-prev {\n  transform: translateX(0);\n  transform: translate3d(0, 0, 0);\n}\n.carousel-item {\n  height: 75vh;\n  min-height: 350px;\n  background: no-repeat center center scroll;\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n  z-index: -1 !important;\n}\n.carousel-caption {\n  position: absolute;\n  right: 0;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-bottom: 20px;\n  color: #fff;\n  top: 110px;\n}\n.carousel-caption span {\n  font-size: 32px;\n  font-weight: 700;\n  color: rgb(46, 56, 66);\n}\n.carousel-caption h2 {\n  font-size: 54px;\n  font-weight: 700;\n  color: rgb(30, 92, 146);\n}\n.carousel-caption p {\n  font-size: 18px;\n  font-weight: 700;\n  color: rgb(46, 56, 66);\n}\n\n/*-----------------\n\t46. Account\n-----------------------*/\n\n.account-card {\n  border-radius: 10px;\n  margin-bottom: 30px;\n  font-size: 16px;\n  padding: 10px;\n  text-align: center;\n}\n.account-card span {\n  font-size: 24px;\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n.info-list {\n  margin-bottom: 10px;\n}\n.info-list .title {\n  color: #272b41;\n  font-weight: 500;\n}\n.info-list .text {\n  color: #757575;\n  display: block;\n  overflow: hidden;\n}\n\n/*-----------------\n\t47. Responsive\n-----------------------*/\n\n@media only screen and (min-width: 768px) {\n  .avatar-xxl {\n    width: 8rem;\n    height: 8rem;\n  }\n  .avatar-xxl .border {\n    border-width: 4px !important;\n  }\n  .avatar-xxl .rounded {\n    border-radius: 12px !important;\n  }\n  .avatar-xxl .avatar-title {\n    font-size: 42px;\n  }\n  .avatar-xxl.avatar-away:before,\n  .avatar-xxl.avatar-offline:before,\n  .avatar-xxl.avatar-online:before {\n    border-width: 4px;\n  }\n}\n@media (min-width: 992px) {\n  .main-nav > li {\n    margin-right: 30px;\n  }\n  .white-font > li > a {\n    color: #fff;\n  }\n  .main-nav > li:last-child {\n    margin-right: 0;\n  }\n  .main-nav li {\n    display: block;\n    position: relative;\n  }\n  .main-nav > li > a {\n    line-height: 85px;\n    padding: 0 !important;\n  }\n  .header-four .main-nav > li > a {\n    line-height: 80px;\n    color: #fff;\n  }\n  .main-nav > li > a > i {\n    font-size: 12px;\n    margin-left: 3px;\n  }\n  .main-nav li > ul {\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n    display: block;\n    font-size: 14px;\n    left: 0;\n    margin: 0;\n    min-width: 200px;\n    opacity: 0;\n    padding: 0;\n    position: absolute;\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n    -webkit-transform: translateY(20px);\n    -ms-transform: translateY(20px);\n    transform: translateY(20px);\n    top: 100%;\n    visibility: hidden;\n    z-index: 1000;\n  }\n  .main-nav li .submenu::before {\n    border: 7px solid #fff;\n    border-color: transparent transparent #fff #fff;\n    box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\n    content: \"\";\n    left: 45px;\n    position: absolute;\n    top: 2px;\n    -webkit-transform-origin: 0 0;\n    transform-origin: 0 0;\n    -webkit-transform: rotate(135deg);\n    transform: rotate(135deg);\n  }\n  .main-nav li.has-submenu:hover > .submenu {\n    visibility: visible;\n    opacity: 1;\n    margin-top: 0;\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0);\n  }\n  .main-nav .has-submenu.active > a {\n    color: #09dca4;\n  }\n  .header-four .main-nav .has-submenu.active > a {\n    color: #fff;\n    border-top: 3px solid #e74e84;\n  }\n  .main-nav .has-submenu.active .submenu li.active > a {\n    color: #09dca4;\n  }\n  .main-nav > li .submenu li:first-child a {\n    border-top: 0;\n  }\n  .main-nav\n    > li.has-submenu:hover\n    > .submenu\n    > li.has-submenu:hover\n    > .submenu {\n    visibility: visible;\n    opacity: 1;\n    margin-top: -1px;\n    margin-right: 0;\n  }\n  .main-nav > li .submenu > li .submenu {\n    left: 100%;\n    top: 0;\n    margin-top: 10px;\n  }\n  .main-nav li .submenu a:hover {\n    color: #09dca4;\n    letter-spacing: 0.5px;\n    padding-left: 20px;\n  }\n  .main-nav > .has-submenu > .submenu > .has-submenu > .submenu::before {\n    top: 20px;\n    margin-left: -35px;\n    box-shadow: 1px 1px 0 0 rgba(0, 0, 0, 0.15);\n    border-color: transparent #fff #fff transparent;\n  }\n  .header-navbar-rht li.show > .dropdown-menu {\n    visibility: visible;\n    opacity: 1;\n    margin-top: 0;\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0);\n  }\n  .header-navbar-rht li .dropdown-menu {\n    border-radius: 5px;\n    padding: 0;\n    margin: 0;\n    min-width: 250px;\n    visibility: hidden;\n    opacity: 0;\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n    display: block;\n    -webkit-transform: translateY(20px);\n    -ms-transform: translateY(20px);\n    transform: translateY(20px);\n  }\n  .header-five .main-nav .has-submenu.active > a {\n    color: #28daf4;\n  }\n  .header-five .main-nav .has-submenu.active > a:after {\n    content: \"\";\n    position: absolute;\n    width: 70px;\n    background: #28daf4;\n    left: -7px;\n    height: 2px;\n    z-index: 9;\n    bottom: 25px;\n  }\n}\n@media only screen and (max-width: 1399px) {\n  .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-name,\n  .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-last-chat {\n    max-width: 180px;\n  }\n  .row.row-grid {\n    margin-left: -8px;\n    margin-right: -8px;\n  }\n  .row.row-grid > div {\n    padding-right: 8px;\n    padding-left: 8px;\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n}\n@media (min-width: 1200px) {\n  .aval-features .custom-contain {\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto;\n  }\n}\n@media (min-width: 1600px) {\n  .blog-wrapper .wrap-content:before {\n    border-left: 221px solid transparent;\n    border-right: 221px solid transparent;\n  }\n}\n@media only screen and (max-width: 1199px) {\n  .header-nav {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .container-fluid {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-name,\n  .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-last-chat {\n    max-width: 150px;\n  }\n  .chat-cont-left {\n    -ms-flex: 0 0 40%;\n    flex: 0 0 40%;\n    max-width: 40%;\n  }\n  .chat-cont-right {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row.row-grid > div {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .dash-widget {\n    -ms-flex-direction: column;\n    flex-direction: column;\n    text-align: center;\n  }\n  .circle-bar {\n    margin: 0 0 15px;\n  }\n  .header-navbar-rht li.contact-item {\n    display: none;\n  }\n  .map-right {\n    height: 450px;\n    position: static;\n    min-height: inherit;\n    margin-bottom: 30px;\n    padding-right: 15px;\n  }\n  .map-listing {\n    height: 450px;\n  }\n  .map-page .content {\n    padding-top: 100px;\n  }\n}\n@media only screen and (max-width: 991.98px) {\n  .main-nav {\n    padding: 0;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n  }\n  .main-nav ul {\n    background-color: #3474ac;\n    display: none;\n    list-style: none;\n    margin: 0;\n    padding-left: 0;\n  }\n  .main-nav > li {\n    border-bottom: 1px solid #1663a6;\n    margin-left: 0;\n  }\n  .main-nav li + li {\n    margin-left: 0;\n  }\n  .main-nav > li > a {\n    line-height: 1.5;\n    padding: 15px 20px !important;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 500;\n  }\n  .main-nav > li > a > i {\n    float: right;\n    margin-top: 5px;\n  }\n  .main-nav > li .submenu li a {\n    border-top: 0;\n    color: #fff;\n    padding: 10px 15px 10px 35px;\n  }\n  .main-nav > li .submenu ul li a {\n    padding: 10px 15px 10px 45px;\n  }\n  .main-nav > li .submenu > li.has-submenu > a::after {\n    content: \"\\f078\";\n  }\n  .main-nav .has-submenu.active > a {\n    color: #09dca4;\n  }\n  .main-nav .has-submenu.active .submenu li.active > a {\n    color: #09dca4;\n  }\n  .login-left {\n    display: none;\n  }\n  .main-menu-wrapper {\n    order: 3;\n    width: 260px;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n    z-index: 1060;\n    transform: translateX(-260px);\n    transition: all 0.4s;\n    background-color: #15558d;\n  }\n  .menu-header {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n  .navbar-header {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n  }\n  #mobile_btn {\n    display: inline-block;\n  }\n  .section-search {\n    min-height: 330px;\n  }\n  .section-specialities {\n    padding: 50px 0;\n  }\n  .footer-widget {\n    margin-bottom: 30px;\n  }\n  .chat-cont-left,\n  .chat-cont-right {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n    transition: left 0.3s ease-in-out 0s, right 0.3s ease-in-out 0s;\n    width: 100%;\n  }\n  .chat-cont-left {\n    border-right: 0;\n  }\n  .chat-cont-right {\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 75%;\n    /* opacity: 0; */\n    /* visibility: hidden; */\n  }\n  .chat-cont-right .chat-header {\n    justify-content: start;\n    -webkit-justify-content: start;\n    -ms-flex-pack: start;\n  }\n  .chat-cont-right .chat-header .back-user-list {\n    display: block;\n  }\n  .chat-cont-right .chat-header .chat-options {\n    margin-left: auto;\n  }\n  .chat-window.chat-slide .chat-cont-left {\n    left: -100%;\n  }\n  .chat-window.chat-slide .chat-cont-right {\n    right: 0;\n    opacity: 1;\n    visibility: visible;\n  }\n  .day-slot li.left-arrow {\n    left: -10px;\n  }\n  .container {\n    max-width: 100%;\n  }\n  .appointments .appointment-action {\n    margin-top: 10px;\n  }\n  .appointments .appointment-list {\n    display: block;\n  }\n  .banner-wrapper {\n    max-width: 620px;\n  }\n  .search-box .search-info {\n    -ms-flex: 0 0 180px;\n    flex: 0 0 180px;\n    width: 180px;\n  }\n  .banner-wrapper .banner-header h1 {\n    font-size: 2.125rem;\n  }\n  .dct-border-rht {\n    border-bottom: 1px solid #f0f0f0;\n    border-right: 0;\n    margin-bottom: 20px;\n    padding-bottom: 15px;\n  }\n  .dr-img {\n    display: none;\n  }\n  .doctor-search {\n    padding: 30px 0;\n  }\n  .doctor-search-section {\n    padding-top: 85px;\n  }\n  .shapes {\n    display: none;\n  }\n  .search-box-3 {\n    position: relative;\n  }\n  .header-top {\n    display: none;\n  }\n  .search-box {\n    max-width: 535px;\n    margin: 0 auto;\n  }\n  .card-label > label {\n    font-size: 12px;\n  }\n  .footer .footer-top {\n    padding-bottom: 10px;\n  }\n  .time-slot li .timing.selected::before {\n    display: none;\n  }\n  .review-listing .recommend-btn {\n    float: none;\n  }\n  .dash-widget {\n    flex-direction: unset;\n    text-align: left;\n  }\n  .circle-bar {\n    margin: 0 15px 0 0;\n  }\n  .call-wrapper {\n    height: calc(100vh - 50px);\n  }\n  .sidebar-overlay.opened {\n    display: block;\n  }\n  .about-content {\n    margin-bottom: 30px;\n  }\n  .slide-image {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .custom-short-by > div {\n    margin-right: 0;\n  }\n  .product-description .doctor-img1 {\n    width: 100%;\n    margin-right: 0;\n    margin-bottom: 30px;\n  }\n  .product-description .doc-info-cont {\n    width: 100%;\n  }\n  .product-description .doc-info-left {\n    flex-wrap: wrap;\n    -webkit-flex-wrap: wrap;\n  }\n  .clinics-section {\n    padding: 40px 0 25px;\n  }\n  .specialities-section {\n    padding: 60px 0 35px;\n  }\n  .our-doctors-section {\n    padding: 40px 0;\n  }\n  .clinic-features-section {\n    padding: 40px 0;\n  }\n  .our-blog-section {\n    padding: 40px 0;\n  }\n  .section-search-3 .banner-info {\n    padding: 60px 0 130px;\n  }\n  .section-search-3 .doctor-search-form .banner-btn {\n    padding: 18px 30px;\n  }\n  .pop-box .body-section h3 {\n    font-size: 20px;\n  }\n  .section-header-three h2 {\n    font-size: 28px;\n  }\n  .doc-background,\n  .pat-background {\n    min-height: 250px;\n  }\n  .doctor-divison h3 {\n    font-size: 20px;\n  }\n  .doctor-divison p {\n    font-size: 12px;\n  }\n  .doctors-body .inner-section > span {\n    font-size: 12px;\n  }\n  .book-best-doctors .doctors-body .average-ratings {\n    padding: 1px 8px;\n    font-size: 10px;\n    margin-left: 7px;\n  }\n  .book-best-doctors .doctors-body h4 {\n    font-size: 18px;\n  }\n  .book-best-doctors .amt-txt {\n    font-size: 16px;\n  }\n  .latest-blog .blog-wrap .blog-wrap-body h3 {\n    font-size: 18px;\n  }\n  .header-four .nav-item a.header-login {\n    margin: 15px 20px;\n  }\n  .header-four .nav-item a.header-login i {\n    float: unset;\n  }\n  .doc-form {\n    position: absolute;\n    top: 85px;\n    left: 20px;\n    padding: 37px 0;\n    width: 600px;\n  }\n  .dot-slider .slick-slide {\n    height: 375px;\n  }\n  .dot-slider .profile-widget {\n    margin-bottom: 0;\n  }\n  .app-form h2 {\n    font-size: 30px;\n  }\n  .app-form .doctor-search-form input {\n    min-height: 50px;\n  }\n  .app-form .banner-btn {\n    padding: 10px 30px;\n    min-height: 50px;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n  }\n  .category-sec {\n    padding: 50px 0;\n    margin-top: 0;\n  }\n  .set-category {\n    padding: 10px;\n  }\n  .set-category .info-holder h3 {\n    font-size: 20px;\n  }\n  .set-category .info-holder p {\n    font-size: 11px;\n  }\n  .set-category .img-holder {\n    margin-right: 10px;\n  }\n  .set-category .img-holder a {\n    width: 50px;\n    height: 50px;\n  }\n  .set-category .img-holder a img {\n    width: 20px;\n  }\n  .select-box {\n    padding: 20px;\n  }\n  .select-box p {\n    font-size: 14px;\n    margin-bottom: 20px;\n  }\n  .select-box .book-now {\n    padding: 8px 20px;\n  }\n  .select-box .image-holder {\n    margin-right: 15px;\n  }\n  .aval-features .custom-contain {\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .aval-features .feature {\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    padding: 40px;\n  }\n  .aval-features .feature .info-box {\n    padding: 20px;\n  }\n  .aval-features .feature .info-box h2 {\n    font-size: 30px;\n  }\n  .footer.footer-four .footer-top {\n    padding: 30px 0 0;\n  }\n  .aval-features .custom-contain {\n    max-width: 100%;\n  }\n  .header-trans.header-five .main-menu-wrapper {\n    margin-left: auto;\n  }\n  .home-search-section .banner-header h2 {\n    font-size: 34px;\n  }\n  .facility-section .operat-img {\n    width: 100%;\n  }\n  .facility-section .visit-doctor {\n    padding: 15px;\n    margin-bottom: 20px;\n  }\n  .facility-section .visit-doctor .inner-details img {\n    bottom: -13px;\n  }\n  .visit-doctor .inner-details .info h2 {\n    font-size: 20px;\n  }\n  .visit-doctor .inner-details .info p {\n    font-size: 12px;\n    max-width: 100%;\n  }\n  .visit-doctor .inner-details .count h2 {\n    width: 55px;\n    height: 55px;\n    font-size: 20px;\n  }\n  .clinic-wrap {\n    height: 200px;\n  }\n  .heading-wrapper h1 {\n    font-size: 30px;\n    max-width: 100%;\n  }\n  .clinic-wrap .wrapper-overlay img {\n    margin-bottom: 20px;\n  }\n  .doc-booking .book-slider .slick-prev,\n  .doc-booking .book-slider .slick-next {\n    top: -100px;\n  }\n  .blog-wrapper .wrap-content .date-cart {\n    font-size: 26px;\n  }\n  .home-search-section .doctor-search {\n    padding: 40px 0;\n  }\n  .facility-section {\n    padding: 40px 0 20px;\n  }\n  .clinic-speciality {\n    padding: 40px 0 10px;\n  }\n  .browse-section.brower-category {\n    padding: 40px 0 20px;\n  }\n  .doctor-divison.provider-select .doc-background,\n  .doctor-divison.provider-select .pat-background {\n    padding: 40px 30px;\n  }\n  .doc-booking {\n    padding: 40px 0;\n  }\n  .blogs-section.blog-container {\n    padding: 40px 0 10px;\n  }\n  .footer.footer-five .footer-top {\n    padding: 40px 0 10px;\n  }\n  .heading-wrapper .nav-arrow {\n    display: none;\n  }\n  .heading-wrapper {\n    margin-bottom: 30px;\n    text-align: center;\n  }\n  .blog-wrapper .wrap-content:before {\n    border-left: 178px solid transparent;\n    border-right: 170px solid transparent;\n  }\n  .divider .carousel-inner {\n    height: 430px;\n  }\n}\n@media only screen and (max-width: 849.98px) {\n  .row.row-grid > div {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n@media only screen and (max-width: 767.98px) {\n  body {\n    font-size: 0.875rem;\n  }\n  h1,\n  .h1 {\n    font-size: 2rem;\n  }\n  h2,\n  .h2 {\n    font-size: 1.75rem;\n  }\n  h3,\n  .h3 {\n    font-size: 1.375rem;\n  }\n  h4,\n  .h4 {\n    font-size: 1rem;\n  }\n  h5,\n  .h5 {\n    font-size: 0.875rem;\n  }\n  h6,\n  .h6 {\n    font-size: 0.75rem;\n  }\n  .content {\n    padding: 15px 0 0;\n  }\n  .account-page .content {\n    padding: 15px 0;\n  }\n  .container-fluid {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .carousel-item {\n    height: auto;\n    min-height: auto;\n  }\n  .card {\n    margin-bottom: 20px;\n  }\n  .profile-sidebar {\n    margin-bottom: 20px;\n  }\n  .appointment-tab {\n    margin-bottom: 20px;\n  }\n  .features-slider .slick-dots,\n  .features-img img {\n    text-align: center;\n    margin: 0 auto;\n  }\n  .doctor-slider {\n    margin-top: 25px;\n  }\n  .breadcrumb-bar {\n    height: auto;\n  }\n  .login-right {\n    margin: 0 15px;\n    padding: 15px;\n  }\n  .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-name,\n  .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-last-chat {\n    max-width: 250px;\n  }\n  .chat-window .chat-cont-right .chat-header .media .media-body {\n    display: none;\n  }\n  .divider .carousel-inner {\n    height: 100%;\n  }\n  .divider .form-group {\n    margin-bottom: 10px;\n  }\n  .banner-wrapper .banner-header h1 {\n    font-size: 2rem;\n  }\n  .banner-wrapper .banner-header p {\n    font-size: 1rem;\n  }\n  .section-header h2 {\n    font-size: 1.875rem;\n  }\n  .section-header .sub-title {\n    font-size: 0.875rem;\n  }\n  .speicality-item p {\n    font-size: 0.875rem;\n  }\n  .section-header p {\n    font-size: 0.9375rem;\n  }\n  .footer-title {\n    font-size: 1.125rem;\n  }\n  .search-box {\n    max-width: 535px;\n    margin: 0 auto;\n  }\n  .search-box {\n    -ms-flex-direction: column;\n    flex-direction: column;\n    word-wrap: break-word;\n    background-clip: border-box;\n  }\n  .search-box .search-location {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    width: 100%;\n  }\n  .search-box .search-info {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    width: 100%;\n  }\n  .search-box .search-btn {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    min-height: 46px;\n    width: 100%;\n  }\n  .search-box .search-btn span {\n    display: inline-block;\n    margin-left: 5px;\n    text-transform: uppercase;\n  }\n  .section-search {\n    background: #f9f9f9;\n  }\n  .day-slot li span {\n    font-size: 16px;\n    text-transform: unset;\n  }\n  .time-slot li .timing span {\n    display: block;\n  }\n  .submit-section.proceed-btn {\n    margin-bottom: 20px;\n  }\n  .day-slot li small.slot-year {\n    display: none;\n  }\n  .success-cont h3 {\n    font-size: 22px;\n  }\n  .view-inv-btn {\n    font-size: 14px;\n    padding: 10px 30px;\n  }\n  .invoice-info.invoice-info2 {\n    text-align: left;\n  }\n  .invoice-item .invoice-details {\n    text-align: left;\n  }\n  .section-search,\n  .section-doctor,\n  .section-features {\n    padding: 50px 0;\n  }\n  .slick-next {\n    right: -10px;\n  }\n  .slick-prev {\n    left: -10px;\n  }\n  .specialities-slider .slick-slide {\n    margin-right: 15px;\n  }\n  .about-content a {\n    padding: 12px 20px;\n  }\n  .submit-section .submit-btn {\n    padding: 10px 20px;\n    font-size: 15px;\n    min-width: 105px;\n  }\n  .policy-menu {\n    margin-top: 10px;\n    text-align: left;\n  }\n  .booking-doc-info .booking-doc-img {\n    width: 75px;\n  }\n  .booking-doc-info .booking-doc-img img {\n    height: 75px;\n    width: 75px;\n  }\n  .btn.btn-danger.trash {\n    margin-bottom: 20px;\n  }\n  .nav-tabs.nav-tabs-bottom > li > a.active,\n  .nav-tabs.nav-tabs-bottom > li > a.active:hover,\n  .nav-tabs.nav-tabs-bottom > li > a.active:focus {\n    background-color: #f5f5f5;\n  }\n  .nav-tabs.nav-justified {\n    border-bottom: 1px solid #ddd;\n  }\n  .nav-tabs.nav-justified > li > a.active,\n  .nav-tabs.nav-justified > li > a.active:hover,\n  .nav-tabs.nav-justified > li > a.active:focus {\n    border-color: transparent transparent transparent #20c0f3;\n    border-left-width: 2px;\n  }\n  .nav-tabs {\n    border-bottom: 0;\n    position: relative;\n    background-color: #fff;\n    padding: 5px 0;\n    border: 1px solid #ddd;\n    border-radius: 3px;\n  }\n  .nav-tabs .nav-item {\n    margin-bottom: 0;\n  }\n  .nav-tabs > li > a {\n    border-width: 2px;\n    border-left-color: transparent;\n  }\n  .nav-tabs .nav-link {\n    border-width: 2px;\n  }\n  .nav-tabs > li > a:hover,\n  .nav-tabs > li > a:focus {\n    background-color: #fafafa;\n  }\n  .nav-tabs .nav-item.show .nav-link,\n  .nav-tabs .nav-link.active,\n  .nav-tabs > li > a.active,\n  .nav-tabs > li > a.active:hover,\n  .nav-tabs > li > a.active:focus {\n    border-color: transparent transparent transparent #20c0f3 !important;\n    border-left-width: 2px;\n  }\n  .nav-tabs > li.open:not(.active) > a,\n  .nav-tabs > li.open:not(.active) > a:hover,\n  .nav-tabs > li.open:not(.active) > a:focus {\n    background-color: #fafafa;\n  }\n  .nav-tabs.nav-tabs-solid {\n    padding: 5px;\n  }\n  .nav-tabs.nav-tabs-solid.nav-tabs-rounded {\n    border-radius: 5px;\n  }\n  .nav-tabs.nav-tabs-solid > li > a {\n    border-left-width: 0 !important;\n  }\n  .nav-tabs-justified {\n    border-bottom: 1px solid #ddd;\n  }\n  .nav-tabs-justified > li > a.active,\n  .nav-tabs-justified > li > a.active:hover,\n  .nav-tabs-justified > li > a.active:focus {\n    border-width: 0 0 0 2px;\n    border-left-color: #20c0f3;\n  }\n  .review-listing > ul li .comment .comment-body .meta-data span.comment-date {\n    margin-bottom: 5px;\n  }\n  .review-listing > ul li .comment .comment-body .meta-data .review-count {\n    position: unset;\n  }\n  .my-video ul li {\n    width: 50px;\n  }\n  .call-users ul li {\n    width: 50px;\n  }\n  .call-mute {\n    font-size: 20px;\n    height: 50px;\n    line-height: 50px;\n    width: 50px;\n  }\n  .call-duration {\n    font-size: 24px;\n  }\n  .voice-call-avatar .call-avatar {\n    height: 100px;\n    width: 100px;\n  }\n  .user-tabs {\n    margin-top: 1.5rem;\n  }\n  .user-tabs .nav-tabs > li > a {\n    border-left: 2px solid transparent;\n    border-bottom: 0;\n    padding: 0.5rem 1rem;\n  }\n  .user-tabs .nav-tabs.nav-tabs-bottom > li > a.active,\n  .user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:hover,\n  .user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:focus {\n    border-left-width: 2px;\n    color: #20c0f3;\n  }\n  .doctor-widget {\n    -ms-flex-direction: column;\n    flex-direction: column;\n    text-align: center;\n  }\n  .doc-info-right {\n    margin-left: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .doc-info-left {\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .clinic-services {\n    display: none;\n  }\n  .doctor-img {\n    margin: 0 auto 20px;\n  }\n  .doctor-action {\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n  }\n  .row.row-grid > div {\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .breadcrumb-bar .breadcrumb-title {\n    font-size: 18px;\n  }\n  .dash-widget h6 {\n    font-size: 15px;\n  }\n  .dash-widget h3 {\n    font-size: 20px;\n  }\n  .dash-widget p {\n    font-size: 13px;\n  }\n  .doctor-widget .doc-name {\n    font-size: 18px;\n  }\n  .exp-title,\n  .booking-total ul li span,\n  .booking-total ul li .total-cost {\n    font-size: 14px;\n  }\n  .invoice-item .customer-text {\n    font-size: 16px;\n  }\n  .call-wrapper {\n    height: calc(100vh - 50px);\n  }\n  .appointment-tab .nav-tabs {\n    padding: 1.5rem;\n  }\n  .submit-btn-bottom {\n    margin-bottom: 20px;\n  }\n  .service-list ul li {\n    width: 50%;\n  }\n  .grid-blog .blog-title {\n    min-height: inherit;\n  }\n  .blog-title {\n    font-size: 20px;\n  }\n  .blog-view .blog-title {\n    font-size: 22px;\n  }\n  .full-slide-home .slick-prev {\n    left: 15px;\n  }\n  .full-slide-home .slick-next {\n    right: 15px;\n  }\n  .search-box1 form p {\n    margin-bottom: 15px !important;\n  }\n  .search-box1 .search-location1 {\n    margin-right: 0;\n    margin-bottom: 15px;\n  }\n  .product-description .doctor-widget {\n    text-align: left;\n  }\n  .pharmacy-home-slider .swiper-button-prev,\n  .pharmacy-home-slider .swiper-button-next {\n    display: none;\n  }\n  .banner-header h2 {\n    font-size: 26px;\n    line-height: 40px;\n  }\n  .section-heading {\n    margin-bottom: 15px;\n  }\n  .owl-theme .owl-dots,\n  .owl-nav button {\n    margin-top: 10px;\n  }\n  .clinics-section {\n    padding: 30px 0 10px;\n  }\n  .specialities-section {\n    padding: 40px 0 15px;\n  }\n  .our-doctors-section {\n    padding: 30px 0;\n  }\n  .clinic-features-section {\n    padding: 30px 0;\n  }\n  .our-blog-section {\n    padding: 30px 0;\n  }\n  .section-heading h2 {\n    font-size: 20px;\n  }\n  .slide-nav-1 button.owl-next,\n  .slide-nav-1 button.owl-prev,\n  .slide-nav-2 button.owl-next,\n  .slide-nav-2 button.owl-prev,\n  .slide-nav-3 button.owl-next,\n  .slide-nav-3 button.owl-prev,\n  .slide-nav-4 button.owl-next,\n  .slide-nav-4 button.owl-prev {\n    width: 28px;\n    height: 28px;\n  }\n  .section-search-3 .banner-info {\n    padding: 20px 0 100px;\n  }\n  .pop-box .body-section h3 {\n    font-size: 18px;\n  }\n  .section-header-three h2 {\n    font-size: 24px;\n  }\n  .section-header-three p {\n    font-size: 14px;\n  }\n  .section-header-three {\n    margin-bottom: 40px;\n  }\n  .doctor-category {\n    padding: 40px 0 10px;\n    margin-top: -110px;\n  }\n  .clinic-specialities {\n    padding: 40px 0;\n  }\n  .browse-section {\n    padding: 40px 0;\n  }\n  .doc-background,\n  .pat-background {\n    padding: 20px 15px;\n    min-height: 200px;\n  }\n  .doctor-divison > .d-flex {\n    display: block !important;\n  }\n  .doctor-divison h3 {\n    font-size: 16px;\n  }\n  .doctor-divison p {\n    font-size: 11px;\n  }\n  .book-section {\n    padding: 40px 0;\n  }\n  .latest-blog {\n    padding: 40px 0 10px;\n  }\n  .footer.custom-footer .footer-top {\n    padding: 40px 0 10px;\n  }\n  .app-form h2 {\n    font-size: 20px;\n  }\n  .doc-form {\n    padding: 10px;\n    left: 0;\n  }\n  .app-form {\n    display: none;\n  }\n  .dot-slider .slick-slide {\n    height: 100%;\n  }\n  .dot-slider .profile-widget {\n    margin: 0;\n  }\n  .category-sec {\n    padding: 30px 0 0;\n  }\n  .set-category {\n    margin-bottom: 30px;\n  }\n  .clinic-section {\n    padding: 30px 0 0;\n  }\n  .sec-header h2 {\n    font-size: 24px;\n  }\n  .browse-speciality {\n    padding: 30px 0 15px;\n  }\n  .select-box {\n    margin-bottom: 30px;\n    border-radius: 60px;\n  }\n  .select-box::before {\n    border-radius: 55px;\n  }\n  .select-box.theme {\n    border-radius: 60px;\n  }\n  .select-box.theme::before {\n    border-radius: 55px;\n  }\n  .set-category h2 {\n    bottom: 0;\n  }\n  .patient-select {\n    background: #2264c5 url(../assets/img/slider/blue-bg.png);\n    padding: 30px 0 0;\n  }\n  .select-box h2 {\n    font-size: 24px;\n  }\n  .select-box p {\n    font-size: 12px;\n  }\n  .select-box .book-now {\n    font-size: 13px;\n  }\n  .book-doctor {\n    padding: 30px 0;\n  }\n  .book-slider .provider-info h3 {\n    font-size: 18px;\n  }\n  .book-slider .provider-info h5 {\n    font-size: 12px;\n  }\n  .book-slider .provider-info .side-arrow {\n    width: 30px;\n    height: 30px;\n  }\n  .book-slider .available-info li {\n    font-size: 13px;\n  }\n  .book-slider .content-info .view-btn,\n  .book-slider .content-info .view-btn:hover,\n  .book-slider .content-info .book-btn,\n  .book-slider .content-info .book-btn:hover {\n    font-size: 12px;\n  }\n  .book-doctor .row.mt-4 {\n    margin-top: 0 !important;\n  }\n  .book-doctor .view-btn,\n  .blogs-section .view-btn {\n    font-size: 14px;\n  }\n  .aval-features .feature {\n    padding: 30px;\n  }\n  .aval-features .feature .info-box h2 {\n    font-size: 24px;\n    margin-bottom: 10px;\n  }\n  .aval-features .feature .info-box p {\n    margin-bottom: 15px;\n    font-size: 13px;\n  }\n  .aval-features .feature .info-box a {\n    font-size: 12px;\n    width: 100px;\n  }\n  .aval-features .col-md-6.pl-0 {\n    padding-left: 15px !important;\n  }\n  .aval-slider .slick-list {\n    padding: 30px 0;\n  }\n  .blogs-section {\n    padding: 30px 0;\n  }\n  .blog-wrapper .wrap-content .date-cart {\n    font-size: 22px;\n    width: 60px;\n    height: 55px;\n    padding: 5px;\n  }\n  .blog-wrapper .wrap-content .date-cart span {\n    font-size: 10px;\n  }\n  .blog-wrapper .wrap-content-body h3 {\n    font-size: 17px;\n  }\n  .home-search-section .banner-header h2 {\n    font-size: 30px;\n  }\n  .heading-wrapper h1 {\n    font-size: 24px;\n  }\n  .clinic-wrap .wrapper-overlay h3 {\n    font-size: 20px;\n    text-align: center;\n  }\n  .facility-section .operat-img {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n  .visit-doctor .inner-details .info h2,\n  .visit-doctor .inner-details .count h2 {\n    font-size: 18px;\n  }\n  .clinic-wrap .wrapper-overlay img {\n    margin: 0 auto 0;\n  }\n  .clinic-wrap .wrapper-overlay p {\n    text-align: center;\n  }\n  .doc-booking .book-slider .slick-list {\n    padding-top: 50px;\n  }\n  .doc-booking .book-slider .slick-prev,\n  .doc-booking .book-slider .slick-next {\n    top: 0;\n  }\n  .book-slider .provider-info h3 a {\n    font-size: 20px;\n  }\n  .blog-container .blog-wrapper .wrap-content-body h3 a {\n    font-size: 17px;\n  }\n  .blog-wrapper .wrap-content:before {\n    border-left: 170px solid transparent;\n    border-right: 160px solid transparent;\n  }\n  .pop-box {\n    margin-bottom: 30px;\n  }\n}\n\n@media only screen and (max-width: 575.98px) {\n  body {\n    font-size: 0.8125rem;\n  }\n  h1,\n  .h1 {\n    font-size: 1.75rem;\n  }\n  h2,\n  .h2 {\n    font-size: 1.5rem;\n  }\n  h3,\n  .h3 {\n    font-size: 1.25rem;\n  }\n  h4,\n  .h4 {\n    font-size: 1rem;\n  }\n  h5,\n  .h5 {\n    font-size: 0.875rem;\n  }\n  h6,\n  .h6 {\n    font-size: 0.75rem;\n  }\n  .card {\n    margin-bottom: 0.9375rem;\n  }\n  .card-body {\n    padding: 1.25rem;\n  }\n  .card-header {\n    padding: 0.75rem 1.25rem;\n  }\n  .card-footer {\n    padding: 0.75rem 1.25rem;\n  }\n  .header-nav {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .header-navbar-rht {\n    display: none;\n  }\n  .main-nav li.login-link {\n    display: block;\n  }\n  .navbar-header {\n    width: 100%;\n  }\n  #mobile_btn {\n    left: 0;\n    margin-right: 0;\n    padding: 0 15px;\n    position: absolute;\n    z-index: 99;\n  }\n  .navbar-brand.logo {\n    width: 100%;\n    text-align: center;\n    margin-right: 0;\n  }\n  .navbar-brand.logo img {\n    height: 40px;\n  }\n  .search-box {\n    display: block;\n  }\n  .search-box .search-location {\n    width: 100%;\n    -ms-flex: none;\n    flex: none;\n  }\n  .search-box .search-info {\n    width: 100%;\n    -ms-flex: none;\n    flex: none;\n  }\n  .banner-wrapper .banner-header h1 {\n    font-size: 28px;\n  }\n  .slick-next {\n    right: 0px;\n  }\n  .section-header h2 {\n    font-size: 1.5rem;\n  }\n  .section-header .sub-title {\n    font-size: 0.875rem;\n  }\n  .speicality-item p {\n    font-size: 0.875rem;\n  }\n  .section-header p {\n    font-size: 0.9375rem;\n  }\n  .footer-title {\n    font-size: 1.125rem;\n  }\n  .booking-schedule.schedule-widget {\n    overflow-x: auto;\n  }\n  .booking-schedule.schedule-widget > div {\n    width: 730px;\n  }\n  .booking-schedule .day-slot ul {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n  .booking-schedule .day-slot li {\n    -ms-flex: 0 0 100px;\n    flex: 0 0 100px;\n    width: 100px;\n  }\n  .booking-schedule .time-slot ul {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n  .booking-schedule .time-slot li {\n    -ms-flex: 0 0 100px;\n    flex: 0 0 100px;\n    width: 100px;\n  }\n  .booking-schedule .time-slot li .timing span {\n    display: inline-block;\n  }\n  .booking-schedule .day-slot li.right-arrow {\n    right: -20px;\n  }\n  .booking-doc-info .booking-doc-img {\n    width: 70px;\n  }\n  .booking-doc-info .booking-doc-img img {\n    height: 70px;\n    width: 70px;\n  }\n  .voice-call-avatar .call-avatar {\n    height: 80px;\n    width: 80px;\n  }\n  .call-duration {\n    display: block;\n    margin-top: 0;\n    margin-bottom: 10px;\n    position: inherit;\n  }\n  .end-call {\n    margin-top: 10px;\n    position: inherit;\n  }\n  .user-tabs .med-records {\n    min-width: 110px;\n  }\n  .pagination-lg .page-link {\n    font-size: 1rem;\n    padding: 0.5rem 0.625rem;\n  }\n  .row.row-grid > div {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .edit-link {\n    font-size: 14px;\n    margin-top: 2px;\n  }\n  .invoice-content {\n    padding: 1.25rem;\n  }\n  .change-avatar .profile-img img {\n    height: 80px;\n    width: 80px;\n  }\n  .submit-btn-bottom {\n    margin-bottom: 0.9375rem;\n  }\n  .service-list ul li {\n    width: 100%;\n  }\n  .blog {\n    padding: 1.25rem;\n  }\n  .blog-title {\n    font-size: 18px;\n  }\n  .blog-view .blog-title {\n    font-size: 20px;\n  }\n  .blog-info i {\n    font-size: 14px;\n  }\n  .post-left ul li {\n    margin-right: 10px;\n  }\n  .post-left ul li:last-child {\n    margin-right: 10px;\n  }\n  .about-author-img {\n    height: 60px;\n    width: 60px;\n  }\n  .author-details {\n    margin-left: 80px;\n  }\n  .blog-comments .comments-list li img.avatar {\n    border-radius: 40px;\n    height: 40px;\n    width: 40px;\n  }\n  .blog-comments .comments-list li {\n    padding: 10px 0 0 50px;\n  }\n  .read-more {\n    font-size: 14px;\n  }\n}\n\n@media only screen and (max-width: 479px) {\n  .section-search {\n    min-height: 410px;\n    padding: 30px 15px;\n  }\n  .specialities-slider .slick-slide {\n    margin-right: 10px;\n  }\n  .speicality-img {\n    width: 120px;\n    height: 120px;\n  }\n  .speicality-img img {\n    width: 50px;\n  }\n  .clinic-booking a.view-pro-btn {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n  .clinic-booking a.apt-btn {\n    width: 100%;\n  }\n  .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-name,\n  .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-last-chat {\n    max-width: 160px;\n  }\n  .section-features,\n  .section-features,\n  .section-specialities {\n    background-color: #fff;\n    padding: 30px 0;\n  }\n  .login-header h3 a {\n    color: #0de0fe;\n    float: none;\n    font-size: 15px;\n    margin-top: 10px;\n    text-align: center;\n    display: block;\n  }\n  .login-header h3 {\n    text-align: center;\n  }\n  .appointments .appointment-list {\n    text-align: center;\n  }\n  .appointment-list .profile-info-widget {\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .appointment-list .profile-info-widget {\n    text-align: center;\n  }\n  .appointment-list .profile-info-widget .booking-doc-img {\n    margin: 0 0 15px;\n  }\n  .appointment-list .profile-info-widget .booking-doc-img img {\n    border-radius: 50%;\n    height: 100px;\n    width: 100px;\n  }\n  .appointment-list .profile-det-info {\n    margin-bottom: 15px;\n  }\n  .appointments .appointment-action {\n    margin-top: 0;\n  }\n  .user-tabs .nav-tabs .nav-item {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n  }\n  .review-listing .recommend-btn span {\n    display: block;\n    margin-bottom: 10px;\n  }\n  .review-listing > ul li .comments-reply {\n    margin-left: 0;\n  }\n  .schedule-nav .nav-tabs li {\n    display: block;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    margin-right: 0;\n  }\n  .fc-header-toolbar .fc-left {\n    margin-bottom: 10px;\n  }\n  .fc-header-toolbar .fc-right {\n    margin-bottom: 10px;\n  }\n  .section-header-three h2 {\n    font-size: 15px;\n  }\n  .section-header-three p {\n    font-size: 11px;\n  }\n  .section-search-3 .banner-info {\n    padding: 20px 0 70px;\n  }\n  .special-box .special-body h4 {\n    font-size: 15px;\n  }\n  .special-box .special-footer .doc-count,\n  .special-box .special-footer .clin-count {\n    font-size: 13px;\n  }\n  .view-all-more .btn {\n    font-size: 14px;\n    padding: 6px 20px;\n  }\n  .section-header-three {\n    margin-bottom: 30px;\n  }\n  .doctor-divison h3 {\n    font-size: 14px;\n    margin-bottom: 15px;\n  }\n  .doctor-divison p {\n    font-size: 10px;\n    margin-bottom: 20px;\n  }\n  .doctor-divison .doc-bok-btn {\n    font-size: 12px;\n    padding: 5px 10px;\n  }\n  .book-best-doctors .doctors-body h4 {\n    font-size: 16px;\n  }\n  .book-best-doctors .loc-details img {\n    margin-right: 6px;\n  }\n  .book-best-doctors .available-info {\n    font-size: 11px;\n  }\n  .book-best-doctors .data-info {\n    font-size: 10px;\n  }\n  .book-best-doctors .amt-txt {\n    font-size: 14px;\n  }\n  .book-best-doctors .doctors-body .book-btn {\n    font-size: 12px;\n    padding: 5px 10px;\n    width: 80px;\n  }\n  .latest-blog .blog-wrap .blog-wrap-body h3 {\n    font-size: 16px;\n  }\n  .latest-blog .blog-wrap .blog-wrap-body p {\n    font-size: 12px;\n  }\n  .latest-blog .blog-footer .read-txt,\n  .latest-blog .blog-footer .cal-txt {\n    font-size: 12px;\n  }\n  .aval-features .feature .info-box h2 {\n    font-size: 20px;\n  }\n  .home-search-section .banner-header h2 {\n    font-size: 28px;\n  }\n  .blog-wrapper .wrap-content:before {\n    border-left: 125px solid transparent;\n    border-right: 125px solid transparent;\n  }\n}\n.mapgridrating i:not(:last-child) {\n  margin-right: 3px;\n}\n.mapgridrating1 i:not(:last-child) {\n  margin-right: 3px;\n}\n.rating1 i:not(:last-child) {\n  margin-right: none !important;\n}\n.favouritesrating .fa-star {\n  font-size: 16px;\n}\n.mapgridrating1 .fa-star {\n  font-size: 16px;\n}\n.favouritesrating .rating {\n  margin-right: unset !important;\n}\n.rating1 i.filled {\n  color: #f3c41b;\n}\n.fancystyle {\n  display: unset !important;\n}\n.stickyside {\n  position: sticky;\n  top: 0;\n  padding-bottom: 1px;\n}\n\n/* @media only screen and (max-width: 576px) {\n  .footer {\n    display: none;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
